/* CSV to Dashboard — built bundle. Source: charts.jsx + app.jsx. */
var LZString=function(){var r=String.fromCharCode,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",e={};function t(r,o){if(!e[r]){e[r]={};for(var n=0;n<r.length;n++)e[r][r.charAt(n)]=n}return e[r][o]}var i={compressToBase64:function(r){if(null==r)return"";var n=i._compress(r,6,function(r){return o.charAt(r)});switch(n.length%4){default:case 0:return n;case 1:return n+"===";case 2:return n+"==";case 3:return n+"="}},decompressFromBase64:function(r){return null==r?"":""==r?null:i._decompress(r.length,32,function(n){return t(o,r.charAt(n))})},compressToUTF16:function(o){return null==o?"":i._compress(o,15,function(o){return r(o+32)})+" "},decompressFromUTF16:function(r){return null==r?"":""==r?null:i._decompress(r.length,16384,function(o){return r.charCodeAt(o)-32})},compressToUint8Array:function(r){for(var o=i.compress(r),n=new Uint8Array(2*o.length),e=0,t=o.length;e<t;e++){var s=o.charCodeAt(e);n[2*e]=s>>>8,n[2*e+1]=s%256}return n},decompressFromUint8Array:function(o){if(null==o)return i.decompress(o);for(var n=new Array(o.length/2),e=0,t=n.length;e<t;e++)n[e]=256*o[2*e]+o[2*e+1];var s=[];return n.forEach(function(o){s.push(r(o))}),i.decompress(s.join(""))},compressToEncodedURIComponent:function(r){return null==r?"":i._compress(r,6,function(r){return n.charAt(r)})},decompressFromEncodedURIComponent:function(r){return null==r?"":""==r?null:(r=r.replace(/ /g,"+"),i._decompress(r.length,32,function(o){return t(n,r.charAt(o))}))},compress:function(o){return i._compress(o,16,function(o){return r(o)})},_compress:function(r,o,n){if(null==r)return"";var e,t,i,s={},u={},a="",p="",c="",l=2,f=3,h=2,d=[],m=0,v=0;for(i=0;i<r.length;i+=1)if(a=r.charAt(i),Object.prototype.hasOwnProperty.call(s,a)||(s[a]=f++,u[a]=!0),p=c+a,Object.prototype.hasOwnProperty.call(s,p))c=p;else{if(Object.prototype.hasOwnProperty.call(u,c)){if(c.charCodeAt(0)<256){for(e=0;e<h;e++)m<<=1,v==o-1?(v=0,d.push(n(m)),m=0):v++;for(t=c.charCodeAt(0),e=0;e<8;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}else{for(t=1,e=0;e<h;e++)m=m<<1|t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t=0;for(t=c.charCodeAt(0),e=0;e<16;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}0==--l&&(l=Math.pow(2,h),h++),delete u[c]}else for(t=s[c],e=0;e<h;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1;0==--l&&(l=Math.pow(2,h),h++),s[p]=f++,c=String(a)}if(""!==c){if(Object.prototype.hasOwnProperty.call(u,c)){if(c.charCodeAt(0)<256){for(e=0;e<h;e++)m<<=1,v==o-1?(v=0,d.push(n(m)),m=0):v++;for(t=c.charCodeAt(0),e=0;e<8;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}else{for(t=1,e=0;e<h;e++)m=m<<1|t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t=0;for(t=c.charCodeAt(0),e=0;e<16;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1}0==--l&&(l=Math.pow(2,h),h++),delete u[c]}else for(t=s[c],e=0;e<h;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1;0==--l&&(l=Math.pow(2,h),h++)}for(t=2,e=0;e<h;e++)m=m<<1|1&t,v==o-1?(v=0,d.push(n(m)),m=0):v++,t>>=1;for(;;){if(m<<=1,v==o-1){d.push(n(m));break}v++}return d.join("")},decompress:function(r){return null==r?"":""==r?null:i._decompress(r.length,32768,function(o){return r.charCodeAt(o)})},_decompress:function(o,n,e){var t,i,s,u,a,p,c,l=[],f=4,h=4,d=3,m="",v=[],g={val:e(0),position:n,index:1};for(t=0;t<3;t+=1)l[t]=t;for(s=0,a=Math.pow(2,2),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;switch(s){case 0:for(s=0,a=Math.pow(2,8),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;c=r(s);break;case 1:for(s=0,a=Math.pow(2,16),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;c=r(s);break;case 2:return""}for(l[3]=c,i=c,v.push(c);;){if(g.index>o)return"";for(s=0,a=Math.pow(2,d),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;switch(c=s){case 0:for(s=0,a=Math.pow(2,8),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;l[h++]=r(s),c=h-1,f--;break;case 1:for(s=0,a=Math.pow(2,16),p=1;p!=a;)u=g.val&g.position,g.position>>=1,0==g.position&&(g.position=n,g.val=e(g.index++)),s|=(u>0?1:0)*p,p<<=1;l[h++]=r(s),c=h-1,f--;break;case 2:return v.join("")}if(0==f&&(f=Math.pow(2,d),d++),l[c])m=l[c];else{if(c!==h)return null;m=i+i.charAt(0)}v.push(m),l[h++]=i+m.charAt(0),i=m,0==--f&&(f=Math.pow(2,d),d++)}}};return i}();"function"==typeof define&&define.amd?define(function(){return LZString}):"undefined"!=typeof module&&null!=module?module.exports=LZString:"undefined"!=typeof angular&&null!=angular&&angular.module("LZString",[]).factory("LZString",function(){return LZString});

/* global React */
// Hand-built minimal SVG charts: BarChart, LineChart, Histogram

const { useState, useMemo, useEffect, useRef } = React;

// Min/max over an array WITHOUT the spread operator. `Math.min(...arr)` /
// `Math.max(...arr)` overflow the call stack past ~125k elements, which a big
// CSV easily exceeds — so anything that may run over per-row data must use these.
// Defined at bundle top so every later file (viz.jsx, app.jsx, …) can reuse them.
function arrMin(a) { let m = Infinity; for (let i = 0; i < a.length; i++) if (a[i] < m) m = a[i]; return m; }
function arrMax(a) { let m = -Infinity; for (let i = 0; i < a.length; i++) if (a[i] > m) m = a[i]; return m; }

// Shared "Build dashboard" handoff used by every tool/converter shell. Since V6
// this is a thin wrapper over the generic tool→tool channel in workspace.jsx
// (sendCSVToTool) — same sessionStorage ?importKey= mechanics, same #data=
// fallback for the dashboard. Function declarations hoist across the
// concatenated bundle, so the later definition is callable from here.
function sendCSVToDashboard(csv, name, onError) {
  sendCSVToTool("/", csv, name, onError);
}

function fmtNum(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e9) return (n / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
  if (abs >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
  if (abs >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
  if (Number.isInteger(n)) return n.toLocaleString();
  return n.toFixed(2);
}

function fmtInt(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Math.round(n).toLocaleString();
}

function fmtCurrency(n, symbol = "$") {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1e9) return sign + symbol + (abs / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
  if (abs >= 1e6) return sign + symbol + (abs / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
  if (abs >= 1e3) return sign + symbol + (abs / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
  return sign + symbol + abs.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

function fmtPercent(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return n.toFixed(1) + "%";
}

// V7 D — seconds → human duration. Only used when the column NAME says the
// unit is seconds (duration/elapsed/…_sec) — "minutes"/"hours" columns keep
// plain numbers rather than being mislabeled.
function fmtDuration(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  let s = Math.abs(Math.round(n));
  if (s < 60) return sign + s + "s";
  if (s < 3600) { const m = Math.floor(s / 60); s %= 60; return sign + m + "m" + (s ? " " + s + "s" : ""); }
  if (s < 86400) { const h = Math.floor(s / 3600); const m = Math.floor((s % 3600) / 60); return sign + h + "h" + (m ? " " + m + "m" : ""); }
  const d = Math.floor(s / 86400); const h = Math.floor((s % 86400) / 3600);
  return sign + d + "d" + (h ? " " + h + "h" : "");
}

function fmtBytes(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const a = Math.abs(n);
  const u = a >= 2 ** 40 ? [2 ** 40, "TB"] : a >= 2 ** 30 ? [2 ** 30, "GB"] : a >= 2 ** 20 ? [2 ** 20, "MB"] : a >= 1024 ? [1024, "KB"] : [1, "B"];
  const x = n / u[0];
  return (u[0] === 1 ? Math.round(x) : x.toFixed(1).replace(/\.0$/, "")) + " " + u[1];
}

// Auto-format based on column meta
function fmtByCol(col, n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  if (col.format === "currency") return fmtCurrency(n, col.currencySymbol || "$");
  if (col.format === "percent") return fmtPercent(n);
  if (col.format === "int") return fmtInt(n);
  if (col.role === "duration" && /sec|duration|elapsed|latency/i.test(col.name || "")) return fmtDuration(n);
  if (/(^|[_\s])(bytes?|file ?size)$/i.test(col.name || "")) return fmtBytes(n);
  return fmtNum(n);
}

function fmtDateShort(d) {
  if (!d) return "";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

function useSize(ref) {
  const [size, setSize] = useState({ w: 0, h: 0 });
  React.useLayoutEffect(() => {
    if (!ref.current) return;
    // Initial measurement — synchronous, before paint
    const r = ref.current.getBoundingClientRect();
    setSize({ w: Math.round(r.width), h: Math.round(r.height) });
    // Then subscribe to resize for responsive updates
    const ro = new ResizeObserver(entries => {
      for (const e of entries) {
        const w = Math.round(e.contentRect.width);
        const h = Math.round(e.contentRect.height);
        setSize(prev => (prev.w === w && prev.h === h) ? prev : { w, h });
      }
    });
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, [ref]);
  return size;
}

// =================== Horizontal Bar Chart ===================
function BarChart({ data, maxBars = 8, col, onBarClick, activeKeys }) {
  const ref = useRef(null);
  const { w, h } = useSize(ref);
  const top = data.slice(0, maxBars);
  const max = Math.max(arrMax(top.map(d => d.value)), 1);
  const grand = data.reduce((a, d) => a + (d.value > 0 ? d.value : 0), 0); // % of total over ALL rows, not just the visible top
  const formatValue = col ? (v) => fmtByCol(col, v) : fmtNum;
  const interactive = !!onBarClick;

  const padL = 110, padR = 64, padT = 8, padB = 8;
  const innerW = Math.max(60, w - padL - padR);
  const innerH = Math.max(80, h - padT - padB);
  const rowH = top.length ? innerH / top.length : 24;
  const barH = Math.min(28, rowH - 8);

  return (
    <div ref={ref} className="chart-body">
      {w > 0 && (
        <svg className="svg-chart" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none">
          {top.map((d, i) => {
            const y = padT + i * rowH + (rowH - barH) / 2;
            const bw = (d.value / max) * innerW;
            const label = d.key.length > 16 ? d.key.slice(0, 15) + "…" : d.key;
            const active = activeKeys && activeKeys.has(d.key);
            const dimmed = activeKeys && activeKeys.size > 0 && !active;
            return (
              <g key={d.key + i}
                style={{ cursor: interactive ? "pointer" : "default", opacity: dimmed ? 0.35 : 1, transition: "opacity 0.15s" }}
                onClick={() => interactive && onBarClick(d.key)}>
                <title>{d.key + ": " + formatValue(d.value) + (grand > 0 && d.value > 0 ? " · " + (d.value / grand * 100).toFixed(1) + "% of total" : "")}</title>
                {interactive && <rect x="0" y={y - 4} width={w} height={barH + 8} fill="transparent" />}
                <text x={padL - 12} y={y + barH / 2 + 4} textAnchor="end" className="bar-label" style={active ? { fill: "var(--accent-ink)", fontWeight: 600 } : {}}>{label}</text>
                <rect className="bar" x={padL} y={y} width={Math.max(2, bw)} height={barH} rx="3"
                  style={active ? { fill: "var(--accent-ink)" } : {}} />
                <text x={padL + bw + 8} y={y + barH / 2 + 4} className="bar-value">{formatValue(d.value)}</text>
              </g>
            );
          })}
        </svg>
      )}
    </div>
  );
}

// =================== Line Chart (time series) ===================
function LineChart({ points, valueLabel, col, brush, onBrushChange, forecast }) {
  // points: [{ x: Date, y: number }]
  const ref = useRef(null);
  const svgRef = useRef(null);
  const { w, h } = useSize(ref);
  const formatValue = col ? (v) => fmtByCol(col, v) : fmtNum;
  const padL = 56, padR = 16, padT = 12, padB = 28;
  const innerW = Math.max(60, w - padL - padR);
  const innerH = Math.max(80, h - padT - padB);

  const [hover, setHover] = useState(null); // { idx, mx }
  const [brushDrag, setBrushDrag] = useState(null); // { x0, x1 }

  const ys = points.map(p => p.y);
  // Forecast: simple linear regression on (i, y). Project out 25% of the existing span (capped at 60 days).
  let forecastPts = null;
  if (forecast && points.length >= 4) {
    const n = points.length;
    const xsRaw = points.map(p => +p.x);
    const xMeanT = xsRaw.reduce((a, b) => a + b, 0) / n;
    const yMeanT = ys.reduce((a, b) => a + b, 0) / n;
    let num = 0, den = 0;
    for (let i = 0; i < n; i++) {
      num += (xsRaw[i] - xMeanT) * (ys[i] - yMeanT);
      den += (xsRaw[i] - xMeanT) ** 2;
    }
    const slope = den === 0 ? 0 : num / den;
    const intercept = yMeanT - slope * xMeanT;
    const lastT = xsRaw[n - 1];
    const spanT = lastT - xsRaw[0];
    const horizonT = Math.min(60 * 86400000, spanT * 0.4);
    const stepT = horizonT / 4;
    forecastPts = [];
    forecastPts.push({ x: new Date(lastT), y: ys[n - 1] });
    for (let k = 1; k <= 4; k++) {
      const t = lastT + stepT * k;
      forecastPts.push({ x: new Date(t), y: slope * t + intercept });
    }
  }

  const allXs = points.map(p => +p.x).concat(forecastPts ? forecastPts.map(p => +p.x) : []);
  const allYs = ys.concat(forecastPts ? forecastPts.map(p => p.y) : []);
  const yMin = Math.min(0, ...allYs);
  const yMax = Math.max(arrMax(allYs), 1);
  const xMin = arrMin(allXs), xMax = arrMax(allXs);
  const xSpan = xMax - xMin || 1;

  const xScale = x => padL + ((+x - xMin) / xSpan) * innerW;
  const yScale = y => padT + innerH - ((y - yMin) / (yMax - yMin || 1)) * innerH;
  const xInverse = px => xMin + ((px - padL) / innerW) * xSpan;

  const path = points.map((p, i) => `${i === 0 ? "M" : "L"} ${xScale(p.x)} ${yScale(p.y)}`).join(" ");
  const area = path + ` L ${xScale(points[points.length - 1].x)} ${padT + innerH} L ${xScale(points[0].x)} ${padT + innerH} Z`;
  const forecastPath = forecastPts
    ? forecastPts.map((p, i) => `${i === 0 ? "M" : "L"} ${xScale(p.x)} ${yScale(p.y)}`).join(" ")
    : null;

  const ticksY = 4;
  const yTicks = Array.from({ length: ticksY + 1 }, (_, i) => yMin + (i / ticksY) * (yMax - yMin));

  function svgCoord(e) {
    const svg = svgRef.current;
    if (!svg) return null;
    const pt = svg.createSVGPoint();
    pt.x = e.clientX; pt.y = e.clientY;
    const ctm = svg.getScreenCTM();
    if (!ctm) return null;
    return pt.matrixTransform(ctm.inverse());
  }
  function nearestIdx(svgX) {
    let best = 0, bestDist = Infinity;
    for (let i = 0; i < points.length; i++) {
      const px = xScale(points[i].x);
      const d = Math.abs(px - svgX);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }
  function onPointerMove(e) {
    const c = svgCoord(e);
    if (!c) return;
    if (c.x < padL || c.x > padL + innerW || c.y < padT - 12 || c.y > padT + innerH + 12) {
      if (!brushDrag) setHover(null);
      if (brushDrag) {
        setBrushDrag(prev => ({ ...prev, x1: Math.max(padL, Math.min(padL + innerW, c.x)) }));
      }
      return;
    }
    const idx = nearestIdx(c.x);
    setHover({ idx, mx: c.x });
    if (brushDrag) {
      setBrushDrag(prev => ({ ...prev, x1: Math.max(padL, Math.min(padL + innerW, c.x)) }));
    }
  }
  function onPointerLeave() { if (!brushDrag) setHover(null); }
  function onPointerDown(e) {
    if (!onBrushChange) return;
    const c = svgCoord(e);
    if (!c) return;
    if (c.x < padL || c.x > padL + innerW) return;
    const x = Math.max(padL, Math.min(padL + innerW, c.x));
    setBrushDrag({ x0: x, x1: x });
    if (e.currentTarget.setPointerCapture) {
      try { e.currentTarget.setPointerCapture(e.pointerId); } catch (_) {}
    }
  }
  function onPointerUp() {
    if (brushDrag && onBrushChange) {
      const a = Math.min(brushDrag.x0, brushDrag.x1);
      const b = Math.max(brushDrag.x0, brushDrag.x1);
      if (Math.abs(b - a) < 4) {
        onBrushChange(null);
      } else {
        onBrushChange({ start: new Date(xInverse(a)), end: new Date(xInverse(b)) });
      }
    }
    setBrushDrag(null);
  }

  let brushVis = null;
  if (brush && brush.start && brush.end) {
    const bx0 = xScale(brush.start);
    const bx1 = xScale(brush.end);
    brushVis = { x: Math.min(bx0, bx1), w: Math.abs(bx1 - bx0) };
  }
  if (brushDrag) {
    const a = Math.min(brushDrag.x0, brushDrag.x1);
    const b = Math.max(brushDrag.x0, brushDrag.x1);
    brushVis = { x: a, w: b - a };
  }

  const hoverPoint = hover ? points[hover.idx] : null;
  const tipX = hoverPoint ? xScale(hoverPoint.x) : 0;
  const tipY = hoverPoint ? yScale(hoverPoint.y) : 0;
  const tipPct = w > 0 ? (tipX / w) * 100 : 50;
  const tipYPct = h > 0 ? (tipY / h) * 100 : 50;

  return (
    <div ref={ref} className="chart-body">
      {w > 0 && points.length > 0 && (
        <React.Fragment>
          <svg ref={svgRef} className="svg-chart" viewBox={`0 0 ${w} ${h}`}
            onPointerMove={onPointerMove}
            onPointerLeave={onPointerLeave}
            onPointerDown={onPointerDown}
            onPointerUp={onPointerUp}
            style={{ cursor: onBrushChange ? "crosshair" : "default", touchAction: "none" }}>
            {yTicks.map((t, i) => (
              <g key={i}>
                <line className="grid-line" x1={padL} x2={padL + innerW} y1={yScale(t)} y2={yScale(t)} />
                <text className="tick-label" x={padL - 8} y={yScale(t) + 3} textAnchor="end">{formatValue(t)}</text>
              </g>
            ))}
            <path className="area-fill" d={area} />
            <path className="line-path" d={path} />
            {forecastPath && (
              <path d={forecastPath}
                fill="none"
                stroke="var(--accent-ink)"
                strokeWidth="2"
                strokeDasharray="5 5"
                opacity="0.6"
                strokeLinejoin="round"
                strokeLinecap="round" />
            )}
            {points.length <= 24 && points.map((p, i) => (
              <circle key={i} className="dot" cx={xScale(p.x)} cy={yScale(p.y)} r="3" />
            ))}
            {[0, Math.floor(points.length / 2), points.length - 1].map((idx, i) => {
              const p = points[idx];
              if (!p) return null;
              return (
                <text key={i} className="tick-label"
                  x={xScale(p.x)} y={padT + innerH + 18}
                  textAnchor={i === 0 ? "start" : i === 2 ? "end" : "middle"}>
                  {fmtDateShort(p.x)}
                </text>
              );
            })}
            {brushVis && brushVis.w > 1 && (
              <rect className="brush-rect"
                x={brushVis.x} y={padT}
                width={brushVis.w} height={innerH} />
            )}
            {hoverPoint && (
              <React.Fragment>
                <line className="crosshair-line"
                  x1={tipX} x2={tipX}
                  y1={padT} y2={padT + innerH} />
                <circle className="crosshair-dot"
                  cx={tipX} cy={tipY} r="5" />
              </React.Fragment>
            )}
          </svg>
          {hoverPoint && (
            <div className="chart-tip" style={{ left: `${tipPct}%`, top: `${tipYPct}%` }}>
              <div className="chart-tip-date">{fmtDateShort(hoverPoint.x)}</div>
              <div className="chart-tip-value">{formatValue(hoverPoint.y)}</div>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

// =================== Histogram ===================
function Histogram({ values, bins = 12, col }) {
  const ref = useRef(null);
  const { w, h } = useSize(ref);
  const formatValue = col ? (v) => fmtByCol(col, v) : fmtNum;
  const padL = 44, padR = 12, padT = 12, padB = 28;
  const innerW = Math.max(60, w - padL - padR);
  const innerH = Math.max(80, h - padT - padB);

  const min = arrMin(values);
  const max = arrMax(values);
  const span = max - min || 1;
  const step = span / bins;
  const counts = new Array(bins).fill(0);
  values.forEach(v => {
    let idx = Math.floor((v - min) / step);
    if (idx >= bins) idx = bins - 1;
    if (idx < 0) idx = 0;
    counts[idx]++;
  });
  const maxC = Math.max(arrMax(counts), 1);
  const barW = innerW / bins;

  return (
    <div ref={ref} className="chart-body">
      {w > 0 && (
        <svg className="svg-chart" viewBox={`0 0 ${w} ${h}`}>
          {[0.25, 0.5, 0.75, 1].map((f, i) => (
            <line key={i} className="grid-line"
              x1={padL} x2={padL + innerW}
              y1={padT + innerH - innerH * f} y2={padT + innerH - innerH * f} />
          ))}
          {counts.map((c, i) => {
            const bh = (c / maxC) * innerH;
            return (
              <rect key={i} className="bar"
                x={padL + i * barW + 1}
                y={padT + innerH - bh}
                width={Math.max(1, barW - 2)}
                height={bh}
                rx="2" />
            );
          })}
          <text className="tick-label" x={padL} y={padT + innerH + 18} textAnchor="start">{formatValue(min)}</text>
          <text className="tick-label" x={padL + innerW / 2} y={padT + innerH + 18} textAnchor="middle">{formatValue((min + max) / 2)}</text>
          <text className="tick-label" x={padL + innerW} y={padT + innerH + 18} textAnchor="end">{formatValue(max)}</text>
        </svg>
      )}
    </div>
  );
}

// =================== Donut for low-card categories ===================
function Donut({ data, col, onSliceClick, activeKeys }) {
  const ref = useRef(null);
  const { w, h } = useSize(ref);
  const interactive = !!onSliceClick;
  const size = Math.min(w, h);
  const cx = w / 2, cy = h / 2;
  const r = size / 2 - 12;
  const inner = r * 0.62;
  const total = data.reduce((a, b) => a + b.value, 0) || 1;
  const hues = [162, 200, 60, 30, 280, 340, 120];

  let angle = -Math.PI / 2;
  const arcs = data.slice(0, 7).map((d, i) => {
    const a0 = angle;
    const a1 = angle + (d.value / total) * Math.PI * 2;
    angle = a1;
    const large = a1 - a0 > Math.PI ? 1 : 0;
    const x0 = cx + r * Math.cos(a0), y0 = cy + r * Math.sin(a0);
    const x1 = cx + r * Math.cos(a1), y1 = cy + r * Math.sin(a1);
    const xi0 = cx + inner * Math.cos(a0), yi0 = cy + inner * Math.sin(a0);
    const xi1 = cx + inner * Math.cos(a1), yi1 = cy + inner * Math.sin(a1);
    const path = `M ${x0} ${y0} A ${r} ${r} 0 ${large} 1 ${x1} ${y1} L ${xi1} ${yi1} A ${inner} ${inner} 0 ${large} 0 ${xi0} ${yi0} Z`;
    const fill = `oklch(${0.55 - i * 0.04} 0.13 var(--ch, ${hues[i % hues.length]}))`; // --ch = per-chart hue override (V7 D)
    const active = activeKeys && activeKeys.has(d.key);
    const dimmed = activeKeys && activeKeys.size > 0 && !active;
    return { path, fill, key: d.key, value: d.value, pct: (d.value / total * 100).toFixed(0), active, dimmed };
  });

  return (
    <div ref={ref} className="chart-body" style={{ display: "flex", alignItems: "center", gap: 24 }}>
      {w > 0 && (
        <>
          <svg width={size} height={size} viewBox={`0 0 ${w} ${h}`} style={{ flex: "0 0 auto", maxWidth: "55%" }}>
            {arcs.map((a, i) => (
              <path key={i} d={a.path} fill={a.fill}
                style={{ opacity: a.dimmed ? 0.3 : 1, cursor: interactive ? "pointer" : "default", transition: "opacity 0.15s" }}
                onClick={() => interactive && onSliceClick(a.key)} />
            ))}
            <text x={cx} y={cy - 4} textAnchor="middle" className="bar-value" style={{ fontSize: 22, fontFamily: "var(--serif)" }}>{data.length}</text>
            <text x={cx} y={cy + 14} textAnchor="middle" className="tick-label">categories</text>
          </svg>
          <div style={{ flex: 1, fontSize: 12, fontFamily: "var(--mono)", display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
            {arcs.map((a, i) => (
              <div key={i}
                onClick={() => interactive && onSliceClick(a.key)}
                style={{
                  display: "flex", alignItems: "center", gap: 8, minWidth: 0,
                  cursor: interactive ? "pointer" : "default",
                  opacity: a.dimmed ? 0.4 : 1,
                  fontWeight: a.active ? 600 : 400
                }}>
                <span style={{ width: 10, height: 10, background: a.fill, borderRadius: 2, flex: "0 0 auto" }}></span>
                <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.key}</span>
                <span style={{ color: "var(--ink-faint)" }}>{a.pct}%</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// =================== Sparkline (inline, no axis) ===================
function Sparkline({ values, width = 80, height = 28 }) {
  if (!values || values.length < 2) return null;
  const min = arrMin(values);
  const max = arrMax(values);
  const span = max - min || 1;
  const step = width / (values.length - 1);
  const points = values.map((v, i) => {
    const x = i * step;
    const y = height - ((v - min) / span) * height;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");
  const last = values[values.length - 1];
  const first = values[0];
  const trend = last >= first;
  const color = trend ? "var(--accent)" : "oklch(0.55 0.13 30)";
  return (
    <svg width={width} height={height} style={{ display: "block", overflow: "visible" }}>
      <polyline points={points} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={(values.length - 1) * step} cy={height - ((last - min) / span) * height} r="2" fill={color} />
    </svg>
  );
}

// =================== Scatter Plot ===================
function ScatterPlot({ points, xCol, yCol, correlation }) {
  // points: [{ x: number, y: number }]
  const ref = useRef(null);
  const { w, h } = useSize(ref);
  const fmtX = xCol ? (v) => fmtByCol(xCol, v) : fmtNum;
  const fmtY = yCol ? (v) => fmtByCol(yCol, v) : fmtNum;
  const padL = 56, padR = 16, padT = 12, padB = 28;
  const innerW = Math.max(60, w - padL - padR);
  const innerH = Math.max(80, h - padT - padB);

  if (!points || points.length < 2) return <div ref={ref} className="chart-body" />;

  const xs = points.map(p => p.x);
  const ys = points.map(p => p.y);
  const xMin = arrMin(xs), xMax = arrMax(xs);
  const yMin = arrMin(ys), yMax = arrMax(ys);
  const xSpan = xMax - xMin || 1;
  const ySpan = yMax - yMin || 1;

  const xScale = x => padL + ((x - xMin) / xSpan) * innerW;
  const yScale = y => padT + innerH - ((y - yMin) / ySpan) * innerH;

  // Optional regression line if correlation is meaningful
  let line = null;
  if (Math.abs(correlation || 0) > 0.3) {
    const xMean = xs.reduce((a, b) => a + b, 0) / xs.length;
    const yMean = ys.reduce((a, b) => a + b, 0) / ys.length;
    let num = 0, den = 0;
    for (let i = 0; i < points.length; i++) {
      num += (xs[i] - xMean) * (ys[i] - yMean);
      den += (xs[i] - xMean) ** 2;
    }
    const slope = den === 0 ? 0 : num / den;
    const intercept = yMean - slope * xMean;
    const y1 = slope * xMin + intercept;
    const y2 = slope * xMax + intercept;
    line = { x1: xScale(xMin), y1: yScale(y1), x2: xScale(xMax), y2: yScale(y2) };
  }

  const ticksY = 4;
  const yTicks = Array.from({ length: ticksY + 1 }, (_, i) => yMin + (i / ticksY) * (yMax - yMin));
  const xTicks = [xMin, (xMin + xMax) / 2, xMax];

  return (
    <div ref={ref} className="chart-body">
      {w > 0 && (
        <svg className="svg-chart" viewBox={`0 0 ${w} ${h}`}>
          {yTicks.map((t, i) => (
            <g key={i}>
              <line className="grid-line" x1={padL} x2={padL + innerW} y1={yScale(t)} y2={yScale(t)} />
              <text className="tick-label" x={padL - 8} y={yScale(t) + 3} textAnchor="end">{fmtY(t)}</text>
            </g>
          ))}
          {xTicks.map((t, i) => (
            <text key={i} className="tick-label"
              x={xScale(t)} y={padT + innerH + 18}
              textAnchor={i === 0 ? "start" : i === 2 ? "end" : "middle"}>{fmtX(t)}</text>
          ))}
          {line && (
            <line x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2}
              stroke="var(--accent-ink)" strokeWidth="1.5" strokeDasharray="4 4" opacity="0.5" />
          )}
          {points.map((p, i) => (
            <circle key={i} cx={xScale(p.x)} cy={yScale(p.y)} r="3.5"
              fill="var(--accent)" opacity="0.7" />
          ))}
        </svg>
      )}
    </div>
  );
}

// =================== Geographic bubble map ===================
// Tiny world-position lookup for common country/state names. Coordinates roughly mapped to
// equirectangular projection (x: -180..180 → 0..w, y: 90..-90 → 0..h).
const GEO_COORDS = {
  // Countries (subset of the most common)
  "united states": [-95.7, 39.5], "usa": [-95.7, 39.5], "us": [-95.7, 39.5],
  "canada": [-106.3, 56.1], "mexico": [-102.5, 23.6], "brazil": [-51.9, -14.2],
  "argentina": [-63.6, -38.4], "chile": [-71.5, -35.7], "colombia": [-74.3, 4.6],
  "united kingdom": [-3.4, 55.4], "uk": [-3.4, 55.4], "ireland": [-8.2, 53.4],
  "france": [2.2, 46.2], "germany": [10.5, 51.2], "spain": [-3.7, 40.5],
  "italy": [12.6, 41.9], "portugal": [-8.2, 39.4], "netherlands": [5.3, 52.1],
  "belgium": [4.5, 50.5], "switzerland": [8.2, 46.8], "austria": [14.6, 47.5],
  "sweden": [18.6, 60.1], "norway": [8.5, 60.5], "denmark": [9.5, 56.3],
  "finland": [25.7, 61.9], "poland": [19.1, 51.9], "russia": [105.3, 61.5],
  "ukraine": [31.2, 48.4], "turkey": [35.2, 38.9], "greece": [21.8, 39.1],
  "china": [104.2, 35.9], "japan": [138.3, 36.2], "south korea": [127.8, 35.9],
  "korea": [127.8, 35.9], "india": [78.9, 20.6], "pakistan": [69.3, 30.4],
  "bangladesh": [90.4, 23.7], "vietnam": [108.3, 14.1], "thailand": [100.9, 15.9],
  "indonesia": [113.9, -0.8], "philippines": [121.8, 12.9], "malaysia": [101.9, 4.2],
  "singapore": [103.8, 1.4], "australia": [133.8, -25.3], "new zealand": [174.9, -40.9],
  "south africa": [22.9, -30.6], "egypt": [30.8, 26.8], "nigeria": [8.7, 9.1],
  "kenya": [37.9, -0.0], "morocco": [-7.1, 31.8], "saudi arabia": [45.1, 23.9],
  "uae": [54, 24], "israel": [34.9, 31], "iran": [53.7, 32.4],
  // Generic regions (very rough centroids for the dashboard's sample data)
  "north": [-95.7, 50], "south": [-90, 25], "east": [-75, 40], "west": [-120, 38],
  // US states (subset)
  "california": [-119.4, 36.8], "texas": [-99.9, 31.0], "florida": [-81.5, 27.7],
  "new york": [-75.5, 42.7], "washington": [-120.7, 47.4], "oregon": [-120.5, 43.8],
  "illinois": [-88.9, 40.0], "ohio": [-82.7, 40.4], "pennsylvania": [-77.2, 41.2],
  "georgia": [-83.4, 32.6], "michigan": [-84.5, 44.3], "north carolina": [-79.8, 35.6],
  "arizona": [-111.7, 34.2], "massachusetts": [-71.5, 42.4]
};

function GeoMap({ data, col }) {
  const ref = useRef(null);
  const { w, h } = useSize(ref);
  const formatValue = col ? (v) => fmtByCol(col, v) : fmtNum;

  // Plot only items we have coords for
  const plotted = data
    .map(d => {
      const k = String(d.key || "").toLowerCase().trim();
      const c = GEO_COORDS[k];
      return c ? { ...d, lng: c[0], lat: c[1] } : null;
    })
    .filter(Boolean);

  if (plotted.length === 0 || w === 0) return <div ref={ref} className="chart-body" />;

  // Equirectangular projection
  const margin = 12;
  const projX = lng => margin + ((lng + 180) / 360) * (w - margin * 2);
  const projY = lat => margin + ((90 - lat) / 180) * (h - margin * 2);

  const maxV = Math.max(arrMax(plotted.map(p => Math.abs(p.value))), 1);
  const rScale = v => 4 + Math.sqrt(Math.abs(v) / maxV) * 24;

  return (
    <div ref={ref} className="chart-body">
      <svg className="svg-chart" viewBox={`0 0 ${w} ${h}`}>
        {/* Subtle equator + meridian guides */}
        <line x1={margin} x2={w - margin} y1={projY(0)} y2={projY(0)} className="grid-line" />
        <line x1={projX(0)} x2={projX(0)} y1={margin} y2={h - margin} className="grid-line" />
        {plotted.map((p, i) => (
          <g key={i}>
            <circle cx={projX(p.lng)} cy={projY(p.lat)} r={rScale(p.value)}
              fill="var(--accent)" opacity="0.55" stroke="var(--accent-ink)" strokeWidth="1" />
            <text x={projX(p.lng)} y={projY(p.lat) - rScale(p.value) - 4}
              textAnchor="middle"
              className="bar-value"
              style={{ fontSize: 10 }}>
              {p.key}
            </text>
          </g>
        ))}
        <text x={w - margin} y={h - margin} textAnchor="end" className="tick-label">
          {plotted.length} locations · max {formatValue(maxV)}
        </text>
      </svg>
    </div>
  );
}

window.Charts = { BarChart, LineChart, Histogram, Donut, Sparkline, ScatterPlot, GeoMap, fmtNum, fmtInt, fmtCurrency, fmtPercent, fmtByCol, fmtDateShort };


/* global React, LZString */
// V6 Batch A — Workspace substrate + cross-tool handoff + shared a11y helpers.
//
// Concatenated after charts.jsx, BEFORE converter.jsx / tools*.jsx / app.jsx, so
// every shell can use these helpers. The whole bundle shares ONE scope: the React
// hook aliases (useState, useEffect, …) come from charts.jsx — do NOT redeclare
// them here, and nothing else may redeclare the consts below.
//
// Design rules (carried from V4/V5):
//   · Persistence is OPT-IN. Nothing is stored unless csvtd-remember === "1"
//     (the dashboard's workspace toggle owns that preference); toggling it off
//     wipes the store.
//   · The store IS the V4 recent-files IndexedDB — workspace v2 raises the cap
//     and lets every tool read/write it. Same DB name, same record shape, so
//     existing users' files survive the upgrade.
//   · Tool→tool handoff rides the same sessionStorage ?importKey= channel the
//     dashboard has used since V2 — nothing new to expire or clean up.

// =================== Opt-in workspace store (IndexedDB) ===================
// Moved here from app.jsx (V6); app.jsx and tools6.jsx keep calling these names.
const RECENT_DB = "csvtd-recent", RECENT_STORE = "files", RECENT_MAX = 10, RECENT_MAX_BYTES = 3 * 1024 * 1024;
// fmtBytes lives in charts.jsx (richer: TB + null handling) and is concatenated
// before this file in the one bundle scope, so call sites here use it. The weak
// duplicate that used to shadow it was removed (V7 audit — esbuild last-wins).
function recentDbOpen() {
  return new Promise((res, rej) => {
    let req;
    try { req = indexedDB.open(RECENT_DB, 1); } catch (e) { return rej(e); }
    req.onupgradeneeded = () => { const db = req.result; if (!db.objectStoreNames.contains(RECENT_STORE)) db.createObjectStore(RECENT_STORE, { keyPath: "id" }); };
    req.onsuccess = () => res(req.result);
    req.onerror = () => rej(req.error);
  });
}
async function recentGetAll() {
  try {
    const db = await recentDbOpen();
    return await new Promise((res) => { const r = db.transaction(RECENT_STORE, "readonly").objectStore(RECENT_STORE).getAll(); r.onsuccess = () => res((r.result || []).sort((a, b) => b.ts - a.ts)); r.onerror = () => res([]); });
  } catch (e) { return []; }
}
async function recentSave(name, csv) {
  if (!csv || csv.length > RECENT_MAX_BYTES) return; // skip huge files
  try {
    const db = await recentDbOpen();
    const rec = { id: name || "data.csv", name: name || "data.csv", csv, ts: Date.now(), bytes: csv.length, rows: (csv.match(/\n/g) || []).length };
    await new Promise((res, rej) => { const tx = db.transaction(RECENT_STORE, "readwrite"); tx.objectStore(RECENT_STORE).put(rec); tx.oncomplete = () => res(); tx.onerror = () => rej(tx.error); });
    const all = await recentGetAll();
    if (all.length > RECENT_MAX) {
      const db2 = await recentDbOpen();
      const tx = db2.transaction(RECENT_STORE, "readwrite");
      all.slice(RECENT_MAX).forEach(r => tx.objectStore(RECENT_STORE).delete(r.id));
    }
  } catch (e) { /* quota / disabled — silent */ }
}
function recentClear() { return recentDbOpen().then(db => new Promise((res) => { const tx = db.transaction(RECENT_STORE, "readwrite"); tx.objectStore(RECENT_STORE).clear(); tx.oncomplete = () => res(); tx.onerror = () => res(); })).catch(() => {}); }
function recentDelete(id) { return recentDbOpen().then(db => new Promise((res) => { const tx = db.transaction(RECENT_STORE, "readwrite"); tx.objectStore(RECENT_STORE).delete(id); tx.oncomplete = () => res(); tx.onerror = () => res(); })).catch(() => {}); }

function wsEnabled() { try { return localStorage.getItem("csvtd-remember") === "1"; } catch (e) { return false; } }

// Save a file into the workspace IF the user opted in. Skips built-in samples,
// generated demos and anonymous pastes — only files the user actually brought
// (or results they made) belong in the workspace.
function wsMaybeSave(name, csv) {
  if (!wsEnabled() || !csv) return Promise.resolve();
  if (/^(sample[-.s]|demo-|pasted)/i.test(String(name || ""))) return Promise.resolve();
  return recentSave(name || "data.csv", csv);
}

// =================== Cross-tool handoff ===================
// Generalizes the V2 converter→dashboard channel: stash the CSV under a one-shot
// sessionStorage key and navigate with ?importKey=. The receiving shell consumes
// it via consumeToolHandoff() on mount. Falls back to an inline #data= URL for
// the dashboard only (its mount effect already understands that hash).
function sendCSVToTool(href, csv, name, onError) {
  if (csv == null || csv === "") return;
  try {
    const key = "csvtd-import-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
    sessionStorage.setItem(key, JSON.stringify({ csv: csv, name: name || "data.csv", t: Date.now() }));
    window.location.assign(href + (href.indexOf("?") >= 0 ? "&" : "?") + "importKey=" + key);
    return;
  } catch (e) {
    if (href === "/" || href === "") {
      try {
        const b64 = btoa(unescape(encodeURIComponent(csv))).replace(/\+/g, "-").replace(/\//g, "_");
        const url = "/#data=" + b64;
        if (url.length <= 1800000) { window.location.assign(url); return; }
      } catch (e2) { /* fall through */ }
    }
    const msg = "This result is too large to hand off automatically. Download it, then drop the file into the next tool.";
    if (onError) onError(msg); else alert(msg);
  }
}

// One-shot ?importKey= consumption for tool shells. The payload is cached so a
// second caller in the same page sees the same object (only one shell renders
// per page, but App also probes this). The dashboard keeps its own richer
// consumption path in app.jsx (error UX, ?demo=, #data=) — guarded by mode.
let __csvtdHandoff = null, __csvtdHandoffRead = false;
function consumeToolHandoff() {
  if (__csvtdHandoffRead) return __csvtdHandoff;
  __csvtdHandoffRead = true;
  try {
    const params = new URLSearchParams(window.location.search);
    const key = params.get("importKey");
    if (!key || !/^csvtd-import-/.test(key)) return null;
    const raw = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    history.replaceState(null, "", window.location.pathname + window.location.hash);
    if (raw) __csvtdHandoff = JSON.parse(raw);
  } catch (e) { /* expired / private mode — silent */ }
  return __csvtdHandoff;
}

// =================== Per-shell registration hook ===================
// Wires a shell into the workspace ecosystem:
//   ingest(csv, name)  — lets ?importKey= handoffs and the command palette load
//                        a file INTO this tool. Pass null for output-only shells.
//   getCurrent()       — returns { csv, name } for "send this file elsewhere"
//                        (palette + SendToMenu). Pass null when nothing loaded.
//   opts.consume:false — skip handoff consumption (the dashboard's own mount
//                        effect owns it there).
function useToolFile(ingest, getCurrent, opts) {
  const o = opts || {};
  const ingestRef = useRef(ingest);
  ingestRef.current = ingest;
  const getRef = useRef(getCurrent);
  getRef.current = getCurrent;
  useEffect(() => {
    // Presence is decided at mount (it follows the page's CONFIG.mode, constant
    // per page). Only claim the globals we own — App mounts this hook with
    // nulls on tool pages, and must not stomp the shell's registrations.
    const ownIngest = !!ingestRef.current, ownGet = !!getRef.current;
    if (ownIngest) {
      window.__csvtdIngest = (csv, name) => { if (ingestRef.current) ingestRef.current(csv, name); };
      if (o.consume !== false) {
        const h = consumeToolHandoff();
        if (h && h.csv) setTimeout(() => { if (ingestRef.current) ingestRef.current(h.csv, h.name || "imported.csv"); }, 0);
      }
    }
    if (ownGet) window.__csvtdGetCurrent = () => (getRef.current ? getRef.current() : null);
    return () => {
      if (ownIngest) window.__csvtdIngest = null;
      if (ownGet) window.__csvtdGetCurrent = null;
    };
  }, []);
}

// =================== Workspace UI ===================
// Chip strip listing workspace files — rendered inside tool input areas. Shows
// nothing unless the user opted in AND has files (no nagging on tool pages; the
// opt-in toggle lives on the dashboard).
function WorkspaceStrip({ onOpen }) {
  const [files, setFiles] = useState([]);
  useEffect(() => {
    let live = true;
    if (wsEnabled()) recentGetAll().then(r => { if (live && r && r.length) setFiles(r); }).catch(() => {});
    return () => { live = false; };
  }, []);
  if (!files.length) return null;
  return (
    <div className="ws-strip" role="group" aria-label="Workspace files">
      <span className="ws-strip-label">Workspace</span>
      {files.slice(0, 6).map(r => (
        <button type="button" key={r.id} className="ws-chip" onClick={() => onOpen(r)} title={"Open " + r.name + " (" + r.rows.toLocaleString() + " rows)"}>
          <span className="ws-chip-name">{r.name}</span>
          <span className="ws-chip-meta">{fmtBytes(r.bytes)}</span>
        </button>
      ))}
    </div>
  );
}

// Compact <select> picker (the join shell's pattern, generalized) for slot-based
// shells where a chip strip per slot would be noisy.
function WorkspacePick({ onPick, label }) {
  const [files, setFiles] = useState([]);
  useEffect(() => {
    let live = true;
    if (wsEnabled()) recentGetAll().then(r => { if (live && r && r.length) setFiles(r); }).catch(() => {});
    return () => { live = false; };
  }, []);
  if (!files.length) return null;
  return (
    <select className="join-recent" value="" aria-label={label || "Load a workspace file"}
      onChange={e => { const r = files.find(x => String(x.id) === e.target.value); if (r) onPick(r); e.target.value = ""; }}>
      <option value="" disabled>workspace…</option>
      {files.map(r => <option key={r.id} value={r.id}>{r.name} ({r.rows.toLocaleString()} rows)</option>)}
    </select>
  );
}

// "Send to ▾" menu — hands the current file/result to another tool via
// sendCSVToTool. Keyboard accessible: Escape closes, arrows move, focus returns.
const SEND_TARGETS = [
  { href: "/", label: "Dashboard" },
  { href: "/ask-csv", label: "Ask CSV" },
  { href: "/csv-editor", label: "Editor" },
  { href: "/csv-join", label: "Join with another file" },
  { href: "/csv-sql-query", label: "Query with SQL" },
  { href: "/csv-pipeline", label: "Pipeline" },
  { href: "/csv-dedupe", label: "Remove duplicates" },
  { href: "/csv-sort-filter", label: "Sort & filter" },
  { href: "/csv-profiler", label: "Profile columns" }
];
function SendToMenu({ getPayload, onError, primaryLabel }) {
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);
  const rootRef = useRef(null);
  const btnRef = useRef(null);
  const here = (typeof window !== "undefined" ? window.location.pathname : "").replace(/\.html$/, "").replace(/\/$/, "") || "/";
  const targets = SEND_TARGETS.filter(t => t.href !== here);
  useEffect(() => {
    if (!open) return;
    function onDown(e) { if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);
  function onKey(e) {
    if (!open) return;
    if (e.key === "Escape") { e.preventDefault(); setOpen(false); if (btnRef.current) btnRef.current.focus(); }
    else if (e.key === "ArrowDown") { e.preventDefault(); setIdx(i => Math.min(targets.length - 1, i + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setIdx(i => Math.max(0, i - 1)); }
    else if (e.key === "Enter") { e.preventDefault(); pick(targets[idx]); }
  }
  function pick(t) {
    if (!t) return;
    const p = getPayload ? getPayload() : null;
    setOpen(false);
    if (!p || !p.csv) { if (onError) onError("Load a file first — there's nothing to send yet."); return; }
    sendCSVToTool(t.href, p.csv, p.name, onError);
  }
  return (
    <div className="sendto" ref={rootRef} onKeyDown={onKey}>
      <button type="button" ref={btnRef} className="btn-ghost sendto-btn" aria-haspopup="menu" aria-expanded={open}
        onClick={() => { setOpen(o => !o); setIdx(0); }} title="Hand this data to another tool — it travels inside your browser, never to a server">
        {primaryLabel || "Send to"} <span aria-hidden="true">▾</span>
      </button>
      {open && (
        <div className="sendto-menu" role="menu" aria-label="Send to tool">
          {targets.map((t, i) => (
            <button type="button" key={t.href} role="menuitem" className={"sendto-item" + (i === idx ? " active" : "")}
              onMouseEnter={() => setIdx(i)} onClick={() => pick(t)}>
              {t.label}
            </button>
          ))}
          <div className="sendto-hint" aria-hidden="true">more tools: Ctrl+K</div>
        </div>
      )}
    </div>
  );
}

// =================== Shared a11y helpers ===================
// Modal dialog behavior: focus moves in, Tab cycles, Escape closes, focus
// returns to the opener on unmount. Attach to the modal CARD element.
function useModalA11y(ref, onClose) {
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const prev = document.activeElement;
    const sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const first = node.querySelector(sel);
    (first || node).focus({ preventScroll: true });
    function onKey(e) {
      if (e.key === "Escape") { e.stopPropagation(); onClose && onClose(); return; }
      if (e.key !== "Tab") return;
      const items = Array.from(node.querySelectorAll(sel)).filter(el => el.offsetParent !== null);
      if (!items.length) return;
      const i = items.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); items[items.length - 1].focus(); }
      else if (!e.shiftKey && (i === items.length - 1 || i === -1)) { e.preventDefault(); items[0].focus(); }
    }
    node.addEventListener("keydown", onKey);
    return () => {
      node.removeEventListener("keydown", onKey);
      if (prev && prev.focus) prev.focus({ preventScroll: true });
    };
  }, []);
}

// Respect prefers-reduced-motion in JS-driven scrolls.
function scrollBehavior() {
  try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"; } catch (e) { return "smooth"; }
}


/* global React */
// V6 Batch A — Ctrl+K command palette. Fuzzy-search every tool, your workspace
// files, and a couple of actions. Mounted once by App (so it exists on every
// React page). The tool index is generated at build time from tools.html
// (scripts/gen-palette-index.mjs → /palette-index.json) so it can never drift
// from the catalog — and it's fetched lazily on first open, costing the bundle
// nothing on pages where the palette is never used.
//
// Carrying files: when a shell has registered a current file
// (window.__csvtdGetCurrent) and the target tool can ingest CSV (x flag in the
// index), Enter hands the file over via sendCSVToTool; Shift+Enter opens the
// tool empty. Workspace entries load into THIS page when the current shell
// registered an ingest hook, else they open in the dashboard.

let __paletteIndexCache = null;
function ensurePaletteIndex() {
  if (__paletteIndexCache) return Promise.resolve(__paletteIndexCache);
  return fetch("/palette-index.json")
    .then(r => (r.ok ? r.json() : Promise.reject(new Error("HTTP " + r.status))))
    .then(j => { __paletteIndexCache = (j && j.tools) || []; return __paletteIndexCache; })
    .catch(() => {
      // Offline/dev fallback: at least the core destinations work.
      __paletteIndexCache = SEND_TARGETS.map(t => ({ t: t.label, u: t.href, d: "", c: "Tools", x: 1 }));
      return __paletteIndexCache;
    });
}

// Tiny fuzzy scorer: prefix > word-start > substring > subsequence; description
// and category matches add a little. Returns 0 for no match.
function paletteScore(q, item) {
  const t = item.t.toLowerCase(), d = (item.d || "").toLowerCase(), c = (item.c || "").toLowerCase();
  let s = 0;
  if (t.startsWith(q)) s = 100;
  else if (t.split(/[\s/&—-]+/).some(w => w.startsWith(q))) s = 80;
  else if (t.includes(q)) s = 60;
  else {
    let i = 0;
    for (const ch of t) { if (ch === q[i]) i++; if (i === q.length) break; }
    if (i === q.length) s = 25;
  }
  if (d.includes(q)) s += s ? 10 : 35;
  if (c.includes(q)) s += s ? 4 : 15;
  return s ? s - Math.min(20, Math.floor(t.length / 4)) : 0;
}

function CommandPalette() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [idx, setIdx] = useState(0);
  const [tools, setTools] = useState(null);
  const [wsFiles, setWsFiles] = useState([]);
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const boxRef = useRef(null);

  // Global shortcut — Ctrl+K / Cmd+K (and Escape to close, handled in the box).
  useEffect(() => {
    function onKey(e) {
      if ((e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setOpen(o => !o);
      }
    }
    window.addEventListener("keydown", onKey);
    window.__csvtdOpenPalette = () => setOpen(true);
    return () => { window.removeEventListener("keydown", onKey); window.__csvtdOpenPalette = null; };
  }, []);

  // Lazy data on first open + focus management.
  useEffect(() => {
    if (!open) return;
    setQ(""); setIdx(0);
    ensurePaletteIndex().then(setTools);
    if (wsEnabled()) recentGetAll().then(r => setWsFiles(r || [])).catch(() => {});
    else setWsFiles([]);
    const prev = document.activeElement;
    setTimeout(() => { if (inputRef.current) inputRef.current.focus({ preventScroll: true }); }, 0);
    function onDown(e) { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onDown);
    return () => {
      document.removeEventListener("mousedown", onDown);
      if (prev && prev.focus) prev.focus({ preventScroll: true });
    };
  }, [open]);

  const current = (typeof window !== "undefined" && window.__csvtdGetCurrent) ? window.__csvtdGetCurrent() : null;
  const canIngestHere = typeof window !== "undefined" && !!window.__csvtdIngest;

  const items = useMemo(() => {
    if (!open) return [];
    const here = window.location.pathname.replace(/\.html$/, "").replace(/\/$/, "") || "/";
    const query = q.trim().toLowerCase();
    const out = [];
    // Workspace files first (they're "yours")
    for (const r of wsFiles) {
      const label = "Open " + r.name;
      if (!query || label.toLowerCase().includes(query) || "workspace".includes(query)) {
        out.push({ kind: "file", t: label, d: r.rows.toLocaleString() + " rows · " + fmtBytes(r.bytes) + (canIngestHere ? " · opens here" : " · opens in dashboard"), rec: r, score: query ? 70 : 50 });
      }
    }
    // Actions
    const actions = [{ kind: "action", t: "Toggle dark / light mode", d: "Theme", run: () => { const b = document.querySelector(".theme-toggle"); if (b) b.click(); } }];
    for (const a of actions) {
      if (!query || a.t.toLowerCase().includes(query) || "theme dark light".includes(query)) out.push({ ...a, score: query ? 45 : 10 });
    }
    // Tools from the generated index
    if (tools) {
      for (const tl of tools) {
        const u = tl.u.replace(/\.html$/, "");
        if (u === here) continue;
        if (!query) { out.push({ kind: "tool", ...tl, score: 20 }); continue; }
        const s = paletteScore(query, tl);
        if (s > 0) out.push({ kind: "tool", ...tl, score: s });
      }
    }
    out.sort((a, b) => b.score - a.score);
    return out.slice(0, 12);
  }, [open, q, tools, wsFiles, canIngestHere]);

  useEffect(() => { setIdx(0); }, [q]);
  useEffect(() => {
    if (!listRef.current) return;
    const el = listRef.current.querySelector('[aria-selected="true"]');
    if (el && el.scrollIntoView) el.scrollIntoView({ block: "nearest" });
  }, [idx, items]);

  function run(item, plain) {
    if (!item) return;
    setOpen(false);
    if (item.kind === "action") { item.run(); return; }
    if (item.kind === "file") {
      if (canIngestHere && window.__csvtdIngest) window.__csvtdIngest(item.rec.csv, item.rec.name);
      else sendCSVToTool("/", item.rec.csv, item.rec.name);
      return;
    }
    const href = item.u;
    if (!plain && item.x && current && current.csv) sendCSVToTool(href, current.csv, current.name);
    else window.location.assign(href);
  }

  function onBoxKey(e) {
    if (e.key === "Escape") { e.preventDefault(); setOpen(false); }
    else if (e.key === "ArrowDown") { e.preventDefault(); setIdx(i => Math.min(items.length - 1, i + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setIdx(i => Math.max(0, i - 1)); }
    else if (e.key === "Enter") { e.preventDefault(); run(items[idx], e.shiftKey); }
  }

  if (!open) return null;
  const active = items[idx];
  const carrying = active && active.kind === "tool" && active.x && current && current.csv;
  return (
    <div className="palette-overlay">
      <div className="palette" ref={boxRef} role="dialog" aria-modal="true" aria-label="Command palette" onKeyDown={onBoxKey}>
        <input
          ref={inputRef}
          className="palette-input"
          type="text"
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Search tools, files, actions…"
          aria-label="Search tools, workspace files and actions"
          role="combobox"
          aria-expanded="true"
          aria-controls="palette-list"
          aria-activedescendant={active ? "palette-opt-" + idx : undefined}
          autoComplete="off"
          spellCheck="false"
        />
        <div className="palette-list" id="palette-list" role="listbox" aria-label="Results" ref={listRef}>
          {items.length === 0 && <div className="palette-empty">{tools ? "No matches — try a different word." : "Loading the tool index…"}</div>}
          {items.map((it, i) => (
            <div key={(it.u || it.t) + i} id={"palette-opt-" + i} role="option" aria-selected={i === idx}
              className={"palette-item" + (i === idx ? " active" : "")}
              onMouseEnter={() => setIdx(i)} onMouseDown={e => e.preventDefault()} onClick={e => run(it, e.shiftKey)}>
              <span className={"palette-kind palette-kind-" + it.kind} aria-hidden="true">{it.kind === "file" ? "⌗" : it.kind === "action" ? "◐" : "→"}</span>
              <span className="palette-item-title">{it.t}</span>
              <span className="palette-item-desc">{it.kind === "tool" ? (it.c || "") : (it.d || "")}</span>
            </div>
          ))}
        </div>
        <div className="palette-foot">
          <span><kbd>↑↓</kbd> navigate · <kbd>↵</kbd> open{carrying ? " with " + current.name : ""}{carrying ? <span> · <kbd>⇧↵</kbd> open empty</span> : null}</span>
          <span><kbd>esc</kbd> close</span>
        </div>
      </div>
    </div>
  );
}


/* global React, CSVTool */
// V7 Batch A — ResultGrid: shared rich result table for tool outputs that are
// CSV strings. Concatenated after palette.jsx and BEFORE converter.jsx /
// tools*.jsx (build.mjs), so every shell can render it. The grid is
// presentation-only: copy / download / dashboard handoff and every test still
// read the raw CSV from the .conv-out-text textarea the shells keep below it.
//
// Per-tool dressing is keyed off RESHAPE_CONFIG.toolType:
//   correlation        → diverging heat cells (r in [-1,1]) + sticky row labels
//   crosstab           → value bars on numeric cells + sticky row labels
//   groupBy            → value bars on numeric cells
//   outliers (flag)    → severity pill (σ distance) + row tint on flagged rows
// Everything else gets the plain sortable grid.

const RG_MAX_CHARS = 4 * 1024 * 1024; // past this the grid bows out (raw textarea remains)
const RG_PAGE = 300;                  // rows rendered initially / added per click

// A shell shows the grid (and shrinks the raw textarea) only when this passes.
function rgGridable(result) {
  return !!(result && result.csv && !result.error && result.csv.length <= RG_MAX_CHARS);
}

// Column is numeric if ≥80% of its non-blank sampled values parse as numbers.
function rgNumericCols(headers, rows) {
  const sample = rows.length > 500 ? rows.slice(0, 500) : rows;
  const out = {};
  for (const h of headers) {
    let seen = 0, num = 0;
    for (const r of sample) {
      const v = r[h];
      if (v === "" || v == null) continue;
      seen++;
      if (CSVTool.parseNumber(v) != null) num++;
    }
    out[h] = seen > 0 && num / seen >= 0.8;
  }
  return out;
}

// Diverging heat for correlation cells: teal for positive, rust for negative,
// alpha scaled by |r|. Plain rgba so it reads on both themes (and on browsers
// without color-mix).
function rgHeatColor(v) {
  const n = CSVTool.parseNumber(v);
  if (n == null || isNaN(n)) return null;
  const a = 0.1 + 0.45 * Math.min(1, Math.abs(n));
  return n >= 0 ? "rgba(18,152,124," + a.toFixed(3) + ")" : "rgba(226,92,61," + a.toFixed(3) + ")";
}

function ResultGrid({ csv, toolType, opts }) {
  const [sort, setSort] = useState(null); // { h, dir }
  const [shown, setShown] = useState(RG_PAGE);

  const parsed = useMemo(() => {
    if (!csv || csv.length > RG_MAX_CHARS) return null;
    try {
      const p = CSVTool.parseCSV(csv);
      if (!p || !p.headers || !p.headers.length) return null;
      return p;
    } catch (e) { return null; }
  }, [csv]);

  // new result → reset paging + sort
  useEffect(() => { setShown(RG_PAGE); setSort(null); }, [csv]);

  const numCols = useMemo(() => parsed ? rgNumericCols(parsed.headers, parsed.rows) : {}, [parsed]);

  const kind = toolType === "correlation" ? "heat"
    : toolType === "outliers" ? "outliers"
    : (toolType === "groupBy" || toolType === "crosstab") ? "bars"
    : "plain";
  const stickyFirst = toolType === "correlation" || toolType === "crosstab";

  // outliers (flag mode): the appended flag column + σ distance per flagged row,
  // from the result itself — mean/std over the flagged column's numeric values.
  const outlierInfo = useMemo(() => {
    if (kind !== "outliers" || !parsed) return null;
    const flagCol = parsed.headers[parsed.headers.length - 1];
    if (!/^is_outlier/.test(flagCol)) return null; // keep/remove modes have no flag column
    const valCol = opts && opts.column && parsed.headers.indexOf(opts.column) >= 0 ? opts.column : null;
    let mean = 0, std = 0;
    if (valCol) {
      let n = 0, sum = 0;
      for (const r of parsed.rows) { const v = CSVTool.parseNumber(r[valCol]); if (v != null && isFinite(v)) { n++; sum += v; } }
      if (n > 1) {
        mean = sum / n;
        let sq = 0;
        for (const r of parsed.rows) { const v = CSVTool.parseNumber(r[valCol]); if (v != null && isFinite(v)) { const d = v - mean; sq += d * d; } }
        std = Math.sqrt(sq / n);
      }
    }
    return { flagCol, valCol, mean, std };
  }, [kind, parsed, opts]);

  // crosstab appends a grand-total row — pin it to the bottom (it must not sort
  // into the body) and keep it out of the bar scale.
  const isTotalRow = row => toolType === "crosstab" && row[parsed.headers[0]] === "Total";

  // bars: per numeric column, max value — only when the column is all ≥ 0
  const barMax = useMemo(() => {
    if (kind !== "bars" || !parsed || parsed.rows.length > 2000) return null;
    const out = {};
    for (const h of parsed.headers) {
      if (!numCols[h]) continue;
      let max = 0, ok = true;
      for (const r of parsed.rows) {
        if (isTotalRow(r)) continue;
        const v = CSVTool.parseNumber(r[h]);
        if (v == null || isNaN(v)) continue;
        if (v < 0) { ok = false; break; }
        if (v > max) max = v;
      }
      if (ok && max > 0) out[h] = max;
    }
    return out;
  }, [kind, parsed, numCols]);

  const rows = useMemo(() => {
    if (!parsed) return [];
    const body = parsed.rows.filter(r => !isTotalRow(r));
    const totals = parsed.rows.filter(isTotalRow);
    if (!sort) return totals.length ? body.concat(totals) : parsed.rows;
    const { h, dir } = sort;
    const mul = dir === "asc" ? 1 : -1;
    const isNum = numCols[h];
    return body.slice().sort((a, b) => {
      const x = a[h], y = b[h];
      if (x === "" && y === "") return 0;
      if (x === "") return 1; // blanks last either direction
      if (y === "") return -1;
      if (isNum) {
        const nx = CSVTool.parseNumber(x), ny = CSVTool.parseNumber(y);
        if (nx != null && ny != null) return (nx - ny) * mul;
      }
      return String(x).localeCompare(String(y)) * mul;
    }).concat(totals);
  }, [parsed, sort, numCols, toolType]);

  if (!csv) return null;
  if (csv.length > RG_MAX_CHARS) {
    return <div className="rg-note">Result is too large for the table preview — the raw CSV below and Download still have everything.</div>;
  }
  if (!parsed) return null;

  function clickSort(h) {
    setSort(s => (s && s.h === h) ? { h, dir: s.dir === "asc" ? "desc" : "asc" } : { h, dir: "asc" });
  }

  function cellProps(h, hIdx, row) {
    const v = row[h];
    const props = { className: "", style: null };
    if (numCols[h]) props.className = "num";
    if (kind === "heat" && hIdx > 0) {
      const bg = rgHeatColor(v);
      if (bg) props.style = { background: bg };
    } else if (kind === "bars" && barMax && barMax[h] && !(stickyFirst && hIdx === 0) && !isTotalRow(row)) {
      const n = CSVTool.parseNumber(v);
      if (n != null && n >= 0) {
        // bottom-anchored data bar (full-height fills read as a checkerboard)
        const w = Math.max(0, Math.min(100, (n / barMax[h]) * 100));
        props.style = { background: "linear-gradient(to right, rgba(18,152,124,0.55) " + w.toFixed(1) + "%, transparent " + w.toFixed(1) + "%) left bottom / 100% 3px no-repeat" };
      }
    }
    return props;
  }

  const visible = rows.length > shown ? rows.slice(0, shown) : rows;

  return (
    <div className={"rg-wrap" + (stickyFirst ? " rg-sticky" : "")}>
      <div className="rg-scroll table-scroll">
        <table className="data rg-table">
          <thead>
            <tr>
              {parsed.headers.map((h, hIdx) => {
                // matrix outputs: the corner header is blank in the CSV; parseCSV
                // auto-names it column_1 — show it blank again
                const label = (stickyFirst && hIdx === 0 && h === "column_1") ? "" : h;
                return (
                <th key={h} className={numCols[h] ? "num" : ""} aria-sort={sort && sort.h === h ? (sort.dir === "asc" ? "ascending" : "descending") : undefined}>
                  <button className="th-sort" onClick={() => clickSort(h)} title={"Sort by " + (label || "row label")}>
                    {label || " "}
                    <span className="th-sort-glyph">{sort && sort.h === h ? (sort.dir === "asc" ? "▲" : "▼") : "↕"}</span>
                  </button>
                </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {visible.map((row, i) => {
              const flagged = outlierInfo && row[outlierInfo.flagCol] === "true";
              return (
                <tr key={i} className={flagged ? "anomaly-row" : isTotalRow(row) ? "rg-total-row" : ""}>
                  {parsed.headers.map((h, hIdx) => {
                    if (outlierInfo && h === outlierInfo.flagCol) {
                      if (!flagged) return <td key={h} className="rg-false">–</td>;
                      let label = "outlier", cls = "rg-sev-lo";
                      if (outlierInfo.valCol && outlierInfo.std > 0) {
                        const v = CSVTool.parseNumber(row[outlierInfo.valCol]);
                        if (v != null && isFinite(v)) {
                          const z = Math.abs(v - outlierInfo.mean) / outlierInfo.std;
                          label = z.toFixed(1) + "σ";
                          cls = z >= 4 ? "rg-sev-hi" : z >= 3 ? "rg-sev-mid" : "rg-sev-lo";
                        }
                      }
                      return <td key={h}><span className={"rg-sev " + cls}>{label}</span></td>;
                    }
                    const p = cellProps(h, hIdx, row);
                    return <td key={h} className={p.className} style={p.style}>{row[h]}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {(rows.length > shown || rows.length > RG_PAGE) && (
        <div className="rg-foot">
          <span>{Math.min(shown, rows.length).toLocaleString()} of {rows.length.toLocaleString()} rows</span>
          {rows.length > shown && <button className="rg-more-btn" onClick={() => setShown(n => n + 1000)}>Show 1,000 more</button>}
          {rows.length > shown && rows.length - shown <= 5000 && <button className="rg-more-btn" onClick={() => setShown(rows.length)}>Show all</button>}
        </div>
      )}
    </div>
  );
}


/* global React, CSVTool, XLSX */
// Converter engine — type inference + format converters + ConverterShell + InsightStrip.
// Concatenated into bundle.js after charts.jsx, before app.jsx.

// Shared value-integrity helpers — defined at module top so BOTH the main
// converter IIFE and the Phase-5 helper scope (csvToYAML, geo, …) can use them.

// A raw number cell is "clean" only if its canonical JS rendering equals the
// source text — otherwise emitting it as a number would drop leading zeros
// (ZIP "02134"), lose >15-digit integer precision, strip a leading +, mangle
// thousands separators, or turn tiny/huge values into 1e-8 notation. Such values
// must be preserved verbatim (as strings) rather than silently corrupted.
function numberRoundTrips(raw) {
  const t = String(raw).trim();
  if (t === "") return true;
  const n = CSVTool.parseNumber(t);
  if (n == null || isNaN(n)) return false;
  return String(n) === t.replace(/^\+/, "");
}
// True iff EVERY non-empty value in a number column round-trips cleanly.
// Memoized on the column (data-derived, so stable for a given dataset).
function numberColClean(col) {
  if (col.__numClean === undefined) {
    col.__numClean = (col.values || []).every(v => v == null || String(v).trim() === "" || numberRoundTrips(v));
  }
  return col.__numClean;
}
// Format a date cell as a canonical ISO date/datetime, preserving the exact
// wall-clock the user typed in ANY timezone. ISO-shaped input is kept verbatim
// (no UTC round-trip); other formats are parsed and rendered from LOCAL parts.
function isoDateParts(raw) {
  const t = String(raw).trim();
  const m = t.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (m) {
    return { day: m[1] + "-" + m[2] + "-" + m[3], time: m[4] ? m[4] + ":" + m[5] + ":" + (m[6] || "00") : "00:00:00", hasTime: !!m[4] };
  }
  const d = CSVTool.parseDate(t);
  if (!d || isNaN(d)) return null;
  const p = n => String(n).padStart(2, "0");
  return { day: d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate()), time: p(d.getHours()) + ":" + p(d.getMinutes()) + ":" + p(d.getSeconds()), hasTime: /\d{1,2}:\d{2}/.test(t) };
}

// =========================================================================
// Type inference (the quality moat — competitors output everything as strings)
// =========================================================================
const Convert = (function () {

  // Identifier safe-ifier for SQL column/table names
  function sqlIdent(name) {
    const cleaned = String(name).trim().replace(/[^A-Za-z0-9_]/g, "_").replace(/^([0-9])/, "_$1");
    return cleaned || "col";
  }
  function xmlIdent(name) {
    let s = String(name).trim().replace(/[^A-Za-z0-9_-]/g, "_");
    if (/^[0-9-]/.test(s) || /^xml/i.test(s)) s = "_" + s;
    return s || "field";
  }

  // Infer the right SQL column type from a profile column.
  // Outputs: BOOLEAN, INT, BIGINT, DECIMAL(p,s), DATE, TIMESTAMP, VARCHAR(n), TEXT
  function inferSQLType(col) {
    if (col.type === "boolean") return "BOOLEAN";
    if (col.type === "date") {
      const hasTime = (col.values || []).some(v => /\d{1,2}:\d{2}/.test(String(v || "")));
      return hasTime ? "TIMESTAMP" : "DATE";
    }
    if (col.type === "number" && numberColClean(col)) {
      const nums = col.nums || [];
      if (nums.length === 0) return "VARCHAR(255)";
      const allInt = nums.every(n => Number.isInteger(n));
      if (allInt) {
        const maxAbs = Math.max(Math.abs(col.min || 0), Math.abs(col.max || 0));
        return maxAbs > 2147483647 ? "BIGINT" : "INT";
      }
      // Decimal — find max precision (digits before .) and scale (digits after .)
      let maxIntDigits = 1, maxScale = 0;
      for (const n of nums) {
        const s = String(n);
        const [intPart, fracPart = ""] = s.replace(/^-/, "").split(".");
        if (intPart.length > maxIntDigits) maxIntDigits = intPart.length;
        if (fracPart.length > maxScale) maxScale = fracPart.length;
      }
      return `DECIMAL(${maxIntDigits + maxScale},${maxScale})`;
    }
    // text / category
    const values = col.values || [];
    let maxLen = 0;
    for (const v of values) {
      const s = String(v == null ? "" : v);
      if (s.length > maxLen) maxLen = s.length;
    }
    if (maxLen > 255) return "TEXT";
    return `VARCHAR(${Math.max(10, maxLen + 10)})`;
  }

  // Render a raw cell value for SQL (quote strings, leave numbers/booleans/null bare)
  function sqlValue(raw, col) {
    if (raw === "" || raw == null) return "NULL";
    if (col.type === "boolean") {
      const s = String(raw).toLowerCase();
      return (s === "true" || s === "yes" || s === "1" || s === "y") ? "TRUE" : "FALSE";
    }
    if (col.type === "number" && numberColClean(col)) {
      const n = CSVTool.parseNumber(raw);
      return n == null ? "NULL" : String(n);
    }
    if (col.type === "date") {
      const dp = isoDateParts(raw);
      if (!dp) return "NULL";
      return dp.hasTime ? `'${dp.day} ${dp.time}'` : `'${dp.day}'`;
    }
    // text / category, or a "number" column that doesn't round-trip cleanly
    // (ZIP/ID/big-int/sci-notation) — preserve the exact source as a string.
    const s = String(raw).replace(/'/g, "''");
    return `'${s}'`;
  }

  // Render a cell value for JSON with correct types
  function jsonValue(raw, col, normalizeDates) {
    if (raw === "" || raw == null) return null;
    if (col.type === "boolean") {
      const s = String(raw).toLowerCase();
      return s === "true" || s === "yes" || s === "1" || s === "y";
    }
    if (col.type === "number") {
      if (numberColClean(col)) { const n = CSVTool.parseNumber(raw); return n == null ? null : n; }
      return String(raw).trim(); // preserve ZIP/ID/big-int/sci-notation verbatim as a string
    }
    if (col.type === "date" && normalizeDates) {
      const dp = isoDateParts(raw);
      return dp ? dp.day : String(raw);
    }
    return String(raw);
  }

  // CSV-safe escape
  function csvEscape(v) {
    const s = v == null ? "" : String(v);
    return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }
  // Markdown cell escape (pipes break the table)
  function mdEscape(v) {
    return String(v == null ? "" : v).replace(/\|/g, "\\|").replace(/\n/g, " ");
  }
  function xmlEscape(v) {
    return String(v == null ? "" : v)
      // Drop control chars XML 1.0 forbids (keep Tab/LF/CR) so a stray byte in a
      // cell doesn't make the document not-well-formed.
      .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, "")
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&apos;");
  }
  function htmlEscape(v) {
    return String(v == null ? "" : v)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  // =====================================================================
  // OUTPUT BUILDERS
  // (Branding comments included for formats that support comments — never
  //  in JSON, since JSON forbids them.)
  // =====================================================================

  function csvToJSON(profile, opts) {
    opts = opts || {};
    const normalizeDates = !!opts.normalizeDates;
    const indent = opts.minified ? 0 : 2;
    const out = profile.rows.map(r => {
      const o = {};
      for (const c of profile.cols) {
        o[c.name] = jsonValue(r[c.name], c, normalizeDates);
      }
      return o;
    });
    return JSON.stringify(out, null, indent);
  }

  function csvToSQL(profile, opts) {
    opts = opts || {};
    const table = sqlIdent(opts.tableName || "csv_data");
    const includeCreate = opts.includeCreate !== false;
    const batch = Math.max(1, opts.batchSize || 100);
    // De-dup sanitized identifiers — distinct headers like "a b" and "a-b" both
    // become "a_b", which would emit a duplicate-column CREATE TABLE that no
    // engine accepts. Suffix collisions (_2, _3) instead.
    const seenId = {};
    const idents = profile.cols.map(c => {
      let id = sqlIdent(c.name);
      if (seenId[id] === undefined) { seenId[id] = 1; return id; }
      let k = seenId[id], cand;
      do { k++; cand = id + "_" + k; } while (seenId[cand] !== undefined);
      seenId[id] = k; seenId[cand] = 1; return cand;
    });
    const lines = [];
    lines.push("-- Generated by csvtodashboard.com — convert + visualize your CSV");
    lines.push(`-- ${profile.rows.length} rows · ${profile.cols.length} columns`);
    lines.push("");
    if (includeCreate) {
      lines.push(`CREATE TABLE ${table} (`);
      lines.push(profile.cols.map((c, i) => `  ${idents[i]} ${inferSQLType(c)}`).join(",\n"));
      lines.push(");");
      lines.push("");
    }
    const colList = idents.join(", ");
    // Batch INSERTs for smaller output
    for (let i = 0; i < profile.rows.length; i += batch) {
      const slice = profile.rows.slice(i, i + batch);
      const rowValues = slice.map(r =>
        "(" + profile.cols.map(c => sqlValue(r[c.name], c)).join(", ") + ")"
      );
      lines.push(`INSERT INTO ${table} (${colList}) VALUES`);
      lines.push(rowValues.join(",\n") + ";");
      lines.push("");
    }
    return lines.join("\n");
  }

  function csvToMarkdown(profile, opts) {
    opts = opts || {};
    const out = [];
    if (opts.includeComment !== false) {
      out.push("<!-- Generated by csvtodashboard.com — convert + visualize your CSV -->");
      out.push("");
    }
    out.push("| " + profile.cols.map(c => mdEscape(c.name)).join(" | ") + " |");
    // V7 E — alignment override; "auto" keeps the numbers-right default
    const align = opts.align || "auto";
    const sep = c => align === "left" ? "---" : align === "center" ? ":---:" : align === "right" ? "---:" : (c.type === "number" ? "---:" : "---");
    out.push("| " + profile.cols.map(sep).join(" | ") + " |");
    for (const r of profile.rows) {
      out.push("| " + profile.cols.map(c => mdEscape(r[c.name])).join(" | ") + " |");
    }
    return out.join("\n");
  }

  function csvToHTML(profile, opts) {
    opts = opts || {};
    const standalone = !!opts.standalone;
    const lines = [];
    if (standalone) {
      lines.push("<!doctype html>");
      lines.push('<html><head><meta charset="utf-8" />');
      lines.push("<title>Data</title>");
      lines.push("<style>body{font-family:system-ui,sans-serif;padding:24px}table{border-collapse:collapse;margin:0 auto}th,td{border:1px solid #ddd;padding:8px 12px;text-align:left}th{background:#f6f5ee;font-weight:600}tr:nth-child(even) td{background:#fafaf6}</style>");
      lines.push("</head><body>");
    }
    lines.push("<!-- Generated by csvtodashboard.com — convert + visualize your CSV -->");
    lines.push('<table class="csvtd-table">');
    lines.push("  <thead><tr>");
    for (const c of profile.cols) lines.push(`    <th>${htmlEscape(c.name)}</th>`);
    lines.push("  </tr></thead>");
    lines.push("  <tbody>");
    for (const r of profile.rows) {
      lines.push("    <tr>");
      for (const c of profile.cols) {
        const align = c.type === "number" ? ' style="text-align:right"' : "";
        lines.push(`      <td${align}>${htmlEscape(r[c.name])}</td>`);
      }
      lines.push("    </tr>");
    }
    lines.push("  </tbody>");
    lines.push("</table>");
    if (standalone) lines.push("</body></html>");
    return lines.join("\n");
  }

  function csvToXML(profile, opts) {
    opts = opts || {};
    const rootName = xmlIdent(opts.rootName || "data");
    const rowName = xmlIdent(opts.rowName || "row");
    const lines = [];
    lines.push('<?xml version="1.0" encoding="UTF-8"?>');
    lines.push("<!-- Generated by csvtodashboard.com — convert + visualize your CSV -->");
    lines.push(`<${rootName}>`);
    for (const r of profile.rows) {
      lines.push(`  <${rowName}>`);
      for (const c of profile.cols) {
        const tag = xmlIdent(c.name);
        lines.push(`    <${tag}>${xmlEscape(r[c.name])}</${tag}>`);
      }
      lines.push(`  </${rowName}>`);
    }
    lines.push(`</${rootName}>`);
    return lines.join("\n");
  }

  // Outputs a binary XLSX as a Uint8Array (caller wraps in Blob for download)
  // V7 E — opts: { sheetName, autoFilter, autoWidth }. Freeze panes and cell
  // styling are SheetJS PRO features — deliberately not offered.
  function csvToExcel(profile, opts) {
    opts = opts || {};
    if (typeof XLSX === "undefined") throw new Error("XLSX library not loaded");
    const headers = profile.cols.map(c => c.name);
    const rows = profile.rows.map(r => {
      const out = {};
      for (const c of profile.cols) {
        const raw = r[c.name];
        if (raw === "" || raw == null) { out[c.name] = ""; continue; }
        // Only coerce to a real number when the WHOLE column round-trips cleanly
        // (matches the JSON/SQL gate at line ~126) — otherwise a leading-zero ZIP,
        // >15-digit ID or percent string would be silently corrupted into Excel.
        if (c.type === "number" && numberColClean(c)) out[c.name] = CSVTool.parseNumber(raw) ?? raw;
        else if (c.type === "boolean") {
          const s = String(raw).toLowerCase();
          out[c.name] = s === "true" || s === "yes" || s === "1" || s === "y";
        } else out[c.name] = raw;
      }
      return out;
    });
    const ws = XLSX.utils.json_to_sheet(rows, { header: headers });
    if (opts.autoWidth !== false) {
      // size each column to its longest value in a 200-row sample (8–44 chars)
      ws["!cols"] = headers.map(h => {
        let max = h.length;
        const n = Math.min(profile.rows.length, 200);
        for (let i = 0; i < n; i++) { const v = profile.rows[i][h]; if (v != null && String(v).length > max) max = String(v).length; }
        return { wch: Math.min(44, Math.max(8, max + 2)) };
      });
    }
    if (opts.autoFilter) {
      ws["!autofilter"] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: profile.rows.length, c: Math.max(0, headers.length - 1) } }) };
    }
    const wb = XLSX.utils.book_new();
    // Excel: ≤31 chars, no []:*?/\
    const sheet = (String(opts.sheetName || "Sheet1").replace(/[\[\]:*?\/\\]/g, " ").trim() || "Sheet1").slice(0, 31);
    XLSX.utils.book_append_sheet(wb, ws, sheet);
    return new Uint8Array(XLSX.write(wb, { type: "array", bookType: "xlsx" }));
  }

  // ============== Reverse converters (X → CSV) ==============

  function flatten(obj, prefix) {
    const out = {};
    prefix = prefix || "";
    if (obj == null || typeof obj !== "object") return { [prefix || "value"]: obj };
    if (Array.isArray(obj)) {
      return { [prefix || "value"]: obj.map(x => typeof x === "object" ? JSON.stringify(x) : String(x)).join("; ") };
    }
    for (const k of Object.keys(obj)) {
      const v = obj[k];
      const path = prefix ? prefix + "." + k : k;
      if (v != null && typeof v === "object" && !Array.isArray(v)) {
        Object.assign(out, flatten(v, path));
      } else if (Array.isArray(v)) {
        const allPrim = v.every(x => x == null || typeof x !== "object");
        if (allPrim) out[path] = v.join("; ");
        else out[path] = JSON.stringify(v);
      } else {
        out[path] = v == null ? "" : v;
      }
    }
    return out;
  }

  function jsonToCSV(text) {
    let data;
    try { data = JSON.parse(text); }
    catch (e) { throw new Error("Invalid JSON: " + e.message); }

    let rows;
    if (Array.isArray(data)) {
      rows = data;
    } else if (data && typeof data === "object") {
      const keys = Object.keys(data);
      const allArrays = keys.length > 0 && keys.every(k => Array.isArray(data[k]));
      if (allArrays) {
        // Column-oriented → row-oriented
        const n = Math.max(0, ...keys.map(k => data[k].length));
        rows = [];
        for (let i = 0; i < n; i++) {
          const o = {};
          for (const k of keys) o[k] = data[k][i] ?? "";
          rows.push(o);
        }
      } else {
        rows = [data];
      }
    } else {
      throw new Error("JSON must be an array of objects or an object.");
    }

    if (rows.length === 0) return "";
    const flatRows = rows.map(r => (r && typeof r === "object") ? flatten(r) : { value: r });
    const seen = new Set();
    const headers = [];
    for (const r of flatRows) for (const k of Object.keys(r)) {
      if (!seen.has(k)) { seen.add(k); headers.push(k); }
    }
    const lines = [headers.map(csvEscape).join(",")];
    for (const r of flatRows) {
      lines.push(headers.map(h => csvEscape(r[h])).join(","));
    }
    return lines.join("\n");
  }

  // Accepts ArrayBuffer; returns array of { name, csv, rowCount } per sheet
  function excelToCSV(buf) {
    if (typeof XLSX === "undefined") throw new Error("XLSX library not loaded");
    const wb = XLSX.read(buf, { type: "array" });
    const all = wb.SheetNames.map(name => {
      const csv = XLSX.utils.sheet_to_csv(wb.Sheets[name]);
      // Data rows = non-blank lines minus the header (so the sheet picker shows a
      // real count instead of "— rows").
      const nonBlank = csv.split("\n").filter(l => l.trim() !== "").length;
      return { name, csv, rowCount: Math.max(0, nonBlank - 1) };
    });
    // Hide empty sheets from the picker, but keep at least one so the "no rows"
    // error can fire for an all-empty workbook.
    const withData = all.filter(s => s.rowCount > 0);
    return withData.length ? withData : all.slice(0, 1);
  }

  // ============== Output downloader ==============

  function download(content, filename, mime) {
    const blob = content instanceof Uint8Array
      ? new Blob([content], { type: mime || "application/octet-stream" })
      : new Blob([content], { type: (mime || "text/plain") + ";charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  // =====================================================================
  // PHASE 2 — Clean / Analyze CSV tools (dedupe, split, sortFilter, validate, sqlQuery)
  // Each takes a profile + opts. Returns either { csv, stats } or { chunks, stats }
  // for split; validate returns { issues, stats } since the "output" is a report.
  // =====================================================================

  function buildCSV(headers, rows) {
    const out = [headers.map(csvEscape).join(",")];
    for (const r of rows) {
      out.push(headers.map(h => csvEscape(r[h])).join(","));
    }
    return out.join("\n");
  }

  function compareCell(va, vb, col) {
    if ((va === "" || va == null) && (vb === "" || vb == null)) return 0;
    if (va === "" || va == null) return 1;
    if (vb === "" || vb == null) return -1;
    if (col && col.type === "number") {
      const na = CSVTool.parseNumber(va), nb = CSVTool.parseNumber(vb);
      if (na === null && nb === null) return 0;
      if (na === null) return 1;
      if (nb === null) return -1;
      return na - nb;
    }
    if (col && col.type === "date") {
      const da = CSVTool.parseDate(va), db = CSVTool.parseDate(vb);
      if (!da && !db) return 0; if (!da) return 1; if (!db) return -1;
      return +da - +db;
    }
    return String(va).localeCompare(String(vb));
  }

  function dedupe(profile, opts) {
    opts = opts || {};
    const headers = profile.cols.map(c => c.name);
    const keys = (opts.columns && opts.columns.length > 0) ? opts.columns : headers;
    const caseInsensitive = !!opts.caseInsensitive;
    const seen = new Set();
    const kept = [];
    let dropped = 0;
    for (const r of profile.rows) {
      let k = keys.map(name => String(r[name] == null ? "" : r[name])).join("");
      if (caseInsensitive) k = k.toLowerCase();
      if (seen.has(k)) { dropped++; continue; }
      seen.add(k);
      kept.push(r);
    }
    return {
      csv: buildCSV(headers, kept),
      stats: { kept: kept.length, dropped, total: profile.rows.length, keys }
    };
  }

  function matchFilter(rawValue, op, target, col) {
    const sv = rawValue == null ? "" : String(rawValue);
    if (op === "is empty") return sv === "";
    if (op === "is not empty") return sv !== "";
    const t = target == null ? "" : String(target);
    const isNum = col && col.type === "number";
    const numTarget = isNum ? parseFloat(t) : NaN;
    if (op === "contains") return sv.toLowerCase().includes(t.toLowerCase());
    if (op === "does not contain") return !sv.toLowerCase().includes(t.toLowerCase());
    if (op === "starts with") return sv.toLowerCase().startsWith(t.toLowerCase());
    if (op === "ends with") return sv.toLowerCase().endsWith(t.toLowerCase());
    if (op === "=")  return isNum ? CSVTool.parseNumber(sv) === numTarget : sv === t;
    if (op === "≠")  return isNum ? CSVTool.parseNumber(sv) !== numTarget : sv !== t;
    if (op === ">")  return isNum ? CSVTool.parseNumber(sv) > numTarget  : sv > t;
    if (op === "<")  return isNum ? CSVTool.parseNumber(sv) < numTarget  : sv < t;
    if (op === "≥")  return isNum ? CSVTool.parseNumber(sv) >= numTarget : sv >= t;
    if (op === "≤")  return isNum ? CSVTool.parseNumber(sv) <= numTarget : sv <= t;
    return true;
  }

  function sortFilter(profile, opts) {
    opts = opts || {};
    const headers = profile.cols.map(c => c.name);
    let rows = profile.rows.slice();

    // Multi-filter: array of { col, op, value } joined by AND.
    // Legacy single-filter shape (filterCol/filterOp/filterValue) is supported as a fallback.
    let filters = Array.isArray(opts.filters) ? opts.filters.slice() : [];
    if (filters.length === 0 && opts.filterCol && opts.filterOp) {
      filters.push({ col: opts.filterCol, op: opts.filterOp, value: opts.filterValue });
    }
    // Drop incomplete filter rows
    filters = filters.filter(f => f && f.col && f.op);

    if (filters.length > 0) {
      rows = rows.filter(r => {
        for (const f of filters) {
          const col = profile.cols.find(c => c.name === f.col);
          if (!matchFilter(r[f.col], f.op, f.value, col)) return false;
        }
        return true;
      });
    }

    if (opts.sortCol) {
      const col = profile.cols.find(c => c.name === opts.sortCol);
      const dir = opts.sortDir === "desc" ? -1 : 1;
      rows.sort((a, b) => compareCell(a[opts.sortCol], b[opts.sortCol], col) * dir);
    }

    return {
      csv: buildCSV(headers, rows),
      stats: {
        rows: rows.length,
        of: profile.rows.length,
        sortedBy: opts.sortCol || null,
        filters: filters.length
      }
    };
  }

  function splitCSV(profile, opts) {
    opts = opts || {};
    const mode = opts.mode || "rowCount";
    const headers = profile.cols.map(c => c.name);
    const chunks = [];

    if (mode === "rowCount") {
      const n = Math.max(1, parseInt(opts.rowsPerFile, 10) || 1000);
      for (let i = 0; i < profile.rows.length; i += n) {
        chunks.push({
          name: "chunk-" + String(chunks.length + 1).padStart(3, "0") + ".csv",
          csv: buildCSV(headers, profile.rows.slice(i, i + n))
        });
      }
      return { chunks, stats: { files: chunks.length, mode: "every " + n + " rows" } };
    }

    if (mode === "fileCount") {
      const n = Math.max(1, parseInt(opts.numFiles, 10) || 2);
      const total = profile.rows.length;
      // Distribute the remainder so we get exactly min(n, total) files — a flat
      // ceil(total/n) exhausts the rows early and yields fewer files than asked.
      const base = Math.floor(total / n), rem = total % n;
      let idx = 0;
      for (let f = 0; f < n && idx < total; f++) {
        const take = base + (f < rem ? 1 : 0);
        if (take === 0) break;
        chunks.push({
          name: "chunk-" + String(chunks.length + 1).padStart(3, "0") + ".csv",
          csv: buildCSV(headers, profile.rows.slice(idx, idx + take))
        });
        idx += take;
      }
      return { chunks, stats: { files: chunks.length, mode: "into " + n + " files" } };
    }

    // by column value
    const colName = opts.byColumn || headers[0];
    const groups = new Map();
    for (const r of profile.rows) {
      const k = String(r[colName] == null ? "" : r[colName]);
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k).push(r);
    }
    const usedNames = new Set();
    for (const [k, rows] of groups) {
      const safe = (k || "blank").replace(/[^A-Za-z0-9_-]/g, "_").slice(0, 40);
      // Distinct group values can sanitize to the same name (e.g. "a/b" and "a-b");
      // de-dup so the zip doesn't drop one entry / collide.
      let name = colName + "-" + safe, n = 1;
      while (usedNames.has(name + ".csv")) name = colName + "-" + safe + "_" + (++n);
      usedNames.add(name + ".csv");
      chunks.push({ name: name + ".csv", csv: buildCSV(headers, rows) });
    }
    return { chunks, stats: { files: chunks.length, mode: "by " + colName } };
  }

  // ============== Inline ZIP writer (stored mode — no compression) ==============
  // Produces a valid .zip file with the listed files. Stored mode keeps the writer
  // tiny (~80 lines) at the cost of no compression; CSV is already small per file.
  let _crcTable = null;
  function crc32(bytes) {
    if (!_crcTable) {
      _crcTable = new Uint32Array(256);
      for (let i = 0; i < 256; i++) {
        let c = i;
        for (let k = 0; k < 8; k++) c = (c & 1) ? (0xedb88320 ^ (c >>> 1)) : (c >>> 1);
        _crcTable[i] = c;
      }
    }
    let crc = 0xffffffff;
    for (let i = 0; i < bytes.length; i++) crc = _crcTable[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
    return (crc ^ 0xffffffff) >>> 0;
  }

  function buildZip(files) {
    // files: [{ name: string, content: string }]
    const enc = new TextEncoder();
    const parts = []; // Uint8Array pieces, in order: each local header + data, then central dir, then EOCD
    const central = [];
    let offset = 0;

    for (const f of files) {
      const nameBytes = enc.encode(f.name);
      const dataBytes = enc.encode(f.content);
      const crc = crc32(dataBytes);

      const lh = new ArrayBuffer(30 + nameBytes.length);
      const lhView = new DataView(lh);
      lhView.setUint32(0, 0x04034b50, true);
      lhView.setUint16(4, 20, true);           // version needed
      lhView.setUint16(6, 0, true);            // flags
      lhView.setUint16(8, 0, true);            // method 0 = stored
      lhView.setUint16(10, 0, true);           // mod time
      lhView.setUint16(12, 0x21, true);        // mod date (arbitrary valid)
      lhView.setUint32(14, crc, true);
      lhView.setUint32(18, dataBytes.length, true);
      lhView.setUint32(22, dataBytes.length, true);
      lhView.setUint16(26, nameBytes.length, true);
      lhView.setUint16(28, 0, true);
      const lhBytes = new Uint8Array(lh);
      lhBytes.set(nameBytes, 30);
      parts.push(lhBytes, dataBytes);

      const cd = new ArrayBuffer(46 + nameBytes.length);
      const cdView = new DataView(cd);
      cdView.setUint32(0, 0x02014b50, true);
      cdView.setUint16(4, 20, true);
      cdView.setUint16(6, 20, true);
      cdView.setUint16(8, 0, true);
      cdView.setUint16(10, 0, true);
      cdView.setUint16(12, 0, true);
      cdView.setUint16(14, 0x21, true);
      cdView.setUint32(16, crc, true);
      cdView.setUint32(20, dataBytes.length, true);
      cdView.setUint32(24, dataBytes.length, true);
      cdView.setUint16(28, nameBytes.length, true);
      cdView.setUint16(30, 0, true);
      cdView.setUint16(32, 0, true);
      cdView.setUint16(34, 0, true);
      cdView.setUint16(36, 0, true);
      cdView.setUint32(38, 0, true);
      cdView.setUint32(42, offset, true);
      const cdBytes = new Uint8Array(cd);
      cdBytes.set(nameBytes, 46);
      central.push(cdBytes);

      offset += lhBytes.length + dataBytes.length;
    }

    const cdSize = central.reduce((s, b) => s + b.length, 0);
    const cdOffset = offset;

    const eocd = new ArrayBuffer(22);
    const ev = new DataView(eocd);
    ev.setUint32(0, 0x06054b50, true);
    ev.setUint16(4, 0, true);
    ev.setUint16(6, 0, true);
    ev.setUint16(8, files.length, true);
    ev.setUint16(10, files.length, true);
    ev.setUint32(12, cdSize, true);
    ev.setUint32(16, cdOffset, true);
    ev.setUint16(20, 0, true);
    parts.push(...central, new Uint8Array(eocd));

    // Concatenate
    const total = parts.reduce((s, p) => s + p.length, 0);
    const out = new Uint8Array(total);
    let o = 0;
    for (const p of parts) { out.set(p, o); o += p.length; }
    return out;
  }

  function validateCSV(profile, csvText) {
    const issues = [];
    const totalCells = profile.rows.length * profile.cols.length;

    // ===== Raw-text checks (need the original CSV, not just the parsed profile) =====
    if (typeof csvText === "string" && csvText.length > 0) {
      const rawLines = csvText.replace(/\r\n/g, "\n").split("\n");
      while (rawLines.length && rawLines[rawLines.length - 1] === "") rawLines.pop();

      // a) Bad delimiter — compare , vs ; vs \t vs | counts on the header line
      if (rawLines.length > 0) {
        const head = rawLines[0];
        const cs = (head.match(/,/g) || []).length;
        const se = (head.match(/;/g) || []).length;
        const ta = (head.match(/\t/g) || []).length;
        const pi = (head.match(/\|/g) || []).length;
        const dominant = Math.max(se, ta, pi);
        if (cs === 0 && dominant >= 1) {
          const name = se === dominant ? "semicolon" : ta === dominant ? "tab" : "pipe";
          // The parser auto-detects the delimiter, so a non-comma file now splits
          // into real columns rather than collapsing to one. Reflect that: if it
          // parsed cleanly it's informational ("detected, and handled"); if it
          // still came out as a single column, it's a genuine high-severity problem.
          const handled = profile.cols.length > 1;
          issues.push({
            kind: "bad-delimiter", severity: handled ? "medium" : "high",
            message: handled ? `Detected a ${name} delimiter` : `Looks ${name}-separated, not comma-separated`,
            detail: handled
              ? `This file uses ${name}s, not commas — it parsed correctly here, but re-save as standard CSV (commas) if another tool struggles with it.`
              : `header line has ${dominant} ${name}${dominant === 1 ? "" : "s"} but no commas — re-save as standard CSV (commas) for best results`
          });
        } else if (dominant > cs * 2 && cs >= 1) {
          const name = se === dominant ? "semicolon" : ta === dominant ? "tab" : "pipe";
          issues.push({
            kind: "bad-delimiter", severity: "medium",
            message: `Header line has more ${name}s than commas`,
            detail: `${dominant} ${name}${dominant === 1 ? "" : "s"} vs ${cs} comma${cs === 1 ? "" : "s"} — check the delimiter`
          });
        }
      }

      // b) Unbalanced quotes — total " across the file (escaped "" adds 2, so balanced files are always even)
      let quoteCount = 0;
      for (let i = 0; i < csvText.length; i++) if (csvText.charCodeAt(i) === 34) quoteCount++;
      if (quoteCount % 2 !== 0) {
        issues.push({
          kind: "unbalanced-quotes", severity: "high",
          message: "Unbalanced double quotes detected",
          detail: `${quoteCount} quote characters total — at least one quoted field is missing its closing quote`
        });
      }

      // c) Empty rows inside the data
      let emptyRows = 0;
      for (let i = 1; i < rawLines.length; i++) {
        if (rawLines[i].trim() === "") emptyRows++;
      }
      if (emptyRows > 0) {
        issues.push({
          kind: "empty-rows", severity: "low",
          message: `${emptyRows} empty row${emptyRows === 1 ? "" : "s"} in the file`,
          detail: "these get dropped automatically during parsing"
        });
      }

      // d) Broken / uneven rows — naive comma-split on lines without quotes
      const headerCells = (rawLines[0] || "").split(",").length;
      let brokenCount = 0;
      const brokenSamples = [];
      for (let i = 1; i < rawLines.length; i++) {
        const line = rawLines[i];
        if (line === "" || line.indexOf('"') >= 0) continue;
        const cells = line.split(",").length;
        if (cells !== headerCells) {
          brokenCount++;
          if (brokenSamples.length < 3) brokenSamples.push(`row ${i + 1}: ${cells} fields (expected ${headerCells})`);
        }
      }
      if (brokenCount > 0) {
        issues.push({
          kind: "uneven-rows", severity: brokenCount > 5 ? "high" : "medium",
          message: `${brokenCount} row${brokenCount === 1 ? "" : "s"} have a different column count than the header`,
          detail: brokenSamples.join(" · ")
        });
      }
    }

    // ===== Profile-based checks =====

    // 1) Missing values
    let missingTotal = 0;
    const missingByCol = {};
    for (const r of profile.rows) for (const c of profile.cols) {
      const v = r[c.name];
      if (v === "" || v == null) {
        missingTotal++;
        missingByCol[c.name] = (missingByCol[c.name] || 0) + 1;
      }
    }
    if (missingTotal > 0) {
      const cols = Object.keys(missingByCol).sort((a, b) => missingByCol[b] - missingByCol[a]);
      issues.push({
        kind: "missing",
        severity: missingTotal / totalCells > 0.2 ? "high" : "low",
        message: `${missingTotal} missing values across ${cols.length} column${cols.length === 1 ? "" : "s"}`,
        detail: cols.map(c => `${c}: ${missingByCol[c]}`).slice(0, 5).join(" · ")
      });
    }

    // 2) Type inconsistencies in numeric columns
    for (const c of profile.cols) {
      if (c.type === "number") {
        const bad = c.values.filter(v => v !== "" && v != null && CSVTool.parseNumber(v) === null);
        if (bad.length > 0) {
          issues.push({
            kind: "type-mismatch",
            severity: "medium",
            message: `${bad.length} non-numeric value${bad.length === 1 ? "" : "s"} in numeric column ${c.name}`,
            detail: "examples: " + bad.slice(0, 3).map(b => JSON.stringify(b)).join(", ")
          });
        }
      }
      if (c.type === "date") {
        const bad = c.values.filter(v => v !== "" && v != null && !CSVTool.parseDate(v));
        if (bad.length > 0) {
          issues.push({
            kind: "type-mismatch",
            severity: "medium",
            message: `${bad.length} unparseable date${bad.length === 1 ? "" : "s"} in date column ${c.name}`,
            detail: "examples: " + bad.slice(0, 3).map(b => JSON.stringify(b)).join(", ")
          });
        }
      }
    }

    // 3) Duplicate rows
    const seen = new Set();
    let dups = 0;
    for (const r of profile.rows) {
      const key = profile.cols.map(c => String(r[c.name] == null ? "" : r[c.name])).join("");
      if (seen.has(key)) dups++; else seen.add(key);
    }
    if (dups > 0) {
      issues.push({
        kind: "duplicates",
        severity: dups / profile.rows.length > 0.05 ? "medium" : "low",
        message: `${dups} duplicate row${dups === 1 ? "" : "s"}`,
        detail: "use the CSV deduplicator to remove them"
      });
    }

    // 4) Empty columns
    for (const c of profile.cols) {
      if (c.values.every(v => v === "" || v == null)) {
        issues.push({
          kind: "empty-column",
          severity: "low",
          message: `Column "${c.name}" is entirely empty`,
          detail: "consider removing it"
        });
      }
    }

    // 5) Header issues
    const headers = profile.cols.map(c => c.name);
    const dupHeaders = headers.filter((h, i) => headers.indexOf(h) !== i);
    if (dupHeaders.length > 0) {
      issues.push({
        kind: "duplicate-headers",
        severity: "high",
        message: `Duplicate column headers detected`,
        detail: "headers: " + [...new Set(dupHeaders)].join(", ")
      });
    }
    const blankHeaders = headers.filter(h => !h || /^column_\d+$/.test(h));
    if (blankHeaders.length > 0) {
      issues.push({
        kind: "blank-headers",
        severity: "medium",
        message: `${blankHeaders.length} blank or auto-named column header${blankHeaders.length === 1 ? "" : "s"}`,
        detail: blankHeaders.slice(0, 5).join(", ")
      });
    }

    return {
      issues,
      stats: { totalIssues: issues.length, totalRows: profile.rows.length, totalCols: profile.cols.length, totalCells, missingTotal, duplicateRows: dups }
    };
  }

  // ============== Tiny SQL engine for CSV ==============
  // Supports: SELECT cols FROM <name> [WHERE expr] [ORDER BY col [DESC]] [LIMIT n]
  // WHERE expressions: col OP value with operators = != <> < > <= >= LIKE
  // joined by AND / OR (no parens, left-to-right).

  // Strip "..." / [...] / `...` quoting from an identifier (for column names
  // containing spaces like "Total Sales").
  function unquoteIdent(s) {
    s = String(s).trim();
    const a = s[0], b = s[s.length - 1];
    if ((a === '"' && b === '"') || (a === '`' && b === '`')) return s.slice(1, -1);
    if (a === '[' && b === ']') return s.slice(1, -1);
    return s;
  }

  function parseSQL(sql) {
    const re = /^\s*select\s+(.+?)\s+from\s+(\w+)(?:\s+where\s+(.+?))?(?:\s+group\s+by\s+(.+?))?(?:\s+order\s+by\s+("[^"]+"|\[[^\]]+\]|`[^`]+`|[^\s]+)(?:\s+(asc|desc))?)?(?:\s+limit\s+(\d+))?\s*;?\s*$/i;
    const m = sql.match(re);
    if (!m) throw new Error("Couldn't parse SQL. Use: SELECT cols FROM csv [WHERE …] [GROUP BY col] [ORDER BY col [DESC]] [LIMIT n]");
    return {
      cols: m[1].trim(),
      from: m[2],
      where: m[3] || null,
      groupBy: m[4] ? m[4].trim() : null,
      orderCol: m[5] ? unquoteIdent(m[5]) : null,
      orderDir: (m[6] || "asc").toLowerCase(),
      limit: m[7] ? parseInt(m[7], 10) : null
    };
  }

  // Parse one SELECT-list item into a column ref or an aggregate.
  // Supports COUNT(*) | COUNT(col) | SUM/AVG/MIN/MAX(col), optional "AS alias".
  function parseSelectItem(raw) {
    const item = raw.trim();
    const agg = item.match(/^(count|sum|avg|min|max)\s*\(\s*(\*|"[^"]+"|`[^`]+`|\[[^\]]+\]|[^)]+?)\s*\)(?:\s+as\s+("[^"]+"|`[^`]+`|\[[^\]]+\]|\S+))?$/i);
    if (agg) {
      const fn = agg[1].toUpperCase();
      const col = agg[2] === "*" ? "*" : unquoteIdent(agg[2].trim());
      const out = agg[3] ? unquoteIdent(agg[3]) : (fn + "(" + (agg[2] === "*" ? "*" : col) + ")");
      return { kind: "agg", fn, col, out };
    }
    const asM = item.match(/^("[^"]+"|`[^`]+`|\[[^\]]+\]|[^\s]+)\s+as\s+("[^"]+"|`[^`]+`|\[[^\]]+\]|\S+)$/i);
    if (asM) return { kind: "col", col: unquoteIdent(asM[1]), out: unquoteIdent(asM[2]) };
    const c = unquoteIdent(item);
    return { kind: "col", col: c, out: c };
  }

  // GROUP BY execution: group `rows` by the group columns and project the SELECT
  // list (group columns + aggregates). Returns { headerNames, outRows }.
  function runGroupBy(profile, ast, rows) {
    const allCols = profile.cols.map(c => c.name);
    const groupCols = ast.groupBy.split(",").map(s => unquoteIdent(s.trim())).filter(Boolean);
    for (const g of groupCols) if (!allCols.includes(g)) throw new Error(`Unknown GROUP BY column "${g}". Available: ${allCols.join(", ")}`);
    const items = (ast.cols.trim() === "*"
      ? groupCols.map(c => c) // SELECT * with GROUP BY -> just the group columns
      : ast.cols.split(",").map(s => s.trim()).filter(Boolean)
    ).map(it => typeof it === "string" ? parseSelectItem(it) : { kind: "col", col: it, out: it });
    // Validate: a plain column in the SELECT must be one of the group columns.
    for (const it of items) {
      if (it.kind === "col" && !groupCols.includes(it.col)) {
        throw new Error(`Column "${it.col}" must appear in GROUP BY or an aggregate (SUM/AVG/COUNT/MIN/MAX).`);
      }
      if (it.kind === "agg" && it.col !== "*" && !allCols.includes(it.col)) {
        throw new Error(`Unknown column "${it.col}" in ${it.fn}().`);
      }
    }
    const groups = new Map();
    for (const r of rows) {
      const keyVals = groupCols.map(c => String(r[c] == null ? "" : r[c]));
      const gk = keyVals.join("‖");
      let g = groups.get(gk);
      if (!g) { g = { keyVals, acc: items.map(() => ({ count: 0, sum: 0, n: 0, min: Infinity, max: -Infinity })) }; groups.set(gk, g); }
      items.forEach((it, i) => {
        if (it.kind !== "agg") return;
        const a = g.acc[i];
        if (it.fn === "COUNT") { if (it.col === "*" || (r[it.col] != null && r[it.col] !== "")) a.count += 1; return; }
        const v = CSVTool.parseNumber(r[it.col]);
        if (v == null) return;
        a.sum += v; a.n += 1; if (v < a.min) a.min = v; if (v > a.max) a.max = v;
      });
    }
    const headerNames = items.map(it => it.out);
    const outRows = [...groups.values()].map(g => {
      const o = {};
      items.forEach((it, i) => {
        if (it.kind === "col") { o[it.out] = g.keyVals[groupCols.indexOf(it.col)]; return; }
        const a = g.acc[i];
        o[it.out] = it.fn === "COUNT" ? a.count
          : it.fn === "SUM" ? a.sum
          : it.fn === "AVG" ? (a.n ? a.sum / a.n : null)
          : it.fn === "MIN" ? (a.n ? a.min : null)
          : it.fn === "MAX" ? (a.n ? a.max : null) : null;
      });
      return o;
    });
    return { headerNames, outRows };
  }

  function compileWhere(expr, cols) {
    // Split on AND/OR (case-insensitive). Evaluated with SQL precedence (AND
    // binds tighter than OR) below — matches DuckDB Power mode.
    const parts = expr.split(/\s+(AND|OR)\s+/i);
    const clauses = []; // [{ test(row) }]
    const joiners = [];
    for (let i = 0; i < parts.length; i++) {
      if (i % 2 === 0) clauses.push(compileClause(parts[i]));
      else joiners.push(parts[i].toUpperCase());
    }
    return function (row) {
      // OR of AND-runs: accumulate consecutive ANDs into a conjunction, OR the runs.
      let orResult = false;
      let andRun = clauses[0](row);
      for (let i = 0; i < joiners.length; i++) {
        const next = clauses[i + 1](row);
        if (joiners[i] === "AND") { andRun = andRun && next; }
        else { orResult = orResult || andRun; andRun = next; }
      }
      return orResult || andRun;
    };
  }

  function compileClause(clause) {
    const m = clause.trim().match(/^("[^"]+"|\[[^\]]+\]|`[^`]+`|\S+?)\s*(=|!=|<>|<=|>=|<|>|LIKE|like)\s*(.+)$/);
    if (!m) throw new Error("Couldn't parse WHERE clause: " + clause);
    const colName = unquoteIdent(m[1]), opRaw = m[2], rawValue = m[3];
    let value = rawValue.trim();
    if ((value.startsWith("'") && value.endsWith("'")) || (value.startsWith('"') && value.endsWith('"'))) {
      value = value.slice(1, -1);
    }
    const op = opRaw.toUpperCase();
    const numValue = parseFloat(value);
    const isNum = !isNaN(numValue) && value !== "";
    return function (row) {
      const raw = row[colName];
      const s = raw == null ? "" : String(raw);
      if (op === "=") return isNum ? CSVTool.parseNumber(s) === numValue : s === value;
      if (op === "!=" || op === "<>") return isNum ? CSVTool.parseNumber(s) !== numValue : s !== value;
      if (op === ">") return isNum ? CSVTool.parseNumber(s) > numValue : s > value;
      if (op === "<") return isNum ? CSVTool.parseNumber(s) < numValue : s < value;
      if (op === ">=") return isNum ? CSVTool.parseNumber(s) >= numValue : s >= value;
      if (op === "<=") return isNum ? CSVTool.parseNumber(s) <= numValue : s <= value;
      if (op === "LIKE") {
        const pattern = "^" + value.replace(/[.+?^${}()|[\]\\]/g, "\\$&").replace(/%/g, ".*").replace(/_/g, ".") + "$";
        return new RegExp(pattern, "i").test(s);
      }
      return false;
    };
  }

  function sqlQuery(profile, opts) {
    opts = opts || {};
    if (!opts.sql || !opts.sql.trim()) {
      return { csv: "", stats: { rows: 0, of: profile.rows.length, message: "Enter a SQL query above." } };
    }
    const ast = parseSQL(opts.sql);
    const allCols = profile.cols.map(c => c.name);
    let rows = profile.rows;
    if (ast.where) {
      const test = compileWhere(ast.where, allCols);
      rows = rows.filter(test);
    }

    // ===== GROUP BY path: aggregate, then ORDER BY / LIMIT on the result =====
    if (ast.groupBy) {
      const { headerNames, outRows } = runGroupBy(profile, ast, rows);
      let result = outRows;
      if (ast.orderCol) {
        if (!headerNames.includes(ast.orderCol)) throw new Error(`Unknown ORDER BY column "${ast.orderCol}". Available: ${headerNames.join(", ")}`);
        const dir = ast.orderDir === "desc" ? -1 : 1;
        result = result.slice().sort((a, b) => {
          const va = a[ast.orderCol], vb = b[ast.orderCol];
          const na = typeof va === "number" ? va : CSVTool.parseNumber(va);
          const nb = typeof vb === "number" ? vb : CSVTool.parseNumber(vb);
          if (na != null && nb != null) return (na - nb) * dir;
          return String(va == null ? "" : va).localeCompare(String(vb == null ? "" : vb)) * dir;
        });
      }
      if (ast.limit !== null) result = result.slice(0, ast.limit);
      return { csv: buildCSV(headerNames, result), stats: { groups: result.length, of: profile.rows.length, engine: "grouped" } };
    }

    // ===== Plain SELECT path (AS aliases + implicit whole-table aggregates) =====
    let items;
    if (ast.cols.trim() === "*") items = allCols.map(c => ({ kind: "col", col: c, out: c }));
    else items = ast.cols.split(",").map(s => s.trim()).filter(Boolean).map(parseSelectItem);

    // SELECT COUNT(*) / SUM(col) … with no GROUP BY = aggregate the whole
    // (post-WHERE) table into a single row.
    if (items.some(it => it.kind === "agg")) {
      if (items.some(it => it.kind === "col")) {
        throw new Error("Plain columns can't mix with aggregates without GROUP BY — add a GROUP BY or remove the plain column.");
      }
      for (const it of items) {
        if (it.col !== "*" && !allCols.includes(it.col)) throw new Error(`Unknown column "${it.col}" in ${it.fn}().`);
      }
      const acc = items.map(() => ({ count: 0, sum: 0, n: 0, min: Infinity, max: -Infinity }));
      for (const r of rows) {
        items.forEach((it, i) => {
          const a = acc[i];
          if (it.fn === "COUNT") { if (it.col === "*" || (r[it.col] != null && r[it.col] !== "")) a.count += 1; return; }
          const v = CSVTool.parseNumber(r[it.col]);
          if (v == null) return;
          a.sum += v; a.n += 1; if (v < a.min) a.min = v; if (v > a.max) a.max = v;
        });
      }
      const one = {};
      items.forEach((it, i) => {
        const a = acc[i];
        one[it.out] = it.fn === "COUNT" ? a.count
          : it.fn === "SUM" ? a.sum
          : it.fn === "AVG" ? (a.n ? a.sum / a.n : null)
          : it.fn === "MIN" ? (a.n ? a.min : null)
          : it.fn === "MAX" ? (a.n ? a.max : null) : null;
      });
      const headerNames = items.map(it => it.out);
      return { csv: buildCSV(headerNames, [one]), stats: { rows: 1, of: profile.rows.length, engine: "aggregate" } };
    }

    for (const it of items) {
      if (!allCols.includes(it.col)) throw new Error(`Unknown column "${it.col}". Available: ${allCols.join(", ")}`);
    }
    if (ast.orderCol) {
      // Accept either a source column name or a SELECT alias in ORDER BY.
      const srcName = allCols.includes(ast.orderCol) ? ast.orderCol : (items.find(it => it.out === ast.orderCol) || {}).col;
      if (!srcName) throw new Error(`Unknown ORDER BY column "${ast.orderCol}"`);
      const col = profile.cols.find(c => c.name === srcName);
      const dir = ast.orderDir === "desc" ? -1 : 1;
      rows = rows.slice().sort((a, b) => compareCell(a[srcName], b[srcName], col) * dir);
    }
    if (ast.limit !== null) rows = rows.slice(0, ast.limit);
    const headerNames = items.map(it => it.out);
    const projected = rows.map(r => {
      const o = {};
      for (const it of items) o[it.out] = r[it.col];
      return o;
    });
    return {
      csv: buildCSV(headerNames, projected),
      stats: { rows: projected.length, of: profile.rows.length, selectedCols: headerNames }
    };
  }

  return {
    inferSQLType, sqlValue, jsonValue,
    csvToJSON, csvToSQL, csvToMarkdown, csvToHTML, csvToXML, csvToExcel,
    jsonToCSV, excelToCSV,
    download,
    csvEscape, mdEscape, xmlEscape, htmlEscape,
    sqlIdent, xmlIdent, flatten,
    // Phase 2
    buildCSV, dedupe, sortFilter, splitCSV, validateCSV, sqlQuery, buildZip,
    compareCell, matchFilter,
    // Phase 5 (assigned below)
  };
})();

// =========================================================================
// PHASE 5 — Format expansion (YAML, SQL ↔, HTML table, fixed-width, geo, KML, multiline)
// All format converters are added to the existing Convert namespace.
// No heavy external libraries — small inline parsers + emitters.
// =========================================================================
(function () {

  // ---------- CSV → YAML ----------
  // YAML emitter. Numbers/booleans/null stay unquoted. Strings get quoted only when
  // they contain characters that would confuse the YAML grammar, or when they collide
  // with reserved literals (true, false, null, yes, no, on, off — case-insensitive).
  const YAML_RESERVED = /^(true|false|null|yes|no|on|off|~)$/i;
  const YAML_NEEDS_QUOTE = /^[\s\-?:,\[\]\{\}#&*!|>'"%@`]|[\s:#]$|[:#]\s|^[\s]*$/;

  function yamlScalar(v) {
    if (v == null) return "null";
    if (typeof v === "number" && isFinite(v)) return String(v);
    if (typeof v === "boolean") return v ? "true" : "false";
    const s = String(v);
    if (s === "") return '""';
    // Numeric-looking strings should be quoted (otherwise they'd parse as numbers)
    if (/^-?\d+(\.\d+)?$/.test(s) || /^-?\.\d+$/.test(s)) return '"' + s.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
    if (YAML_RESERVED.test(s)) return '"' + s + '"';
    if (YAML_NEEDS_QUOTE.test(s) || /\n/.test(s)) {
      return '"' + s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\t/g, "\\t") + '"';
    }
    return s;
  }

  function csvToYAML(profile, opts) {
    opts = opts || {};
    const normalizeDates = !!opts.normalizeDates;
    const out = ["# Generated by csvtodashboard.com — convert + visualize your CSV"];
    for (const r of profile.rows) {
      const lines = [];
      let first = true;
      for (const c of profile.cols) {
        const raw = r[c.name];
        let v;
        if (raw === "" || raw == null) v = null;
        else if (c.type === "number") v = numberColClean(c) ? CSVTool.parseNumber(raw) : String(raw).trim();
        else if (c.type === "boolean") {
          const s = String(raw).toLowerCase();
          v = s === "true" || s === "yes" || s === "1" || s === "y";
        } else if (c.type === "date" && normalizeDates) {
          const dp = isoDateParts(raw);
          v = dp ? dp.day : String(raw);
        } else v = String(raw);
        const key = /^[A-Za-z_][A-Za-z0-9_-]*$/.test(c.name) ? c.name : '"' + c.name.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\t/g, "\\t") + '"';
        lines.push((first ? "- " : "  ") + key + ": " + yamlScalar(v));
        first = false;
      }
      out.push(lines.join("\n"));
    }
    return out.join("\n");
  }

  // ---------- YAML → CSV ----------
  // Hand-rolled minimal YAML parser. Handles block-style sequences of mappings,
  // single flat mappings, indentation-based nesting (flattened with dot notation),
  // and basic scalars. Explicit non-goals: anchors/aliases, tags, multi-document,
  // block scalars (| / >), flow style. Errors clearly when something's unsupported.
  function parseYAML(text) {
    // Strip comments (anything after `#` that's preceded by space or at start of line)
    const rawLines = text.replace(/\r\n/g, "\n").split("\n");
    const lines = rawLines.map(l => {
      // Find a `#` that's NOT inside quotes
      let inQ = false, quote = "";
      for (let i = 0; i < l.length; i++) {
        const c = l[i];
        if (inQ) { if (c === "\\") { i++; continue; } if (c === quote) inQ = false; continue; }
        if (c === '"' || c === "'") { inQ = true; quote = c; continue; }
        if (c === "#" && (i === 0 || l[i - 1] === " " || l[i - 1] === "\t")) return l.slice(0, i).replace(/\s+$/, "");
      }
      return l.replace(/\s+$/, "");
    }).filter(l => l.length > 0 && !/^---\s*$/.test(l) && !/^\.\.\.\s*$/.test(l));

    if (lines.length === 0) throw new Error("Empty YAML input.");

    function indent(line) {
      let n = 0;
      while (n < line.length && line[n] === " ") n++;
      if (line[n] === "\t") throw new Error("Tab indentation is not supported; please re-indent with spaces.");
      return n;
    }

    function unquote(s) {
      s = s.trim();
      if (s === "" || s === "~" || s.toLowerCase() === "null") return null;
      if (/^(true|yes|on)$/i.test(s)) return true;
      if (/^(false|no|off)$/i.test(s)) return false;
      if (/^-?\d+$/.test(s) && !/^-?0\d/.test(s)) return parseInt(s, 10); // keep leading-zero tokens ("01234") as strings (YAML 1.2)
      if (/^-?\d+\.\d+([eE][+-]?\d+)?$/.test(s) || /^-?\.\d+$/.test(s)) return parseFloat(s);
      // Double-quoted
      if (s.startsWith('"') && s.endsWith('"')) {
        return s.slice(1, -1).replace(/\\"/g, '"').replace(/\\n/g, "\n").replace(/\\t/g, "\t").replace(/\\\\/g, "\\");
      }
      // Single-quoted
      if (s.startsWith("'") && s.endsWith("'")) {
        return s.slice(1, -1).replace(/''/g, "'");
      }
      // Flow-style array/object — not supported deeply, return raw text
      if (s.startsWith("[") || s.startsWith("{")) return s;
      return s;
    }

    // Block scalar markers
    for (const l of lines) {
      if (/:\s*[|>][+\-]?\s*$/.test(l)) throw new Error("Block scalars (| / >) are not supported in this YAML parser. Use double-quoted strings instead.");
      if (/^[&*]/.test(l.trimStart())) throw new Error("YAML anchors/aliases (& *) are not supported.");
      if (/^\s*!!?\S/.test(l)) throw new Error("YAML tags (!!type) are not supported.");
    }

    // Determine top-level shape
    const top = lines[0];
    const isSeq = /^\s*-\s/.test(top) || /^\s*-$/.test(top);

    function parseMapping(startIdx, baseIndent, endIdx) {
      // Returns { obj, lastLineConsumed }
      const obj = {};
      let i = startIdx;
      while (i <= endIdx) {
        const line = lines[i];
        const ind = indent(line);
        if (ind < baseIndent) return { obj, lastIdx: i - 1 };
        if (ind > baseIndent) { i++; continue; } // shouldn't really happen for well-formed input

        const content = line.slice(baseIndent);
        const m = content.match(/^([^:]+):\s*(.*)$/);
        if (!m) throw new Error("Expected 'key: value' at line " + (i + 1) + ": " + line);
        const key = unquote(m[1]).toString();
        const valuePart = m[2];

        if (valuePart === "" || valuePart === null) {
          // Nested mapping or sequence — peek next line
          if (i + 1 <= endIdx) {
            const nextInd = indent(lines[i + 1]);
            const nextTrim = lines[i + 1].slice(nextInd);
            if (nextInd > baseIndent) {
              if (/^-\s/.test(nextTrim) || /^-$/.test(nextTrim)) {
                // Nested sequence — flatten as joined string
                const { arr, lastIdx } = parseSequence(i + 1, nextInd, endIdx);
                obj[key] = arr.map(v => (v && typeof v === "object") ? JSON.stringify(v) : String(v)).join("; ");
                i = lastIdx + 1; continue;
              }
              const { obj: child, lastIdx } = parseMapping(i + 1, nextInd, endIdx);
              // Flatten with dot notation
              for (const k of Object.keys(child)) {
                const v = child[k];
                if (v && typeof v === "object" && !Array.isArray(v)) {
                  // Already flattened in child
                  obj[key + "." + k] = v;
                } else {
                  obj[key + "." + k] = v;
                }
              }
              i = lastIdx + 1; continue;
            }
          }
          obj[key] = null;
        } else {
          obj[key] = unquote(valuePart);
        }
        i++;
      }
      return { obj, lastIdx: endIdx };
    }

    function parseSequence(startIdx, baseIndent, endIdx) {
      const arr = [];
      let i = startIdx;
      while (i <= endIdx) {
        const line = lines[i];
        const ind = indent(line);
        if (ind < baseIndent) return { arr, lastIdx: i - 1 };
        if (ind > baseIndent) { i++; continue; }
        const content = line.slice(baseIndent);
        if (!/^-(\s|$)/.test(content)) return { arr, lastIdx: i - 1 };
        const afterDash = content.slice(1).replace(/^\s/, "");
        if (afterDash === "") {
          // Item on subsequent lines
          if (i + 1 <= endIdx && indent(lines[i + 1]) > baseIndent) {
            const childInd = indent(lines[i + 1]);
            const { obj, lastIdx } = parseMapping(i + 1, childInd, endIdx);
            arr.push(obj);
            i = lastIdx + 1; continue;
          }
          arr.push(null);
          i++; continue;
        }
        // Inline form — could be `- key: value` (mapping start) or `- scalar`
        if (/^[^:]+:\s/.test(afterDash) || /^[^:]+:$/.test(afterDash)) {
          // Mapping item — parse this line as first key, then more lines at same indent
          const itemInd = baseIndent + (line.indexOf("-") - baseIndent + 1) + 1;
          // Synthesize: treat from this position
          const m = afterDash.match(/^([^:]+):\s*(.*)$/);
          const key = unquote(m[1]).toString();
          const valuePart = m[2];
          const obj = {};
          let j = i + 1;
          if (valuePart === "") {
            // First key with an empty inline value may head a nested block on the
            // following (more-indented) lines — flatten it with dotted keys instead
            // of dropping it as null (mirrors the later-key handling below).
            if (j <= endIdx && indent(lines[j]) > itemInd) {
              const { obj: child, lastIdx } = parseMapping(j, indent(lines[j]), endIdx);
              for (const ck of Object.keys(child)) obj[key + "." + ck] = child[ck];
              j = lastIdx + 1;
            } else obj[key] = null;
          } else obj[key] = unquote(valuePart);
          // Consume subsequent same-item-indent lines
          while (j <= endIdx) {
            const ind2 = indent(lines[j]);
            if (ind2 < itemInd) break;
            if (ind2 === itemInd) {
              const c2 = lines[j].slice(itemInd);
              if (/^-(\s|$)/.test(c2)) break;
              const m2 = c2.match(/^([^:]+):\s*(.*)$/);
              if (!m2) break;
              const k2 = unquote(m2[1]).toString();
              const v2 = m2[2];
              if (v2 === "") {
                // Nested
                if (j + 1 <= endIdx && indent(lines[j + 1]) > itemInd) {
                  const { obj: child, lastIdx } = parseMapping(j + 1, indent(lines[j + 1]), endIdx);
                  for (const ck of Object.keys(child)) obj[k2 + "." + ck] = child[ck];
                  j = lastIdx + 1; continue;
                }
                obj[k2] = null;
              } else obj[k2] = unquote(v2);
              j++; continue;
            }
            // Deeper than item indent — nested under last key
            j++;
          }
          arr.push(obj);
          i = j; continue;
        }
        // Scalar item
        arr.push(unquote(afterDash));
        i++;
      }
      return { arr, lastIdx: endIdx };
    }

    let rows;
    if (isSeq) {
      const { arr } = parseSequence(0, indent(top), lines.length - 1);
      rows = arr.filter(x => x != null);
    } else {
      const { obj } = parseMapping(0, indent(top), lines.length - 1);
      rows = [obj];
    }
    if (rows.length === 0) throw new Error("Couldn't extract any rows from this YAML. Expected a sequence of mappings (block-style YAML).");
    // Promote primitive items to one-column rows
    rows = rows.map(r => (r && typeof r === "object") ? r : { value: r });
    return rows;
  }

  function yamlToCSV(text) {
    const rows = parseYAML(text);
    const seen = new Set();
    const headers = [];
    for (const r of rows) for (const k of Object.keys(r)) {
      if (!seen.has(k)) { seen.add(k); headers.push(k); }
    }
    const lines = [headers.map(csvEscape).join(",")];
    for (const r of rows) {
      lines.push(headers.map(h => {
        const v = r[h];
        if (v == null) return "";
        if (typeof v === "object") return csvEscape(JSON.stringify(v));
        return csvEscape(v);
      }).join(","));
    }
    return lines.join("\n");
  }

  // ---------- SQL → CSV ----------
  // Parse practical INSERT statements:
  //   INSERT INTO table (col1, col2) VALUES (1, 'a'), (2, 'b');
  //   INSERT INTO table VALUES (1, 'a');
  // Uses the column list from the first INSERT for the output header. Subsequent
  // INSERTs against the same table contribute additional rows.
  function parseSQLValues(valuesText) {
    // valuesText is everything after "VALUES " up to the trailing ";"
    // Returns array of row-arrays. Handles 'string' literals with '' escapes,
    // numbers, NULL, TRUE/FALSE.
    const rows = [];
    let i = 0;
    const n = valuesText.length;
    while (i < n) {
      while (i < n && /[\s,]/.test(valuesText[i])) i++;
      if (i >= n || valuesText[i] === ";") break;
      if (valuesText[i] !== "(") throw new Error("Expected '(' at position " + i + " — got '" + valuesText[i] + "'");
      i++;
      const row = [];
      while (i < n && valuesText[i] !== ")") {
        while (i < n && /\s/.test(valuesText[i])) i++;
        // Parse one value
        if (valuesText[i] === "'") {
          // String literal — handle '' escaped quotes
          i++;
          let s = "";
          while (i < n) {
            if (valuesText[i] === "'" && valuesText[i + 1] === "'") { s += "'"; i += 2; continue; }
            if (valuesText[i] === "'") break;
            s += valuesText[i++];
          }
          i++; // closing '
          row.push(s);
        } else if (valuesText[i] === '"') {
          // Double-quoted identifier-ish — accept as string
          i++;
          let s = "";
          while (i < n && valuesText[i] !== '"') s += valuesText[i++];
          i++;
          row.push(s);
        } else {
          // Bare token: number, NULL, TRUE, FALSE, NOW(), etc.
          let tok = "";
          while (i < n && !/[,)]/.test(valuesText[i])) tok += valuesText[i++];
          tok = tok.trim();
          if (/^null$/i.test(tok)) row.push(null);
          else if (/^true$/i.test(tok)) row.push("true");
          else if (/^false$/i.test(tok)) row.push("false");
          else if (/^-?\d+(\.\d+)?$/.test(tok)) row.push(tok);
          else row.push(tok); // function call, etc. — keep as text
        }
        while (i < n && /\s/.test(valuesText[i])) i++;
        if (valuesText[i] === ",") i++;
      }
      if (valuesText[i] === ")") i++;
      rows.push(row);
    }
    return rows;
  }

  function sqlToCSV(text) {
    // Strip /* … */ and -- comments, but QUOTE-AWARE so a literal '--' or '/*'
    // inside a string value (e.g. VALUES (1, 'AB--12')) isn't removed.
    const cleaned = (function (src) {
      let out = "", i = 0, q = null;
      while (i < src.length) {
        const c = src[i];
        if (q) { out += c; if (c === q && src[i + 1] === q) { out += src[++i]; } else if (c === q) { q = null; } i++; continue; }
        if (c === "'" || c === '"') { q = c; out += c; i++; continue; }
        if (c === "-" && src[i + 1] === "-") { while (i < src.length && src[i] !== "\n") i++; continue; }
        if (c === "/" && src[i + 1] === "*") { i += 2; while (i < src.length && !(src[i] === "*" && src[i + 1] === "/")) i++; i += 2; continue; }
        out += c; i++;
      }
      return out;
    })(text);

    const inserts = [];
    // Capture everything after VALUES up to the next "; INSERT INTO" statement
    // boundary (or EOF) rather than the first ";" — parseSQLValues itself stops
    // at the first TOP-LEVEL ; (quote-aware), so a ";" inside a string literal
    // like 'Ship to: A; then B' no longer truncates the value and drops rows.
    const re = /INSERT\s+INTO\s+(?:\w+\.)?(\w+|`[^`]+`|"[^"]+")\s*(?:\(([^)]+)\))?\s*VALUES\s*([\s\S]*?)(?=;\s*INSERT\s+INTO\b|$)/gi;
    let m;
    while ((m = re.exec(cleaned)) !== null) {
      const table = m[1].replace(/[`"]/g, "");
      const colsList = m[2] ? m[2].split(",").map(s => s.trim().replace(/[`"]/g, "")) : null;
      const valuesText = m[3];
      let rows;
      try { rows = parseSQLValues(valuesText); }
      catch (e) { throw new Error("Couldn't parse VALUES block: " + e.message); }
      inserts.push({ table, cols: colsList, rows });
    }
    if (inserts.length === 0) {
      throw new Error("No INSERT statements found. Expected: INSERT INTO table (cols) VALUES (...);");
    }

    // Use the first insert's columns; if none specified, generate column_1..N from first row width
    const first = inserts[0];
    const headers = first.cols || first.rows[0].map((_, i) => "column_" + (i + 1));

    const all = [];
    for (const ins of inserts) {
      if (ins.table !== first.table) continue; // Only process the first table
      for (const r of ins.rows) {
        // Pad / trim to header count
        const out = headers.map((_, i) => r[i] == null ? "" : r[i]);
        all.push(out);
      }
    }

    const lines = [headers.map(csvEscape).join(",")];
    for (const r of all) lines.push(r.map(csvEscape).join(","));
    return lines.join("\n");
  }

  // ---------- HTML table → CSV ----------
  function htmlTableToCSV(html) {
    if (typeof DOMParser === "undefined") throw new Error("DOMParser not available in this environment.");
    const doc = new DOMParser().parseFromString(html, "text/html");
    const table = doc.querySelector("table");
    if (!table) throw new Error("No <table> found in the pasted HTML.");

    // Build a row × col matrix accounting for colspan/rowspan
    const matrix = [];
    let r = 0;
    // Only this table's own rows — :scope avoids pulling in rows of a NESTED
    // <table> inside a cell.
    let trs = table.querySelectorAll(":scope > tr, :scope > thead > tr, :scope > tbody > tr, :scope > tfoot > tr");
    if (trs.length === 0) trs = table.querySelectorAll("tr"); // fallback for odd markup
    for (const tr of trs) {
      if (!matrix[r]) matrix[r] = [];
      let c = 0;
      // Find next free cell
      function nextFree(row, fromCol) {
        let cc = fromCol;
        while (matrix[row] && matrix[row][cc] !== undefined) cc++;
        return cc;
      }
      for (const cell of tr.children) {
        c = nextFree(r, c);
        const cs = parseInt(cell.getAttribute("colspan") || "1", 10) || 1;
        const rs = parseInt(cell.getAttribute("rowspan") || "1", 10) || 1;
        const text = (cell.textContent || "").replace(/\s+/g, " ").trim();
        for (let dr = 0; dr < rs; dr++) {
          for (let dc = 0; dc < cs; dc++) {
            if (!matrix[r + dr]) matrix[r + dr] = [];
            matrix[r + dr][c + dc] = text;
          }
        }
        c += cs;
      }
      r++;
    }
    if (matrix.length === 0) throw new Error("Table is empty.");
    const width = Math.max(...matrix.map(row => row.length));
    const lines = matrix.map(row => {
      const padded = [];
      for (let i = 0; i < width; i++) padded.push(row[i] == null ? "" : row[i]);
      return padded.map(csvEscape).join(",");
    });
    return lines.join("\n");
  }

  // ---------- Fixed-width → CSV ----------
  function autoDetectBoundaries(text) {
    const lines = text.replace(/\r\n/g, "\n").split("\n").filter(l => l.length > 0);
    if (lines.length < 2) return [];
    const maxLen = Math.max(...lines.map(l => l.length));
    // A column boundary candidate: a position where every line has a space AND
    // the previous position has at least one non-space character.
    const boundaries = [];
    for (let i = 1; i < maxLen; i++) {
      let allSpace = true, prevNonSpace = false;
      for (const l of lines) {
        if (i >= l.length) continue; // shorter lines don't contribute
        if (l[i] !== " ") { allSpace = false; break; }
        if (l[i - 1] && l[i - 1] !== " ") prevNonSpace = true;
      }
      if (allSpace && prevNonSpace) boundaries.push(i);
    }
    // Collapse adjacent boundary positions (whitespace runs)
    const collapsed = [];
    for (const b of boundaries) {
      if (collapsed.length === 0 || b - collapsed[collapsed.length - 1] > 1) collapsed.push(b);
    }
    return collapsed;
  }

  function fixedWidthToCSV(text, boundaries) {
    const lines = text.replace(/\r\n/g, "\n").split("\n").filter(l => l.length > 0);
    if (lines.length === 0) return "";
    const cuts = boundaries && boundaries.length > 0 ? boundaries : autoDetectBoundaries(text);
    function splitLine(l) {
      const out = [];
      let start = 0;
      for (const cut of cuts) {
        out.push(l.slice(start, cut).trim());
        start = cut;
      }
      out.push(l.slice(start).trim());
      return out;
    }
    const rows = lines.map(splitLine);
    return rows.map(r => r.map(csvEscape).join(",")).join("\n");
  }

  // ---------- CSV → Fixed-width ----------
  function csvToFixedWidth(profile, opts) {
    opts = opts || {};
    const padding = opts.padding == null ? 2 : Math.max(0, parseInt(opts.padding, 10) || 0);
    const showHeader = opts.showHeader !== false;
    const showUnderline = opts.showUnderline !== false;

    const headers = profile.cols.map(c => c.name);
    const widths = headers.map((h, i) => {
      const col = profile.cols[i];
      let w = h.length;
      for (const r of profile.rows) {
        const v = r[h];
        const s = (v == null ? "" : String(v)).replace(/\r?\n/g, " ");
        if (s.length > w) w = s.length;
      }
      return w;
    });
    const aligns = profile.cols.map(c => (c.type === "number" ? "right" : "left"));

    function fmtCell(s, i) {
      // Collapse embedded newlines so each logical row stays on one physical line
      // and the width math is correct.
      s = (s == null ? "" : String(s)).replace(/\r?\n/g, " ");
      const w = widths[i];
      if (aligns[i] === "right") return s.padStart(w);
      return s.padEnd(w);
    }

    const out = [];
    const sep = " ".repeat(padding);
    if (showHeader) {
      out.push(headers.map((h, i) => fmtCell(h, i)).join(sep));
      if (showUnderline) out.push(widths.map(w => "-".repeat(w)).join(sep));
    }
    for (const r of profile.rows) {
      out.push(headers.map((h, i) => fmtCell(r[h], i)).join(sep));
    }
    return out.join("\n");
  }

  // ---------- CSV → GeoJSON ----------
  function detectLatLon(profile) {
    const cols = profile.cols.map(c => c.name);
    // Prefer explicit geographic names; only fall back to bare x/y when no real
    // lat/lon column exists (so a non-geographic scatter CSV isn't auto-mapped).
    const lat = cols.find(c => /^lat(itude)?$/i.test(c)) || cols.find(c => /^y$/i.test(c)) || null;
    const lon = cols.find(c => /^lon(g(itude)?)?$|^lng$/i.test(c)) || cols.find(c => /^x$/i.test(c)) || null;
    return { lat, lon };
  }
  // Parse a coordinate (or elevation) cell. CSVTool.parseNumber strips commas as
  // thousands separators, which corrupts European decimal-comma coords ("8,5" ->
  // 85). Normalize a lone decimal comma to a dot first.
  function parseCoord(raw) {
    const t = String(raw == null ? "" : raw).trim();
    return CSVTool.parseNumber(/^-?\d+,\d+$/.test(t) ? t.replace(",", ".") : t);
  }

  function csvToGeoJSON(profile, opts) {
    opts = opts || {};
    const det = detectLatLon(profile);
    const latCol = opts.latColumn || det.lat;
    const lonCol = opts.lonColumn || det.lon;
    if (!latCol || !lonCol) {
      throw new Error("Couldn't detect latitude/longitude columns. Use the picker above to choose them manually.");
    }
    const features = [];
    let skipped = 0;
    for (const r of profile.rows) {
      const lat = parseCoord(r[latCol]);
      const lon = parseCoord(r[lonCol]);
      if (lat == null || lon == null || isNaN(lat) || isNaN(lon)) { skipped++; continue; }
      if (lat < -90 || lat > 90 || lon < -180 || lon > 180) { skipped++; continue; }
      const props = {};
      for (const c of profile.cols) {
        if (c.name === latCol || c.name === lonCol) continue;
        const raw = r[c.name];
        if (raw === "" || raw == null) { props[c.name] = null; continue; }
        if (c.type === "number") props[c.name] = CSVTool.parseNumber(raw);
        else if (c.type === "boolean") {
          const s = String(raw).toLowerCase();
          props[c.name] = s === "true" || s === "yes" || s === "1" || s === "y";
        } else props[c.name] = String(raw);
      }
      features.push({
        type: "Feature",
        geometry: { type: "Point", coordinates: [lon, lat] },
        properties: props
      });
    }
    const fc = { type: "FeatureCollection", features };
    return { json: JSON.stringify(fc, null, opts.minified ? 0 : 2), skipped, total: profile.rows.length };
  }

  // ---------- GeoJSON → CSV ----------
  function flattenProps(obj, prefix) {
    const out = {};
    if (obj == null || typeof obj !== "object") return out;
    for (const k of Object.keys(obj)) {
      const v = obj[k];
      const key = prefix ? prefix + "." + k : k;
      if (v == null) out[key] = "";
      else if (typeof v === "object" && !Array.isArray(v)) Object.assign(out, flattenProps(v, key));
      else if (Array.isArray(v)) out[key] = v.map(x => typeof x === "object" ? JSON.stringify(x) : String(x)).join("; ");
      else out[key] = v;
    }
    return out;
  }

  function geojsonToCSV(text) {
    let data;
    try { data = JSON.parse(text); }
    catch (e) { throw new Error("Invalid JSON: " + e.message); }
    let features;
    if (data && data.type === "FeatureCollection" && Array.isArray(data.features)) features = data.features;
    else if (data && data.type === "Feature") features = [data];
    else if (Array.isArray(data)) features = data;
    else throw new Error("Expected a GeoJSON FeatureCollection or Feature.");

    const rows = features.map(f => {
      const props = flattenProps(f.properties || {}, "");
      const row = { ...props };
      // Don't clobber a feature property that's already named longitude/latitude/
      // elevation/geometry — suffix the derived column instead (geom_*).
      const put = (name, val) => { row[name in props ? "geom_" + name : name] = val; };
      const g = f.geometry;
      if (g && g.type === "Point" && Array.isArray(g.coordinates)) {
        put("longitude", g.coordinates[0]);
        put("latitude", g.coordinates[1]);
        if (g.coordinates[2] != null) put("elevation", g.coordinates[2]);
      } else if (g) {
        put("geometry", JSON.stringify(g));
      }
      return row;
    });

    const seen = new Set();
    const headers = [];
    // Prefer lat/lon first if present
    for (const preferred of ["latitude", "longitude", "elevation"]) {
      if (rows.some(r => preferred in r)) { headers.push(preferred); seen.add(preferred); }
    }
    for (const r of rows) for (const k of Object.keys(r)) {
      if (!seen.has(k)) { seen.add(k); headers.push(k); }
    }
    const lines = [headers.map(csvEscape).join(",")];
    for (const r of rows) lines.push(headers.map(h => csvEscape(r[h])).join(","));
    return lines.join("\n");
  }

  // ---------- CSV → KML ----------
  function csvToKML(profile, opts) {
    opts = opts || {};
    const det = detectLatLon(profile);
    const latCol = opts.latColumn || det.lat;
    const lonCol = opts.lonColumn || det.lon;
    if (!latCol || !lonCol) {
      throw new Error("Couldn't detect latitude/longitude columns. Use the picker above to choose them manually.");
    }
    const nameCol = opts.nameColumn || profile.cols.find(c => /^(name|title|label)$/i.test(c.name))?.name;
    const descCol = opts.descriptionColumn || profile.cols.find(c => /^(description|desc|notes)$/i.test(c.name))?.name;

    const lines = [];
    lines.push('<?xml version="1.0" encoding="UTF-8"?>');
    lines.push('<!-- Generated by csvtodashboard.com — convert + visualize your CSV -->');
    lines.push('<kml xmlns="http://www.opengis.net/kml/2.2">');
    lines.push("  <Document>");
    let skipped = 0;
    for (const r of profile.rows) {
      const lat = parseCoord(r[latCol]);
      const lon = parseCoord(r[lonCol]);
      if (lat == null || lon == null || isNaN(lat) || isNaN(lon)) { skipped++; continue; }
      if (lat < -90 || lat > 90 || lon < -180 || lon > 180) { skipped++; continue; } // skip impossible coords (matches GeoJSON/GPX)
      const name = nameCol && r[nameCol] != null ? String(r[nameCol]) : "";
      const desc = descCol && r[descCol] != null ? String(r[descCol]) : "";
      lines.push("    <Placemark>");
      if (name) lines.push("      <name>" + xmlEscape(name) + "</name>");
      if (desc) lines.push("      <description>" + xmlEscape(desc) + "</description>");
      lines.push("      <Point><coordinates>" + lon + "," + lat + "</coordinates></Point>");
      lines.push("    </Placemark>");
    }
    lines.push("  </Document>");
    lines.push("</kml>");
    return { kml: lines.join("\n"), skipped, total: profile.rows.length };
  }

  // ---------- CSV → GPX ----------
  // One <wpt> waypoint per row that has valid lat/lon. Optional ele/time/name/desc
  // columns ride along when present (auto-detected, overridable).
  function csvToGPX(profile, opts) {
    opts = opts || {};
    const det = detectLatLon(profile);
    const latCol = opts.latColumn || det.lat;
    const lonCol = opts.lonColumn || det.lon;
    if (!latCol || !lonCol) {
      throw new Error("Couldn't detect latitude/longitude columns. Use the picker above to choose them manually.");
    }
    const find = re => { const c = profile.cols.find(c => re.test(c.name)); return c ? c.name : null; };
    const nameCol = opts.nameColumn || find(/^(name|title|label)$/i);
    const descCol = opts.descriptionColumn || find(/^(description|desc|notes)$/i);
    const eleCol = opts.elevationColumn || find(/^(ele|elevation|altitude|alt)$/i);
    const timeCol = opts.timeColumn || find(/^(time|timestamp|date|datetime)$/i);

    const lines = [];
    lines.push('<?xml version="1.0" encoding="UTF-8"?>');
    lines.push('<!-- Generated by csvtodashboard.com — convert + visualize your CSV -->');
    lines.push('<gpx version="1.1" creator="csvtodashboard.com" xmlns="http://www.topografix.com/GPX/1/1">');
    let skipped = 0;
    for (const r of profile.rows) {
      const lat = parseCoord(r[latCol]);
      const lon = parseCoord(r[lonCol]);
      if (lat == null || lon == null || isNaN(lat) || isNaN(lon) || lat < -90 || lat > 90 || lon < -180 || lon > 180) { skipped++; continue; }
      lines.push('  <wpt lat="' + lat + '" lon="' + lon + '">');
      if (eleCol && r[eleCol] != null && String(r[eleCol]).trim() !== "") {
        const e = parseCoord(r[eleCol]);
        if (e != null && !isNaN(e)) lines.push("    <ele>" + e + "</ele>");
      }
      if (timeCol && r[timeCol] != null && String(r[timeCol]).trim() !== "") lines.push("    <time>" + xmlEscape(String(r[timeCol])) + "</time>");
      if (nameCol && r[nameCol] != null && String(r[nameCol]) !== "") lines.push("    <name>" + xmlEscape(String(r[nameCol])) + "</name>");
      if (descCol && r[descCol] != null && String(r[descCol]) !== "") lines.push("    <desc>" + xmlEscape(String(r[descCol])) + "</desc>");
      lines.push("  </wpt>");
    }
    lines.push("</gpx>");
    return { gpx: lines.join("\n"), skipped, total: profile.rows.length };
  }

  // ---------- GPX → CSV ----------
  // Flattens every <wpt>/<trkpt>/<rtpt> point into a row with type/lat/lon/ele/time/name/desc.
  function gpxToCSV(text) {
    if (typeof DOMParser === "undefined") throw new Error("GPX parsing needs a browser environment.");
    const doc = new DOMParser().parseFromString(text, "application/xml");
    const perr = doc.getElementsByTagName("parsererror");
    if (perr && perr.length) throw new Error("Invalid GPX — that doesn't look like well-formed XML.");
    const pts = [];
    function collect(tag, type) {
      const els = doc.getElementsByTagName(tag);
      for (let i = 0; i < els.length; i++) {
        const el = els[i];
        const lat = el.getAttribute("lat"), lon = el.getAttribute("lon");
        if (lat == null || lon == null) continue;
        const child = t => { const c = el.getElementsByTagName(t); return c && c.length ? (c[0].textContent || "") : ""; };
        pts.push({ type: type, latitude: lat, longitude: lon, elevation: child("ele"), time: child("time"), name: child("name"), desc: child("desc") });
      }
    }
    collect("wpt", "waypoint");
    collect("trkpt", "trackpoint");
    collect("rtpt", "routepoint");
    if (!pts.length) throw new Error("No <wpt>, <trkpt>, or <rtpt> points found in this GPX file.");
    const headers = ["type", "latitude", "longitude", "elevation", "time", "name", "desc"];
    const lines = [headers.join(",")];
    for (const p of pts) lines.push(headers.map(h => csvEscape(p[h])).join(","));
    return lines.join("\n");
  }

  // ---------- CSV → PDF (table) ----------
  // Renders the profile as a paginated PDF table via jsPDF + autoTable.
  // Returns PDF bytes (Uint8Array). The engine is lazy-loaded by ensurePDF().
  function csvToPDF(profile, opts) {
    opts = opts || {};
    if (!(window.jspdf && window.jspdf.jsPDF)) throw new Error("PDF engine not loaded yet — try again in a moment.");
    const jsPDF = window.jspdf.jsPDF;
    const orientation = opts.orientation === "landscape" ? "landscape" : "portrait";
    const fmt = (opts.pageSize || "a4").toLowerCase();
    const doc = new jsPDF({ orientation: orientation, unit: "pt", format: fmt });
    const headers = profile.cols.map(c => c.name);
    const body = profile.rows.map(r => headers.map(h => { const v = r[h]; return v == null ? "" : String(v); }));
    let startY = 40;
    const title = opts.title == null ? "" : String(opts.title).trim();
    if (title) { doc.setFontSize(15); doc.text(title, 40, 30); startY = 50; }
    let fontSize = parseInt(opts.fontSize, 10); if (!isFinite(fontSize) || fontSize < 5 || fontSize > 14) fontSize = 8;
    const includeHeader = opts.includeHeader !== false && opts.includeHeader !== "false";
    doc.autoTable({
      head: includeHeader ? [headers] : undefined,
      body: body,
      startY: startY,
      styles: { fontSize: fontSize, cellPadding: 4, overflow: "linebreak", valign: "middle" },
      headStyles: { fillColor: [13, 42, 34], textColor: [255, 255, 255], fontStyle: "bold" },
      alternateRowStyles: { fillColor: [246, 244, 238] },
      margin: { top: 40, left: 40, right: 40, bottom: 40 }
    });
    return new Uint8Array(doc.output("arraybuffer"));
  }

  // ---------- CSV → Multiline (template) ----------
  // Template syntax: {{column_name}} placeholders. Optional row separator.
  function csvToMultiline(profile, opts) {
    opts = opts || {};
    const tmpl = opts.template || profile.cols.map(c => c.name + ": {{" + c.name + "}}").join("\n");
    const sep = opts.separator || "\n---\n";
    const out = [];
    for (const r of profile.rows) {
      const rendered = tmpl.replace(/\{\{\s*([^}]+?)\s*\}\}/g, (_, k) => {
        const v = r[k.trim()];
        return v == null ? "" : String(v);
      });
      out.push(rendered);
    }
    return out.join(sep);
  }

  // Attach all Phase 5 helpers to the existing Convert namespace (the module-level
  // const from the main IIFE above). `window.Convert` isn't assigned yet at this
  // point in the bundle, so we must use the in-scope `Convert` directly.
  // TSV (tab-separated) -> CSV. Tabs effectively never occur inside fields, so a
  // newline/tab split is safe; fields are re-quoted RFC-4180 style so the result
  // is valid CSV. Strips a BOM and a single trailing newline.
  function tsvToCSV(text) {
    if (text == null) return "";
    if (text.charCodeAt(0) === 0xfeff) text = text.slice(1);
    var esc = function (cell) {
      return /[",\n\r]/.test(cell) ? '"' + cell.replace(/"/g, '""') + '"' : cell;
    };
    return text.replace(/\r\n?/g, "\n").replace(/\n$/, "").split("\n")
      .map(function (line) { return line.split("\t").map(esc).join(","); })
      .join("\n");
  }

  Convert.csvToYAML = csvToYAML;
  Convert.yamlToCSV = yamlToCSV;
  Convert.tsvToCSV = tsvToCSV;
  Convert.parseYAML = parseYAML;
  Convert.sqlToCSV = sqlToCSV;
  Convert.htmlTableToCSV = htmlTableToCSV;
  Convert.fixedWidthToCSV = fixedWidthToCSV;
  Convert.autoDetectBoundaries = autoDetectBoundaries;
  Convert.csvToFixedWidth = csvToFixedWidth;
  Convert.csvToGeoJSON = csvToGeoJSON;
  Convert.geojsonToCSV = geojsonToCSV;
  Convert.csvToKML = csvToKML;
  Convert.csvToGPX = csvToGPX;
  Convert.gpxToCSV = gpxToCSV;
  Convert.csvToPDF = csvToPDF;
  Convert.csvToMultiline = csvToMultiline;
  Convert.detectLatLon = detectLatLon;

  // Local helpers reused from the main Convert IIFE — they're already in scope
  // via the global Convert assignment, but we add minimal versions here for safety.
  function csvEscape(v) {
    const s = v == null ? "" : String(v);
    return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }
  function xmlEscape(v) {
    return String(v == null ? "" : v)
      // Drop control chars XML 1.0 forbids (keep Tab/LF/CR) so a stray byte in a
      // cell doesn't make the document not-well-formed.
      .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, "")
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&apos;");
  }
})();

// =========================================================================
// PHASE 3 — Pipeline engine
// Pure function. Takes an initial CSV string + an ordered list of step descriptors,
// dispatches each step to the existing Convert.* helpers (no duplicate logic),
// and returns the final CSV plus a per-step history with row-count deltas.
// =========================================================================
const Pipeline = (function () {

  // V7 E: cleanHeaders/trim/fillBlanks/selectColumns promote the standalone
  // reshape tools (Convert.reshape_*) into chainable steps.
  const KINDS = ["validate", "cleanHeaders", "trim", "fillBlanks", "dedupe", "filter", "sort", "selectColumns", "sql", "split"];

  const LABELS = {
    validate: "Validate",
    cleanHeaders: "Clean headers",
    trim: "Trim whitespace",
    fillBlanks: "Fill blanks",
    dedupe: "Remove duplicates",
    filter: "Filter rows",
    sort: "Sort rows",
    selectColumns: "Select columns",
    sql: "Query with SQL",
    split: "Split CSV"
  };

  const DEFAULTS = {
    validate: {},
    cleanHeaders: { style: "snake_case" },
    trim: { collapseSpaces: true },
    fillBlanks: { method: "forward fill", value: "" },
    dedupe: { columns: [], caseInsensitive: false },
    filter: { filters: [{ col: "", op: "=", value: "" }] },
    sort: { col: "", dir: "asc" },
    selectColumns: { columns: [] },
    sql: { sql: "" },
    split: { mode: "rowCount", rowsPerFile: 1000, numFiles: 2, byColumn: "" }
  };

  // step kind → Convert.reshape_* function + how to summarize its stats
  const RESHAPE_STEPS = {
    cleanHeaders: { fn: "reshape_cleanHeaders", sum: (r, c) => (c.style || "snake_case") },
    trim: { fn: "reshape_trimWhitespace", sum: r => ((r.stats && r.stats["cells changed"]) || 0) + " cells changed" },
    fillBlanks: { fn: "reshape_fillBlanks", sum: r => ((r.stats && r.stats["cells filled"]) || 0) + " filled" },
    selectColumns: { fn: "reshape_selectColumns", sum: r => ((r.stats && r.stats["columns kept"]) != null ? r.stats["columns kept"] + " columns kept" : "all columns") }
  };

  function newStep(kind) {
    if (!KINDS.includes(kind)) throw new Error("Unknown step kind: " + kind);
    return {
      id: "s-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 6),
      kind,
      enabled: true,
      config: JSON.parse(JSON.stringify(DEFAULTS[kind]))
    };
  }

  function parse(csv) {
    const parsed = CSVTool.parseCSV(csv);
    const profile = CSVTool.profile(parsed);
    return profile;
  }

  // Returns { finalCSV, history: [{ id, kind, enabled, skipped?, rowsIn, rowsOut, summary, csv, chunks?, report?, error?, terminal? }] }
  function run(initialCSV, steps) {
    if (!initialCSV) return { finalCSV: "", history: [], finalChunks: null };
    let currentCSV = initialCSV;
    let lastChunks = null;
    const history = [];

    for (const step of steps) {
      if (!step.enabled) {
        history.push({ id: step.id, kind: step.kind, enabled: false, skipped: true });
        continue;
      }

      let profile;
      try { profile = parse(currentCSV); }
      catch (e) {
        history.push({ id: step.id, kind: step.kind, enabled: true, error: "Couldn't parse CSV at this stage: " + e.message });
        break;
      }

      const rowsIn = profile.rows.length;
      const entry = { id: step.id, kind: step.kind, enabled: true, rowsIn };

      try {
        if (step.kind === "validate") {
          const r = Convert.validateCSV(profile, currentCSV);
          entry.report = r;
          entry.rowsOut = rowsIn;
          entry.summary = r.issues.length === 0
            ? "no issues"
            : r.issues.length + " issue" + (r.issues.length === 1 ? "" : "s");
          entry.csv = currentCSV;
        } else if (step.kind === "dedupe") {
          const r = Convert.dedupe(profile, step.config);
          entry.csv = r.csv;
          entry.rowsOut = r.stats.kept;
          entry.summary = r.stats.dropped + " dropped";
          currentCSV = r.csv;
        } else if (step.kind === "filter") {
          const r = Convert.sortFilter(profile, { filters: step.config.filters });
          entry.csv = r.csv;
          entry.rowsOut = r.stats.rows;
          const fc = (step.config.filters || []).filter(f => f && f.col && f.op).length;
          entry.summary = fc === 0 ? "no filter set" : (fc === 1 ? "1 filter" : fc + " filters (AND)");
          currentCSV = r.csv;
        } else if (step.kind === "sort") {
          if (!step.config.col) {
            entry.csv = currentCSV;
            entry.rowsOut = rowsIn;
            entry.summary = "no sort column set";
          } else {
            const r = Convert.sortFilter(profile, { sortCol: step.config.col, sortDir: step.config.dir });
            entry.csv = r.csv;
            entry.rowsOut = r.stats.rows;
            entry.summary = "sorted by " + step.config.col + " " + (step.config.dir === "desc" ? "↓" : "↑");
            currentCSV = r.csv;
          }
        } else if (step.kind === "sql") {
          if (!step.config.sql || !step.config.sql.trim()) {
            entry.csv = currentCSV;
            entry.rowsOut = rowsIn;
            entry.summary = "no query set";
          } else {
            const r = Convert.sqlQuery(profile, step.config);
            entry.csv = r.csv;
            entry.rowsOut = r.stats.rows;
            entry.summary = "query returned " + r.stats.rows;
            currentCSV = r.csv;
          }
        } else if (RESHAPE_STEPS[step.kind]) {
          // selectColumns with nothing picked = pass-through (matches the
          // standalone tool's "empty = all" behavior, but don't reshape noise)
          if (step.kind === "selectColumns" && !(step.config.columns || []).length) {
            entry.csv = currentCSV;
            entry.rowsOut = rowsIn;
            entry.summary = "no columns picked — unchanged";
          } else {
            const spec = RESHAPE_STEPS[step.kind];
            const r = Convert[spec.fn](profile, step.config);
            const csv = typeof r === "string" ? r : r.csv;
            entry.csv = csv;
            entry.rowsOut = rowsIn; // these reshape rows in place, never drop them
            entry.summary = spec.sum(typeof r === "string" ? {} : r, step.config);
            currentCSV = csv;
          }
        } else if (step.kind === "split") {
          const r = Convert.splitCSV(profile, step.config);
          entry.chunks = r.chunks;
          entry.rowsOut = rowsIn; // split doesn't change overall row count
          entry.summary = r.chunks.length + " file" + (r.chunks.length === 1 ? "" : "s") + " · " + r.stats.mode;
          entry.terminal = true;
          lastChunks = r.chunks;
          // Don't update currentCSV — split is a terminal action
        }
      } catch (e) {
        entry.error = e.message || String(e);
      }

      history.push(entry);
      if (entry.terminal) break;
      if (entry.error) break;
    }

    return { finalCSV: currentCSV, history, finalChunks: lastChunks };
  }

  return { KINDS, LABELS, DEFAULTS, newStep, run };
})();
window.Pipeline = Pipeline;

// =========================================================================
// InsightStrip — 4 KPI tiles + 3 deterministic bullets + suggested chart
// =========================================================================
function InsightStrip({ profile, onBuildDashboard }) {
  if (!profile || !profile.cols || profile.cols.length === 0) return null;
  const { rows, cols } = profile;

  // KPIs
  const chartable = cols.filter(c => c.role !== "id");
  const nums = chartable.filter(c => c.type === "number").sort((a, b) => b.importance - a.importance);
  const cats = chartable.filter(c => c.type === "category" || c.type === "boolean").sort((a, b) => b.importance - a.importance);
  const dates = chartable.filter(c => c.type === "date");
  const num = nums[0];
  const cat = cats[0];
  const date = dates[0];

  // Missing-values count
  let missing = 0;
  for (const r of rows) for (const c of cols) {
    const v = r[c.name];
    if (v === "" || v == null) missing++;
  }

  // Outlier count using existing helper if defined; otherwise inline
  let outlierCount = 0;
  if (num && num.nums && num.nums.length >= 6) {
    const mean = num.avg;
    const variance = num.nums.reduce((s, n) => s + (n - mean) ** 2, 0) / num.nums.length;
    const sigma = Math.sqrt(variance);
    if (sigma > 0) {
      outlierCount = num.nums.filter(n => Math.abs((n - mean) / sigma) >= 2).length;
    }
  }

  // KPI tiles
  const tiles = [
    { label: "Rows", value: fmtNum(rows.length) },
    { label: "Columns", value: String(cols.length) }
  ];
  if (num) {
    const useAvg = num.role === "rating" || num.role === "percent" || num.role === "age";
    tiles.push({
      label: (useAvg ? "Avg · " : "Total · ") + num.name,
      value: fmtByCol(num, useAvg ? num.avg : num.sum)
    });
  }
  if (missing > 0) {
    tiles.push({ label: "Missing values", value: fmtNum(missing) });
  } else if (cat) {
    tiles.push({ label: "Top · " + cat.name, value: cat.counts[0]?.key || "—" });
  } else if (date && date.minDate && date.maxDate) {
    const days = Math.round((date.maxDate - date.minDate) / 86400000);
    const rng = days >= 365 ? (days / 365).toFixed(1) + "y" : days >= 60 ? Math.round(days / 30) + "mo" : days + "d";
    tiles.push({ label: "Range", value: rng });
  } else {
    tiles.push({ label: "Outliers", value: String(outlierCount) });
  }

  // Bullet insights — reuse generateInsights if present, otherwise simple fallback
  let bullets = [];
  try {
    if (typeof generateInsights === "function") bullets = generateInsights(profile).slice(0, 3);
  } catch (e) { /* fall through */ }
  if (bullets.length === 0) {
    if (num) bullets.push(`Primary numeric ${num.name} ranges from ${fmtByCol(num, num.min)} to ${fmtByCol(num, num.max)}.`);
    if (cat && cat.counts[0]) {
      const pct = (cat.counts[0].value / rows.length * 100).toFixed(0);
      bullets.push(`${cat.counts[0].key} appears in ${pct}% of rows of ${cat.name}.`);
    }
    if (outlierCount > 0) bullets.push(`${outlierCount} row${outlierCount === 1 ? " is an" : "s are"} outlier${outlierCount === 1 ? "" : "s"} in ${num.name}.`);
  }
  bullets = bullets.slice(0, 3);

  // Suggested chart
  let suggested = "Bar chart by category";
  if (num && date) suggested = `Line chart — ${num.name} over time`;
  else if (num && cat) suggested = `Bar chart — ${num.name} by ${cat.name}`;
  else if (num) suggested = `Distribution of ${num.name}`;
  else if (cat) suggested = `Counts by ${cat.name}`;

  return (
    <div className="insight-strip">
      <div className="insight-strip-head">
        <span className="insight-strip-eyebrow"><span className="dot"></span>What's in this data</span>
        {onBuildDashboard && (
          <button className="insight-strip-cta" onClick={onBuildDashboard}>
            View full dashboard →
          </button>
        )}
      </div>
      <div className="insight-strip-tiles">
        {tiles.map((t, i) => (
          <div className="insight-strip-tile" key={i}>
            <div className="insight-strip-tile-label">{t.label}</div>
            <div className="insight-strip-tile-value">{t.value}</div>
          </div>
        ))}
      </div>
      {bullets.length > 0 && (
        <ul className="insight-strip-bullets">
          {bullets.map((b, i) => <li key={i}>{b}</li>)}
        </ul>
      )}
      <div className="insight-strip-suggest">
        <span className="insight-strip-suggest-label">Suggested chart</span>
        <span className="insight-strip-suggest-value">{suggested}</span>
      </div>
    </div>
  );
}

// =========================================================================
// ConverterShell — the page-level component every /csv-to-X uses.
// Reads window.CONVERT_CONFIG: { inputFormat, outputFormat, downloadExtension, mimeType, optionsSchema }
// =========================================================================

const DEFAULT_CONVERT_CONFIG = {
  inputFormat: "csv",     // csv | json | xlsx
  outputFormat: "json",   // json | sql | markdown | html | xml | xlsx | csv
  downloadExtension: "json",
  downloadMime: "application/json",
  options: {},            // initial options for the chosen converter
  headline: "Convert your CSV.",
  subhead: "Drop a file, see clean output and what your data is telling you — instantly."
};

// Lazy-load SheetJS (XLSX) on demand; cached after first load via a shared
// global flag. The converter shell + pipeline both need this for any xlsx
// read/write. app.jsx defines its own copy inside the dashboard component, but
// converter.jsx is concatenated BEFORE app.jsx, so the converter pages need
// their own module-scope loader here — otherwise xlsx tools throw
// "ensureXLSX is not defined" / "XLSX library not loaded".
function ensureXLSX() {
  if (typeof window.XLSX !== "undefined") return Promise.resolve();
  if (window.__xlsxLoading) return window.__xlsxLoading;
  window.__xlsxLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "/vendor/xlsx.full.min.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Could not load XLSX library"));
    document.head.appendChild(s);
  });
  return window.__xlsxLoading;
}

// Lazy-load jsPDF + the autoTable plugin (only the csv-to-pdf page ever needs
// them). Same self-hosted, on-demand pattern as ensureXLSX.
function pdfEngineReady() {
  return !!(window.jspdf && window.jspdf.jsPDF && window.jspdf.jsPDF.API && window.jspdf.jsPDF.API.autoTable);
}
function ensurePDF() {
  if (pdfEngineReady()) return Promise.resolve();
  if (window.__pdfLoading) return window.__pdfLoading;
  const load = src => new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src; s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Could not load " + src));
    document.head.appendChild(s);
  });
  window.__pdfLoading = load("/vendor/jspdf.umd.min.js").then(() => load("/vendor/jspdf.plugin.autotable.min.js"));
  return window.__pdfLoading;
}

// Lazy-load the Apache Arrow UMD bundle (sets window.Arrow). Only the
// csv-to-arrow page ever needs it. Same self-hosted, on-demand pattern.
function ensureArrow() {
  if (typeof window.Arrow !== "undefined") return Promise.resolve();
  if (window.__arrowLoading) return window.__arrowLoading;
  window.__arrowLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "/vendor/arrow.es2015.min.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Could not load Arrow library"));
    document.head.appendChild(s);
  });
  return window.__arrowLoading;
}

// Lazy-load the (esbuild-bundled) Parquet writer (sets window.hyparquetWriter).
function ensureParquet() {
  if (window.hyparquetWriter) return Promise.resolve();
  if (window.__parquetLoading) return window.__parquetLoading;
  window.__parquetLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "/vendor/hyparquet-writer.global.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Could not load Parquet library"));
    document.head.appendChild(s);
  });
  return window.__parquetLoading;
}

// SQL-query "Power mode": lazy-load DuckDB-WASM (the SINGLE-THREAD build — DuckDB
// auto-picks it when crossOriginIsolated is false, so NO COOP/COEP headers are
// needed and AdSense is unaffected). Loaded from the CDN only when the user opts
// in (the engine is ~10MB+ gzipped — too heavy to self-host in the repo). The
// CSV is registered as table "csv" and re-registered only when the data changes.
// Returns an api { query(sql, csvText) -> { csv, cols, rows, count } }.
const DUCKDB_CDN = "https://cdn.jsdelivr.net/npm/@duckdb/duckdb-wasm@1.29.0/+esm";
function ensureDuckDB() {
  if (window.__duckdbApi) return Promise.resolve(window.__duckdbApi);
  if (window.__duckdbLoading) return window.__duckdbLoading;
  window.__duckdbLoading = (async () => {
    const duckdb = await import(/* @vite-ignore */ DUCKDB_CDN);
    const bundle = await duckdb.selectBundle(duckdb.getJsDelivrBundles());
    // Cross-origin Worker is blocked, so wrap the CDN worker in a same-origin blob.
    const workerUrl = URL.createObjectURL(new Blob(['importScripts("' + bundle.mainWorker + '");'], { type: "text/javascript" }));
    const db = new duckdb.AsyncDuckDB(new duckdb.ConsoleLogger(), new Worker(workerUrl));
    await db.instantiate(bundle.mainModule, bundle.pthreadWorker);

    function esc(v) { const s = (v === null || v === undefined) ? "" : String(v); return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s; }
    let registered = null, registeredExtras = "";
    const api = {
      // extras: [{name:"csv2", csv}] — fixed names assigned by the shell, so
      // they're safe to splice into DDL.
      async query(sql, csvText, extras) {
        const conn = await db.connect();
        try {
          if (registered !== csvText) {
            await db.registerFileText("__data.csv", csvText);
            await conn.query("CREATE OR REPLACE TABLE csv AS SELECT * FROM read_csv_auto('__data.csv', header=true)");
            registered = csvText;
          }
          // Full-string fingerprint — a length+first-80-chars hash could serve a
          // stale JOIN when two different tables share that prefix (V7 audit).
          const extSig = (extras || []).map(t => t.name + ":" + t.csv).join("");
          if (registeredExtras !== extSig) {
            for (const t of (extras || [])) {
              await db.registerFileText("__" + t.name + ".csv", t.csv);
              await conn.query("CREATE OR REPLACE TABLE " + t.name + " AS SELECT * FROM read_csv_auto('__" + t.name + ".csv', header=true)");
            }
            registeredExtras = extSig;
          }
          const res = await conn.query(sql);
          const cols = res.schema.fields.map(f => f.name);
          const rows = res.toArray().map(r => { const o = r.toJSON(); const out = {}; for (const c of cols) out[c] = o[c]; return out; });
          const lines = [cols.map(esc).join(",")];
          for (const r of rows) lines.push(cols.map(c => esc(r[c])).join(","));
          return { csv: lines.join("\r\n"), cols, rows, count: rows.length };
        } finally { try { await conn.close(); } catch (e) {} }
      }
    };
    window.__duckdbApi = api;
    return api;
  })().catch(e => { window.__duckdbLoading = null; throw e; });
  return window.__duckdbLoading;
}

// V7 Batch C — lazy loader for the SQL workbench chunk (sqlbench.js: syntax
// highlighting + query history/snippets). Loaded only on /csv-sql-query so it
// stays out of the main bundle budget.
// Lazy-load convert-extra.js (the ~100KB chunk of markup/format converters,
// reshape_*, texttool_*, gen_* and fmt_* — none used by the homepage/dashboard,
// so they're carved out of the main bundle). It attaches its functions onto
// window.Convert and sets window.__convertExtraReady when done.
function ensureConvertExtra() {
  if (window.__convertExtraReady) return Promise.resolve();
  if (window.__convertExtraLoading) return window.__convertExtraLoading;
  window.__convertExtraLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "/convert-extra.js";
    s.async = true;
    s.onload = () => { if (window.__convertExtraReady) { resolve(); } else { window.__convertExtraLoading = null; reject(new Error("convert-extra failed to initialize")); } };
    s.onerror = () => { window.__convertExtraLoading = null; reject(new Error("Could not load the converters")); };
    document.head.appendChild(s);
  });
  return window.__convertExtraLoading;
}

// Hook for any shell that dispatches a convert-extra function: returns true once
// the chunk is attached, and kicks off the load on mount. Shells gate their
// dispatch on this and show a brief "loading" state until ready.
function useConvertExtra(needed) {
  if (needed === undefined) needed = true;
  const [ready, setReady] = useState(typeof window !== "undefined" && !!window.__convertExtraReady);
  useEffect(() => { if (needed && !ready) ensureConvertExtra().then(() => setReady(true)).catch(() => {}); }, [needed]);
  return ready;
}
// Output formats whose converters live in the lazy convert-extra chunk (so the
// ConverterShell gates output on the chunk; json/sql/csv/html/xml/xlsx/yaml/etc.
// are in-bundle and need no gate). Reverse-input handlers self-gate below.
const CE_OUTPUTS = { latex: 1, rst: 1, asciidoc: 1, mediawiki: 1, toml: 1, ini: 1, ndjson: 1, delimited: 1, tsv: 1, code: 1, arrow: 1, parquet: 1 };

function ensureSqlBench() {
  if (window.SqlBench) return Promise.resolve(window.SqlBench);
  if (window.__sqlBenchLoading) return window.__sqlBenchLoading;
  window.__sqlBenchLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "/sqlbench.js";
    s.async = true;
    s.onload = () => (window.SqlBench ? resolve(window.SqlBench) : reject(new Error("SQL workbench failed to initialize")));
    s.onerror = () => { window.__sqlBenchLoading = null; reject(new Error("Could not load the SQL workbench")); };
    document.head.appendChild(s);
  });
  return window.__sqlBenchLoading;
}

function ConverterShell({ config }) {
  const cfg = { ...DEFAULT_CONVERT_CONFIG, ...(config || {}) };
  const isTool = !!cfg.action; // Phase 2 tool-mode flag
  const needsCE = !!CE_OUTPUTS[cfg.outputFormat]; // this page's output format lives in the lazy convert-extra chunk
  const ceReady = useConvertExtra(needsCE);
  const [csvText, setCsvText] = useState("");
  const [profile, setProfile] = useState(null);
  const [output, setOutput] = useState("");
  const [outputBinary, setOutputBinary] = useState(null);
  const [outputChunks, setOutputChunks] = useState(null);  // for split tool
  const [validateReport, setValidateReport] = useState(null); // for validate tool
  const [toolStats, setToolStats] = useState(null);
  const [filename, setFilename] = useState("data");
  const [error, setError] = useState("");
  const [xlsxReady, setXlsxReady] = useState(0); // bumped when SheetJS finishes loading → re-runs the xlsx conversion
  const [pdfReady, setPdfReady] = useState(0); // bumped when jsPDF+autoTable finish loading → re-runs the pdf conversion
  const [arrowReady, setArrowReady] = useState(0); // bumped when Arrow finishes loading → re-runs the arrow conversion
  const [parquetReady, setParquetReady] = useState(0); // bumped when the Parquet writer finishes loading → re-runs
  const [opts, setOpts] = useState(cfg.options || {});
  const [copied, setCopied] = useState(false);
  const [pendingSheets, setPendingSheets] = useState(null);
  const [xlsxBusy, setXlsxBusy] = useState(false); // "Download .xlsx" on reverse converters (lazy SheetJS load)
  const [saved, setSaved] = useState(false); // brief "Saved ✓" flash after a download
  // V7 Batch C — SQL workbench state (only used when action === "sqlQuery")
  const [sqlBench, setSqlBench] = useState(() => window.SqlBench || null);
  const [extraTables, setExtraTables] = useState([]); // [{name:"csv2", label, csv, headers}]
  const sqlFileRef = useRef(null);

  useEffect(() => {
    if (!isTool || cfg.action !== "sqlQuery" || window.SqlBench) return;
    ensureSqlBench()
      .then(api => { api.setPersist(typeof wsEnabled === "function" && wsEnabled()); setSqlBench(api); })
      .catch(() => {}); // plain textarea keeps working without the chunk
  }, [isTool, cfg.action]);

  function addExtraTable(text, label) {
    if (!text || !text.trim()) return;
    let headers = [];
    try { headers = CSVTool.parseCSV(text.slice(0, text.indexOf("\n") > 0 ? text.indexOf("\n") : text.length)).headers || []; } catch (e) {}
    setExtraTables(ts => {
      if (ts.length >= 2) return ts;
      return ts.concat([{ name: "csv" + (ts.length + 2), label: label || "table", csv: text, headers }]);
    });
    // joining needs the real engine — flip Power mode on for the user
    setOpts(o => (o.duckdb ? o : { ...o, duckdb: true }));
  }
  function onAddTableFile(e) {
    const f = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!f) return;
    if (f.size > 50 * 1024 * 1024) { setError("That file is over 50 MB — too large for a join table here. Trim it first (/csv-split)."); return; }
    const reader = new FileReader();
    reader.onload = ev => addExtraTable(ev.target.result, f.name);
    reader.onerror = () => setError("Could not read that file.");
    reader.readAsText(f);
  }

  // The file this page would hand to another tool: the tool RESULT when it's
  // CSV (dedupe/sort/query/…), else the loaded input. Used by send-to + palette.
  function currentPayload() {
    if (isTool && output && !outputBinary && !outputChunks && cfg.action !== "validate") {
      return { csv: output, name: filename + "-" + (cfg.action || "result") + ".csv" };
    }
    return csvText ? { csv: csvText, name: filename + ".csv" } : null;
  }

  // V6 workspace wiring — only CSV-input pages can ingest a handed-off CSV
  // (a stored CSV pasted into, say, the JSON→CSV input would be nonsense).
  useToolFile(
    cfg.inputFormat === "csv" ? ((csv, name) => loadCSVText(csv, name)) : null,
    () => currentPayload()
  );

  function clear() {
    setCsvText("");
    setProfile(null);
    setOutput("");
    setOutputBinary(null);
    setOutputChunks(null);
    setValidateReport(null);
    setToolStats(null);
    setError("");
    setFilename("data");
    setPendingSheets(null);
  }

  // Convert / run-tool whenever csvText or opts change
  useEffect(() => {
    if (!csvText) {
      setProfile(null); setOutput(""); setOutputBinary(null);
      setOutputChunks(null); setValidateReport(null); setToolStats(null);
      return;
    }
    try {
      const parsed = CSVTool.parseCSV(csvText);
      if (parsed.headers.length === 0 || parsed.rows.length === 0) {
        setError("That doesn't look like a valid CSV — make sure there's a header row.");
        return;
      }
      const prof = CSVTool.profile(parsed);
      setProfile(prof);
      setError("");

      if (isTool) {
        try {
          if (cfg.action === "dedupe") {
            const r = Convert.dedupe(prof, opts);
            setOutput(r.csv); setOutputBinary(null); setOutputChunks(null); setValidateReport(null); setToolStats(r.stats);
          } else if (cfg.action === "sortFilter") {
            const r = Convert.sortFilter(prof, opts);
            setOutput(r.csv); setOutputBinary(null); setOutputChunks(null); setValidateReport(null); setToolStats(r.stats);
          } else if (cfg.action === "split") {
            const r = Convert.splitCSV(prof, opts);
            setOutputChunks(r.chunks); setOutput(r.chunks.length + " files generated · click Download to save them all"); setOutputBinary(null); setValidateReport(null); setToolStats(r.stats);
          } else if (cfg.action === "validate") {
            const r = Convert.validateCSV(prof, csvText);
            setValidateReport(r); setOutput(r.issues.length === 0 ? "✓ No issues found." : `${r.issues.length} issue${r.issues.length === 1 ? "" : "s"} detected — see report below`); setOutputBinary(null); setOutputChunks(null); setToolStats(r.stats);
          } else if (cfg.action === "sqlQuery") {
            // Power mode runs through DuckDB asynchronously (see the effect below);
            // the instant regex engine handles the default path.
            if (!opts.duckdb) {
              const r = Convert.sqlQuery(prof, opts);
              setOutput(r.csv); setOutputBinary(null); setOutputChunks(null); setValidateReport(null); setToolStats(r.stats);
              if (r.csv && window.SqlBench) window.SqlBench.record(opts.sql, { rows: r.stats && (r.stats.rows != null ? r.stats.rows : r.stats.groups), engine: "instant" });
            }
          } else {
            setOutput("Unknown tool action: " + cfg.action);
          }
        } catch (e) {
          setError(e.message || "Tool failed.");
        }
        return;
      }

      // Converter path
      // Gate on the lazy chunk for convert-extra output formats (latex/toml/
      // arrow/parquet/…); in-bundle formats (json/sql/csv/html/xml/xlsx/yaml)
      // run immediately.
      if (needsCE && !ceReady) { setOutput("Loading the converter…"); setOutputBinary(null); return; }
      switch (cfg.outputFormat) {
        case "json":     setOutput(Convert.csvToJSON(prof, opts)); setOutputBinary(null); break;
        case "sql":      setOutput(Convert.csvToSQL(prof, opts)); setOutputBinary(null); break;
        case "markdown": setOutput(Convert.csvToMarkdown(prof, opts)); setOutputBinary(null); break;
        case "html":     setOutput(Convert.csvToHTML(prof, opts)); setOutputBinary(null); break;
        case "xml":      setOutput(Convert.csvToXML(prof, opts)); setOutputBinary(null); break;
        case "xlsx":
          if (typeof window.XLSX !== "undefined") {
            setOutputBinary(Convert.csvToExcel(prof, opts));
            setOutput("[binary .xlsx output — click Download to save]");
          } else {
            // SheetJS isn't loaded on this page yet — fetch it, then re-run.
            setOutputBinary(null);
            setOutput("Preparing the .xlsx engine…");
            ensureXLSX().then(() => setXlsxReady(n => n + 1))
              .catch(() => setError("Could not load the XLSX engine. Check your connection and retry."));
          }
          break;
        case "pdf":
          if (pdfEngineReady()) {
            setOutputBinary(Convert.csvToPDF(prof, opts));
            setOutput("[binary .pdf output — click Download to save]");
          } else {
            setOutputBinary(null);
            setOutput("Preparing the .pdf engine…");
            ensurePDF().then(() => setPdfReady(n => n + 1))
              .catch(() => setError("Could not load the PDF engine. Check your connection and retry."));
          }
          break;
        case "arrow":
          if (typeof window.Arrow !== "undefined") {
            setOutputBinary(Convert.csvToArrow(prof));
            setOutput("[binary .arrow output — click Download to save]");
          } else {
            setOutputBinary(null);
            setOutput("Preparing the Arrow engine…");
            ensureArrow().then(() => setArrowReady(n => n + 1))
              .catch(() => setError("Could not load the Arrow engine. Check your connection and retry."));
          }
          break;
        case "parquet":
          if (window.hyparquetWriter) {
            setOutputBinary(Convert.csvToParquet(prof, opts));
            setOutput("[binary .parquet output — click Download to save]");
          } else {
            setOutputBinary(null);
            setOutput("Preparing the Parquet engine…");
            ensureParquet().then(() => setParquetReady(n => n + 1))
              .catch(() => setError("Could not load the Parquet engine. Check your connection and retry."));
          }
          break;
        case "csv":      setOutput(csvText); setOutputBinary(null); break;
        // Phase 5
        case "yaml":     setOutput(Convert.csvToYAML(prof, opts)); setOutputBinary(null); break;
        case "fixed":    setOutput(Convert.csvToFixedWidth(prof, opts)); setOutputBinary(null); break;
        case "geojson": {
          const r = Convert.csvToGeoJSON(prof, opts);
          // Output VALID JSON only — a // or /* */ note would make the downloaded
          // .geojson un-parseable. (Skipped rows simply yield fewer features.)
          setOutput(r.json); setOutputBinary(null);
          break;
        }
        case "kml": {
          const r = Convert.csvToKML(prof, opts);
          const note = r.skipped > 0 ? `\n<!-- ${r.skipped} of ${r.total} rows skipped — missing or out-of-range lat/lon -->` : "";
          setOutput(r.kml + note); setOutputBinary(null);
          break;
        }
        case "gpx": {
          const r = Convert.csvToGPX(prof, opts);
          const note = r.skipped > 0 ? `\n<!-- ${r.skipped} of ${r.total} rows skipped — missing or out-of-range lat/lon -->` : "";
          setOutput(r.gpx + note); setOutputBinary(null);
          break;
        }
        case "multiline": setOutput(Convert.csvToMultiline(prof, opts)); setOutputBinary(null); break;
        // Batch 3 — dev/format outputs (helpers defined in tools2.jsx)
        case "schema":   setOutput(Convert.csvToSchema(prof, opts)); setOutputBinary(null); break;
        case "notion":   setOutput(Convert.csvToNotion(prof)); setOutputBinary(null); break;
        case "airtable": setOutput(Convert.csvToAirtable(prof)); setOutputBinary(null); break;
        // Wave A — markup/format converters (bodies in convert-extra.jsx)
        case "latex":     setOutput(Convert.csvToLatex(prof, opts)); setOutputBinary(null); break;
        case "rst":       setOutput(Convert.csvToRst(prof, opts)); setOutputBinary(null); break;
        case "asciidoc":  setOutput(Convert.csvToAsciidoc(prof, opts)); setOutputBinary(null); break;
        case "mediawiki": setOutput(Convert.csvToMediawiki(prof, opts)); setOutputBinary(null); break;
        case "toml":      setOutput(Convert.csvToToml(prof, opts)); setOutputBinary(null); break;
        case "ini":       setOutput(Convert.csvToIni(prof, opts)); setOutputBinary(null); break;
        case "ndjson":    setOutput(Convert.csvToNdjson(prof, opts)); setOutputBinary(null); break;
        case "delimited": setOutput(Convert.csvToDelimited(prof, opts)); setOutputBinary(null); break;
        case "tsv":      setOutput(Convert.csvToDelimited(prof, Object.assign({}, opts, { delimiter: "\t" }))); setOutputBinary(null); break;
        case "code":      setOutput(Convert.csvToCode(prof, opts)); setOutputBinary(null); break;
        default:         setOutput("Unknown output format: " + cfg.outputFormat);
      }
    } catch (e) {
      setError(e.message || "Could not parse that input.");
    }
  }, [csvText, opts, cfg.outputFormat, cfg.action, isTool, xlsxReady, pdfReady, arrowReady, parquetReady, ceReady]);

  // ============ SQL Power mode (DuckDB) — async query path ============
  useEffect(() => {
    if (!isTool || cfg.action !== "sqlQuery" || !opts.duckdb) return;
    if (!csvText || !opts.sql || !opts.sql.trim()) {
      setOutput(csvText ? "Enter a SQL query above." : "");
      setToolStats(null);
      return;
    }
    let cancelled = false;
    setError("");
    setOutput(window.__duckdbApi ? "Running query in DuckDB…" : "Loading the DuckDB engine (first run only)…");
    setToolStats(null); // status text must not render through the result grid
    setOutputBinary(null); setOutputChunks(null); setValidateReport(null);
    ensureDuckDB()
      .then(api => api.query(opts.sql, csvText, extraTables))
      .then(res => {
        if (cancelled) return;
        setOutput(res.csv);
        setToolStats({ rows: res.count, columns: res.cols.length, engine: "DuckDB" });
        if (window.SqlBench) window.SqlBench.record(opts.sql, { rows: res.count, engine: "duckdb" });
      })
      .catch(e => {
        if (cancelled) return;
        setOutput("");
        setToolStats(null);
        setError("DuckDB: " + (e && e.message ? e.message : "query failed"));
      });
    return () => { cancelled = true; };
  }, [isTool, cfg.action, opts.duckdb, opts.sql, csvText, extraTables]);

  // Seed a working starter query the first time data is loaded into the SQL tool,
  // so the sample (and any drop) shows real result rows instead of just the column
  // list. Only auto-fills once and only while the box is empty — the user can edit
  // or clear it freely. Uses the default engine's GROUP BY, so no Power mode needed.
  const sqlSeededRef = useRef(false);
  useEffect(() => {
    if (!isTool || cfg.action !== "sqlQuery" || !csvText) return;
    if ((opts.sql && opts.sql.trim()) || sqlSeededRef.current) return;
    let prof; try { prof = CSVTool.profile(CSVTool.parseCSV(csvText)); } catch (e) { return; }
    if (!prof || !prof.cols || !prof.cols.length) return;
    sqlSeededRef.current = true;
    const cat = prof.cols.find(c => (c.type === "category" || c.type === "boolean") && c.role !== "id");
    const num = prof.cols.find(c => c.type === "number" && c.role !== "id");
    const q = (cat && num)
      ? `SELECT ${cat.name}, SUM(${num.name}) AS total\nFROM csv\nGROUP BY ${cat.name}\nORDER BY total DESC`
      : (num ? `SELECT * FROM csv WHERE ${num.name} > 0 ORDER BY ${num.name} DESC LIMIT 10` : `SELECT * FROM csv LIMIT 20`);
    setOpts(o => ({ ...o, sql: q }));
  }, [csvText, isTool, cfg.action]);

  // ============ Input ingestion ============

  function loadCSVText(text, name) {
    setCsvText(text);
    setFilename((name || "data").replace(/\.[^.]+$/, ""));
    wsMaybeSave(name || "data.csv", text);
  }

  function handleJSONText(text) {
    try {
      const converted = Convert.jsonToCSV(text);
      loadCSVText(converted, "from-json");
    } catch (e) {
      setError(e.message);
    }
  }

  // Phase 5 — reverse format ingestion
  function handleYAMLText(text) {
    try { loadCSVText(Convert.yamlToCSV(text), "from-yaml"); }
    catch (e) { setError(e.message); }
  }
  function handleSQLText(text) {
    try { loadCSVText(Convert.sqlToCSV(text), "from-sql"); }
    catch (e) { setError(e.message); }
  }
  function handleHTMLText(text) {
    try { loadCSVText(Convert.htmlTableToCSV(text), "from-html"); }
    catch (e) { setError(e.message); }
  }
  function handleGeoJSONText(text) {
    try { loadCSVText(Convert.geojsonToCSV(text), "from-geojson"); }
    catch (e) { setError(e.message); }
  }
  function handleGPXText(text) {
    try { loadCSVText(Convert.gpxToCSV(text), "from-gpx"); }
    catch (e) { setError(e.message); }
  }
  function handleFixedText(text) {
    // Stash the raw text so the boundaries control can re-parse on demand
    setOpts(o => ({ ...o, __rawFixed: text }));
    try {
      const cuts = opts.boundaries || Convert.autoDetectBoundaries(text);
      loadCSVText(Convert.fixedWidthToCSV(text, cuts), "from-fixed-width");
    } catch (e) { setError(e.message); }
  }
  // Wave B — reverse format ingestion (parsers in convert-extra.jsx)
  // These parsers live in the lazy convert-extra chunk, and detection (isXML/isMD)
  // can call them on any page — so await the chunk before converting.
  function handleXMLText(text) { ensureConvertExtra().then(() => { try { loadCSVText(Convert.xmlToCSV(text), "from-xml"); } catch (e) { setError(e.message); } }).catch(() => setError("Could not load the converter.")); }
  function handleMarkdownText(text) { ensureConvertExtra().then(() => { try { loadCSVText(Convert.markdownToCSV(text), "from-markdown"); } catch (e) { setError(e.message); } }).catch(() => setError("Could not load the converter.")); }
  function handleTSVText(text) { try { loadCSVText(Convert.tsvToCSV(text), "from-tsv"); } catch (e) { setError(e.message); } }
  function handleTOMLText(text) { ensureConvertExtra().then(() => { try { loadCSVText(Convert.tomlToCSV(text), "from-toml"); } catch (e) { setError(e.message); } }).catch(() => setError("Could not load the converter.")); }
  function handleNDJSONText(text) { ensureConvertExtra().then(() => { try { loadCSVText(Convert.ndjsonToCSV(text), "from-ndjson"); } catch (e) { setError(e.message); } }).catch(() => setError("Could not load the converter.")); }
  function handleINIText(text) { ensureConvertExtra().then(() => { try { loadCSVText(Convert.iniToCSV(text), "from-ini"); } catch (e) { setError(e.message); } }).catch(() => setError("Could not load the converter.")); }

  function handleXLSXBuffer(buf, name) {
    try {
      const sheets = Convert.excelToCSV(buf);
      if (!sheets.length) { setError("That workbook didn't have any rows."); return; }
      if (sheets.length === 1) {
        loadCSVText(sheets[0].csv, name);
      } else {
        setPendingSheets({ sheets, filename: name });
      }
    } catch (e) {
      setError(e.message);
    }
  }

  function handleFile(file) {
    if (!file) return;
    setFilename(file.name.replace(/\.[^.]+$/, ""));
    const reader = new FileReader();
    const isXLSX = /\.(xlsx|xls)$/i.test(file.name);
    const isJSON = /\.json$/i.test(file.name);
    const isYAML = /\.(ya?ml)$/i.test(file.name);
    const isSQL = /\.sql$/i.test(file.name);
    const isHTML = /\.(html?|htm)$/i.test(file.name);
    const isGeo = /\.geojson$/i.test(file.name);
    const isGPX = /\.gpx$/i.test(file.name);
    const isXML = /\.xml$/i.test(file.name);
    const isMD = /\.(md|markdown)$/i.test(file.name);
    const isTOML = /\.toml$/i.test(file.name);
    const isNDJSON = /\.(ndjson|jsonl|jsonlines)$/i.test(file.name);
    const isINI = /\.(ini|cfg|conf)$/i.test(file.name);
    const isTSV = /\.(tsv|tab)$/i.test(file.name);
    reader.onerror = () => setError("Could not read file.");
    if (isXLSX) {
      reader.onload = e => ensureXLSX().then(() => handleXLSXBuffer(e.target.result, file.name));
      reader.readAsArrayBuffer(file);
      return;
    }
    reader.onload = e => {
      const text = e.target.result;
      if (cfg.inputFormat === "yaml" || isYAML) handleYAMLText(text);
      else if (cfg.inputFormat === "sql" || isSQL) handleSQLText(text);
      else if (cfg.inputFormat === "html" || isHTML) handleHTMLText(text);
      else if (cfg.inputFormat === "geojson" || isGeo) handleGeoJSONText(text);
      else if (cfg.inputFormat === "gpx" || isGPX) handleGPXText(text);
      else if (cfg.inputFormat === "fixed") handleFixedText(text);
      else if (cfg.inputFormat === "xml" || isXML) handleXMLText(text);
      else if (cfg.inputFormat === "markdown" || isMD) handleMarkdownText(text);
      else if (cfg.inputFormat === "toml" || isTOML) handleTOMLText(text);
      else if (cfg.inputFormat === "ndjson" || isNDJSON) handleNDJSONText(text);
      else if (cfg.inputFormat === "ini" || isINI) handleINIText(text);
      else if (cfg.inputFormat === "tsv" || isTSV) handleTSVText(text);
      else if (cfg.inputFormat === "json" || isJSON) handleJSONText(text);
      else loadCSVText(text, file.name);
    };
    reader.readAsText(file);
  }

  function onPasteInput(text) {
    if (cfg.inputFormat === "yaml") handleYAMLText(text);
    else if (cfg.inputFormat === "sql") handleSQLText(text);
    else if (cfg.inputFormat === "html") handleHTMLText(text);
    else if (cfg.inputFormat === "geojson") handleGeoJSONText(text);
    else if (cfg.inputFormat === "gpx") handleGPXText(text);
    else if (cfg.inputFormat === "fixed") handleFixedText(text);
    else if (cfg.inputFormat === "xml") handleXMLText(text);
    else if (cfg.inputFormat === "markdown") handleMarkdownText(text);
    else if (cfg.inputFormat === "toml") handleTOMLText(text);
    else if (cfg.inputFormat === "ndjson") handleNDJSONText(text);
    else if (cfg.inputFormat === "ini") handleINIText(text);
    else if (cfg.inputFormat === "tsv") handleTSVText(text);
    else if (cfg.inputFormat === "json") handleJSONText(text);
    else loadCSVText(text, "pasted");
  }

  // ============ Output actions ============

  async function copy() {
    if (!output) return;
    try {
      await navigator.clipboard.writeText(output);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) { /* permission denied */ }
  }

  // Brief "Saved ✓" flash on the Download button once a download actually fired.
  function flashSaved() {
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  }

  function doDownload() {
    if (cfg.outputFormat === "xlsx") {
      if (!outputBinary) return;
      Convert.download(outputBinary, filename + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      flashSaved();
      return;
    }
    if (cfg.outputFormat === "pdf") {
      if (!outputBinary) return;
      Convert.download(outputBinary, filename + ".pdf", "application/pdf");
      flashSaved();
      return;
    }
    if (cfg.outputFormat === "arrow") {
      if (!outputBinary) return;
      Convert.download(outputBinary, filename + ".arrow", "application/vnd.apache.arrow.file");
      flashSaved();
      return;
    }
    if (cfg.outputFormat === "parquet") {
      if (!outputBinary) return;
      Convert.download(outputBinary, filename + ".parquet", "application/vnd.apache.parquet");
      flashSaved();
      return;
    }
    if (isTool && cfg.action === "split" && outputChunks) {
      // Default: download a single .zip containing every chunk. Falls back to one-file-at-a-time
      // if the user unticked the ZIP option.
      if (opts.downloadAsZip !== false) {
        const zipBytes = Convert.buildZip(outputChunks.map(c => ({ name: c.name, content: c.csv })));
        Convert.download(zipBytes, (filename || "data") + "-chunks.zip", "application/zip");
      } else {
        outputChunks.forEach((c, i) => {
          setTimeout(() => Convert.download(c.csv, c.name, "text/csv"), i * 250);
        });
      }
      flashSaved();
      return;
    }
    if (isTool && cfg.action === "validate") return; // No file to download for validate
    if (!output) return;
    Convert.download(output, filename + "." + cfg.downloadExtension, cfg.downloadMime);
    flashSaved();
  }

  // Offer the CSV produced by a reverse (X->CSV) converter as a real .xlsx
  // workbook too. The SheetJS engine is lazy-loaded on first use (same pattern
  // as the forward csv-to-excel tool); we re-profile the output CSV so types
  // (numbers/dates) carry into the spreadsheet.
  function downloadXlsx() {
    if (!output || xlsxBusy) return;
    setXlsxBusy(true);
    ensureXLSX().then(() => {
      const prof = CSVTool.profile(CSVTool.parseCSV(output));
      Convert.download(Convert.csvToExcel(prof), filename + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }).catch(() => setError("Could not load the .xlsx engine. Check your connection and retry."))
      .then(() => setXlsxBusy(false));
  }

  // Parse the GFM table we just emitted back into {header, aligns, body} so the
  // preview is always faithful to the actual output (respecting the same
  // alignment markers). No markdown library needed — it's our own output.
  function parseMarkdownTable(md) {
    const rowsMd = String(md || "").split(/\r?\n/).filter(l => l.trim().charAt(0) === "|");
    if (rowsMd.length < 2) return null;
    const splitRow = l => l.trim().replace(/^\|/, "").replace(/\|\s*$/, "").split("|")
      .map(c => c.trim().replace(/\\\|/g, "|"));
    const isDelim = cells => cells.every(c => /^:?-{1,}:?$/.test(c));
    const header = splitRow(rowsMd[0]);
    if (!isDelim(splitRow(rowsMd[1]))) return null; // not actually a table
    const aligns = splitRow(rowsMd[1]).map(d => {
      const L = d.charAt(0) === ":", R = d.charAt(d.length - 1) === ":";
      return L && R ? "center" : R ? "right" : "left";
    });
    const body = rowsMd.slice(2).map(splitRow);
    return { header, aligns, body };
  }

  function renderMarkdownPreview() {
    if (cfg.outputFormat !== "markdown" || !output) return null;
    const t = parseMarkdownTable(output);
    if (!t || !t.header.length) return null;
    return (
      <div className="conv-md-preview">
        <div className="conv-md-preview-label">PREVIEW</div>
        <div className="conv-md-preview-scroll">
          <table className="csvtd-md-table">
            <thead>
              <tr>{t.header.map((h, i) => <th key={i} style={{ textAlign: t.aligns[i] || "left" }}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {t.body.map((row, ri) => (
                <tr key={ri}>{t.header.map((_, ci) => <td key={ci} style={{ textAlign: t.aligns[ci] || "left" }}>{row[ci] != null ? row[ci] : ""}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // ============ Build dashboard hand-off (storage-key) ============

  function buildDashboard() {
    sendCSVToDashboard(csvText, filename + ".csv", setError);
  }

  // ============ Option controls ============

  function renderToolControls() {
    if (!isTool || !profile) return null;

    if (cfg.action === "dedupe") {
      const cols = profile.cols.map(c => c.name);
      return (
        <div className="conv-opts">
          <div style={{ flex: "1 0 100%", fontSize: 11, color: "var(--ink-faint)", marginBottom: 2 }}>
            Drop a row if its values match an earlier row in the selected columns. Leave all unchecked to dedupe across every column.
          </div>
          <label><input type="checkbox" checked={!!opts.caseInsensitive} onChange={e => setOpts(o => ({ ...o, caseInsensitive: e.target.checked }))} /> Case-insensitive</label>
          <div style={{ flex: "1 0 100%", display: "flex", flexWrap: "wrap", gap: "4px 10px" }}>
            {cols.map(c => (
              <label key={c} style={{ fontSize: 11 }}>
                <input type="checkbox"
                  checked={(opts.columns || []).includes(c)}
                  onChange={e => {
                    const cur = opts.columns || [];
                    setOpts(o => ({ ...o, columns: e.target.checked ? [...cur, c] : cur.filter(x => x !== c) }));
                  }} /> {c}
              </label>
            ))}
          </div>
        </div>
      );
    }

    if (cfg.action === "sortFilter") {
      const cols = profile.cols.map(c => c.name);
      const ops = ["=", "≠", ">", "<", "≥", "≤", "contains", "does not contain", "starts with", "ends with", "is empty", "is not empty"];
      const filters = Array.isArray(opts.filters) && opts.filters.length > 0 ? opts.filters : [{ col: "", op: "=", value: "" }];

      function updateFilter(i, patch) {
        setOpts(o => {
          const arr = (Array.isArray(o.filters) && o.filters.length > 0 ? o.filters : filters).slice();
          arr[i] = { ...arr[i], ...patch };
          return { ...o, filters: arr };
        });
      }
      function addFilter() {
        setOpts(o => {
          const arr = (Array.isArray(o.filters) && o.filters.length > 0 ? o.filters : filters).slice();
          if (arr.length >= 3) return o;
          return { ...o, filters: [...arr, { col: "", op: "=", value: "" }] };
        });
      }
      function removeFilter(i) {
        setOpts(o => {
          const arr = (Array.isArray(o.filters) && o.filters.length > 0 ? o.filters : filters).filter((_, idx) => idx !== i);
          return { ...o, filters: arr };
        });
      }

      return (
        <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch" }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px 18px" }}>
            <label>Sort by{" "}
              <select className="conv-opts-input" value={opts.sortCol || ""} onChange={e => setOpts(o => ({ ...o, sortCol: e.target.value }))}>
                <option value="">(none)</option>
                {cols.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
            <label>
              <select aria-label="Sort direction" className="conv-opts-input" value={opts.sortDir || "asc"} onChange={e => setOpts(o => ({ ...o, sortDir: e.target.value }))}>
                <option value="asc">↑ ascending</option>
                <option value="desc">↓ descending</option>
              </select>
            </label>
          </div>
          <div style={{ fontSize: 11, color: "var(--ink-faint)", marginTop: 6 }}>
            Filters {filters.length > 1 ? "(joined by AND)" : ""}:
          </div>
          {filters.map((f, i) => (
            <div key={i} style={{ display: "flex", flexWrap: "wrap", gap: "6px 10px", alignItems: "center" }}>
              {i > 0 && <span style={{ fontFamily: "var(--mono)", fontSize: 10, color: "var(--accent-ink)", textTransform: "uppercase", letterSpacing: "0.08em" }}>AND</span>}
              <label>where{" "}
                <select className="conv-opts-input" value={f.col || ""} onChange={e => updateFilter(i, { col: e.target.value })}>
                  <option value="">(none)</option>
                  {cols.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </label>
              <label>
                <select aria-label="Filter operator" className="conv-opts-input" value={f.op || "="} onChange={e => updateFilter(i, { op: e.target.value })}>
                  {ops.map(op => <option key={op} value={op}>{op}</option>)}
                </select>
              </label>
              <label>
                <input type="text" aria-label="Filter value" className="conv-opts-input" style={{ minWidth: 140 }}
                  placeholder="value"
                  value={f.value == null ? "" : f.value}
                  onChange={e => updateFilter(i, { value: e.target.value })}
                  disabled={f.op === "is empty" || f.op === "is not empty"} />
              </label>
              {filters.length > 1 && (
                <button type="button" className="conv-opts-x" onClick={() => removeFilter(i)} title="Remove filter">×</button>
              )}
            </div>
          ))}
          {filters.length < 3 && (
            <button type="button" className="conv-opts-add" onClick={addFilter}>+ Add filter (AND)</button>
          )}
        </div>
      );
    }

    if (cfg.action === "split") {
      const cols = profile.cols.map(c => c.name);
      const mode = opts.mode || "rowCount";
      return (
        <div className="conv-opts">
          <label>Mode{" "}
            <select className="conv-opts-input" value={mode} onChange={e => setOpts(o => ({ ...o, mode: e.target.value }))}>
              <option value="rowCount">Every N rows</option>
              <option value="fileCount">Into N files</option>
              <option value="byColumn">By column value</option>
            </select>
          </label>
          {mode === "rowCount" && (
            <label>Rows per file{" "}
              <input type="number" min="1" className="conv-opts-input" style={{ width: 100 }}
                value={opts.rowsPerFile || 1000}
                onChange={e => setOpts(o => ({ ...o, rowsPerFile: e.target.value }))} />
            </label>
          )}
          {mode === "fileCount" && (
            <label>Number of files{" "}
              <input type="number" min="2" max="999" className="conv-opts-input" style={{ width: 100 }}
                value={opts.numFiles || 2}
                onChange={e => setOpts(o => ({ ...o, numFiles: e.target.value }))} />
            </label>
          )}
          {mode === "byColumn" && (
            <label>Split by{" "}
              <select className="conv-opts-input" value={opts.byColumn || cols[0]}
                onChange={e => setOpts(o => ({ ...o, byColumn: e.target.value }))}>
                {cols.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
          )}
          <label style={{ marginLeft: 8 }}>
            <input type="checkbox"
              checked={opts.downloadAsZip !== false}
              onChange={e => setOpts(o => ({ ...o, downloadAsZip: e.target.checked }))} />
            {" "}Download as a single .zip
          </label>
        </div>
      );
    }

    if (cfg.action === "sqlQuery") {
      const exampleCol = profile.cols.find(c => c.role !== "id" && c.type === "number");
      const ex = exampleCol
        ? `SELECT * FROM csv WHERE ${exampleCol.name} > 0 ORDER BY ${exampleCol.name} DESC LIMIT 10`
        : `SELECT * FROM csv LIMIT 10`;
      return (
        <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch" }}>
          <div className="nl-ask">
            <input className="conv-opts-input nl-ask-input"
              placeholder='Ask in plain English — e.g. "total revenue by region" or "top 5 products by revenue"'
              value={opts.nlq || ""}
              onChange={e => setOpts(o => ({ ...o, nlq: e.target.value }))}
              onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); setOpts(o => { const r = Convert.nlToSQL(profile, o.nlq); return r.sql ? { ...o, sql: r.sql, nlErr: "" } : { ...o, nlErr: r.error }; }); } }} />
            <button type="button" className="conv-opts-add"
              onClick={() => setOpts(o => { const r = Convert.nlToSQL(profile, o.nlq); return r.sql ? { ...o, sql: r.sql, nlErr: "" } : { ...o, nlErr: r.error }; })}>
              Generate SQL
            </button>
          </div>
          {opts.nlErr && <div style={{ fontSize: 11, color: "var(--warn-ink)" }}>{opts.nlErr}</div>}
          <div style={{ fontSize: 10, color: "var(--ink-faint)" }}>Experimental and 100% local — the question is parsed in your browser, nothing is sent anywhere.</div>
          <div style={{ fontSize: 11, color: "var(--ink-faint)" }}>
            Available columns: <code>csv</code>({profile.cols.map(c => c.name).join(", ")})
            {extraTables.map(t => <span key={t.name}> · <code>{t.name}</code>({t.headers.join(", ")})</span>)}
          </div>
          {sqlBench ? (
            <sqlBench.SqlEditor value={opts.sql || ""} onChange={v => setOpts(o => ({ ...o, sql: v }))} placeholder={ex} rows={4} />
          ) : (
            <textarea
              className="conv-sql-input"
              rows="3"
              placeholder={ex}
              value={opts.sql || ""}
              onChange={e => setOpts(o => ({ ...o, sql: e.target.value }))}
            />
          )}
          {sqlBench && (
            <>
              <sqlBench.SqlTables tables={extraTables} filename={filename} canAdd={extraTables.length < 2} duckdb={!!opts.duckdb}
                onRemove={i => setExtraTables(ts => ts.filter((_, j) => j !== i).map((x, j) => ({ ...x, name: "csv" + (j + 2) })))}
                onAddClick={() => sqlFileRef.current && sqlFileRef.current.click()}
                extraSlot={<WorkspacePick label="Add a workspace file as a table" onPick={r => addExtraTable(r.csv, r.name)} />} />
              <input ref={sqlFileRef} type="file" accept=".csv,.tsv,.txt" style={{ display: "none" }} onChange={onAddTableFile} aria-hidden="true" tabIndex={-1} />
            </>
          )}
          <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12, color: "var(--ink-soft)" }}>
            <input type="checkbox" checked={!!opts.duckdb} onChange={e => setOpts(o => ({ ...o, duckdb: e.target.checked }))} />
            <span><strong>Power mode (DuckDB)</strong> — real <code>JOIN</code>, <code>GROUP BY</code>, aggregates &amp; window functions. Loads a ~10&nbsp;MB engine in your browser on first use; nothing is uploaded.</span>
          </label>
          <div style={{ fontSize: 11, color: "var(--ink-faint)" }}>
            {opts.duckdb
              ? <>Full DuckDB SQL — <code>JOIN</code>, <code>HAVING</code>, window functions, CTEs. Your table is named <code>csv</code>{extraTables.length ? "; joined tables: " + extraTables.map(t => t.name).join(", ") : ""}.</>
              : <>Supports <code>SELECT</code> · <code>WHERE</code> · <code>GROUP BY</code> with <code>COUNT/SUM/AVG/MIN/MAX</code> · <code>ORDER BY</code> · <code>LIMIT</code> — all instant. Tick Power mode for JOINs &amp; window functions.</>}
          </div>
          {sqlBench && <sqlBench.SqlPanel current={opts.sql || ""} onPick={q => setOpts(o => ({ ...o, sql: q }))} />}
        </div>
      );
    }

    return null;
  }

  function renderOptions() {
    if (cfg.outputFormat === "json") {
      return (
        <div className="conv-opts">
          <label><input type="checkbox" checked={!!opts.minified} onChange={e => setOpts(o => ({ ...o, minified: e.target.checked }))} /> Minify (no whitespace)</label>
          <label><input type="checkbox" checked={!!opts.normalizeDates} onChange={e => setOpts(o => ({ ...o, normalizeDates: e.target.checked }))} /> Normalize dates to ISO 8601</label>
        </div>
      );
    }
    // V7 E — Excel output options (sheet name, filter row, fitted widths)
    if (cfg.outputFormat === "xlsx") {
      return (
        <div className="conv-opts">
          <label>Sheet name <input className="conv-opts-input" type="text" maxLength={31} value={opts.sheetName != null ? opts.sheetName : "Sheet1"} onChange={e => setOpts(o => ({ ...o, sheetName: e.target.value }))} placeholder="Sheet1" /></label>
          <label><input type="checkbox" checked={!!opts.autoFilter} onChange={e => setOpts(o => ({ ...o, autoFilter: e.target.checked }))} /> Filter dropdowns on the header row</label>
          <label><input type="checkbox" checked={opts.autoWidth !== false} onChange={e => setOpts(o => ({ ...o, autoWidth: e.target.checked }))} /> Fit column widths to content</label>
        </div>
      );
    }
    // V7 E — Markdown alignment + attribution comment
    if (cfg.outputFormat === "markdown") {
      return (
        <div className="conv-opts">
          <label>Alignment{" "}
            <select className="conv-opts-input" value={opts.align || "auto"} onChange={e => setOpts(o => ({ ...o, align: e.target.value }))}>
              <option value="auto">Auto (numbers right)</option>
              <option value="left">All left</option>
              <option value="center">All center</option>
              <option value="right">All right</option>
            </select>
          </label>
          <label><input type="checkbox" checked={opts.includeComment !== false} onChange={e => setOpts(o => ({ ...o, includeComment: e.target.checked }))} /> Include attribution comment</label>
        </div>
      );
    }
    // V7 E — Parquet compression
    if (cfg.outputFormat === "parquet") {
      return (
        <div className="conv-opts">
          <label><input type="checkbox" checked={opts.compressed !== false} onChange={e => setOpts(o => ({ ...o, compressed: e.target.checked }))} /> Snappy compression (smaller file, universally readable)</label>
        </div>
      );
    }
    if (cfg.outputFormat === "sql") {
      return (
        <div className="conv-opts">
          <label>Table name <input className="conv-opts-input" type="text" value={opts.tableName || "csv_data"} onChange={e => setOpts(o => ({ ...o, tableName: e.target.value }))} placeholder="csv_data" /></label>
          <label><input type="checkbox" checked={opts.includeCreate !== false} onChange={e => setOpts(o => ({ ...o, includeCreate: e.target.checked }))} /> Include CREATE TABLE</label>
          <label>Batch size <input className="conv-opts-input" style={{ width: 70 }} type="number" min="1" max="1000" value={opts.batchSize || 100} onChange={e => setOpts(o => ({ ...o, batchSize: Math.max(1, parseInt(e.target.value) || 100) }))} /></label>
        </div>
      );
    }
    if (cfg.outputFormat === "html") {
      return (
        <div className="conv-opts">
          <label><input type="checkbox" checked={!!opts.standalone} onChange={e => setOpts(o => ({ ...o, standalone: e.target.checked }))} /> Standalone document (full HTML page)</label>
        </div>
      );
    }
    if (cfg.outputFormat === "xml") {
      return (
        <div className="conv-opts">
          <label>Root element <input className="conv-opts-input" type="text" value={opts.rootName || "data"} onChange={e => setOpts(o => ({ ...o, rootName: e.target.value }))} placeholder="data" /></label>
          <label>Row element <input className="conv-opts-input" type="text" value={opts.rowName || "row"} onChange={e => setOpts(o => ({ ...o, rowName: e.target.value }))} placeholder="row" /></label>
        </div>
      );
    }
    if (cfg.outputFormat === "schema") {
      return (
        <div className="conv-opts">
          <label>Target{" "}
            <select className="conv-opts-input" value={opts.dialect || "typescript"} onChange={e => setOpts(o => ({ ...o, dialect: e.target.value }))}>
              <option value="typescript">TypeScript interface</option>
              <option value="zod">Zod schema</option>
              <option value="pydantic">Pydantic model</option>
              <option value="json-schema">JSON Schema</option>
              <option value="go">Go struct</option>
            </select>
          </label>
          <label>Type name <input className="conv-opts-input" type="text" value={opts.typeName || "Row"} onChange={e => setOpts(o => ({ ...o, typeName: e.target.value }))} placeholder="Row" /></label>
        </div>
      );
    }
    if (cfg.outputFormat === "delimited") {
      const presets = { "\t": "Tab (TSV)", "|": "Pipe |", ";": "Semicolon ;", ",": "Comma ,", custom: "Custom…" };
      const cur = opts.delimiter == null ? "\t" : opts.delimiter;
      const isPreset = ["\t", "|", ";", ","].includes(cur);
      return (
        <div className="conv-opts">
          <label>Delimiter{" "}
            <select className="conv-opts-input" value={isPreset ? cur : "custom"} onChange={e => setOpts(o => ({ ...o, delimiter: e.target.value === "custom" ? (isPreset ? "" : cur) : e.target.value }))}>
              {Object.entries(presets).map(([v, lbl]) => <option key={v} value={v}>{lbl}</option>)}
            </select>
          </label>
          {!isPreset && <label>Custom <input className="conv-opts-input" style={{ width: 90 }} type="text" value={cur} onChange={e => setOpts(o => ({ ...o, delimiter: e.target.value }))} placeholder="e.g. ::" /></label>}
        </div>
      );
    }
    if (cfg.outputFormat === "code") {
      return (
        <div className="conv-opts">
          <label>Language{" "}
            <select className="conv-opts-input" value={opts.dialect || "pandas"} onChange={e => setOpts(o => ({ ...o, dialect: e.target.value }))}>
              <option value="pandas">Python · pandas</option>
              <option value="polars">Python · polars</option>
              <option value="r">R · data.frame</option>
              <option value="php">PHP · array</option>
              <option value="ruby">Ruby · array of hashes</option>
            </select>
          </label>
        </div>
      );
    }
    // Phase 5
    if (cfg.outputFormat === "yaml") {
      return (
        <div className="conv-opts">
          <label><input type="checkbox" checked={!!opts.normalizeDates} onChange={e => setOpts(o => ({ ...o, normalizeDates: e.target.checked }))} /> Normalize dates to ISO 8601</label>
        </div>
      );
    }
    if (cfg.outputFormat === "fixed") {
      return (
        <div className="conv-opts">
          <label>Column padding <input type="number" min="1" max="8" className="conv-opts-input" style={{ width: 70 }}
            value={opts.padding == null ? 2 : opts.padding}
            onChange={e => setOpts(o => ({ ...o, padding: parseInt(e.target.value, 10) }))} /></label>
          <label><input type="checkbox" checked={opts.showHeader !== false} onChange={e => setOpts(o => ({ ...o, showHeader: e.target.checked }))} /> Show header row</label>
          <label><input type="checkbox" checked={opts.showUnderline !== false} onChange={e => setOpts(o => ({ ...o, showUnderline: e.target.checked }))} /> Header underline</label>
        </div>
      );
    }
    if (cfg.outputFormat === "geojson" || cfg.outputFormat === "kml" || cfg.outputFormat === "gpx") {
      const cols = profile ? profile.cols.map(c => c.name) : [];
      const det = profile ? Convert.detectLatLon(profile) : { lat: null, lon: null };
      return (
        <div className="conv-opts">
          <label>Latitude column{" "}
            <select className="conv-opts-input" value={opts.latColumn || det.lat || ""} onChange={e => setOpts(o => ({ ...o, latColumn: e.target.value }))}>
              <option value="">(auto)</option>
              {cols.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </label>
          <label>Longitude column{" "}
            <select className="conv-opts-input" value={opts.lonColumn || det.lon || ""} onChange={e => setOpts(o => ({ ...o, lonColumn: e.target.value }))}>
              <option value="">(auto)</option>
              {cols.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </label>
          {(cfg.outputFormat === "kml" || cfg.outputFormat === "gpx") && (
            <>
              <label>Name column{" "}
                <select className="conv-opts-input" value={opts.nameColumn || ""} onChange={e => setOpts(o => ({ ...o, nameColumn: e.target.value }))}>
                  <option value="">(auto)</option>
                  {cols.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </label>
              <label>Description column{" "}
                <select className="conv-opts-input" value={opts.descriptionColumn || ""} onChange={e => setOpts(o => ({ ...o, descriptionColumn: e.target.value }))}>
                  <option value="">(auto)</option>
                  {cols.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </label>
            </>
          )}
        </div>
      );
    }
    if (cfg.outputFormat === "pdf") {
      return (
        <div className="conv-opts">
          <label>Title{" "}
            <input className="conv-opts-input" type="text" placeholder="(optional)" value={opts.title == null ? "" : opts.title} onChange={e => setOpts(o => ({ ...o, title: e.target.value }))} />
          </label>
          <label>Orientation{" "}
            <select className="conv-opts-input" value={opts.orientation || "portrait"} onChange={e => setOpts(o => ({ ...o, orientation: e.target.value }))}>
              <option value="portrait">Portrait</option>
              <option value="landscape">Landscape</option>
            </select>
          </label>
          <label>Page size{" "}
            <select className="conv-opts-input" value={opts.pageSize || "a4"} onChange={e => setOpts(o => ({ ...o, pageSize: e.target.value }))}>
              <option value="a4">A4</option>
              <option value="letter">Letter</option>
              <option value="legal">Legal</option>
            </select>
          </label>
          <label>Font size{" "}
            <input className="conv-opts-input" type="number" min="5" max="14" style={{ width: 64 }} value={opts.fontSize || 8} onChange={e => setOpts(o => ({ ...o, fontSize: e.target.value }))} />
          </label>
        </div>
      );
    }
    if (cfg.outputFormat === "multiline") {
      const defaultTmpl = profile ? profile.cols.map(c => c.name + ": {{" + c.name + "}}").join("\n") : "";
      return (
        <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch" }}>
          <label style={{ fontSize: 11, color: "var(--ink-faint)" }}>
            Template — use <code>{"{{column_name}}"}</code> placeholders. Available columns: {profile ? profile.cols.map(c => c.name).join(", ") : "(load data first)"}
          </label>
          <textarea
            className="conv-sql-input"
            rows="5"
            placeholder={defaultTmpl}
            value={opts.template == null ? "" : opts.template}
            onChange={e => setOpts(o => ({ ...o, template: e.target.value }))}
          />
          <label>Row separator{" "}
            <input className="conv-opts-input" type="text" style={{ width: 100 }}
              value={opts.separator == null ? "\\n---\\n" : opts.separator.replace(/\n/g, "\\n")}
              onChange={e => setOpts(o => ({ ...o, separator: e.target.value.replace(/\\n/g, "\n") }))}
              placeholder="\\n---\\n" />
          </label>
        </div>
      );
    }
    // Fixed-width INPUT — let the user override the auto-detected column boundaries
    if (cfg.inputFormat === "fixed") {
      return (
        <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch" }}>
          <label style={{ fontSize: 11, color: "var(--ink-faint)" }}>
            Column boundaries (comma-separated character positions). Leave blank for auto-detect.
          </label>
          <input className="conv-opts-input"
            type="text"
            aria-label="Column boundaries"
            placeholder="e.g. 10, 25, 40"
            value={opts.boundariesText == null ? "" : opts.boundariesText}
            onChange={e => {
              const txt = e.target.value;
              const arr = txt.split(/[,\s]+/).map(s => parseInt(s, 10)).filter(n => Number.isFinite(n) && n > 0);
              setOpts(o => ({ ...o, boundariesText: txt, boundaries: arr.length > 0 ? arr : null }));
              if (opts.__rawFixed) {
                try {
                  const cuts = arr.length > 0 ? arr : Convert.autoDetectBoundaries(opts.__rawFixed);
                  loadCSVText(Convert.fixedWidthToCSV(opts.__rawFixed, cuts), "from-fixed-width");
                } catch (e) { setError(e.message); }
              }
            }}
          />
          {opts.__rawFixed && (
            <div style={{ fontSize: 10, color: "var(--ink-faint)" }}>
              Auto-detected: {Convert.autoDetectBoundaries(opts.__rawFixed).join(", ") || "(none — needs manual boundaries)"}
            </div>
          )}
        </div>
      );
    }
    return null;
  }

  // ============ Render ============

  const IN_LABELS = { json: "Drop a .json file or paste JSON", xlsx: "Drop a .xlsx or .xls file", yaml: "Drop a .yaml file or paste YAML", sql: "Drop a .sql file or paste SQL", html: "Drop an .html file or paste HTML", geojson: "Drop a .geojson file or paste GeoJSON", fixed: "Drop a fixed-width .txt file or paste it", xml: "Drop a .xml file or paste XML", markdown: "Drop a .md file or paste a Markdown table", toml: "Drop a .toml file or paste TOML", ndjson: "Drop a .ndjson file or paste JSON Lines", ini: "Drop an .ini file or paste INI", tsv: "Drop a .tsv file or paste tab-separated data" };
  const IN_ACCEPT = { xml: ".xml,text/xml,application/xml", markdown: ".md,.markdown,text/markdown", toml: ".toml,text/plain", ndjson: ".ndjson,.jsonl,application/x-ndjson", ini: ".ini,.cfg,.conf,text/plain", tsv: ".tsv,.tab,.txt,text/tab-separated-values" };
  const inputLabel = IN_LABELS[cfg.inputFormat] || "Drop a .csv file or paste CSV";

  return (
    <div className="conv">
      {pendingSheets && (
        <SheetPicker
          sheets={pendingSheets.sheets}
          filename={pendingSheets.filename}
          onPick={s => { loadCSVText(s.csv, pendingSheets.filename + " · " + s.name); setPendingSheets(null); }}
          onCancel={() => setPendingSheets(null)}
        />
      )}

      <div className="conv-panes">
        <ConverterInput
          label={inputLabel}
          inputFormat={cfg.inputFormat}
          accept={cfg.inputFormat === "json" ? ".json,application/json" : cfg.inputFormat === "xlsx" ? ".xlsx,.xls" : (IN_ACCEPT[cfg.inputFormat] || ".csv,.txt,text/csv")}
          onFile={handleFile}
          onPasteText={onPasteInput}
          onOpenRecord={rec => loadCSVText(rec.csv, rec.name)}
          onLoadSample={() => {
            // Map formats need lat/lon — give those pages the geo sample so the
            // demo produces a real export instead of "no latitude/longitude" error.
            const geo = /^(geojson|gpx|kml)$/.test(cfg.outputFormat) || /^(geojson|gpx)$/.test(cfg.inputFormat);
            const s = (geo && CSVTool.SAMPLES.places) ? CSVTool.SAMPLES.places : CSVTool.SAMPLES.sales;
            loadCSVText(s.csv, s.name.replace(/\.csv$/, ""));
          }}
          loaded={!!csvText}
          onClear={clear}
        />

        <div className="conv-pane conv-out">
          <div className="conv-pane-head">
            <span className="conv-pane-label">
              {isTool
                ? (cfg.action === "validate" ? "VALIDATION REPORT"
                  : cfg.action === "split" ? "SPLIT FILES"
                  : "RESULT")
                : cfg.outputFormat.toUpperCase() + " output"}
              {/^(Preparing the|Loading the DuckDB|Running query)/.test(output || "") && <span className="spinner" style={{ display: "inline-block", marginLeft: 8, verticalAlign: "-2px" }} role="status" aria-label="Loading the engine" />}
            </span>
            <div className="conv-pane-actions">
              <button className="btn-ghost" onClick={copy} disabled={!output || outputBinary != null || cfg.outputFormat === "xlsx" || cfg.action === "split" || cfg.action === "validate"}>{copied ? "Copied!" : "Copy"}</button>
              <button className="btn-ghost" onClick={doDownload} disabled={(!output && !outputBinary && !outputChunks) || cfg.action === "validate"}>
                {saved ? "Saved ✓"
                  : cfg.action === "split" && outputChunks
                  ? (opts.downloadAsZip !== false ? `Download .zip (${outputChunks.length} files)` : `Download ${outputChunks.length} files`)
                  : "Download"}
              </button>
              {!isTool && cfg.outputFormat === "csv" && (
                <button className="btn-ghost" onClick={downloadXlsx} disabled={!output || xlsxBusy}>
                  {xlsxBusy ? "Preparing…" : "Download .xlsx"}
                </button>
              )}
              <SendToMenu getPayload={() => currentPayload()} onError={msg => setError(msg)} />
            </div>
          </div>
          {renderToolControls()}
          {renderOptions()}
          {isTool && cfg.action === "validate" && validateReport ? (
            <ValidateReport report={validateReport} />
          ) : isTool && cfg.action === "sqlQuery" && toolStats && output ? (
            // V7 Batch C — SQL results render as a real grid; the raw textarea
            // stays below it (tests + copy/download read it).
            <>
              <ResultGrid csv={output} toolType="sqlresult" opts={opts} />
              <div className="rg-raw-label">Raw CSV</div>
              <textarea className="conv-out-text rg-rawbox" value={output} readOnly />
            </>
          ) : (
            <textarea className="conv-out-text" value={output} readOnly placeholder="The output will appear here once you drop a file." />
          )}
          {renderMarkdownPreview()}
          {toolStats && (
            <div className="conv-stats">
              {Object.entries(toolStats).filter(([_, v]) => v !== null && v !== undefined).map(([k, v]) => (
                <span key={k}><span className="conv-stats-label">{k}</span> {Array.isArray(v) ? v.join(", ") : String(v)}</span>
              ))}
            </div>
          )}
          {error && <div className="conv-err" role="alert">{error}</div>}
        </div>
      </div>

      {profile && (
        <>
          <InsightStrip profile={profile} onBuildDashboard={buildDashboard} />
          <div className="conv-cta">
            <a href="#" className="conv-cta-link" onClick={(e) => { e.preventDefault(); buildDashboard(); }}>
              Want to know what this data is telling you? <strong>Build a dashboard from this CSV →</strong>
            </a>
            <div className="conv-cta-secondary">
              Need more than one operation? <a href="/csv-pipeline">Try CSV Pipeline →</a>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function ValidateReport({ report }) {
  if (!report) return null;
  if (report.issues.length === 0) {
    return (
      <div className="validate-clean">
        <div className="validate-clean-mark">✓</div>
        <div>
          <div className="validate-clean-title">No issues found.</div>
          <div className="validate-clean-sub">{report.stats.totalRows} rows × {report.stats.totalCols} columns checked.</div>
        </div>
      </div>
    );
  }
  return (
    <ul className="validate-list">
      {report.issues.map((i, idx) => (
        <li key={idx} className={"validate-item validate-" + i.severity}>
          <span className="validate-badge">{i.severity}</span>
          <div>
            <div className="validate-message">{i.message}</div>
            {i.detail && <div className="validate-detail">{i.detail}</div>}
          </div>
        </li>
      ))}
    </ul>
  );
}

function ConverterInput({ label, accept, onFile, onPasteText, onLoadSample, loaded, onClear, inputFormat, onOpenRecord }) {
  const [drag, setDrag] = useState(false);
  const [paste, setPaste] = useState("");
  const inputRef = useRef(null);

  return (
    <div className="conv-pane conv-in">
      <div className="conv-pane-head">
        <span className="conv-pane-label">Input</span>
        <div className="conv-pane-actions">
          {loaded && <button className="btn-ghost" onClick={onClear}>Clear</button>}
        </div>
      </div>
      <div
        className={"conv-drop " + (drag ? "dragging" : "")}
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => {
          e.preventDefault(); setDrag(false);
          if (e.dataTransfer.files && e.dataTransfer.files[0]) onFile(e.dataTransfer.files[0]);
        }}
        onClick={() => inputRef.current && inputRef.current.click()}
      >
        <input ref={inputRef} type="file" accept={accept} style={{ display: "none" }}
          onChange={e => e.target.files && e.target.files[0] && onFile(e.target.files[0])} />
        <div className="conv-drop-title">{label}</div>
        <div className="conv-drop-sub">{inputFormat === "xlsx" ? "drag or click to choose a file" : "drag · click · or paste below"}</div>
        {/* The sample loads canonical CSV into the model to demo the OUTPUT, so it
            works for every input format — including xlsx (which can't be pasted). */}
        <button className="conv-drop-sample" onClick={(e) => { e.stopPropagation(); onLoadSample(); }}>
          try with sample data
        </button>
      </div>
      {/* V6 workspace: stored CSVs are offered only where CSV is the input format */}
      {onOpenRecord && inputFormat === "csv" && <WorkspaceStrip onOpen={onOpenRecord} />}
      {inputFormat !== "xlsx" && (
        <textarea
          className="conv-in-paste"
          placeholder={inputFormat === "json" ? "…or paste JSON here" : "…or paste CSV / TSV here"}
          value={paste}
          onChange={e => setPaste(e.target.value)}
          onBlur={() => { if (paste.trim()) { onPasteText(paste); setPaste(""); } }}
        />
      )}
    </div>
  );
}

// =========================================================================
// PHASE 3 — PipelineShell (CSV Workflow Builder)
// Reuses every Convert.* helper via the Pipeline.run engine.
// =========================================================================

// V9 #4: saved pipeline profiles. A profile is the same {k,c} step spec used by
// recipe links, persisted to localStorage so a user can "build once, use forever"
// — load a saved pipeline, drop a new file, and it runs. 100% local; no account.
const PIPE_PROFILES_KEY = "csvtd_pipeline_profiles";
function pipeLoadProfiles() {
  try {
    const a = JSON.parse(localStorage.getItem(PIPE_PROFILES_KEY) || "[]");
    return Array.isArray(a) ? a.filter(p => p && p.name && Array.isArray(p.s)) : [];
  } catch (e) { return []; }
}
function pipeSaveProfiles(list) {
  try { localStorage.setItem(PIPE_PROFILES_KEY, JSON.stringify(list.slice(0, 50))); } catch (e) { /* quota/private mode — non-fatal */ }
}
function pipeRehydrate(specArr) {
  return (specArr || []).filter(s => s && Pipeline.KINDS.includes(s.k)).map(s => {
    const st = Pipeline.newStep(s.k);
    st.config = { ...st.config, ...(s.c || {}) };
    return st;
  });
}

function PipelineShell({ config }) {
  const [csvText, setCsvText] = useState("");
  const [filename, setFilename] = useState("data");
  const [steps, setSteps] = useState([
    Pipeline.newStep("validate"),
    Pipeline.newStep("dedupe")
  ]);
  const [exportFormat, setExportFormat] = useState("csv");
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);
  const [pendingSheets, setPendingSheets] = useState(null);
  const [recipeName, setRecipeName] = useState(""); // set when steps arrived via a #r= recipe link
  const [linkCopied, setLinkCopied] = useState(false);
  const [saved, setSaved] = useState(false);
  const [profiles, setProfiles] = useState(() => { try { return pipeLoadProfiles(); } catch (e) { return []; } });
  const [profileName, setProfileName] = useState("");
  const [profileSaved, setProfileSaved] = useState(false);
  // Only the 4 promoted reshape steps live in the lazy chunk; validate/dedupe/
  // filter/sort/sql/split are in-bundle, so don't load or gate on the chunk
  // unless a reshape step is actually present.
  const ceNeeds = steps.some(s => s.kind === "cleanHeaders" || s.kind === "trim" || s.kind === "fillBlanks" || s.kind === "selectColumns");
  const ceReady = useConvertExtra(ceNeeds);

  // V6 recipes: a #r= hash is a complete pipeline preset — { v:1, n:"name",
  // s:[{k:kind, c:configOverrides}] } compressed with the same vendored
  // lz-string the share/embed codecs use. Data never travels in the link; the
  // steps arrive configured and wait for a file. The hash is kept in the URL so
  // refresh re-applies and the link stays shareable from the address bar.
  useEffect(() => {
    const m = (window.location.hash || "").match(/^#r=(.+)$/);
    if (!m) return;
    try {
      const spec = JSON.parse(LZString.decompressFromEncodedURIComponent(m[1]));
      if (!spec || spec.v !== 1 || !Array.isArray(spec.s) || !spec.s.length) return;
      const loaded = spec.s.filter(s => s && Pipeline.KINDS.includes(s.k)).map(s => {
        const st = Pipeline.newStep(s.k);
        st.config = { ...st.config, ...(s.c || {}) };
        return st;
      });
      if (loaded.length) {
        setSteps(loaded);
        setRecipeName(String(spec.n || "Shared recipe"));
      }
    } catch (e) { /* malformed/foreign hash — ignore */ }
  }, []);

  // V6 workspace wiring: handed-off CSVs flow straight into the pipeline; the
  // final result is the current file for send-to/palette.
  useToolFile(
    (csv, name) => loadCSVText(csv, name),
    () => (finalCSV ? { csv: finalCSV, name: (filename || "data") + "-pipeline.csv" } : null)
  );

  function copyRecipeLink() {
    if (!steps.length) return;
    const spec = { v: 1, n: recipeName || steps.map(s => Pipeline.LABELS[s.kind]).join(" → "), s: steps.map(st => ({ k: st.kind, c: st.config })) };
    const url = window.location.origin + "/csv-pipeline#r=" + LZString.compressToEncodedURIComponent(JSON.stringify(spec));
    navigator.clipboard.writeText(url).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 1800);
    }).catch(() => {});
  }

  // Saved profiles (V9 #4) — persist the current steps under a name, reload later.
  function saveProfile() {
    if (!steps.length) return;
    const name = (profileName.trim() || recipeName || steps.map(s => Pipeline.LABELS[s.kind]).join(" → ")).slice(0, 60);
    const prof = { id: "p" + Date.now(), name, s: steps.map(st => ({ k: st.kind, c: st.config })) };
    const next = [prof, ...profiles.filter(p => p.name !== name)].slice(0, 50);
    setProfiles(next);
    pipeSaveProfiles(next);
    setProfileName("");
    setProfileSaved(true);
    setTimeout(() => setProfileSaved(false), 1800);
  }
  function applyProfile(p) {
    const loaded = pipeRehydrate(p.s);
    if (loaded.length) { setSteps(loaded); setRecipeName(p.name); }
  }
  function deleteProfile(id) {
    const next = profiles.filter(p => p.id !== id);
    setProfiles(next);
    pipeSaveProfiles(next);
  }

  // Run the pipeline whenever inputs change
  const { finalCSV, history, finalChunks } = useMemo(
    () => (ceNeeds && !ceReady) ? { finalCSV: "", history: [], finalChunks: null } : Pipeline.run(csvText, steps),
    [csvText, steps, ceReady, ceNeeds]
  );

  // Build the final profile (for the data preview + insight strip + dashboard handoff)
  const finalProfile = useMemo(() => {
    if (!finalCSV) return null;
    try {
      const parsed = CSVTool.parseCSV(finalCSV);
      if (parsed.headers.length === 0) return null;
      return CSVTool.profile(parsed);
    } catch (e) { return null; }
  }, [finalCSV]);

  const initialRowCount = useMemo(() => {
    if (!csvText) return 0;
    try { return CSVTool.parseCSV(csvText).rows.length; }
    catch (e) { return 0; }
  }, [csvText]);

  function loadCSVText(text, name) {
    setCsvText(text);
    setFilename((name || "data").replace(/\.[^.]+$/, ""));
    setError("");
    wsMaybeSave(name || "data.csv", text);
  }

  function handleXLSXBuffer(buf, name) {
    try {
      const sheets = Convert.excelToCSV(buf);
      if (!sheets.length) { setError("That workbook didn't have any rows."); return; }
      if (sheets.length === 1) loadCSVText(sheets[0].csv, name);
      else setPendingSheets({ sheets, filename: name });
    } catch (e) { setError(e.message); }
  }

  function handleFile(file) {
    if (!file) return;
    setFilename(file.name.replace(/\.[^.]+$/, ""));
    const reader = new FileReader();
    reader.onerror = () => setError("Could not read file.");
    if (/\.(xlsx|xls)$/i.test(file.name)) {
      reader.onload = e => ensureXLSX().then(() => handleXLSXBuffer(e.target.result, file.name));
      reader.readAsArrayBuffer(file);
    } else {
      reader.onload = e => loadCSVText(e.target.result, file.name);
      reader.readAsText(file);
    }
  }

  function clearAll() {
    setCsvText(""); setFilename("data"); setError(""); setPendingSheets(null);
    setSteps([Pipeline.newStep("validate"), Pipeline.newStep("dedupe")]);
  }

  // === Step management ===
  function addStep(kind) {
    setSteps(s => [...s, Pipeline.newStep(kind)]);
  }
  function removeStep(id) { setSteps(s => s.filter(st => st.id !== id)); }
  function moveStep(id, delta) {
    setSteps(s => {
      const i = s.findIndex(st => st.id === id);
      if (i < 0) return s;
      const j = i + delta;
      if (j < 0 || j >= s.length) return s;
      const out = s.slice();
      [out[i], out[j]] = [out[j], out[i]];
      return out;
    });
  }
  function toggleStep(id) {
    setSteps(s => s.map(st => st.id === id ? { ...st, enabled: !st.enabled } : st));
  }
  function updateStepConfig(id, patch) {
    setSteps(s => s.map(st => st.id === id ? { ...st, config: { ...st.config, ...patch } } : st));
  }
  function resetPipeline() {
    setSteps([]);
  }

  function copyFinal() {
    if (!finalCSV) return;
    navigator.clipboard.writeText(finalCSV).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    }).catch(() => {});
  }

  function exportFinal() {
    if (!finalProfile) return;
    const base = filename || "pipeline-result";
    // Split is terminal — if it ran, use those chunks
    if (finalChunks && finalChunks.length > 0) {
      const zip = Convert.buildZip(finalChunks.map(c => ({ name: c.name, content: c.csv })));
      Convert.download(zip, base + "-chunks.zip", "application/zip");
      return;
    }
    switch (exportFormat) {
      case "csv":      Convert.download(finalCSV, base + ".csv", "text/csv"); break;
      case "json":     Convert.download(Convert.csvToJSON(finalProfile, {}), base + ".json", "application/json"); break;
      case "sql":      Convert.download(Convert.csvToSQL(finalProfile, { tableName: base }), base + ".sql", "application/sql"); break;
      case "markdown": Convert.download(Convert.csvToMarkdown(finalProfile, {}), base + ".md", "text/markdown"); break;
      case "html":     Convert.download(Convert.csvToHTML(finalProfile, { standalone: true }), base + ".html", "text/html"); break;
      case "xml":      Convert.download(Convert.csvToXML(finalProfile, {}), base + ".xml", "application/xml"); break;
      case "xlsx":     ensureXLSX().then(() => Convert.download(Convert.csvToExcel(finalProfile), base + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")); break;
    }
  }

  function sendToDashboard() {
    sendCSVToDashboard(finalCSV, filename + ".csv", setError);
  }

  // Saved-pipelines panel — rendered in both the pre-file view (load a profile,
  // then drop a file to run it) and the builder grid (save what you just built).
  const profilesPanel = (
    <div className="pipe-profiles">
      <div className="pipe-profiles-save">
        <input
          className="pipe-profile-input"
          type="text"
          placeholder="Name this pipeline to reuse it…"
          value={profileName}
          maxLength={60}
          aria-label="Pipeline name"
          onChange={e => setProfileName(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter") saveProfile(); }}
        />
        <button className="btn-ghost" onClick={saveProfile} disabled={!steps.length} title="Save this pipeline in your browser, then run it on any new file — build once, use forever">{profileSaved ? "Saved ✓" : "Save pipeline"}</button>
      </div>
      {profiles.length > 0 && (
        <div className="pipe-profiles-list">
          <span className="pipe-profiles-label">Saved pipelines:</span>
          {profiles.map(p => (
            <span className="pipe-profile-chip" key={p.id}>
              <button className="pipe-profile-load" onClick={() => applyProfile(p)} title={"Load “" + p.name + "” — then drop a new file to run it"}>{p.name}</button>
              <button className="pipe-profile-del" onClick={() => deleteProfile(p.id)} aria-label={"Delete saved pipeline " + p.name} title="Delete">×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );

  // === Render ===

  if (!csvText) {
    return (
      <div className="conv">
        {pendingSheets && (
          <SheetPicker
            sheets={pendingSheets.sheets}
            filename={pendingSheets.filename}
            onPick={s => { loadCSVText(s.csv, pendingSheets.filename + " · " + s.name); setPendingSheets(null); }}
            onCancel={() => setPendingSheets(null)}
          />
        )}
        <div className="conv-panes">
          <ConverterInput
            label={recipeName ? "Drop a CSV to run “" + recipeName + "”" : "Drop a .csv or .xlsx file to start the pipeline"}
            inputFormat="csv"
            accept=".csv,.xlsx,.xls,.txt,text/csv"
            onFile={handleFile}
            onPasteText={(text) => loadCSVText(text, "pasted")}
            onLoadSample={() => loadCSVText(CSVTool.SAMPLES.sales.csv, "sample-sales")}
            loaded={false}
            onClear={() => {}}
            onOpenRecord={rec => loadCSVText(rec.csv, rec.name)}
          />
          {recipeName ? (
            <div className="conv-pane">
              <div className="conv-pane-head">
                <span className="conv-pane-label">Recipe loaded</span>
              </div>
              <div className="pipe-explain">
                <div className="pipe-recipe">
                  <span className="pipe-recipe-name">{recipeName}</span>
                  <span>{steps.length} step{steps.length === 1 ? "" : "s"} ready — your file runs through them the moment it lands.</span>
                </div>
                {steps.map((st, i) => (
                  <div className="pipe-explain-row" key={st.id}><span className="pipe-explain-step">{i + 1}</span> {Pipeline.LABELS[st.kind]}</div>
                ))}
              </div>
            </div>
          ) : (
            <div className="conv-pane">
              <div className="conv-pane-head">
                <span className="conv-pane-label">What pipelines look like</span>
              </div>
              <div className="pipe-explain">
                <div className="pipe-explain-row"><span className="pipe-explain-step">1</span> Validate — catch broken headers, empty rows, type mismatches</div>
                <div className="pipe-explain-row"><span className="pipe-explain-step">2</span> Remove duplicates — by row or by selected columns</div>
                <div className="pipe-explain-row"><span className="pipe-explain-step">3</span> Filter — up to 3 conditions joined by AND</div>
                <div className="pipe-explain-row"><span className="pipe-explain-step">4</span> Sort — by any column, asc or desc</div>
                <div className="pipe-explain-row"><span className="pipe-explain-step">5</span> Query — SELECT / WHERE / ORDER BY / LIMIT</div>
                <div className="pipe-explain-row"><span className="pipe-explain-step">6</span> Split — into chunks or by column value</div>
                <div className="pipe-explain-row"><span className="pipe-explain-step">→</span> Export as CSV/JSON/SQL/MD/HTML/XML/XLSX or send to dashboard</div>
              </div>
            </div>
          )}
        </div>
        {profilesPanel}
      </div>
    );
  }

  return (
    <div className="conv pipe">
      {pendingSheets && (
        <SheetPicker
          sheets={pendingSheets.sheets}
          filename={pendingSheets.filename}
          onPick={s => { loadCSVText(s.csv, pendingSheets.filename + " · " + s.name); setPendingSheets(null); }}
          onCancel={() => setPendingSheets(null)}
        />
      )}

      <div className="pipe-grid">
        <div className="pipe-steps">
          {recipeName && (
            <div className="pipe-recipe" role="status">
              <span className="pipe-recipe-name">Recipe: {recipeName}</span>
              <span>steps arrived pre-configured — tweak anything below.</span>
            </div>
          )}
          <div className="pipe-steps-head">
            <span className="conv-pane-label">Pipeline · {steps.filter(s => s.enabled).length}/{steps.length} active</span>
            <div className="conv-pane-actions">
              <button className="btn-ghost" onClick={copyRecipeLink} disabled={!steps.length} title="Copy a link that opens this pipeline pre-configured — your data is not included">{linkCopied ? "Link copied ✓" : "Copy recipe link"}</button>
              <button className="btn-ghost" onClick={resetPipeline}>Reset</button>
              <button className="btn-ghost danger" onClick={clearAll}>Clear data</button>
            </div>
          </div>

          {profilesPanel}

          {steps.length === 0 && (
            <div className="pipe-empty">No steps yet — add one below to start transforming your data.</div>
          )}

          {steps.map((step, i) => {
            const entry = history.find(h => h.id === step.id);
            return (
              <PipelineStepCard
                key={step.id}
                step={step}
                index={i}
                total={steps.length}
                entry={entry}
                profile={finalProfile}
                rawCSV={csvText}
                onUpdate={(patch) => updateStepConfig(step.id, patch)}
                onRemove={() => removeStep(step.id)}
                onMoveUp={() => moveStep(step.id, -1)}
                onMoveDown={() => moveStep(step.id, 1)}
                onToggle={() => toggleStep(step.id)}
              />
            );
          })}

          <AddStepMenu onAdd={addStep} />
        </div>

        <div className="pipe-preview">
          <div className="pipe-preview-head">
            <span className="conv-pane-label">Result preview</span>
            <span className="pipe-preview-meta">
              {initialRowCount} → {finalProfile ? finalProfile.rows.length : 0} rows
            </span>
          </div>
          {finalProfile ? <PipelinePreview profile={finalProfile} /> : <div className="pipe-empty">No result yet.</div>}
        </div>
      </div>

      {error && <div className="conv-err" role="alert">{error}</div>}

      {finalProfile && (
        <>
          <InsightStrip profile={finalProfile} onBuildDashboard={sendToDashboard} />

          <div className="pipe-actions">
            <div className="pipe-actions-left">
              <button className="btn-ghost" onClick={copyFinal} disabled={!finalCSV}>{copied ? "Copied!" : "Copy CSV"}</button>
              <select aria-label="Export format" className="conv-opts-input" value={exportFormat} onChange={e => setExportFormat(e.target.value)} disabled={!!finalChunks}>
                <option value="csv">Export as CSV</option>
                <option value="json">Export as JSON</option>
                <option value="sql">Export as SQL</option>
                <option value="markdown">Export as Markdown</option>
                <option value="html">Export as HTML</option>
                <option value="xml">Export as XML</option>
                <option value="xlsx">Export as Excel</option>
              </select>
              <button className="btn-ghost" onClick={() => { exportFinal(); setSaved(true); setTimeout(() => setSaved(false), 1500); }}>
                {saved ? "Saved ✓" : finalChunks ? `Download .zip (${finalChunks.length} files)` : "Download"}
              </button>
              <SendToMenu getPayload={() => (finalCSV ? { csv: finalCSV, name: (filename || "data") + "-pipeline.csv" } : null)} onError={msg => setError(msg)} />
            </div>
            <div className="conv-cta" style={{ margin: 0, flex: 1, minWidth: 320 }}>
              <a href="#" className="conv-cta-link" onClick={(e) => { e.preventDefault(); sendToDashboard(); }}>
                <strong>Build dashboard from final result →</strong>
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function AddStepMenu({ onAdd }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="pipe-add" ref={ref}>
      <button className="pipe-add-btn" onClick={() => setOpen(v => !v)}>+ Add step {open ? "▴" : "▾"}</button>
      {open && (
        <div className="pipe-add-menu">
          {Pipeline.KINDS.map(k => (
            <button key={k} className="pipe-add-item" onClick={() => { onAdd(k); setOpen(false); }}>
              {Pipeline.LABELS[k]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function PipelineStepCard({ step, index, total, entry, profile, rawCSV, onUpdate, onRemove, onMoveUp, onMoveDown, onToggle }) {
  // The profile here is the FINAL profile after the whole pipeline; for per-step config controls
  // we need the profile of the data *entering* this step. For dropdowns of column names, the
  // initial CSV's columns are usually fine (most steps don't change the schema). We use the
  // initial profile parsed from rawCSV for the dropdowns.
  const inputProfile = useMemo(() => {
    if (!rawCSV) return null;
    try { return CSVTool.profile(CSVTool.parseCSV(rawCSV)); }
    catch (e) { return null; }
  }, [rawCSV]);

  const rowsIn = entry && entry.rowsIn !== undefined ? entry.rowsIn : "—";
  const rowsOut = entry && entry.rowsOut !== undefined ? entry.rowsOut : "—";
  const delta = (typeof rowsIn === "number" && typeof rowsOut === "number")
    ? (rowsOut - rowsIn) : null;
  const deltaText = delta === null ? "" : (delta > 0 ? ` (+${delta})` : delta < 0 ? ` (${delta})` : "");

  return (
    <div className={"pipe-step" + (step.enabled ? "" : " pipe-step-off") + (entry && entry.error ? " pipe-step-err" : "") + (entry && entry.terminal ? " pipe-step-terminal" : "")}>
      <div className="pipe-step-head">
        <div className="pipe-step-title">
          <span className="pipe-step-num">{index + 1}.</span>
          {Pipeline.LABELS[step.kind]}
        </div>
        <div className="pipe-step-controls">
          <button onClick={onMoveUp} disabled={index === 0} title="Move up" aria-label="Move up">↑</button>
          <button onClick={onMoveDown} disabled={index === total - 1} title="Move down" aria-label="Move down">↓</button>
          <button onClick={onToggle} title={step.enabled ? "Disable step" : "Enable step"} aria-label="Toggle">
            {step.enabled ? "◉" : "○"}
          </button>
          <button onClick={onRemove} title="Remove step" aria-label="Remove" className="pipe-step-x">×</button>
        </div>
      </div>
      <div className="pipe-step-body">
        <PipelineStepConfig step={step} onUpdate={onUpdate} profile={inputProfile} />
      </div>
      <div className="pipe-step-foot">
        {entry && entry.skipped && <span className="pipe-step-stat">skipped</span>}
        {entry && entry.error && <span className="pipe-step-stat pipe-step-err-msg">⚠ {entry.error}</span>}
        {entry && !entry.skipped && !entry.error && (
          <span className="pipe-step-stat">
            {rowsIn} → {rowsOut} rows{deltaText}{entry.summary ? " · " + entry.summary : ""}
            {entry.terminal && " · terminal step"}
          </span>
        )}
      </div>
      {entry && entry.report && entry.report.issues && entry.report.issues.length > 0 && (
        <details className="pipe-step-report">
          <summary>{entry.report.issues.length} issue{entry.report.issues.length === 1 ? "" : "s"} detected — show</summary>
          <ValidateReport report={entry.report} />
        </details>
      )}
    </div>
  );
}

function PipelineStepConfig({ step, onUpdate, profile }) {
  if (!profile) return <div className="pipe-step-cfg-empty">Load data to configure this step.</div>;
  const cols = profile.cols.map(c => c.name);

  if (step.kind === "validate") {
    return <div className="pipe-step-cfg-empty">No configuration — runs the validator on the current data.</div>;
  }

  // V7 E — promoted reshape steps
  if (step.kind === "cleanHeaders") {
    return (
      <div className="conv-opts" style={{ margin: 0 }}>
        <label>Style{" "}
          <select className="conv-opts-input" value={step.config.style || "snake_case"} onChange={e => onUpdate({ style: e.target.value })}>
            <option value="snake_case">snake_case</option>
            <option value="camelCase">camelCase</option>
            <option value="Title Case">Title Case</option>
            <option value="lowercase">lowercase</option>
            <option value="UPPERCASE">UPPERCASE</option>
          </select>
        </label>
      </div>
    );
  }
  if (step.kind === "trim") {
    return (
      <div className="conv-opts" style={{ margin: 0 }}>
        <label><input type="checkbox" checked={step.config.collapseSpaces !== false} onChange={e => onUpdate({ collapseSpaces: e.target.checked })} /> Collapse internal space runs to one</label>
      </div>
    );
  }
  if (step.kind === "fillBlanks") {
    const method = step.config.method || "forward fill";
    return (
      <div className="conv-opts" style={{ margin: 0 }}>
        <label>Method{" "}
          <select className="conv-opts-input" value={method} onChange={e => onUpdate({ method: e.target.value })}>
            <option value="forward fill">Forward fill (carry down)</option>
            <option value="value">Fixed value</option>
            <option value="zero">Zero (0)</option>
          </select>
        </label>
        {method === "value" && (
          <label>Value{" "}
            <input type="text" className="conv-opts-input" style={{ minWidth: 90 }} placeholder="e.g. N/A"
              value={step.config.value == null ? "" : step.config.value} onChange={e => onUpdate({ value: e.target.value })} />
          </label>
        )}
      </div>
    );
  }
  if (step.kind === "selectColumns") {
    return (
      <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch", margin: 0 }}>
        <div style={{ fontSize: 10, color: "var(--ink-faint)" }}>Keep these columns (none picked = unchanged):</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 10px" }}>
          {cols.map(c => (
            <label key={c} style={{ fontSize: 11 }}>
              <input type="checkbox"
                checked={(step.config.columns || []).includes(c)}
                onChange={e => {
                  const cur = step.config.columns || [];
                  onUpdate({ columns: e.target.checked ? [...cur, c] : cur.filter(x => x !== c) });
                }} /> {c}
            </label>
          ))}
        </div>
      </div>
    );
  }

  if (step.kind === "dedupe") {
    return (
      <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch", margin: 0 }}>
        <label><input type="checkbox" checked={!!step.config.caseInsensitive} onChange={e => onUpdate({ caseInsensitive: e.target.checked })} /> Case-insensitive</label>
        <div style={{ fontSize: 10, color: "var(--ink-faint)" }}>Match on (leave all unchecked = entire row):</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 10px" }}>
          {cols.map(c => (
            <label key={c} style={{ fontSize: 11 }}>
              <input type="checkbox"
                checked={(step.config.columns || []).includes(c)}
                onChange={e => {
                  const cur = step.config.columns || [];
                  onUpdate({ columns: e.target.checked ? [...cur, c] : cur.filter(x => x !== c) });
                }} /> {c}
            </label>
          ))}
        </div>
      </div>
    );
  }

  if (step.kind === "sort") {
    return (
      <div className="conv-opts" style={{ margin: 0 }}>
        <label>By{" "}
          <select className="conv-opts-input" value={step.config.col || ""} onChange={e => onUpdate({ col: e.target.value })}>
            <option value="">(none)</option>
            {cols.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </label>
        <label>
          <select aria-label="Sort direction" className="conv-opts-input" value={step.config.dir || "asc"} onChange={e => onUpdate({ dir: e.target.value })}>
            <option value="asc">↑ ascending</option>
            <option value="desc">↓ descending</option>
          </select>
        </label>
      </div>
    );
  }

  if (step.kind === "filter") {
    const ops = ["=", "≠", ">", "<", "≥", "≤", "contains", "does not contain", "starts with", "ends with", "is empty", "is not empty"];
    const filters = (step.config.filters && step.config.filters.length > 0) ? step.config.filters : [{ col: "", op: "=", value: "" }];
    function updateF(i, patch) {
      const arr = filters.slice();
      arr[i] = { ...arr[i], ...patch };
      onUpdate({ filters: arr });
    }
    function addF() {
      if (filters.length >= 3) return;
      onUpdate({ filters: [...filters, { col: "", op: "=", value: "" }] });
    }
    function rmF(i) { onUpdate({ filters: filters.filter((_, idx) => idx !== i) }); }
    return (
      <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch", margin: 0 }}>
        {filters.map((f, i) => (
          <div key={i} style={{ display: "flex", flexWrap: "wrap", gap: "6px 8px", alignItems: "center" }}>
            {i > 0 && <span style={{ fontFamily: "var(--mono)", fontSize: 10, color: "var(--accent-ink)", textTransform: "uppercase" }}>AND</span>}
            <select aria-label="Filter column" className="conv-opts-input" value={f.col || ""} onChange={e => updateF(i, { col: e.target.value })}>
              <option value="">(none)</option>
              {cols.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <select aria-label="Filter operator" className="conv-opts-input" value={f.op || "="} onChange={e => updateF(i, { op: e.target.value })}>
              {ops.map(op => <option key={op} value={op}>{op}</option>)}
            </select>
            <input type="text" aria-label="Filter value" className="conv-opts-input" style={{ minWidth: 100 }}
              placeholder="value" value={f.value == null ? "" : f.value}
              onChange={e => updateF(i, { value: e.target.value })}
              disabled={f.op === "is empty" || f.op === "is not empty"} />
            {filters.length > 1 && <button type="button" className="conv-opts-x" onClick={() => rmF(i)}>×</button>}
          </div>
        ))}
        {filters.length < 3 && <button type="button" className="conv-opts-add" onClick={addF}>+ AND filter</button>}
      </div>
    );
  }

  if (step.kind === "sql") {
    return (
      <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch", margin: 0 }}>
        <div style={{ fontSize: 10, color: "var(--ink-faint)" }}>Columns: {cols.join(", ")}</div>
        <textarea className="conv-sql-input" rows="2"
          placeholder="SELECT * FROM csv WHERE …"
          value={step.config.sql || ""}
          onChange={e => onUpdate({ sql: e.target.value })} />
      </div>
    );
  }

  if (step.kind === "split") {
    const mode = step.config.mode || "rowCount";
    return (
      <div className="conv-opts" style={{ margin: 0 }}>
        <label>Mode{" "}
          <select className="conv-opts-input" value={mode} onChange={e => onUpdate({ mode: e.target.value })}>
            <option value="rowCount">Every N rows</option>
            <option value="fileCount">Into N files</option>
            <option value="byColumn">By column value</option>
          </select>
        </label>
        {mode === "rowCount" && (
          <label>Rows / file{" "}
            <input type="number" min="1" className="conv-opts-input" style={{ width: 80 }}
              value={step.config.rowsPerFile || 1000}
              onChange={e => onUpdate({ rowsPerFile: e.target.value })} />
          </label>
        )}
        {mode === "fileCount" && (
          <label># files{" "}
            <input type="number" min="2" max="999" className="conv-opts-input" style={{ width: 80 }}
              value={step.config.numFiles || 2}
              onChange={e => onUpdate({ numFiles: e.target.value })} />
          </label>
        )}
        {mode === "byColumn" && (
          <label>By{" "}
            <select className="conv-opts-input" value={step.config.byColumn || cols[0]} onChange={e => onUpdate({ byColumn: e.target.value })}>
              {cols.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </label>
        )}
      </div>
    );
  }

  return null;
}

function PipelinePreview({ profile }) {
  const cols = profile.cols.slice(0, 8); // limit visible columns for sanity
  const rows = profile.rows.slice(0, 12);
  return (
    <div className="pipe-preview-table-wrap">
      <table className="pipe-preview-table">
        <thead>
          <tr>
            {cols.map(c => <th key={c.name}>{c.name}</th>)}
            {profile.cols.length > 8 && <th>…</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              {cols.map(c => <td key={c.name} className={c.type === "number" ? "num" : ""}>{String(r[c.name] == null ? "" : r[c.name]).slice(0, 60)}</td>)}
              {profile.cols.length > 8 && <td>…</td>}
            </tr>
          ))}
        </tbody>
      </table>
      {profile.rows.length > 12 && (
        <div className="pipe-preview-more">… {profile.rows.length - 12} more row{profile.rows.length - 12 === 1 ? "" : "s"}</div>
      )}
    </div>
  );
}

// Expose globally so app.jsx can use them
window.Convert = Convert;
// Module-top helpers the lazy convert-extra.js chunk needs (it runs in its own
// IIFE and aliases these off window): keep in sync with convert-extra's header.
window.numberColClean = numberColClean;
window.numberRoundTrips = numberRoundTrips;
window.isoDateParts = isoDateParts;
window.InsightStrip = InsightStrip;
window.ConverterShell = ConverterShell;
window.PipelineShell = PipelineShell;
window.DEFAULT_CONVERT_CONFIG = DEFAULT_CONVERT_CONFIG;


/* global React, CSVTool */
// Visualization tools — Pivot, Heatmap, Timeline, Treemap, Sankey.
// Concatenated into bundle.js AFTER charts.jsx + converter.jsx, BEFORE app.jsx,
// so it can reuse: fmtNum/fmtByCol/fmtDateShort/useSize (charts.jsx),
// ConverterInput/SheetPicker/InsightStrip/ensureXLSX (converter.jsx), CSVTool (parser.js).
// app.jsx (loaded after) mounts <VizShell> when window.PAGE_CONFIG.mode === "viz".

// ============== shared aggregation ==============
// Build a row×col matrix of an aggregated measure. Date dims are bucketed to YYYY-MM.
function vizAggMatrix(rows, rowDim, colDim, measure, agg, typeOf) {
  const bucket = (dim, raw) => {
    if (dim && typeOf(dim) === "date") {
      const d = CSVTool.parseDate(raw);
      return d ? d.toISOString().slice(0, 7) : "—"; // YYYY-MM
    }
    return String(raw == null || raw === "" ? "—" : raw);
  };
  const rowKeys = [], colKeys = [];
  const rowSeen = new Set(), colSeen = new Set();
  const cell = new Map();
  const rowTotals = new Map(), colTotals = new Map(), rowCounts = new Map();
  for (const r of rows) {
    const rk = bucket(rowDim, r[rowDim]);
    const ck = colDim ? bucket(colDim, r[colDim]) : "Total";
    if (!rowSeen.has(rk)) { rowSeen.add(rk); rowKeys.push(rk); }
    if (!colSeen.has(ck)) { colSeen.add(ck); colKeys.push(ck); }
    const v = agg === "count" ? 1 : CSVTool.parseNumber(r[measure]);
    if (v === null || v === undefined || isNaN(v)) continue;
    const k = rk + "‖" + ck;
    const p = cell.get(k) || { sum: 0, count: 0, min: Infinity, max: -Infinity };
    p.sum += v; p.count += 1; p.min = Math.min(p.min, v); p.max = Math.max(p.max, v);
    cell.set(k, p);
    rowTotals.set(rk, (rowTotals.get(rk) || 0) + v);
    rowCounts.set(rk, (rowCounts.get(rk) || 0) + 1);
    colTotals.set(ck, (colTotals.get(ck) || 0) + v);
  }
  const valOf = (rk, ck) => {
    const c = cell.get(rk + "‖" + ck);
    if (!c) return null;
    if (agg === "count") return c.count;
    if (agg === "avg") return c.count ? c.sum / c.count : null;
    if (agg === "min") return c.min === Infinity ? null : c.min;
    if (agg === "max") return c.max === -Infinity ? null : c.max;
    return c.sum;
  };
  return { rowKeys, colKeys, valOf, rowTotals, colTotals, rowCounts };
}

// Sort keys by their total (desc) and cap to n, for readable heatmaps/sankeys.
function topKeys(keys, totals, n) {
  return keys.slice().sort((a, b) => (totals.get(b) || 0) - (totals.get(a) || 0)).slice(0, n);
}

// ============== Pivot ==============
function PivotViz({ profile, sel }) {
  const { rows } = profile;
  const typeOf = name => (profile.cols.find(c => c.name === name) || {}).type;
  const measureCol = profile.cols.find(c => c.name === sel.measure);
  const m = useMemo(
    () => sel.rowDim ? vizAggMatrix(rows, sel.rowDim, sel.colDim, sel.measure, sel.agg, typeOf) : null,
    [rows, sel.rowDim, sel.colDim, sel.measure, sel.agg]
  );
  if (!m) return <div className="viz-empty">Pick a row dimension to build the pivot.</div>;
  const fmt = v => v == null || isNaN(v) ? "" : (sel.agg === "count" ? fmtNum(v) : (measureCol ? fmtByCol(measureCol, v) : fmtNum(v)));
  // Date-dimension columns render chronologically (the bucket keys, e.g. YYYY-MM,
  // sort lexically = chronologically) instead of CSV insertion order.
  const colKeys = sel.colDim && typeOf(sel.colDim) === "date" ? m.colKeys.slice().sort() : m.colKeys;
  return (
    <div className="pivot-scroll">
      <table className="pivot-table">
        <thead>
          <tr>
            <th className="pivot-corner">{sel.rowDim}{sel.colDim ? " × " + sel.colDim : ""}</th>
            {colKeys.map(ck => <th key={ck}>{ck}</th>)}
            <th className="pivot-total">Total</th>
          </tr>
        </thead>
        <tbody>
          {m.rowKeys.map(rk => {
            let tot = 0;
            colKeys.forEach(ck => { const v = m.valOf(rk, ck); if (v != null) tot += v; });
            // The avg Total is the TRUE grand average (sum of all row values / their
            // count), not the mean of the per-cell averages.
            const totDisp = sel.agg === "avg" ? (m.rowCounts.get(rk) ? m.rowTotals.get(rk) / m.rowCounts.get(rk) : null) : (sel.agg === "min" || sel.agg === "max" ? null : tot);
            return (
              <tr key={rk}>
                <th>{rk}</th>
                {colKeys.map(ck => <td key={ck}>{fmt(m.valOf(rk, ck))}</td>)}
                <td className="pivot-total">{fmt(totDisp)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ============== Heatmap ==============
function heatColor(t) {
  const x = Math.max(0, Math.min(1, t));
  return `oklch(${(0.95 - x * 0.52).toFixed(3)} ${(0.03 + x * 0.13).toFixed(3)} 162)`;
}
function HeatmapViz({ profile, sel }) {
  const ref = useRef(null);
  const { w } = useSize(ref);
  const [picked, setPicked] = useState(null); // clicked cell { rk, ck, v }
  useEffect(() => { setPicked(null); }, [sel.rowDim, sel.colDim, sel.measure, sel.agg]);
  const { rows } = profile;
  const typeOf = name => (profile.cols.find(c => c.name === name) || {}).type;
  const measureCol = profile.cols.find(c => c.name === sel.measure);
  const m = useMemo(
    () => sel.rowDim ? vizAggMatrix(rows, sel.rowDim, sel.colDim || "", sel.measure, sel.agg, typeOf) : null,
    [rows, sel.rowDim, sel.colDim, sel.measure, sel.agg]
  );
  if (!m) return <div ref={ref} className="viz-empty">Pick row and column dimensions.</div>;

  // Sort an axis chronologically only when its dimension is a date; otherwise keep
  // the top-by-total order (the old blanket .sort() on the column axis scrambled
  // numeric categories like 2 / 10 / 100).
  const rowKeys = typeOf(sel.rowDim) === "date" ? m.rowKeys.slice().sort() : topKeys(m.rowKeys, m.rowTotals, 20);
  const colKeys = typeOf(sel.colDim) === "date" ? m.colKeys.slice().sort() : topKeys(m.colKeys, m.colTotals, 20);
  let lo = Infinity, hi = -Infinity;
  rowKeys.forEach(rk => colKeys.forEach(ck => { const v = m.valOf(rk, ck); if (v != null) { lo = Math.min(lo, v); hi = Math.max(hi, v); } }));
  if (lo === Infinity) return <div ref={ref} className="viz-empty">No numeric values to plot.</div>;
  const norm = v => hi === lo ? 0.6 : (v - lo) / (hi - lo);
  const fmt = v => sel.agg === "count" ? fmtNum(v) : (measureCol ? fmtByCol(measureCol, v) : fmtNum(v));

  const padL = 120, padT = 64, gap = 2;
  const W = Math.max(360, w);
  const cellW = Math.max(20, (W - padL - 12) / colKeys.length - gap);
  const cellH = Math.min(46, Math.max(20, 460 / Math.max(1, rowKeys.length) - gap));
  const H = padT + rowKeys.length * (cellH + gap) + 8;

  return (
    <div ref={ref} className="viz-canvas-inner">
      {w > 0 && (
        <svg className="svg-chart viz-svg" viewBox={`0 0 ${W} ${H}`} width={W} height={H}>
          {colKeys.map((ck, j) => {
            const x = padL + j * (cellW + gap) + cellW / 2;
            const label = ck.length > 12 ? ck.slice(0, 11) + "…" : ck;
            return <text key={ck} x={x} y={padT - 10} transform={`rotate(-35 ${x} ${padT - 10})`} textAnchor="start" className="viz-axis-label">{label}</text>;
          })}
          {rowKeys.map((rk, i) => {
            const y = padT + i * (cellH + gap);
            const rlabel = rk.length > 16 ? rk.slice(0, 15) + "…" : rk;
            return (
              <g key={rk}>
                <text x={padL - 10} y={y + cellH / 2 + 4} textAnchor="end" className="viz-axis-label">{rlabel}</text>
                {colKeys.map((ck, j) => {
                  const v = m.valOf(rk, ck);
                  const x = padL + j * (cellW + gap);
                  const fill = v == null ? "var(--bg-soft)" : heatColor(norm(v));
                  const showText = cellW >= 38 && cellH >= 22 && v != null;
                  const isPicked = picked && picked.rk === rk && picked.ck === ck;
                  return (
                    <g key={ck}>
                      <rect x={x} y={y} width={cellW} height={cellH} rx="3" fill={fill}
                        style={{ cursor: v == null ? "default" : "pointer" }}
                        stroke={isPicked ? "var(--ink)" : "none"} strokeWidth={isPicked ? 2.5 : 0}
                        onClick={v == null ? undefined : () => setPicked(p => (p && p.rk === rk && p.ck === ck) ? null : { rk, ck, v })}>
                        <title>{`${rk} × ${ck}: ${v == null ? "—" : fmt(v)}`}</title>
                      </rect>
                      {/* cells use a fixed light→dark green scale, so text color must be fixed too (not theme vars) */}
                      {showText && <text x={x + cellW / 2} y={y + cellH / 2 + 4} textAnchor="middle" className="viz-cell-text" style={{ fill: norm(v) > 0.55 ? "#fff" : "#15302a" }}>{fmt(v)}</text>}
                    </g>
                  );
                })}
              </g>
            );
          })}
          {/* legend */}
          <g>
            {Array.from({ length: 20 }).map((_, k) => (
              <rect key={k} x={padL + k * 10} y={H - 4} width={10} height={6} fill={heatColor(k / 19)} />
            ))}
            <text x={padL - 6} y={H + 2} textAnchor="end" className="viz-axis-label">{fmt(lo)}</text>
            <text x={padL + 200 + 6} y={H + 2} textAnchor="start" className="viz-axis-label">{fmt(hi)}</text>
          </g>
        </svg>
      )}
      {picked && (
        <div className="viz-pick">
          <span><strong>{picked.rk}</strong>{sel.colDim ? <> × <strong>{picked.ck}</strong></> : null} · {fmt(picked.v)}</span>
          <button className="viz-pick-clear" onClick={() => setPicked(null)} aria-label="Clear selection">clear</button>
        </div>
      )}
    </div>
  );
}

// ============== Timeline ==============
function TimelineViz({ profile, sel }) {
  const ref = useRef(null);
  const { w } = useSize(ref);
  const { rows } = profile;
  const valCol = profile.cols.find(c => c.name === sel.valueCol);

  const events = useMemo(() => {
    if (!sel.dateCol) return [];
    return rows.map(r => {
      const d = CSVTool.parseDate(r[sel.dateCol]);
      if (!d) return null;
      return {
        date: d,
        lane: sel.laneCol ? String(r[sel.laneCol] || "—") : "All",
        label: sel.labelCol ? String(r[sel.labelCol] || "") : "",
        value: sel.valueCol ? CSVTool.parseNumber(r[sel.valueCol]) : null
      };
    }).filter(Boolean).sort((a, b) => a.date - b.date).slice(0, 400);
  }, [rows, sel.dateCol, sel.laneCol, sel.labelCol, sel.valueCol]);

  if (!sel.dateCol) return <div ref={ref} className="viz-empty">Pick a date column.</div>;
  if (events.length === 0) return <div ref={ref} className="viz-empty">No valid dates found in that column.</div>;

  const laneOrder = [];
  const laneSeen = new Set();
  events.forEach(e => { if (!laneSeen.has(e.lane)) { laneSeen.add(e.lane); laneOrder.push(e.lane); } });
  const lanes = laneOrder.slice(0, 12);
  const laneSet = new Set(lanes);
  const ev = events.filter(e => laneSet.has(e.lane));

  const padL = 130, padR = 24, padT = 16;
  const laneH = 46;
  const W = Math.max(360, w);
  const H = padT + lanes.length * laneH + 36;
  const t0 = +ev[0].date, t1 = +ev[ev.length - 1].date;
  const span = (t1 - t0) || 1;
  const xOf = d => padL + ((+d - t0) / span) * (W - padL - padR);
  const laneY = ln => padT + lanes.indexOf(ln) * laneH + laneH / 2;
  const maxV = Math.max(1, ...ev.map(e => Math.abs(e.value || 0)));
  const rOf = v => v == null ? 5 : 4 + Math.sqrt(Math.abs(v) / maxV) * 12;
  const hues = [162, 200, 30, 280, 340, 60, 120, 250, 15, 90, 220, 0];
  const showLabels = ev.length <= 40;

  return (
    <div ref={ref} className="viz-canvas-inner">
      {w > 0 && (
        <svg className="svg-chart viz-svg" viewBox={`0 0 ${W} ${H}`} width={W} height={H}>
          {lanes.map((ln, i) => {
            const y = laneY(ln);
            const label = ln.length > 18 ? ln.slice(0, 17) + "…" : ln;
            return (
              <g key={ln}>
                <line x1={padL} x2={W - padR} y1={y} y2={y} className="grid-line" />
                <text x={padL - 12} y={y + 4} textAnchor="end" className="viz-axis-label" style={{ fontWeight: 600 }}>{label}</text>
                <circle cx={8} cy={y} r="4" fill={`oklch(0.6 0.13 ${hues[i % hues.length]})`} />
              </g>
            );
          })}
          {ev.map((e, i) => {
            const x = xOf(e.date), y = laneY(e.lane);
            const hue = hues[lanes.indexOf(e.lane) % hues.length];
            return (
              <g key={i}>
                <circle cx={x} cy={y} r={rOf(e.value)} fill={`oklch(0.6 0.13 ${hue})`} opacity="0.78" stroke={`oklch(0.45 0.15 ${hue})`} strokeWidth="1">
                  <title>{`${fmtDateShort(e.date)}${e.label ? " · " + e.label : ""}${e.value != null ? " · " + (valCol ? fmtByCol(valCol, e.value) : fmtNum(e.value)) : ""}`}</title>
                </circle>
                {showLabels && e.label && <text x={x} y={y - rOf(e.value) - 4} textAnchor="middle" className="viz-cell-text">{e.label.length > 14 ? e.label.slice(0, 13) + "…" : e.label}</text>}
              </g>
            );
          })}
          {[t0, (t0 + t1) / 2, t1].map((t, i) => (
            <text key={i} x={i === 0 ? padL : i === 1 ? (padL + W - padR) / 2 : W - padR} y={H - 12}
              textAnchor={i === 0 ? "start" : i === 1 ? "middle" : "end"} className="viz-axis-label">{fmtDateShort(new Date(t))}</text>
          ))}
        </svg>
      )}
    </div>
  );
}

// ============== Treemap ==============
function squarify(items, x, y, w, h) {
  const out = [];
  const total = items.reduce((s, n) => s + n.value, 0) || 1;
  const area = Math.max(1, w * h);
  const nodes = items.map(n => ({ ...n, _a: (n.value / total) * area }));
  const rect = { x, y, w, h };
  let row = [];
  const shortSide = () => Math.min(rect.w, rect.h);
  const worst = (rw, side) => {
    const sum = rw.reduce((s, n) => s + n._a, 0);
    if (sum === 0) return Infinity;
    const _av = rw.map(n => n._a); const mx = arrMax(_av), mn = arrMin(_av);
    const s2 = side * side, sum2 = sum * sum;
    return Math.max((s2 * mx) / sum2, sum2 / (s2 * mn));
  };
  const place = rw => {
    const sum = rw.reduce((s, n) => s + n._a, 0);
    const side = shortSide();
    const thick = sum / side;
    if (rect.w >= rect.h) {
      let oy = rect.y;
      for (const n of rw) { const nh = (n._a / sum) * side; out.push({ ...n, x: rect.x, y: oy, w: thick, h: nh }); oy += nh; }
      rect.x += thick; rect.w -= thick;
    } else {
      let ox = rect.x;
      for (const n of rw) { const nw = (n._a / sum) * side; out.push({ ...n, x: ox, y: rect.y, w: nw, h: thick }); ox += nw; }
      rect.y += thick; rect.h -= thick;
    }
  };
  const q = nodes.slice();
  while (q.length) {
    const n = q[0], side = shortSide();
    if (row.length === 0) { row.push(q.shift()); continue; }
    if (worst([...row, n], side) <= worst(row, side)) row.push(q.shift());
    else { place(row); row = []; }
  }
  if (row.length) place(row);
  return out;
}
function TreemapViz({ profile, sel }) {
  const ref = useRef(null);
  const { w } = useSize(ref);
  const [picked, setPicked] = useState(null); // clicked leaf { i, group, key, value }
  useEffect(() => { setPicked(null); }, [sel.groupCol, sel.subCol, sel.sizeCol]);
  const { rows } = profile;
  const sizeCol = profile.cols.find(c => c.name === sel.sizeCol);
  const hues = [162, 200, 30, 280, 340, 60, 120, 250, 15, 90, 220, 0];

  const groups = useMemo(() => {
    if (!sel.groupCol) return [];
    const gmap = new Map();
    for (const r of rows) {
      const g = String(r[sel.groupCol] || "—");
      const v = sel.sizeCol ? CSVTool.parseNumber(r[sel.sizeCol]) : 1;
      if (v == null || isNaN(v) || v <= 0) continue;
      if (!gmap.has(g)) gmap.set(g, { key: g, value: 0, subs: new Map() });
      const gg = gmap.get(g); gg.value += v;
      if (sel.subCol) { const s = String(r[sel.subCol] || "—"); gg.subs.set(s, (gg.subs.get(s) || 0) + v); }
    }
    return [...gmap.values()]
      .map(g => ({ key: g.key, value: g.value, children: [...g.subs.entries()].map(([k, v]) => ({ key: k, value: v })).sort((a, b) => b.value - a.value) }))
      .sort((a, b) => b.value - a.value).slice(0, 14);
  }, [rows, sel.groupCol, sel.subCol, sel.sizeCol]);

  if (!sel.groupCol) return <div ref={ref} className="viz-empty">Pick a grouping column.</div>;
  if (groups.length === 0) return <div ref={ref} className="viz-empty">No positive numeric sizes to lay out.</div>;

  const W = Math.max(360, w), H = 460;
  const hasSub = !!sel.subCol && groups.some(g => g.children.length);
  const groupRects = squarify(groups, 2, 2, W - 4, H - 4);
  const fmt = v => sizeCol ? fmtByCol(sizeCol, v) : fmtNum(v);

  const leaves = [];
  groupRects.forEach((g, gi) => {
    const hue = hues[gi % hues.length];
    if (hasSub && g.children && g.children.length) {
      const pad = g.h > 34 ? 20 : 2;
      const inner = squarify(g.children, g.x + 2, g.y + pad, Math.max(2, g.w - 4), Math.max(2, g.h - pad - 2));
      inner.forEach((s, si) => leaves.push({ ...s, group: g.key, hue, l: 0.5 - (si % 5) * 0.04, isLeaf: true }));
    } else {
      leaves.push({ ...g, group: g.key, hue, l: 0.52, isLeaf: true });
    }
  });

  return (
    <div ref={ref} className="viz-canvas-inner">
      {w > 0 && (
        <svg className="svg-chart viz-svg" viewBox={`0 0 ${W} ${H}`} width={W} height={H}>
          {leaves.map((n, i) => {
            const big = n.w > 54 && n.h > 26;
            return (
              <g key={i}>
                <rect x={n.x} y={n.y} width={Math.max(0, n.w - 1)} height={Math.max(0, n.h - 1)} rx="2"
                  fill={`oklch(${n.l} 0.13 ${n.hue})`} style={{ cursor: "pointer" }}
                  stroke={picked && picked.i === i ? "var(--ink)" : "var(--bg-card)"} strokeWidth={picked && picked.i === i ? 2.5 : 1}
                  onClick={() => setPicked(p => (p && p.i === i) ? null : { i, group: n.group, key: n.key, value: n.value })}>
                  <title>{`${n.group}${n.key !== n.group ? " · " + n.key : ""}: ${fmt(n.value)}`}</title>
                </rect>
                {big && <text x={n.x + 6} y={n.y + 16} className="viz-cell-text" style={{ fill: "#fff", fontWeight: 600 }}>{(n.key.length > Math.floor(n.w / 8) ? n.key.slice(0, Math.floor(n.w / 8)) + "…" : n.key)}</text>}
                {big && n.h > 40 && <text x={n.x + 6} y={n.y + 32} className="viz-cell-text" style={{ fill: "rgba(255,255,255,0.85)" }}>{fmt(n.value)}</text>}
              </g>
            );
          })}
          {hasSub && groupRects.map((g, i) => (
            g.h > 34 ? <g key={i}>
              <rect x={g.x} y={g.y} width={Math.max(0, g.w - 1)} height={Math.max(0, g.h - 1)} fill="none" stroke="var(--ink)" strokeWidth="1.5" opacity="0.25" rx="2" />
              <text x={g.x + 6} y={g.y + 14} className="viz-axis-label" style={{ fontWeight: 700 }}>{g.key.length > Math.floor(g.w / 8) ? g.key.slice(0, Math.floor(g.w / 8)) + "…" : g.key}</text>
            </g> : null
          ))}
        </svg>
      )}
      {picked && (
        <div className="viz-pick">
          <span><strong>{picked.group}</strong>{picked.key !== picked.group ? <> · <strong>{picked.key}</strong></> : null} · {fmt(picked.value)}</span>
          <button className="viz-pick-clear" onClick={() => setPicked(null)} aria-label="Clear selection">clear</button>
        </div>
      )}
    </div>
  );
}

// ============== Sankey ==============
function SankeyViz({ profile, sel }) {
  const ref = useRef(null);
  const { w } = useSize(ref);
  const [picked, setPicked] = useState(null); // clicked link { i, s, t, v }
  useEffect(() => { setPicked(null); }, [sel.sourceCol, sel.targetCol, sel.valueCol]);
  const { rows } = profile;
  const valCol = profile.cols.find(c => c.name === sel.valueCol);
  const hues = [162, 200, 30, 280, 340, 60, 120, 250, 15, 90, 220, 0];

  const model = useMemo(() => {
    if (!sel.sourceCol || !sel.targetCol) return null;
    const flow = new Map(); // src|tgt -> value
    const srcTot = new Map(), tgtTot = new Map();
    for (const r of rows) {
      const s = String(r[sel.sourceCol] || "—"), t = String(r[sel.targetCol] || "—");
      const v = sel.valueCol ? CSVTool.parseNumber(r[sel.valueCol]) : 1;
      if (v == null || isNaN(v) || v <= 0) continue;
      flow.set(s + "‖" + t, (flow.get(s + "‖" + t) || 0) + v);
      srcTot.set(s, (srcTot.get(s) || 0) + v);
      tgtTot.set(t, (tgtTot.get(t) || 0) + v);
    }
    const sources = [...srcTot.entries()].sort((a, b) => b[1] - a[1]).slice(0, 12).map(e => e[0]);
    const targets = [...tgtTot.entries()].sort((a, b) => b[1] - a[1]).slice(0, 12).map(e => e[0]);
    const srcSet = new Set(sources), tgtSet = new Set(targets);
    const links = [];
    flow.forEach((v, k) => { const [s, t] = k.split("‖"); if (srcSet.has(s) && tgtSet.has(t)) links.push({ s, t, v }); });
    return { sources, targets, links, srcTot, tgtTot };
  }, [rows, sel.sourceCol, sel.targetCol, sel.valueCol]);

  if (!sel.sourceCol || !sel.targetCol) return <div ref={ref} className="viz-empty">Pick source and target columns.</div>;
  if (!model || model.links.length === 0) return <div ref={ref} className="viz-empty">No flows between those columns.</div>;

  const W = Math.max(420, w), H = 460;
  const padT = 16, padB = 16, nodeW = 14, gap = 8;
  const colTotal = side => model[side === "s" ? "sources" : "targets"].reduce((a, k) => a + (model[side === "s" ? "srcTot" : "tgtTot"].get(k) || 0), 0) || 1;
  const sTotal = colTotal("s"), tTotal = colTotal("t");
  const usableH = H - padT - padB;
  const scale = Math.min(usableH / sTotal, usableH / tTotal);

  function layout(keys, totals, total) {
    const n = keys.length;
    const totalGap = gap * (n - 1);
    const avail = usableH - totalGap;
    let y = padT;
    const pos = new Map();
    for (const k of keys) {
      const v = totals.get(k) || 0;
      const hgt = Math.max(3, (v / (total || 1)) * avail);
      pos.set(k, { y, h: hgt, v }); y += hgt + gap;
    }
    return pos;
  }
  const sPos = layout(model.sources, model.srcTot, sTotal);
  const tPos = layout(model.targets, model.tgtTot, tTotal);

  const links = model.links.slice().sort((a, b) => b.v - a.v);
  const sOff = new Map(), tOff = new Map();
  const fmt = v => valCol ? fmtByCol(valCol, v) : fmtNum(v);
  const x0 = 4, x1 = W - 4 - nodeW;
  const maxLinkV = Math.max(arrMax(links.map(l => l.v)), 1);

  return (
    <div ref={ref} className="viz-canvas-inner">
      {w > 0 && (
        <svg className="svg-chart viz-svg" viewBox={`0 0 ${W} ${H}`} width={W} height={H}>
          {links.map((l, i) => {
            const sp = sPos.get(l.s), tp = tPos.get(l.t);
            if (!sp || !tp) return null;
            const so = sOff.get(l.s) || 0, to = tOff.get(l.t) || 0;
            const lw = Math.max(1, (l.v / maxLinkV) * Math.min(sp.h, 40));
            const totLW = (model.srcTot.get(l.s) || 1);
            const sh = (l.v / totLW) * sp.h;
            const totTW = (model.tgtTot.get(l.t) || 1);
            const th = (l.v / totTW) * tp.h;
            const y0 = sp.y + so + sh / 2, y1 = tp.y + to + th / 2;
            sOff.set(l.s, so + sh); tOff.set(l.t, to + th);
            const hue = hues[model.sources.indexOf(l.s) % hues.length];
            const mx = (x0 + nodeW + x1) / 2;
            const d = `M ${x0 + nodeW} ${y0} C ${mx} ${y0}, ${mx} ${y1}, ${x1} ${y1}`;
            const isPicked = picked && picked.i === i;
            return <path key={i} d={d} fill="none" stroke={`oklch(0.62 0.12 ${hue})`} strokeWidth={Math.max(1, (sh + th) / 2)}
              strokeOpacity={isPicked ? 0.9 : (picked ? 0.18 : 0.4)} style={{ cursor: "pointer" }}
              onClick={() => setPicked(p => (p && p.i === i) ? null : { i, s: l.s, t: l.t, v: l.v })}>
              <title>{`${l.s} → ${l.t}: ${fmt(l.v)}`}</title>
            </path>;
          })}
          {model.sources.map((k, i) => {
            const p = sPos.get(k); const hue = hues[i % hues.length];
            return <g key={"s" + k}>
              <rect x={x0} y={p.y} width={nodeW} height={p.h} rx="2" fill={`oklch(0.55 0.13 ${hue})`} />
              <text x={x0 + nodeW + 6} y={p.y + p.h / 2 + 4} className="viz-axis-label">{k.length > 16 ? k.slice(0, 15) + "…" : k}</text>
            </g>;
          })}
          {model.targets.map((k, i) => {
            const p = tPos.get(k);
            return <g key={"t" + k}>
              <rect x={x1} y={p.y} width={nodeW} height={p.h} rx="2" fill="oklch(0.5 0.05 230)" />
              <text x={x1 - 6} y={p.y + p.h / 2 + 4} textAnchor="end" className="viz-axis-label">{k.length > 16 ? k.slice(0, 15) + "…" : k}</text>
            </g>;
          })}
        </svg>
      )}
      {picked && (
        <div className="viz-pick">
          <span><strong>{picked.s}</strong> → <strong>{picked.t}</strong> · {fmt(picked.v)}</span>
          <button className="viz-pick-clear" onClick={() => setPicked(null)} aria-label="Clear selection">clear</button>
        </div>
      )}
    </div>
  );
}

// ============== column-picker control ==============
function VizPicker({ label, cols, value, onChange, allowNone, noneLabel }) {
  return (
    <label className="pivot-control">
      <span>{label}</span>
      <select value={value || ""} onChange={e => onChange(e.target.value)}>
        {allowNone && <option value="">{noneLabel || "(none)"}</option>}
        {cols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
      </select>
    </label>
  );
}

// ============== VizShell ==============
function VizShell({ config }) {
  const cfg = config || {};
  const vizType = cfg.vizType || "pivot";
  const [csvText, setCsvText] = useState("");
  const [profile, setProfile] = useState(null);
  const [filename, setFilename] = useState("data");
  const [error, setError] = useState("");
  const [pendingSheets, setPendingSheets] = useState(null);
  const [sel, setSel] = useState({});
  const vizRef = useRef(null);

  // V6 workspace wiring
  useToolFile(
    (csv, name) => loadCSVText(csv, name),
    () => (csvText ? { csv: csvText, name: filename + ".csv" } : null)
  );

  function loadCSVText(text, name) {
    try {
      const parsed = CSVTool.parseCSV(text);
      if (!parsed.headers.length || !parsed.rows.length) { setError("That doesn't look like a valid CSV — it needs a header row and at least one data row."); return; }
      setProfile(CSVTool.profile(parsed));
      setCsvText(text);
      if (name) setFilename(String(name).replace(/\.[^.]+$/, ""));
      setError("");
      wsMaybeSave(name ? String(name) : "data.csv", text);
    } catch (e) { setError(e.message || "Could not parse that CSV."); }
  }

  function handleFile(file) {
    if (!file) return;
    setFilename((file.name || "data").replace(/\.[^.]+$/, ""));
    const reader = new FileReader();
    reader.onerror = () => setError("Could not read that file.");
    if (/\.(xlsx|xls)$/i.test(file.name || "")) {
      reader.onload = e => ensureXLSX().then(() => {
        try {
          const { sheets } = CSVTool.parseXLSXBuffer(e.target.result);
          if (!sheets || !sheets.length) { setError("That workbook had no rows."); return; }
          if (sheets.length === 1) loadCSVText(sheets[0].csvText, file.name);
          else setPendingSheets({ sheets, filename: file.name });
        } catch (err) { setError(err.message); }
      }).catch(() => setError("Could not load the Excel engine."));
      reader.readAsArrayBuffer(file);
    } else {
      reader.onload = e => loadCSVText(e.target.result, file.name);
      reader.readAsText(file);
    }
  }

  function reset() { setProfile(null); setCsvText(""); setFilename("data"); setError(""); setSel({}); }

  function buildDashboard() {
    sendCSVToDashboard(csvText, filename + ".csv");
  }

  // sensible default column choices when data loads / viz type changes
  useEffect(() => {
    if (!profile) return;
    const ch = profile.cols.filter(c => c.role !== "id");
    const cats = ch.filter(c => c.type === "category" || c.type === "boolean");
    const dates = ch.filter(c => c.type === "date");
    const nums = ch.filter(c => c.type === "number").sort((a, b) => b.importance - a.importance);
    const texts = ch.filter(c => c.type === "text");
    const dim = cats.concat(dates);
    const d = {};
    if (vizType === "pivot" || vizType === "heatmap") {
      d.rowDim = (cats[0] || dates[0] || dim[0] || {}).name || "";
      d.colDim = (cats[1] || dates[0] || {}).name || "";
      d.measure = (nums[0] || {}).name || "";
      d.agg = nums.length ? "sum" : "count";
    } else if (vizType === "timeline") {
      d.dateCol = (dates[0] || {}).name || "";
      d.laneCol = (cats[0] || {}).name || "";
      d.labelCol = (texts[0] || cats.find(c => c.role === "name" || c.role === "product") || cats[1] || cats[0] || {}).name || "";
      d.valueCol = (nums[0] || {}).name || "";
    } else if (vizType === "treemap") {
      d.groupCol = (cats[0] || {}).name || "";
      d.subCol = (cats[1] || {}).name || "";
      d.sizeCol = (nums[0] || {}).name || "";
    } else if (vizType === "sankey") {
      d.sourceCol = (cats[0] || {}).name || "";
      d.targetCol = (cats[1] || cats[0] || {}).name || "";
      d.valueCol = (nums[0] || {}).name || "";
    }
    setSel(d);
  }, [profile, vizType]);

  const ch = profile ? profile.cols.filter(c => c.role !== "id") : [];
  const cats = ch.filter(c => c.type === "category" || c.type === "boolean");
  const dates = ch.filter(c => c.type === "date");
  const nums = ch.filter(c => c.type === "number");
  const texts = ch.filter(c => c.type === "text");
  const up = patch => setSel(s => ({ ...s, ...patch }));

  function renderControls() {
    if (vizType === "pivot" || vizType === "heatmap") {
      return (
        <div className="pivot-controls viz-controls">
          <VizPicker label="Rows" cols={cats.concat(dates)} value={sel.rowDim} onChange={v => up({ rowDim: v })} />
          <VizPicker label="Columns" cols={cats.concat(dates)} value={sel.colDim} onChange={v => up({ colDim: v })} allowNone noneLabel={vizType === "heatmap" ? "(single column)" : "(none)"} />
          <VizPicker label="Values" cols={nums.length ? nums : cats} value={sel.measure} onChange={v => up({ measure: v })} />
          <label className="pivot-control"><span>Aggregate</span>
            <select value={sel.agg || "sum"} onChange={e => up({ agg: e.target.value })}>
              <option value="sum">Sum</option><option value="avg">Average</option><option value="count">Count</option><option value="min">Min</option><option value="max">Max</option>
            </select>
          </label>
        </div>
      );
    }
    if (vizType === "timeline") {
      return (
        <div className="pivot-controls viz-controls">
          <VizPicker label="Date" cols={dates.length ? dates : ch} value={sel.dateCol} onChange={v => up({ dateCol: v })} />
          <VizPicker label="Lanes" cols={cats} value={sel.laneCol} onChange={v => up({ laneCol: v })} allowNone noneLabel="(single lane)" />
          <VizPicker label="Label" cols={texts.concat(cats)} value={sel.labelCol} onChange={v => up({ labelCol: v })} allowNone noneLabel="(none)" />
          <VizPicker label="Size by" cols={nums} value={sel.valueCol} onChange={v => up({ valueCol: v })} allowNone noneLabel="(uniform)" />
        </div>
      );
    }
    if (vizType === "treemap") {
      return (
        <div className="pivot-controls viz-controls">
          <VizPicker label="Group" cols={cats} value={sel.groupCol} onChange={v => up({ groupCol: v })} />
          <VizPicker label="Subgroup" cols={cats} value={sel.subCol} onChange={v => up({ subCol: v })} allowNone noneLabel="(none)" />
          <VizPicker label="Size by" cols={nums} value={sel.sizeCol} onChange={v => up({ sizeCol: v })} allowNone noneLabel="(row count)" />
        </div>
      );
    }
    if (vizType === "sankey") {
      return (
        <div className="pivot-controls viz-controls">
          <VizPicker label="From" cols={cats} value={sel.sourceCol} onChange={v => up({ sourceCol: v })} />
          <VizPicker label="To" cols={cats} value={sel.targetCol} onChange={v => up({ targetCol: v })} />
          <VizPicker label="Flow by" cols={nums} value={sel.valueCol} onChange={v => up({ valueCol: v })} allowNone noneLabel="(row count)" />
        </div>
      );
    }
    return null;
  }

  function renderViz() {
    if (vizType === "pivot") return <PivotViz profile={profile} sel={sel} />;
    if (vizType === "heatmap") return <HeatmapViz profile={profile} sel={sel} />;
    if (vizType === "timeline") return <TimelineViz profile={profile} sel={sel} />;
    if (vizType === "treemap") return <TreemapViz profile={profile} sel={sel} />;
    if (vizType === "sankey") return <SankeyViz profile={profile} sel={sel} />;
    return null;
  }

  function downloadSVG() {
    const svg = vizRef.current && vizRef.current.querySelector("svg");
    if (!svg) return;
    const blob = new Blob([serializeSVG(svg)], { type: "image/svg+xml" });
    triggerDownload(URL.createObjectURL(blob), filename + "-" + vizType + ".svg");
  }
  function downloadPNG() {
    const svg = vizRef.current && vizRef.current.querySelector("svg");
    if (!svg) return;
    const data = serializeSVG(svg);
    const img = new Image();
    const url = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(data)));
    img.onload = () => {
      const scale = 2;
      const canvas = document.createElement("canvas");
      canvas.width = (svg.viewBox.baseVal.width || svg.clientWidth || 800) * scale;
      canvas.height = (svg.viewBox.baseVal.height || svg.clientHeight || 460) * scale;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = (getComputedStyle(document.documentElement).getPropertyValue("--bg-card") || "#fff").trim();
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(b => { if (b) triggerDownload(URL.createObjectURL(b), filename + "-" + vizType + ".png"); });
    };
    img.src = url;
  }
  function copyPivotTSV() {
    const table = vizRef.current && vizRef.current.querySelector("table");
    if (!table) return;
    const lines = [...table.querySelectorAll("tr")].map(tr => [...tr.querySelectorAll("th,td")].map(c => c.textContent).join("\t"));
    navigator.clipboard.writeText(lines.join("\n")).catch(() => {});
  }

  return (
    <div className="viz-shell">
      {pendingSheets && (
        <SheetPicker sheets={pendingSheets.sheets} filename={pendingSheets.filename}
          onPick={s => { loadCSVText(s.csvText, pendingSheets.filename + " · " + s.name); setPendingSheets(null); }}
          onCancel={() => setPendingSheets(null)} />
      )}

      {!profile ? (
        <div className="viz-input">
          <ConverterInput
            label="Drop a .csv or .xlsx file"
            inputFormat="csv"
            accept=".csv,.txt,.xlsx,.xls,text/csv"
            onFile={handleFile}
            onPasteText={t => loadCSVText(t, "pasted")}
            onLoadSample={() => loadCSVText(CSVTool.SAMPLES.sales.csv, "sample-sales")}
            loaded={false}
            onClear={reset}
            onOpenRecord={rec => loadCSVText(rec.csv, rec.name)}
          />
          {error && <div className="conv-err">{error}</div>}
        </div>
      ) : (
        <div className="viz">
          {renderControls()}
          <div className="chart-card viz-card">
            <div className="chart-head">
              <div className="chart-title">{cfg.cardTitle || "Visualization"}</div>
              <div className="chart-kind">{vizType}</div>
            </div>
            <div className="viz-canvas" ref={vizRef}>{renderViz()}</div>
          </div>
          <div className="viz-actions">
            {vizType === "pivot"
              ? <button className="btn-ghost" onClick={copyPivotTSV}>Copy table (TSV)</button>
              : <>
                  <button className="btn-ghost" onClick={downloadSVG}>Download SVG</button>
                  <button className="btn-ghost" onClick={downloadPNG}>Download PNG</button>
                </>}
            <button className="btn-ghost" onClick={reset}>Use different data</button>
          </div>
          {error && <div className="conv-err">{error}</div>}
          <InsightStrip profile={profile} onBuildDashboard={buildDashboard} />
          <div className="conv-cta">
            <a href="#" className="conv-cta-link" onClick={e => { e.preventDefault(); buildDashboard(); }}>
              Want the full picture? <strong>Build a complete dashboard from this CSV →</strong>
            </a>
            <div className="conv-cta-secondary">Need a different chart? <a href="/tools">Browse all visual tools →</a></div>
          </div>
        </div>
      )}
    </div>
  );
}

// Serialize an <svg> for export, inlining the few CSS-variable-driven colors the
// chart classes rely on so the exported file isn't missing its text/grid colors.
function serializeSVG(svg) {
  const clone = svg.cloneNode(true);
  const cs = getComputedStyle(document.documentElement);
  const ink = (cs.getPropertyValue("--ink") || "#1f2937").trim();
  const faint = (cs.getPropertyValue("--ink-faint") || "#9ca3af").trim();
  const grid = (cs.getPropertyValue("--line") || "rgba(0,0,0,0.12)").trim();
  const surface = (cs.getPropertyValue("--bg-card") || "#ffffff").trim();
  const styleEl = document.createElementNS("http://www.w3.org/2000/svg", "style");
  styleEl.textContent = `text{font-family:ui-sans-serif,system-ui,sans-serif}.viz-axis-label,.viz-cell-text{fill:${ink};font-size:11px}.tick-label{fill:${faint};font-size:11px}.grid-line{stroke:${grid}}`;
  clone.insertBefore(styleEl, clone.firstChild);
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const bg = document.createElementNS("http://www.w3.org/2000/svg", "rect");
  bg.setAttribute("x", "0"); bg.setAttribute("y", "0");
  bg.setAttribute("width", String(svg.viewBox.baseVal.width || 800));
  bg.setAttribute("height", String(svg.viewBox.baseVal.height || 460));
  bg.setAttribute("fill", surface || "#fff");
  clone.insertBefore(bg, clone.firstChild);
  return '<?xml version="1.0" encoding="UTF-8"?>\n' + new XMLSerializer().serializeToString(clone);
}
function triggerDownload(url, name) {
  const a = document.createElement("a");
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 1000);
}


/* global React, CSVTool, Convert */
// Batch 3 — dev + cleaning tools. Concatenated after charts.jsx + converter.jsx
// + viz.jsx, before app.jsx. Reuses Convert/CSVTool/ConverterInput/InsightStrip
// + charts.jsx helpers. app.jsx mounts DevToolShell (mode:"devtool") and
// DualToolShell (mode:"dual").

// ============================================================ helpers
function csvEscapeCell(v) {
  const s = v == null ? "" : String(v);
  return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}
function rowsToCSV(headers, rows) {
  const head = headers.map(csvEscapeCell).join(",");
  const body = rows.map(r => headers.map(h => csvEscapeCell(r[h])).join(",")).join("\n");
  return head + (body ? "\n" + body : "");
}
function identifier(name) {
  let s = String(name || "").replace(/[^A-Za-z0-9_]/g, "_");
  if (/^\d/.test(s)) s = "_" + s;
  return s || "field";
}
function pascalCase(name) {
  let s = String(name || "").split(/[^A-Za-z0-9]+/).filter(Boolean).map(w => w[0].toUpperCase() + w.slice(1)).join("");
  if (/^\d/.test(s)) s = "_" + s; // Go/TS identifiers + type names can't start with a digit
  return s || "Field";
}
// Distinct headers can collapse to the same identifier (e.g. "first name" and
// "first_name" -> "first_name"); suffix collisions so the generated struct/model
// doesn't have duplicate fields (uncompilable Go / silently-shadowed Pydantic).
function makeUniquer() {
  const seen = {};
  return function (n) {
    if (seen[n] === undefined) { seen[n] = 1; return n; }
    let k = seen[n], cand;
    do { k++; cand = n + "_" + k; } while (seen[cand] !== undefined);
    seen[n] = k; seen[cand] = 1; return cand;
  };
}
function isIntCol(col) {
  return col.type === "number" && col.nums && col.nums.length > 0 && col.nums.every(n => Number.isInteger(n));
}
function colNullable(col) {
  return col.values.some(v => v === "" || v == null);
}

// ============================================================ Schema generator
(function () {
  function tsType(col) { return col.type === "number" ? "number" : col.type === "boolean" ? "boolean" : "string"; }
  function goType(col) { return col.type === "number" ? (isIntCol(col) ? "int" : "float64") : col.type === "boolean" ? "bool" : col.type === "date" ? "time.Time" : "string"; }
  function pyType(col) { return col.type === "number" ? (isIntCol(col) ? "int" : "float") : col.type === "boolean" ? "bool" : col.type === "date" ? "date" : "str"; }
  function zodType(col) {
    if (col.type === "number") return isIntCol(col) ? "z.number().int()" : "z.number()";
    if (col.type === "boolean") return "z.boolean()";
    if (col.type === "date") return "z.coerce.date()";
    return "z.string()";
  }
  function jsonType(col) {
    if (col.type === "number") return isIntCol(col) ? "integer" : "number";
    if (col.type === "boolean") return "boolean";
    return "string";
  }

  Convert.csvToSchema = function (profile, opts) {
    opts = opts || {};
    const dialect = opts.dialect || "typescript";
    const name = pascalCase(opts.typeName || "Row");
    const cols = profile.cols;

    if (dialect === "typescript") {
      const lines = cols.map(c => {
        const key = /^[A-Za-z_$][A-Za-z0-9_$]*$/.test(c.name) ? c.name : JSON.stringify(c.name);
        const nul = colNullable(c);
        return `  ${key}${nul ? "?" : ""}: ${tsType(c)}${nul ? " | null" : ""};`;
      });
      return `// Generated by csvtodashboard.com\nexport interface ${name} {\n${lines.join("\n")}\n}`;
    }
    if (dialect === "zod") {
      const lines = cols.map(c => {
        let t = zodType(c);
        if (colNullable(c)) t += ".nullable()";
        const key = /^[A-Za-z_$][A-Za-z0-9_$]*$/.test(c.name) ? c.name : JSON.stringify(c.name);
        return `  ${key}: ${t},`;
      });
      return `// Generated by csvtodashboard.com\nimport { z } from "zod";\n\nexport const ${name}Schema = z.object({\n${lines.join("\n")}\n});\n\nexport type ${name} = z.infer<typeof ${name}Schema>;`;
    }
    if (dialect === "pydantic") {
      const needsDate = cols.some(c => c.type === "date");
      const anyOpt = cols.some(colNullable);
      const imports = ["from pydantic import BaseModel"];
      if (needsDate) imports.push("from datetime import date");
      if (anyOpt) imports.push("from typing import Optional");
      const uniq = makeUniquer();
      const lines = cols.map(c => {
        const fn = uniq(identifier(c.name));
        const t = pyType(c);
        return colNullable(c) ? `    ${fn}: Optional[${t}] = None` : `    ${fn}: ${t}`;
      });
      return `# Generated by csvtodashboard.com\n${imports.join("\n")}\n\n\nclass ${name}(BaseModel):\n${lines.join("\n")}`;
    }
    if (dialect === "go") {
      const needsTime = cols.some(c => c.type === "date");
      const uniq = makeUniquer();
      const lines = cols.map(c => {
        const fn = uniq(pascalCase(c.name));
        const t = (colNullable(c) ? "*" : "") + goType(c);
        return `\t${fn}\t${t}\t\`json:"${c.name}"\``;
      });
      const imp = needsTime ? `import "time"\n\n` : "";
      return `// Generated by csvtodashboard.com\npackage main\n\n${imp}type ${name} struct {\n${lines.join("\n")}\n}`;
    }
    // json-schema
    const props = {};
    const required = [];
    cols.forEach(c => {
      const base = c.type === "date" ? { type: "string", format: "date" } : { type: jsonType(c) };
      props[c.name] = colNullable(c) ? { type: [base.type, "null"], ...(base.format ? { format: base.format } : {}) } : base;
      if (!colNullable(c)) required.push(c.name);
    });
    return JSON.stringify({ $schema: "http://json-schema.org/draft-07/schema#", title: name, type: "object", properties: props, required }, null, 2);
  };
})();

// ============================================================ Notion + Airtable
Convert.csvToNotion = function (profile) {
  // GitHub-flavored Markdown table — paste into Notion to get a table/database.
  const headers = profile.cols.map(c => c.name);
  const esc = v => String(v == null ? "" : v).replace(/\|/g, "\\|").replace(/\r\n?|\n/g, " "); // normalize all CR/LF so a bare \r doesn't corrupt the table
  const head = "| " + headers.map(esc).join(" | ") + " |";
  const sep = "| " + headers.map(() => "---").join(" | ") + " |";
  const body = profile.rows.map(r => "| " + headers.map(h => esc(r[h])).join(" | ") + " |").join("\n");
  return head + "\n" + sep + (body ? "\n" + body : "");
};
Convert.csvToAirtable = function (profile) {
  // Tab-separated — paste directly into an Airtable grid (Airtable's paste expects TSV).
  const headers = profile.cols.map(c => c.name);
  const esc = v => String(v == null ? "" : v).replace(/\t/g, " ").replace(/\r\n?|\n/g, " "); // normalize a lone \r too (Airtable paste corrupts on it)
  const head = headers.map(esc).join("\t");
  const body = profile.rows.map(r => headers.map(h => esc(r[h])).join("\t")).join("\n");
  return head + (body ? "\n" + body : "");
};

// ============================================================ Anonymizer
function hashToken(v) {
  // Deterministic non-cryptographic token (djb2 → base36). Same input → same token.
  const s = String(v == null ? "" : v);
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) >>> 0;
  return "tok_" + h.toString(36);
}
function maskValue(v, role) {
  const s = String(v == null ? "" : v);
  if (!s) return s;
  if (role === "email" && s.includes("@")) {
    const at = s.indexOf("@"); // split on the FIRST @ only, keep the whole domain
    return (s[0] || "") + "***@" + s.slice(at + 1);
  }
  if (s.length <= 2) return s[0] + "*";
  return s[0] + "*".repeat(Math.min(6, s.length - 2)) + s[s.length - 1];
}
const FAKE_FIRST = ["Ava", "Liam", "Mia", "Noah", "Zoe", "Kai", "Eve", "Leo", "Ada", "Ian", "Ruby", "Omar", "Nina", "Jude", "Kira", "Rex", "Uma", "Sam", "Tess", "Paul"];
const FAKE_LAST = ["Stone", "Park", "Cole", "Reyes", "Vance", "Frost", "Marsh", "Quill", "Bram", "Lux", "Nash", "Wren", "Tate", "Voss", "Gale", "Hart"];
const FAKE_CITY = ["Lakeview", "Fairmont", "Westbrook", "Ashford", "Brightwater", "Cedar Falls", "Maplewood", "Northgate", "Stonehaven", "Riverton"];
function fakeValue(col, idx) {
  const role = col.role, type = col.type;
  if (role === "email") return `user${idx + 1}@example.com`;
  if (role === "phone") return `555-01${String(10 + (idx % 90)).padStart(2, "0")}`;
  if (role === "name") return FAKE_FIRST[idx % FAKE_FIRST.length] + " " + FAKE_LAST[(idx * 7) % FAKE_LAST.length];
  if (role === "city") return FAKE_CITY[idx % FAKE_CITY.length];
  if (role === "url") return `https://example.com/${hashToken(idx).slice(4)}`;
  if (type === "number") { const v = CSVTool.parseNumber(col.values[idx]); return v == null ? "" : String(Math.round((v || 0) * (0.85 + ((idx % 7) / 20)))); }
  if (type === "boolean") return idx % 2 ? "true" : "false";
  return "value_" + ((idx % 50) + 1);
}
Convert.suggestAnonStrategies = function (profile) {
  const s = {};
  profile.cols.forEach(c => {
    if (c.role === "email" || c.role === "phone") s[c.name] = "mask";
    else if (c.role === "id" || c.role === "name") s[c.name] = "hash";
    else if (c.role === "url") s[c.name] = "redact";
    else s[c.name] = "keep";
  });
  return s;
};
Convert.anonymizeCSV = function (profile, opts) {
  opts = opts || {};
  const strat = opts.strategies || {};
  const headers = profile.cols.map(c => c.name);
  let redacted = 0;
  const out = profile.rows.map((r, idx) => {
    const o = {};
    profile.cols.forEach(c => {
      const mode = strat[c.name] || "keep";
      const v = r[c.name];
      if (mode === "keep") o[c.name] = v;
      else { redacted++;
        o[c.name] = mode === "redact" ? "[redacted]"
          : mode === "hash" ? hashToken(v)
          : mode === "mask" ? maskValue(v, c.role)
          : mode === "fake" ? fakeValue(c, idx) : v;
      }
    });
    return o;
  });
  const changedCols = Object.keys(strat).filter(k => strat[k] && strat[k] !== "keep");
  return { csv: rowsToCSV(headers, out), changedCols, stats: { "columns transformed": changedCols.length, "cells changed": redacted } };
};

// ============================================================ Regex tester
Convert.regexRun = function (profile, opts) {
  opts = opts || {};
  const col = opts.column || (profile.cols[0] && profile.cols[0].name);
  const mode = opts.mode || "test";
  // De-dup flags so "gg" (or any repeat) doesn't throw "Invalid flags" and blank
  // the whole tool.
  const safeFlags = [...new Set(String(opts.flags || "").split(""))].join("");
  let re;
  try { re = new RegExp(opts.pattern || "", safeFlags); }
  catch (e) { return { error: e.message }; }
  if (!opts.pattern) return { error: null, empty: true };
  const values = profile.rows.map(r => String(r[col] == null ? "" : r[col]));
  let matchCount = 0;
  const sample = [];
  values.forEach((v, i) => {
    re.lastIndex = 0;
    const m = re.exec(v);
    const matched = !!m;
    if (matched) matchCount++;
    if (sample.length < 12) sample.push({ value: v, matched, group: m ? (m[1] != null ? m[1] : m[0]) : "" });
  });

  if (mode === "extract") {
    // Unique target name so an existing "<col>_match" column isn't overwritten.
    const existing = new Set(profile.cols.map(c => c.name));
    let mcol = col + "_match", k = 1;
    while (existing.has(mcol)) mcol = col + "_match_" + (++k);
    const headers = profile.cols.map(c => c.name).concat([mcol]);
    const gre = new RegExp(opts.pattern, safeFlags.replace("g", ""));
    const rows = profile.rows.map(r => {
      const v = String(r[col] == null ? "" : r[col]);
      gre.lastIndex = 0;
      const m = gre.exec(v);
      return { ...r, [mcol]: m ? (m[1] != null ? m[1] : m[0]) : "" };
    });
    return { mode, matchCount, total: values.length, sample, csv: rowsToCSV(headers, rows) };
  }
  if (mode === "replace") {
    const headers = profile.cols.map(c => c.name);
    // Honor the user's flags (don't silently force global) so the output matches
    // what the previewed pattern/flags describe.
    const rows = profile.rows.map(r => {
      const v = String(r[col] == null ? "" : r[col]);
      let rre; try { rre = new RegExp(opts.pattern, safeFlags); } catch (e) { return r; }
      return { ...r, [col]: v.replace(rre, opts.replacement == null ? "" : opts.replacement) };
    });
    return { mode, matchCount, total: values.length, sample, csv: rowsToCSV(headers, rows) };
  }
  return { mode, matchCount, total: values.length, sample };
};

// ============================================================ DevToolShell (single input)
function DevToolShell({ config }) {
  const cfg = config || {};
  const toolType = cfg.toolType || "anonymize";
  const [csvText, setCsvText] = useState("");
  const [profile, setProfile] = useState(null);
  const [filename, setFilename] = useState("data");
  const [error, setError] = useState("");
  const [pendingSheets, setPendingSheets] = useState(null);
  const [opts, setOpts] = useState({});
  const [copied, setCopied] = useState(false);

  function loadCSVText(text, name) {
    try {
      const parsed = CSVTool.parseCSV(text);
      if (!parsed.headers.length || !parsed.rows.length) { setError("That doesn't look like a valid CSV — it needs a header row and at least one data row."); return; }
      const prof = CSVTool.profile(parsed);
      setProfile(prof); setCsvText(text); setError("");
      if (name) setFilename(String(name).replace(/\.[^.]+$/, ""));
      if (toolType === "anonymize") setOpts(o => o.strategies ? o : { strategies: Convert.suggestAnonStrategies(prof) });
      if (toolType === "regex") setOpts(o => o.column ? o : { column: (prof.cols[0] || {}).name, mode: "test", flags: "" });
    } catch (e) { setError(e.message || "Could not parse that CSV."); }
  }
  function handleFile(file) {
    if (!file) return;
    setFilename((file.name || "data").replace(/\.[^.]+$/, ""));
    const reader = new FileReader();
    reader.onerror = () => setError("Could not read that file.");
    if (/\.(xlsx|xls)$/i.test(file.name || "")) {
      reader.onload = e => ensureXLSX().then(() => {
        try { const { sheets } = CSVTool.parseXLSXBuffer(e.target.result);
          if (!sheets || !sheets.length) { setError("That workbook had no rows."); return; }
          if (sheets.length === 1) loadCSVText(sheets[0].csvText, file.name); else setPendingSheets({ sheets, filename: file.name });
        } catch (err) { setError(err.message); }
      }).catch(() => setError("Could not load the Excel engine."));
      reader.readAsArrayBuffer(file);
    } else { reader.onload = e => loadCSVText(e.target.result, file.name); reader.readAsText(file); }
  }
  function reset() { setProfile(null); setCsvText(""); setError(""); setOpts({}); }
  function buildDashboard() {
    sendCSVToDashboard(csvText, filename + ".csv");
  }

  const result = useMemo(() => {
    if (!profile) return null;
    try {
      if (toolType === "anonymize") return Convert.anonymizeCSV(profile, opts);
      if (toolType === "regex") return Convert.regexRun(profile, opts);
    } catch (e) { return { error: e.message }; }
    return null;
  }, [profile, opts, toolType]);

  function copyOut(text) { navigator.clipboard.writeText(text).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }).catch(() => {}); }
  function download(text, ext) {
    const blob = new Blob([text], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = filename + "-" + toolType + "." + (ext || "csv");
    document.body.appendChild(a); a.click(); setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 800);
  }
  const cols = profile ? profile.cols.map(c => c.name) : [];

  function renderControls() {
    if (toolType === "anonymize") {
      const strat = opts.strategies || {};
      const STR = ["keep", "redact", "hash", "mask", "fake"];
      return (
        <div className="anon-controls">
          <div className="anon-controls-head">Per-column strategy <span>· PII columns are pre-set; change any below</span></div>
          <div className="anon-grid">
            {profile.cols.map(c => (
              <label className="anon-row" key={c.name}>
                <span className="anon-col" title={c.name}>{c.name}<em>{c.role}</em></span>
                <select className="conv-opts-input" value={strat[c.name] || "keep"}
                  onChange={e => setOpts(o => ({ ...o, strategies: { ...o.strategies, [c.name]: e.target.value } }))}>
                  {STR.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </label>
            ))}
          </div>
        </div>
      );
    }
    if (toolType === "regex") {
      return (
        <div className="conv-opts" style={{ flexDirection: "column", alignItems: "stretch", gap: 10 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px 14px", alignItems: "center" }}>
            <label>Column{" "}
              <select className="conv-opts-input" value={opts.column || ""} onChange={e => setOpts(o => ({ ...o, column: e.target.value }))}>
                {cols.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
            <label>Mode{" "}
              <select className="conv-opts-input" value={opts.mode || "test"} onChange={e => setOpts(o => ({ ...o, mode: e.target.value }))}>
                <option value="test">Test / match</option><option value="extract">Extract to new column</option><option value="replace">Find &amp; replace</option>
              </select>
            </label>
            <label>Flags{" "}
              <input className="conv-opts-input" style={{ width: 70 }} placeholder="gi" value={opts.flags || ""} onChange={e => setOpts(o => ({ ...o, flags: e.target.value.replace(/[^gimsuy]/g, "") }))} />
            </label>
          </div>
          <label style={{ fontSize: 11, color: "var(--ink-faint)" }}>Pattern (JavaScript regex; first capture group is extracted if present)</label>
          <input className="conv-sql-input" style={{ fontFamily: "var(--mono)" }} placeholder="e.g. (\\d{4})-(\\d{2})-(\\d{2})"
            value={opts.pattern || ""} onChange={e => setOpts(o => ({ ...o, pattern: e.target.value }))} />
          {opts.mode === "replace" && (
            <input className="conv-opts-input" placeholder="replacement (use $1 for capture groups)" value={opts.replacement == null ? "" : opts.replacement}
              onChange={e => setOpts(o => ({ ...o, replacement: e.target.value }))} />
          )}
        </div>
      );
    }
    return null;
  }

  function renderResult() {
    if (!result) return null;
    if (result.error) return <div className="conv-err">{result.error}</div>;
    if (toolType === "anonymize") return (
      <>
        {result.stats && <div className="conv-stats">{Object.entries(result.stats).map(([k, v]) => <span key={k}><span className="conv-stats-label">{k}</span> {v}</span>)}</div>}
        <textarea className="conv-out-text" readOnly value={result.csv} />
      </>
    );
    if (toolType === "regex") {
      if (result.empty) return <div className="viz-empty">Enter a regex pattern above to test it against the column.</div>;
      return (
        <>
          <div className="conv-stats"><span><span className="conv-stats-label">matches</span> {fmtInt(result.matchCount)} / {fmtInt(result.total)} rows</span></div>
          <div className="regex-sample">
            {result.sample.map((s, i) => (
              <div className={"regex-srow" + (s.matched ? " matched" : "")} key={i}>
                <span className="regex-dot">{s.matched ? "✓" : "·"}</span>
                <code className="regex-val">{s.value || "—"}</code>
                {s.matched && opts.mode !== "replace" && <span className="regex-grp">{s.group}</span>}
              </div>
            ))}
          </div>
          {result.csv != null && <textarea className="conv-out-text" readOnly value={result.csv} />}
        </>
      );
    }
    return null;
  }

  const outText = result && (toolType === "anonymize" ? result.csv : toolType === "regex" ? result.csv : null);

  return (
    <div className="viz-shell">
      {pendingSheets && <SheetPicker sheets={pendingSheets.sheets} filename={pendingSheets.filename}
        onPick={s => { loadCSVText(s.csvText, pendingSheets.filename + " · " + s.name); setPendingSheets(null); }} onCancel={() => setPendingSheets(null)} />}
      {!profile ? (
        <div className="viz-input">
          <ConverterInput label="Drop a .csv or .xlsx file" inputFormat="csv" accept=".csv,.txt,.xlsx,.xls,text/csv"
            onFile={handleFile} onPasteText={t => loadCSVText(t, "pasted")}
            onLoadSample={() => loadCSVText(CSVTool.SAMPLES.sales.csv, "sample-sales")} loaded={false} onClear={reset} />
          {error && <div className="conv-err">{error}</div>}
        </div>
      ) : (
        <div className="viz">
          {renderControls()}
          <div className="chart-card viz-card">
            <div className="chart-head">
              <div className="chart-title">{cfg.cardTitle || "Result"}</div>
              <div className="chart-kind">{toolType}</div>
            </div>
            <div className="viz-canvas devtool-canvas">{renderResult()}</div>
          </div>
          <div className="viz-actions">
            {outText != null && <button className="btn-ghost" onClick={() => copyOut(outText)}>{copied ? "Copied!" : "Copy CSV"}</button>}
            {outText != null && <button className="btn-ghost" onClick={() => download(outText, "csv")}>Download CSV</button>}
            <button className="btn-ghost" onClick={reset}>Use different data</button>
          </div>
          {error && <div className="conv-err">{error}</div>}
          <InsightStrip profile={profile} onBuildDashboard={buildDashboard} />
        </div>
      )}
    </div>
  );
}

// ============================================================ Diff + Merge (two inputs)
Convert.diffCSV = function (profA, profB, opts) {
  opts = opts || {};
  const key = opts.keyColumn || "";
  const aH = profA.cols.map(c => c.name), bH = profB.cols.map(c => c.name);
  const headers = aH.concat(bH.filter(h => !aH.includes(h)));
  const shared = aH.filter(h => bH.includes(h));
  const added = [], removed = [], changed = [];
  let unchanged = 0;

  let warning = null;
  if (key && aH.includes(key) && bH.includes(key)) {
    const mapA = new Map(), mapB = new Map();
    profA.rows.forEach(r => mapA.set(String(r[key] == null ? "" : r[key]), r));
    profB.rows.forEach(r => mapB.set(String(r[key] == null ? "" : r[key]), r));
    if (mapA.size < profA.rows.length || mapB.size < profB.rows.length) {
      warning = "The key column \"" + key + "\" has duplicate values — only the last row per key was compared, so some rows may be missing from this diff. Choose a column with unique values.";
    }
    mapA.forEach((ra, k) => {
      if (!mapB.has(k)) { removed.push(ra); return; }
      const rb = mapB.get(k);
      const diffCols = shared.filter(h => String(ra[h] == null ? "" : ra[h]) !== String(rb[h] == null ? "" : rb[h]));
      if (diffCols.length) changed.push({ key: k, before: ra, after: rb, cols: diffCols });
      else unchanged++;
    });
    mapB.forEach((rb, k) => { if (!mapA.has(k)) added.push(rb); });
  } else {
    // positional diff (row index)
    if (shared.length === 0) {
      warning = "These two files share no column names, so rows can't be compared cell-by-cell. Pick a key column they have in common, or align the headers.";
    }
    const n = Math.max(profA.rows.length, profB.rows.length);
    for (let i = 0; i < n; i++) {
      const ra = profA.rows[i], rb = profB.rows[i];
      if (ra && !rb) removed.push(ra);
      else if (!ra && rb) added.push(rb);
      else {
        const diffCols = shared.filter(h => String(ra[h] == null ? "" : ra[h]) !== String(rb[h] == null ? "" : rb[h]));
        if (diffCols.length) changed.push({ key: "#" + (i + 1), before: ra, after: rb, cols: diffCols });
        else unchanged++;
      }
    }
  }
  return { key: key || null, headers, shared, added, removed, changed, unchanged, warning,
    stats: { added: added.length, removed: removed.length, changed: changed.length, unchanged } };
};

Convert.mergeCSV = function (profA, profB, opts) {
  opts = opts || {};
  const keyA = opts.keyA || (profA.cols[0] && profA.cols[0].name);
  const keyB = opts.keyB || (profB.cols[0] && profB.cols[0].name);
  const joinType = opts.joinType || "inner";
  const aHeaders = profA.cols.map(c => c.name);
  const aSet = new Set(aHeaders);
  const bMap = new Map();
  profB.rows.forEach(r => { const k = String(r[keyB] == null ? "" : r[keyB]); if (!bMap.has(k)) bMap.set(k, []); bMap.get(k).push(r); });
  // B output columns (drop B's join key; suffix collisions)
  const bOut = profB.cols.map(c => c.name).filter(h => h !== keyB).map(h => ({ src: h, out: aSet.has(h) ? h + "_b" : h }));
  const headers = aHeaders.concat(bOut.map(x => x.out));
  const out = [];
  const matchedKeys = new Set();
  let matched = 0;
  profA.rows.forEach(ra => {
    const k = String(ra[keyA] == null ? "" : ra[keyA]);
    const bs = bMap.get(k);
    if (bs && bs.length) {
      matched++; matchedKeys.add(k);
      bs.forEach(rb => { const o = { ...ra }; bOut.forEach(x => o[x.out] = rb[x.src]); out.push(o); });
    } else if (joinType === "left" || joinType === "outer") {
      const o = { ...ra }; bOut.forEach(x => o[x.out] = ""); out.push(o);
    }
  });
  if (joinType === "right" || joinType === "outer") {
    profB.rows.forEach(rb => {
      const k = String(rb[keyB] == null ? "" : rb[keyB]);
      if (!matchedKeys.has(k)) { const o = {}; aHeaders.forEach(h => o[h] = h === keyA ? rb[keyB] : ""); bOut.forEach(x => o[x.out] = rb[x.src]); out.push(o); }
    });
  }
  return { csv: rowsToCSV(headers, out), headers, rows: out,
    stats: { join: joinType, "matched keys": matchedKeys.size, "matched A-rows": matched, "rows out": out.length } };
};

// V7: word-level diff for a changed cell. LCS over word+whitespace tokens;
// returns null (caller falls back to whole-value <s>before</s> -> <b>after</b>)
// when the values are too long or share no word worth aligning.
function diffWordTokens(a, b) {
  const A = String(a).split(/(\s+)/).filter(Boolean), B = String(b).split(/(\s+)/).filter(Boolean);
  if (!A.length || !B.length || A.length > 60 || B.length > 60) return null;
  const n = A.length, m = B.length;
  const dp = Array.from({ length: n + 1 }, () => new Array(m + 1).fill(0));
  for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--)
    dp[i][j] = A[i] === B[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
  const out = [];
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (A[i] === B[j]) { out.push({ t: A[i], k: 0 }); i++; j++; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) { out.push({ t: A[i], k: -1 }); i++; }
    else { out.push({ t: B[j], k: 1 }); j++; }
  }
  while (i < n) { out.push({ t: A[i], k: -1 }); i++; }
  while (j < m) { out.push({ t: B[j], k: 1 }); j++; }
  return out.some(x => x.k === 0 && x.t.trim()) ? out : null;
}

function DiffWords({ before, after }) {
  const d = diffWordTokens(before, after);
  if (!d) return <><s>{before || "∅"}</s> {"→"} <b>{after || "∅"}</b></>;
  return <>{d.map((x, i) => x.k === 0 ? <span key={i}>{x.t}</span> : x.k < 0 ? <s className="dw-rem" key={i}>{x.t}</s> : <b className="dw-add" key={i}>{x.t}</b>)}</>;
}

function DiffView({ diff }) {
  if (!diff) return null;
  const cols = (diff.key ? [diff.key] : []).concat(diff.shared.filter(h => h !== diff.key)).slice(0, 6);
  const cell = (r, h) => String(r && r[h] != null ? r[h] : "");
  const limit = 120;
  const rowsOut = [];
  diff.changed.slice(0, limit).forEach(ch => rowsOut.push({ kind: "changed", ch }));
  diff.added.slice(0, limit).forEach(r => rowsOut.push({ kind: "added", r }));
  diff.removed.slice(0, limit).forEach(r => rowsOut.push({ kind: "removed", r }));
  return (
    <div className="diff">
      {diff.warning && <div className="conv-err" style={{ marginBottom: 12 }}>⚠ {diff.warning}</div>}
      <div className="diff-stats">
        <span className="diff-pill diff-add">+{diff.stats.added} added</span>
        <span className="diff-pill diff-rem">−{diff.stats.removed} removed</span>
        <span className="diff-pill diff-chg">~{diff.stats.changed} changed</span>
        <span className="diff-pill diff-same">={diff.stats.unchanged} unchanged</span>
      </div>
      {rowsOut.length === 0 ? <div className="viz-empty">No differences — the two files match{diff.key ? " on key " + diff.key : ""}.</div> : (
        <div className="pivot-scroll">
          <table className="pivot-table diff-table">
            <thead><tr><th>change</th>{cols.map(c => <th key={c}>{c}</th>)}<th>details</th></tr></thead>
            <tbody>
              {rowsOut.map((x, i) => {
                if (x.kind === "changed") {
                  return <tr key={i} className="diff-row-chg">
                    <td><span className="diff-pill diff-chg">~ changed</span></td>
                    {cols.map(c => <td key={c}>{cell(x.ch.after, c)}</td>)}
                    <td className="diff-details">{x.ch.cols.map(c => <span className="diff-chip" key={c}>{c}: <DiffWords before={cell(x.ch.before, c)} after={cell(x.ch.after, c)} /></span>)}</td>
                  </tr>;
                }
                const r = x.r, add = x.kind === "added";
                return <tr key={i} className={add ? "diff-row-add" : "diff-row-rem"}>
                  <td><span className={"diff-pill " + (add ? "diff-add" : "diff-rem")}>{add ? "+ added" : "− removed"}</span></td>
                  {cols.map(c => <td key={c}>{cell(r, c)}</td>)}
                  <td className="diff-details">{add ? "only in B" : "only in A"}</td>
                </tr>;
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ============================================================ DualToolShell (two inputs)
function DualToolShell({ config }) {
  const cfg = config || {};
  const dualType = cfg.dualType || "diff";
  const [a, setA] = useState(null), [b, setB] = useState(null);
  const [errA, setErrA] = useState(""), [errB, setErrB] = useState("");
  const [opts, setOpts] = useState({});
  const [copied, setCopied] = useState(false);

  function parse(text) { const p = CSVTool.parseCSV(text); if (!p.headers.length || !p.rows.length) throw new Error("needs a header row + data"); return CSVTool.profile(p); }
  function loadInto(which, text, name) {
    try { const prof = parse(text); const obj = { prof, name: (name || "data").replace(/\.[^.]+$/, "") };
      if (which === "a") { setA(obj); setErrA(""); } else { setB(obj); setErrB(""); }
      wsMaybeSave(String(name || "data"), text);
    } catch (e) { if (which === "a") setErrA(e.message); else setErrB(e.message); }
  }
  function fileInto(which, file) {
    if (!file) return;
    const reader = new FileReader();
    reader.onerror = () => (which === "a" ? setErrA : setErrB)("Could not read file.");
    if (/\.(xlsx|xls)$/i.test(file.name || "")) {
      reader.onload = e => ensureXLSX().then(() => { try { const { sheets } = CSVTool.parseXLSXBuffer(e.target.result); if (sheets && sheets[0]) loadInto(which, sheets[0].csvText, file.name); } catch (err) { (which === "a" ? setErrA : setErrB)(err.message); } }).catch(() => {});
      reader.readAsArrayBuffer(file);
    } else { reader.onload = e => loadInto(which, e.target.result, file.name); reader.readAsText(file); }
  }

  const result = useMemo(() => {
    if (!a || !b) return null;
    try { return dualType === "merge" ? Convert.mergeCSV(a.prof, b.prof, opts) : { diff: Convert.diffCSV(a.prof, b.prof, opts) }; }
    catch (e) { return { error: e.message }; }
  }, [a, b, opts, dualType]);

  // V6 workspace wiring: a handed-off CSV becomes side A; the diff/merge result
  // is the current file for send-to/palette.
  useToolFile(
    (csv, name) => loadInto("a", csv, name),
    () => (result && result.csv ? { csv: result.csv, name: dualType + ".csv" } : null)
  );

  // default key selections once both loaded
  useEffect(() => {
    if (!a || !b) return;
    const aH = a.prof.cols.map(c => c.name), bH = b.prof.cols.map(c => c.name);
    const common = aH.filter(h => bH.includes(h));
    setOpts(o => {
      const n = { ...o };
      if (dualType === "diff" && n.keyColumn == null) n.keyColumn = common[0] || "";
      if (dualType === "merge") { if (n.keyA == null) n.keyA = common[0] || aH[0]; if (n.keyB == null) n.keyB = common[0] || bH[0]; if (!n.joinType) n.joinType = "inner"; }
      return n;
    });
  }, [a, b, dualType]);

  function copyOut() { if (result && result.csv) navigator.clipboard.writeText(result.csv).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }).catch(() => {}); }
  function downloadOut() {
    if (!result || !result.csv) return;
    const blob = new Blob([result.csv], { type: "text/csv" });
    const aEl = document.createElement("a"); aEl.href = URL.createObjectURL(blob); aEl.download = (a ? a.name : "data") + "-" + dualType + ".csv";
    document.body.appendChild(aEl); aEl.click(); setTimeout(() => { document.body.removeChild(aEl); URL.revokeObjectURL(aEl.href); }, 800);
  }
  const aH = a ? a.prof.cols.map(c => c.name) : [], bH = b ? b.prof.cols.map(c => c.name) : [];
  const common = aH.filter(h => bH.includes(h));

  function renderControls() {
    if (dualType === "diff") {
      return (
        <div className="pivot-controls viz-controls">
          <label className="pivot-control"><span>Match rows by</span>
            <select value={opts.keyColumn || ""} onChange={e => setOpts(o => ({ ...o, keyColumn: e.target.value }))}>
              <option value="">(row position)</option>
              {common.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </label>
        </div>
      );
    }
    return (
      <div className="pivot-controls viz-controls">
        <label className="pivot-control"><span>A join key</span>
          <select value={opts.keyA || ""} onChange={e => setOpts(o => ({ ...o, keyA: e.target.value }))}>{aH.map(c => <option key={c} value={c}>{c}</option>)}</select>
        </label>
        <label className="pivot-control"><span>B join key</span>
          <select value={opts.keyB || ""} onChange={e => setOpts(o => ({ ...o, keyB: e.target.value }))}>{bH.map(c => <option key={c} value={c}>{c}</option>)}</select>
        </label>
        <label className="pivot-control"><span>Join type</span>
          <select value={opts.joinType || "inner"} onChange={e => setOpts(o => ({ ...o, joinType: e.target.value }))}>
            <option value="inner">Inner</option><option value="left">Left</option><option value="right">Right</option><option value="outer">Full outer</option>
          </select>
        </label>
      </div>
    );
  }

  return (
    <div className="viz-shell">
      <div className="dual-inputs">
        <div className="dual-pane">
          <div className="dual-label">Dataset A {a && <span className="dual-meta">{a.prof.rows.length} rows · {a.prof.cols.length} cols</span>}</div>
          <ConverterInput label="Drop CSV / XLSX (A)" inputFormat="csv" accept=".csv,.txt,.xlsx,.xls,text/csv"
            onFile={f => fileInto("a", f)} onPasteText={t => loadInto("a", t, "A")}
            onLoadSample={() => loadInto("a", CSVTool.SAMPLES.sales.csv, "A")} loaded={!!a} onClear={() => setA(null)} />
          <WorkspacePick onPick={r => loadInto("a", r.csv, r.name)} label="Load a workspace file into A" />
          {errA && <div className="conv-err">{errA}</div>}
        </div>
        <div className="dual-pane">
          <div className="dual-label">Dataset B {b && <span className="dual-meta">{b.prof.rows.length} rows · {b.prof.cols.length} cols</span>}</div>
          <ConverterInput label="Drop CSV / XLSX (B)" inputFormat="csv" accept=".csv,.txt,.xlsx,.xls,text/csv"
            onFile={f => fileInto("b", f)} onPasteText={t => loadInto("b", t, "B")}
            onLoadSample={() => loadInto("b", CSVTool.SAMPLES.sales.csv, "B")} loaded={!!b} onClear={() => setB(null)} />
          <WorkspacePick onPick={r => loadInto("b", r.csv, r.name)} label="Load a workspace file into B" />
          {errB && <div className="conv-err">{errB}</div>}
        </div>
      </div>

      {a && b && (
        <div className="viz" style={{ marginTop: 18 }}>
          {renderControls()}
          <div className="chart-card viz-card">
            <div className="chart-head">
              <div className="chart-title">{cfg.cardTitle || (dualType === "merge" ? "Merged" : "Differences")}</div>
              <div className="chart-kind">{dualType}</div>
            </div>
            <div className="viz-canvas devtool-canvas">
              {result && result.error ? <div className="conv-err">{result.error}</div>
                : dualType === "diff" ? <DiffView diff={result && result.diff} />
                : <>
                    {result && result.stats && <div className="conv-stats">{Object.entries(result.stats).map(([k, v]) => <span key={k}><span className="conv-stats-label">{k}</span> {v}</span>)}</div>}
                    <textarea className="conv-out-text" readOnly value={result ? result.csv : ""} />
                  </>}
            </div>
          </div>
          <div className="viz-actions">
            {dualType === "merge" && <button className="btn-ghost" onClick={copyOut}>{copied ? "Copied!" : "Copy CSV"}</button>}
            {dualType === "merge" && <button className="btn-ghost" onClick={downloadOut}>Download CSV</button>}
            {dualType === "merge" && <SendToMenu getPayload={() => (result && result.csv ? { csv: result.csv, name: dualType + ".csv" } : null)} onError={msg => setErrA(msg)} />}
            <button className="btn-ghost" onClick={() => { setA(null); setB(null); setOpts({}); }}>Reset both</button>
          </div>
        </div>
      )}
    </div>
  );
}


/* global React, CSVTool, Convert */
// Batch 4 — share / social tools (hash-based, no backend). Concatenated after
// charts.jsx + converter.jsx + viz.jsx + tools2.jsx, before app.jsx.
// app.jsx mounts: mode "embed" → EmbedView (chrome-free), mode "share" →
// ShareRouter (tool: embed builder | story | compare).

// ============================================================ hash codec
// Compresses with lz-string (bundled) so embed/story/compare links stay short —
// a CSV in the URL hash shrinks ~50-70%. A leading "." marks a compressed
// payload; older links (plain base64url, never start with ".") still decode.
function shareEncode(obj) {
  try {
    const json = JSON.stringify(obj);
    if (typeof LZString !== "undefined" && LZString.compressToEncodedURIComponent) {
      return "." + LZString.compressToEncodedURIComponent(json);
    }
    return btoa(unescape(encodeURIComponent(json))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  } catch (e) { return ""; }
}
function shareDecode(s) {
  try {
    if (s && s.charAt(0) === "." && typeof LZString !== "undefined") {
      const json = LZString.decompressFromEncodedURIComponent(s.slice(1));
      return json ? JSON.parse(json) : null;
    }
    const b = s.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(b))));
  } catch (e) { return null; }
}

// ============================================================ chart builder (reuses charts.jsx)
function buildChartData(profile, cfg) {
  const a = cfg.a || "sum";
  const yCol = profile.cols.find(c => c.name === cfg.y);
  const xCol = profile.cols.find(c => c.name === cfg.x);
  const agg = (sum, count) => a === "avg" ? (count ? sum / count : 0) : a === "count" ? count : sum;

  if (cfg.c === "line") {
    const map = new Map();
    profile.rows.forEach(r => {
      const d = CSVTool.parseDate(r[cfg.x]); if (!d) return;
      const k = d.toISOString().slice(0, 10);
      const v = a === "count" ? 1 : CSVTool.parseNumber(r[cfg.y]); if (v == null || isNaN(v)) return;
      const p = map.get(k) || { sum: 0, count: 0, date: d }; p.sum += v; p.count++; map.set(k, p);
    });
    const points = [...map.values()].map(p => ({ x: p.date, y: agg(p.sum, p.count) })).sort((m, n) => m.x - n.x);
    return { kind: "line", points, col: yCol };
  }
  if (cfg.c === "histogram") {
    const values = (yCol && yCol.nums) ? yCol.nums.slice() : profile.rows.map(r => CSVTool.parseNumber(r[cfg.y])).filter(v => v != null);
    return { kind: "histogram", values, col: yCol };
  }
  if (cfg.c === "scatter") {
    const points = profile.rows.map(r => ({ x: CSVTool.parseNumber(r[cfg.x]), y: CSVTool.parseNumber(r[cfg.y]) })).filter(p => p.x != null && p.y != null);
    return { kind: "scatter", points, xCol, yCol };
  }
  // bar / donut
  const map = new Map();
  profile.rows.forEach(r => {
    const k = String(r[cfg.x] == null || r[cfg.x] === "" ? "—" : r[cfg.x]);
    const v = a === "count" ? 1 : CSVTool.parseNumber(r[cfg.y]); if (v == null || isNaN(v)) return;
    const p = map.get(k) || { sum: 0, count: 0 }; p.sum += v; p.count++; map.set(k, p);
  });
  const data = [...map.entries()].map(([key, p]) => ({ key, value: agg(p.sum, p.count) })).sort((m, n) => n.value - m.value).slice(0, 12);
  return { kind: cfg.c === "donut" ? "donut" : "bar", data, col: yCol };
}

function ChartRender({ profile, cfg, height }) {
  const d = useMemo(() => { try { return buildChartData(profile, cfg); } catch (e) { return null; } }, [profile, cfg]);
  // V5: table embeds — render the top rows as a real table instead of a chart.
  if (cfg.c === "table") {
    const style = height ? { height, overflow: "auto" } : { flex: "1 1 0", minHeight: 0, overflow: "auto" };
    const rows = profile.rows.slice(0, 50);
    return (
      <div style={style} className="embed-table-wrap">
        <table className="data">
          <thead><tr>{profile.cols.map(c => <th key={c.name}>{c.name}</th>)}</tr></thead>
          <tbody>
            {rows.map((r, i) => <tr key={i}>{profile.cols.map(c => <td key={c.name}>{String(r[c.name] == null ? "" : r[c.name])}</td>)}</tr>)}
          </tbody>
        </table>
        {profile.rows.length > 50 && <div className="join-preview-note">First 50 of {profile.rows.length.toLocaleString()} rows.</div>}
      </div>
    );
  }
  if (!d) return <div className="viz-empty">Pick columns to chart.</div>;
  // height>0 → fixed-height box; height 0/undefined → fill a flex parent (embed)
  const style = height ? { height, display: "flex", flexDirection: "column" } : { flex: "1 1 0", minHeight: 0, display: "flex", flexDirection: "column" };
  let inner = null;
  if (d.kind === "bar") inner = (d.data && d.data.length) ? <BarChart data={d.data} col={d.col} maxBars={12} /> : null;
  else if (d.kind === "donut") inner = (d.data && d.data.length) ? <Donut data={d.data} col={d.col} /> : null;
  else if (d.kind === "line") inner = (d.points && d.points.length) ? <LineChart points={d.points} col={d.col} /> : null;
  else if (d.kind === "histogram") inner = (d.values && d.values.length) ? <Histogram values={d.values} col={d.col} /> : null;
  else if (d.kind === "scatter") inner = (d.points && d.points.length >= 2) ? <ScatterPlot points={d.points} xCol={d.xCol} yCol={d.yCol} correlation={0.5} /> : null;
  return <div style={style}>{inner || <div className="viz-empty">No data for this chart — try different columns.</div>}</div>;
}

// ============================================================ EmbedView (chrome-free, reads hash)
function EmbedView() {
  const [state, setState] = useState(() => {
    const raw = (window.location.hash || "").replace(/^#/, "");
    const obj = raw ? shareDecode(raw) : null;
    if (!obj || !obj.d) return { error: "No chart data in this link." };
    try { const prof = CSVTool.profile(CSVTool.parseCSV(obj.d)); return { prof, cfg: obj, title: obj.t || "" }; }
    catch (e) { return { error: "Could not read the embedded data." }; }
  });
  // V5: embeds carry an optional fixed theme (th) and color palette (p).
  useEffect(() => {
    const th = state.cfg && state.cfg.th;
    if (th === "dark" || th === "light") document.documentElement.setAttribute("data-theme", th);
  }, []);
  if (state.error) return <div className="embed-wrap"><div className="viz-empty">{state.error}</div></div>;
  return (
    <div className="embed-wrap pal-scope" data-palette={(state.cfg && state.cfg.p) || ""}>
      {state.title && <div className="embed-title">{state.title}</div>}
      <div className="embed-chart"><ChartRender profile={state.prof} cfg={state.cfg} height={0} /></div>
      <a className="embed-credit" href={"https://csvtodashboard.com/csv-to-embed"} target="_blank" rel="noopener">made with csvtodashboard.com</a>
    </div>
  );
}

// ============================================================ shared CSV-input hook for share shells
function useCsvInput(toolDefaults, hookOpts) {
  const [csvText, setCsvText] = useState("");
  const [profile, setProfile] = useState(null);
  const [filename, setFilename] = useState("data");
  const [error, setError] = useState("");
  const [pendingSheets, setPendingSheets] = useState(null);
  // V6 workspace wiring — registers this shell for handoff + palette. A shell
  // that mounts useCsvInput twice (two slots) passes {register:false} for the
  // secondary slot so only one registration owns the page.
  const reg = !hookOpts || hookOpts.register !== false;
  useToolFile(
    reg ? ((csv, name) => loadCSVText(csv, name)) : null,
    reg ? (() => (csvText ? { csv: csvText, name: filename + ".csv" } : null)) : null
  );
  function loadCSVText(text, name) {
    try {
      const parsed = CSVTool.parseCSV(text);
      if (!parsed.headers.length || !parsed.rows.length) { setError("That doesn't look like a valid CSV — it needs a header row and at least one data row."); return null; }
      const prof = CSVTool.profile(parsed); setProfile(prof); setCsvText(text); setError("");
      if (name) setFilename(String(name).replace(/\.[^.]+$/, ""));
      wsMaybeSave(name ? String(name) : "data.csv", text);
      return prof;
    } catch (e) { setError(e.message || "Could not parse that CSV."); return null; }
  }
  function handleFile(file) {
    if (!file) return;
    setFilename((file.name || "data").replace(/\.[^.]+$/, ""));
    const reader = new FileReader();
    reader.onerror = () => setError("Could not read that file.");
    if (/\.(xlsx|xls)$/i.test(file.name || "")) {
      reader.onload = e => ensureXLSX().then(() => { try { const { sheets } = CSVTool.parseXLSXBuffer(e.target.result); if (!sheets || !sheets.length) { setError("That workbook had no rows."); return; } if (sheets.length === 1) loadCSVText(sheets[0].csvText, file.name); else setPendingSheets({ sheets, filename: file.name }); } catch (err) { setError(err.message); } }).catch(() => setError("Could not load the Excel engine."));
      reader.readAsArrayBuffer(file);
    } else { reader.onload = e => loadCSVText(e.target.result, file.name); reader.readAsText(file); }
  }
  function reset() { setProfile(null); setCsvText(""); setError(""); }
  return { csvText, profile, filename, error, pendingSheets, setPendingSheets, loadCSVText, handleFile, reset };
}

function CsvDrop({ io, onLoaded }) {
  return (
    <div className="viz-input">
      {io.pendingSheets && <SheetPicker sheets={io.pendingSheets.sheets} filename={io.pendingSheets.filename}
        onPick={s => { const p = io.loadCSVText(s.csvText, io.pendingSheets.filename + " · " + s.name); io.setPendingSheets(null); if (p && onLoaded) onLoaded(p); }} onCancel={() => io.setPendingSheets(null)} />}
      <ConverterInput label="Drop a .csv or .xlsx file" inputFormat="csv" accept=".csv,.txt,.xlsx,.xls,text/csv"
        onFile={io.handleFile} onPasteText={t => { const p = io.loadCSVText(t, "pasted"); if (p && onLoaded) onLoaded(p); }}
        onLoadSample={() => { const p = io.loadCSVText(CSVTool.SAMPLES.sales.csv, "sample-sales"); if (p && onLoaded) onLoaded(p); }} loaded={false} onClear={io.reset}
        onOpenRecord={rec => { const p = io.loadCSVText(rec.csv, rec.name); if (p && onLoaded) onLoaded(p); }} />
      {io.error && <div className="conv-err">{io.error}</div>}
    </div>
  );
}

// ============================================================ EmbedShell (builder)
function EmbedShell() {
  const io = useCsvInput();
  const [cfg, setCfg] = useState({ c: "bar", x: "", y: "", a: "sum", t: "", p: "", th: "" });
  const [size, setSize] = useState({ w: 640, h: 420 });
  const [copied, setCopied] = useState("");

  function defaults(prof) {
    const cats = prof.cols.filter(c => (c.type === "category" || c.type === "boolean") && c.role !== "id");
    const dates = prof.cols.filter(c => c.type === "date");
    const nums = prof.cols.filter(c => c.type === "number" && c.role !== "id").sort((a, b) => b.importance - a.importance);
    setCfg({ c: dates.length && nums.length ? "line" : "bar", x: (dates[0] || cats[0] || prof.cols[0]).name, y: (nums[0] || prof.cols[0]).name, a: nums.length ? "sum" : "count", t: "" });
  }

  const prof = io.profile;
  const cats = prof ? prof.cols.filter(c => (c.type === "category" || c.type === "boolean") && c.role !== "id") : [];
  const dates = prof ? prof.cols.filter(c => c.type === "date") : [];
  const nums = prof ? prof.cols.filter(c => c.type === "number" && c.role !== "id") : [];
  const allCols = prof ? prof.cols.map(c => c.name) : [];

  const payload = prof ? { c: cfg.c, x: cfg.x, y: cfg.y, a: cfg.a, t: cfg.t, ...(cfg.p ? { p: cfg.p } : {}), ...(cfg.th ? { th: cfg.th } : {}), d: io.csvText } : null;
  const hash = payload ? shareEncode(payload) : "";
  const origin = (typeof window !== "undefined" && window.location && window.location.origin) || "https://csvtodashboard.com";
  const url = origin + "/embed#" + hash;
  const iframe = `<iframe src="${url}" width="${size.w}" height="${size.h}" style="border:0;border-radius:12px;overflow:hidden" loading="lazy" title="${(cfg.t || "CSV chart").replace(/"/g, "&quot;")}"></iframe>`;
  const tooBig = hash.length > 28000;

  function copy(text, which) { navigator.clipboard.writeText(text).then(() => { setCopied(which); setTimeout(() => setCopied(""), 1500); }).catch(() => {}); }

  const xCols = cfg.c === "line" ? (dates.length ? dates : prof ? prof.cols : []) : cfg.c === "scatter" ? nums : cats.concat(nums);
  const yCols = cfg.c === "histogram" || cfg.c === "scatter" ? nums : (nums.length ? nums : cats);

  // When the chart type changes, snap X/Y to columns valid for the new type —
  // otherwise stale columns leave the preview AND the encoded embed URL rendering
  // a different chart than the dropdowns show.
  useEffect(() => {
    if (cfg.c === "table") return; // table ignores X/Y entirely
    const xn = xCols.map(c => c.name), yn = yCols.map(c => c.name);
    setCfg(c => {
      let nx = c.x, ny = c.y;
      if (c.c !== "histogram" && xn.length && xn.indexOf(c.x) === -1) nx = xn[0];
      if (yn.length && yn.indexOf(c.y) === -1) ny = yn[0];
      return (nx === c.x && ny === c.y) ? c : { ...c, x: nx, y: ny };
    });
  }, [cfg.c]);

  return (
    <div className="viz-shell">
      {!prof ? <CsvDrop io={io} onLoaded={defaults} /> : (
        <div className="viz">
          <div className="pivot-controls viz-controls">
            <label className="pivot-control"><span>Chart</span>
              <select value={cfg.c} onChange={e => setCfg(c => ({ ...c, c: e.target.value }))}>
                <option value="bar">Bar</option><option value="line">Line (time)</option><option value="donut">Donut</option><option value="histogram">Histogram</option><option value="scatter">Scatter</option><option value="table">Table (top 50 rows)</option>
              </select>
            </label>
            {cfg.c !== "table" && (
              <label className="pivot-control"><span>{cfg.c === "scatter" ? "X (number)" : cfg.c === "line" ? "Date" : cfg.c === "histogram" ? "—" : "Category"}</span>
                <select value={cfg.x} disabled={cfg.c === "histogram"} onChange={e => setCfg(c => ({ ...c, x: e.target.value }))}>{(xCols).map(c => <option key={c.name} value={c.name}>{c.name}</option>)}</select>
              </label>
            )}
            {cfg.c !== "table" && (
              <label className="pivot-control"><span>{cfg.c === "scatter" ? "Y (number)" : "Value"}</span>
                <select value={cfg.y} onChange={e => setCfg(c => ({ ...c, y: e.target.value }))}>{(yCols).map(c => <option key={c.name} value={c.name}>{c.name}</option>)}</select>
              </label>
            )}
            {cfg.c !== "histogram" && cfg.c !== "scatter" && cfg.c !== "table" && (
              <label className="pivot-control"><span>Aggregate</span>
                <select value={cfg.a} onChange={e => setCfg(c => ({ ...c, a: e.target.value }))}><option value="sum">Sum</option><option value="avg">Average</option><option value="count">Count</option></select>
              </label>
            )}
            <label className="pivot-control"><span>Palette</span>
              <select value={cfg.p} onChange={e => setCfg(c => ({ ...c, p: e.target.value }))}>
                <option value="">Site default</option><option value="ocean">Ocean</option><option value="sunset">Sunset</option><option value="plum">Plum</option><option value="mono">Mono</option>
              </select>
            </label>
            <label className="pivot-control"><span>Embed theme</span>
              <select value={cfg.th} onChange={e => setCfg(c => ({ ...c, th: e.target.value }))}>
                <option value="">Visitor's choice</option><option value="light">Always light</option><option value="dark">Always dark</option>
              </select>
            </label>
          </div>

          <div className="chart-card viz-card">
            <div className="chart-head">
              <input className="conv-opts-input embed-title-input" placeholder="Chart title (optional)" value={cfg.t} onChange={e => setCfg(c => ({ ...c, t: e.target.value }))} />
              <div className="chart-kind">preview</div>
            </div>
            <div className="viz-canvas pal-scope" data-palette={cfg.p}><ChartRender profile={prof} cfg={cfg} height={size.h - 60} /></div>
          </div>

          <div className="embed-out">
            <div className="embed-out-head">
              <span>Embed snippet</span>
              <span className="embed-size">
                <input type="number" value={size.w} min="240" onChange={e => setSize(s => ({ ...s, w: Math.max(240, parseInt(e.target.value) || 640) }))} /> ×
                <input type="number" value={size.h} min="200" onChange={e => setSize(s => ({ ...s, h: Math.max(200, parseInt(e.target.value) || 420) }))} /> px
              </span>
            </div>
            {tooBig && <div className="conv-err">This dataset is large for a URL-embed ({Math.round(hash.length / 1024)} KB). It will still work, but consider filtering to fewer rows for a snappier embed.</div>}
            <textarea className="conv-out-text embed-snippet" readOnly value={iframe} />
            <div className="viz-actions">
              <button className="btn-ghost" onClick={() => copy(iframe, "iframe")}>{copied === "iframe" ? "Copied!" : "Copy iframe"}</button>
              <button className="btn-ghost" onClick={() => copy(url, "link")}>{copied === "link" ? "Copied!" : "Copy direct link"}</button>
              <a className="btn-ghost" href={"/embed#" + hash} target="_blank" rel="noopener">Open preview →</a>
              <button className="btn-ghost" onClick={io.reset}>Use different data</button>
            </div>
            <div className="embed-note">The data is encoded in the link — no upload, no account. Anyone who loads the embed renders it entirely in their own browser.</div>
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================================ Story (scrollytelling)
function buildStory(profile, title) {
  const cols = profile.cols;
  const nums = cols.filter(c => c.type === "number" && c.role !== "id").sort((a, b) => b.importance - a.importance);
  const dates = cols.filter(c => c.type === "date");
  const cats = cols.filter(c => (c.type === "category" || c.type === "boolean") && c.role !== "id");
  const metric = nums[0], dateCol = dates[0], cat1 = cats[0], cat2 = cats[1];
  const fmtV = metric ? v => fmtByCol(metric, v) : fmtNum;
  const scenes = [];

  const kpis = [{ v: fmtInt(profile.rows.length), l: "rows" }];
  if (metric) kpis.push({ v: fmtV(metric.sum), l: "total " + metric.name });
  if (cat1) kpis.push({ v: fmtInt(cat1.unique), l: cat1.name });
  if (dateCol && dateCol.minDate) kpis.push({ v: Math.round((dateCol.maxDate - dateCol.minDate) / 86400000) + "d", l: "span" });
  scenes.push({ eyebrow: "The data", headline: title || (metric ? `${fmtInt(profile.rows.length)} rows of ${metric.name}` : `${fmtInt(profile.rows.length)} rows`),
    text: `A quick walk through this dataset — ${fmtInt(profile.rows.length)} rows across ${cols.length} columns${dateCol && dateCol.minDate ? `, spanning ${fmtDateShort(dateCol.minDate)} to ${fmtDateShort(dateCol.maxDate)}` : ""}.`, kpis });

  if (dateCol && metric) {
    // first vs last day trend
    const byDay = new Map();
    profile.rows.forEach(r => { const d = CSVTool.parseDate(r[dateCol.name]); const v = CSVTool.parseNumber(r[metric.name]); if (!d || v == null) return; const k = d.toISOString().slice(0, 10); byDay.set(k, (byDay.get(k) || 0) + v); });
    const series = [...byDay.entries()].sort();
    let trend = "";
    if (series.length >= 4) {
      // Compare the average of the first half vs the second half — far less noisy
      // (and less misleading) than first-point-vs-last-point.
      const half = Math.floor(series.length / 2);
      const firstAvg = series.slice(0, half).reduce((a, b) => a + b[1], 0) / half;
      const secondAvg = series.slice(half).reduce((a, b) => a + b[1], 0) / (series.length - half);
      const pct = firstAvg ? Math.round(((secondAvg - firstAvg) / Math.abs(firstAvg)) * 100) : 0;
      trend = pct > 8 ? ` The second half ran about ${pct}% higher than the first.` : pct < -8 ? ` The second half ran about ${Math.abs(pct)}% lower than the first.` : " It held roughly steady across the period.";
    }
    scenes.push({ eyebrow: "Over time", headline: `How ${metric.name} moved`, text: `${metric.name} totaled ${fmtV(metric.sum)} over the period.${trend}`, chart: { c: "line", x: dateCol.name, y: metric.name, a: "sum" } });
  }
  if (cat1 && metric) {
    const map = new Map();
    profile.rows.forEach(r => { const k = String(r[cat1.name] || "—"); const v = CSVTool.parseNumber(r[metric.name]); if (v == null) return; map.set(k, (map.get(k) || 0) + v); });
    const sorted = [...map.entries()].sort((a, b) => b[1] - a[1]);
    const top = sorted[0]; const total = sorted.reduce((a, b) => a + b[1], 0);
    // Only show a share % when the grand total is meaningfully non-zero — a near-
    // zero mixed-sign total (|total| ≈ 0) makes the percentage meaningless.
    const share = Math.abs(total) > 1e-9 ? Math.round((top[1] / total) * 100) : null;
    scenes.push({ eyebrow: `By ${cat1.name}`, headline: `Where ${metric.name} concentrates`,
      text: top ? `${top[0]} leads ${cat1.name} with ${fmtV(top[1])}${share != null ? ` — ${share}% of all ${metric.name}` : ""}.` : `${metric.name} by ${cat1.name}.`, chart: { c: "bar", x: cat1.name, y: metric.name, a: "sum" } });
  }
  if (cat2 && metric) scenes.push({ eyebrow: `By ${cat2.name}`, headline: `The ${cat2.name} split`, text: `${metric.name} broken down across ${fmtInt(cat2.unique)} ${cat2.name} values.`, chart: { c: "donut", x: cat2.name, y: metric.name, a: "sum" } });
  if (metric) scenes.push({ eyebrow: "Distribution", headline: `The shape of ${metric.name}`, text: `Values range from ${fmtV(metric.min)} to ${fmtV(metric.max)}, averaging ${fmtV(metric.avg)} per row.`, chart: { c: "histogram", y: metric.name } });
  return scenes;
}

function StoryShell() {
  const io = useCsvInput();
  const [title, setTitle] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const raw = (window.location.hash || "").replace(/^#/, "");
    if (!raw) return;
    const obj = shareDecode(raw);
    if (obj && obj.d) { io.loadCSVText(obj.d, "shared"); if (obj.t) setTitle(obj.t); }
  }, []);

  const prof = io.profile;
  const scenes = useMemo(() => prof ? buildStory(prof, title) : [], [prof, title]);
  const hash = prof ? shareEncode({ d: io.csvText, t: title }) : "";
  const origin = (typeof window !== "undefined" && window.location && window.location.origin) || "https://csvtodashboard.com";
  const shareUrl = origin + "/csv-story#" + hash;
  function share() { navigator.clipboard.writeText(shareUrl).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1600); }).catch(() => {}); if (history.replaceState) history.replaceState(null, "", "#" + hash); }

  return (
    <div className="viz-shell">
      {!prof ? <CsvDrop io={io} /> : (
        <div className="viz">
          <div className="pivot-controls viz-controls">
            <label className="pivot-control" style={{ flex: 1 }}><span>Story title</span>
              <input className="conv-opts-input" style={{ minWidth: 240 }} placeholder="e.g. Our 2025 sales story" value={title} onChange={e => setTitle(e.target.value)} />
            </label>
          </div>
          <div className="story">
            {scenes.map((s, i) => (
              <div className="story-scene" key={i}>
                <div className="story-eyebrow">{s.eyebrow}</div>
                <div className="story-headline">{s.headline}</div>
                <div className="story-text">{s.text}</div>
                {s.kpis && <div className="story-kpis">{s.kpis.map((k, j) => <div className="story-kpi" key={j}><div className="story-kpi-v">{k.v}</div><div className="story-kpi-l">{k.l}</div></div>)}</div>}
                {s.chart && <div className="story-chart"><ChartRender profile={prof} cfg={s.chart} height={0} /></div>}
              </div>
            ))}
          </div>
          <div className="viz-actions" style={{ marginTop: 20 }}>
            <button className="btn-ghost" onClick={share}>{copied ? "Link copied!" : "Copy shareable link"}</button>
            <button className="btn-ghost" onClick={io.reset}>Use different data</button>
          </div>
          <div className="embed-note">The whole story — data included — is encoded in the link. No upload, no account; anyone who opens it renders it in their own browser.</div>
        </div>
      )}
    </div>
  );
}

// ============================================================ CSV Compare loader
// V10.4 keeps the substantial variance/drift workspace off every unrelated
// route. This shell mirrors Ask CSV's page-only asset loading contract.
function CompareCsvLoader() {
  const readyAtStart = window.CompareCsvShell && document.querySelector("link[data-comparecsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.CompareCsvShell && document.querySelector("link[data-comparecsv-style]")?.sheet) {
      setState("ready");
      return;
    }
    let scriptReady = !!window.CompareCsvShell;
    let style = document.querySelector("link[data-comparecsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-comparecsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => {
      scriptReady = !!window.CompareCsvShell;
      if (!scriptReady) setState("error");
      else finish();
    };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "/comparecsv.min.css?v=10.4";
      style.dataset.comparecsvStyle = "1";
      document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script");
      script.src = "/comparecsv.js?v=10.4";
      script.async = true;
      script.dataset.comparecsvChunk = "1";
      document.head.appendChild(script);
    }
    style.addEventListener("load", styled);
    style.addEventListener("error", failed);
    script.addEventListener("load", loaded);
    script.addEventListener("error", failed);
    if (style.sheet) styleReady = true;
    if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled);
      style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") {
    return <div className="conv-err" role="alert">The CSV comparison workspace could not load. Refresh the page to try again.</div>;
  }
  const Shell = window.CompareCsvShell;
  if (state !== "ready" || !Shell) {
    return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the local variance workspace</span></div>;
  }
  return <Shell />;
}

// ============================================================ CSV Profiler loader
// V10.5 keeps the substantial audit/contract workspace off unrelated routes.
function ProfileCsvLoader() {
  const readyAtStart = window.ProfileCsvShell && document.querySelector("link[data-profilecsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.ProfileCsvShell && document.querySelector("link[data-profilecsv-style]")?.sheet) {
      setState("ready");
      return;
    }
    let scriptReady = !!window.ProfileCsvShell;
    let style = document.querySelector("link[data-profilecsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-profilecsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => {
      scriptReady = !!window.ProfileCsvShell;
      if (!scriptReady) setState("error");
      else finish();
    };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "/profilecsv.min.css?v=10.5";
      style.dataset.profilecsvStyle = "1";
      document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script");
      script.src = "/profilecsv.js?v=10.5";
      script.async = true;
      script.dataset.profilecsvChunk = "1";
      document.head.appendChild(script);
    }
    style.addEventListener("load", styled);
    style.addEventListener("error", failed);
    script.addEventListener("load", loaded);
    script.addEventListener("error", failed);
    if (style.sheet) styleReady = true;
    if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled);
      style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") {
    return <div className="conv-err" role="alert">The CSV data-quality workspace could not load. Refresh the page to try again.</div>;
  }
  const Shell = window.ProfileCsvShell;
  if (state !== "ready" || !Shell) {
    return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the local data-quality workspace</span></div>;
  }
  return <Shell />;
}

// ============================================================ CSV Import Mapper loader
// V10.6 keeps matching, transforms, recipes, preview, and validation off every
// unrelated route. The generated page preloads these assets before mount.
function MapCsvLoader() {
  const readyAtStart = window.MapCsvShell && document.querySelector("link[data-mapcsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.MapCsvShell && document.querySelector("link[data-mapcsv-style]")?.sheet) {
      setState("ready");
      return;
    }
    let scriptReady = !!window.MapCsvShell;
    let style = document.querySelector("link[data-mapcsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-mapcsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => {
      scriptReady = !!window.MapCsvShell;
      if (!scriptReady) setState("error");
      else finish();
    };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "/mapcsv.min.css?v=10.6";
      style.dataset.mapcsvStyle = "1";
      document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script");
      script.src = "/mapcsv.js?v=10.6";
      script.async = true;
      script.dataset.mapcsvChunk = "1";
      document.head.appendChild(script);
    }
    style.addEventListener("load", styled);
    style.addEventListener("error", failed);
    script.addEventListener("load", loaded);
    script.addEventListener("error", failed);
    if (style.sheet) styleReady = true;
    if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled);
      style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") {
    return <div className="conv-err" role="alert">The CSV import-mapping workspace could not load. Refresh the page to try again.</div>;
  }
  const Shell = window.MapCsvShell;
  if (state !== "ready" || !Shell) {
    return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the local import-mapping workspace</span></div>;
  }
  return <Shell />;
}

// ============================================================ CSV Data Dictionary loader
// V10.7 keeps evidence, governance editing, validation, persistence, and
// exports off unrelated routes. The generated page preloads both assets.
function DictionaryCsvLoader() {
  const readyAtStart = window.DictionaryCsvShell && document.querySelector("link[data-dictionarycsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.DictionaryCsvShell && document.querySelector("link[data-dictionarycsv-style]")?.sheet) {
      setState("ready");
      return;
    }
    let scriptReady = !!window.DictionaryCsvShell;
    let style = document.querySelector("link[data-dictionarycsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-dictionarycsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => {
      scriptReady = !!window.DictionaryCsvShell;
      if (!scriptReady) setState("error");
      else finish();
    };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "/dictionarycsv.min.css?v=10.7";
      style.dataset.dictionarycsvStyle = "1";
      document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script");
      script.src = "/dictionarycsv.js?v=10.7";
      script.async = true;
      script.dataset.dictionarycsvChunk = "1";
      document.head.appendChild(script);
    }
    style.addEventListener("load", styled);
    style.addEventListener("error", failed);
    script.addEventListener("load", loaded);
    script.addEventListener("error", failed);
    if (style.sheet) styleReady = true;
    if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled);
      style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The CSV data dictionary workspace could not load. Refresh the page to try again.</div>;
  const Shell = window.DictionaryCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the local documentation workspace</span></div>;
  return <Shell />;
}

// ============================================================ CSV/Excel to vCard loader
// V10.10 keeps contact mapping, validation, preview, and vCard generation off
// unrelated routes. The source file remains inside the page-only workspace.
function VCardCsvLoader() {
  const readyAtStart = window.VCardCsvShell && document.querySelector("link[data-vcardcsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.VCardCsvShell && document.querySelector("link[data-vcardcsv-style]")?.sheet) {
      setState("ready");
      return;
    }
    let scriptReady = !!window.VCardCsvShell;
    let style = document.querySelector("link[data-vcardcsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-vcardcsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => {
      scriptReady = !!window.VCardCsvShell;
      if (!scriptReady) setState("error");
      else finish();
    };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "/vcardcsv.min.css?v=10.10";
      style.dataset.vcardcsvStyle = "1";
      document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script");
      script.src = "/vcardcsv.js?v=10.10";
      script.async = true;
      script.dataset.vcardcsvChunk = "1";
      document.head.appendChild(script);
    }
    style.addEventListener("load", styled);
    style.addEventListener("error", failed);
    script.addEventListener("load", loaded);
    script.addEventListener("error", failed);
    if (style.sheet) styleReady = true;
    if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled);
      style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local vCard workspace could not load. Refresh the page to try again.</div>;
  const Shell = window.VCardCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the local contact workspace</span></div>;
  return <Shell />;
}

// ============================================================ CSV/Excel to iCalendar loader
// V10.11 keeps event mapping, clock rules, validation, preview, and ICS output
// off unrelated routes. The source file remains inside the page-only workspace.
function ICSCsvLoader() {
  const readyAtStart = window.ICSCsvShell && document.querySelector("link[data-icscsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.ICSCsvShell && document.querySelector("link[data-icscsv-style]")?.sheet) {
      setState("ready");
      return;
    }
    let scriptReady = !!window.ICSCsvShell;
    let style = document.querySelector("link[data-icscsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-icscsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => {
      scriptReady = !!window.ICSCsvShell;
      if (!scriptReady) setState("error");
      else finish();
    };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "/icscsv.min.css?v=10.11";
      style.dataset.icscsvStyle = "1";
      document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script");
      script.src = "/icscsv.js?v=10.11";
      script.async = true;
      script.dataset.icscsvChunk = "1";
      document.head.appendChild(script);
    }
    style.addEventListener("load", styled);
    style.addEventListener("error", failed);
    script.addEventListener("load", loaded);
    script.addEventListener("error", failed);
    if (style.sheet) styleReady = true;
    if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled);
      style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local iCalendar workspace could not load. Refresh the page to try again.</div>;
  const Shell = window.ICSCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the local calendar workspace</span></div>;
  return <Shell />;
}

// ============================================================ CSV/Excel coordinate map loader
// V10.13 keeps coordinate validation, Natural Earth geometry, map rendering,
// and GIS exports off unrelated routes. No tile or geocoding request exists.
function GeoMapCsvLoader() {
  const readyAtStart = window.GeoMapCsvShell && document.querySelector("link[data-geomapcsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.GeoMapCsvShell && document.querySelector("link[data-geomapcsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.GeoMapCsvShell;
    let style = document.querySelector("link[data-geomapcsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-geomapcsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.GeoMapCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/geomapcsv.min.css?v=10.13";
      style.dataset.geomapcsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/geomapcsv.js?v=10.13"; script.async = true;
      script.dataset.geomapcsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local coordinate-map workspace could not load. Refresh the page to try again.</div>;
  const Shell = window.GeoMapCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private coordinate workspace</span></div>;
  return <Shell />;
}

// ============================================================ CSV/Excel Power BI preparation loader
// V10.14 keeps complete-file type review, localized validation, key checks,
// and Power Query generation off unrelated routes.
function PowerBiCsvLoader() {
  const readyAtStart = window.PowerBiCsvShell && document.querySelector("link[data-powerbicsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.PowerBiCsvShell && document.querySelector("link[data-powerbicsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.PowerBiCsvShell;
    let style = document.querySelector("link[data-powerbicsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-powerbicsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.PowerBiCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/powerbicsv.min.css?v=10.14";
      style.dataset.powerbicsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/powerbicsv.js?v=10.14"; script.async = true;
      script.dataset.powerbicsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Power BI preparation workspace could not load. Refresh the page to try again.</div>;
  const Shell = window.PowerBiCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Power BI preparation desk</span></div>;
  return <Shell />;
}

// ============================================================ Shopify product CSV preflight loader
// V10.15 keeps catalog-specific rules and product evidence off unrelated pages.
function ShopifyCsvLoader() {
  const readyAtStart = window.ShopifyCsvShell && document.querySelector("link[data-shopifycsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.ShopifyCsvShell && document.querySelector("link[data-shopifycsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.ShopifyCsvShell;
    let style = document.querySelector("link[data-shopifycsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-shopifycsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.ShopifyCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.15";
      style.dataset.shopifycsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/shopifycsv.js?v=10.15"; script.async = true;
      script.dataset.shopifycsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Shopify product preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.ShopifyCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Shopify product preflight</span></div>;
  return <Shell />;
}

// ============================================================ WooCommerce core product CSV preflight loader
// V10.16 reuses the catalog-preflight CSS while isolating all WooCommerce rules.
function WooCommerceCsvLoader() {
  const readyAtStart = window.WooCommerceCsvShell && document.querySelector("link[data-woocsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.WooCommerceCsvShell && document.querySelector("link[data-woocsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.WooCommerceCsvShell;
    let style = document.querySelector("link[data-woocsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-woocsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.WooCommerceCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.15";
      style.dataset.woocsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/woocommercecsv.js?v=10.16"; script.async = true;
      script.dataset.woocsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local WooCommerce core product preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.WooCommerceCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private WooCommerce core product preflight</span></div>;
  return <Shell />;
}

// ============================================================ HubSpot contact CSV preflight loader
// V10.17 reuses the evidence-receipt CSS while isolating all contact rules.
function HubSpotCsvLoader() {
  const readyAtStart = window.HubSpotCsvShell && document.querySelector("link[data-hubspotcsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.HubSpotCsvShell && document.querySelector("link[data-hubspotcsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.HubSpotCsvShell;
    let style = document.querySelector("link[data-hubspotcsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-hubspotcsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.HubSpotCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.17";
      style.dataset.hubspotcsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/hubspotcsv.js?v=10.17"; script.async = true;
      script.dataset.hubspotcsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local HubSpot contact preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.HubSpotCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private HubSpot contact preflight</span></div>;
  return <Shell />;
}

// ============================================================ Mailchimp email-contact CSV preflight loader
// V10.18 reuses the evidence-receipt CSS while isolating Mailchimp rules.
function MailchimpCsvLoader() {
  const readyAtStart = window.MailchimpCsvShell && document.querySelector("link[data-mailchimpcsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.MailchimpCsvShell && document.querySelector("link[data-mailchimpcsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.MailchimpCsvShell;
    let style = document.querySelector("link[data-mailchimpcsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-mailchimpcsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.MailchimpCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.18";
      style.dataset.mailchimpcsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/mailchimpcsv.js?v=10.18"; script.async = true;
      script.dataset.mailchimpcsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Mailchimp email-contact preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.MailchimpCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Mailchimp email-contact preflight</span></div>;
  return <Shell />;
}

// ============================================================ Klaviyo profile/list CSV preflight loader
// V10.19 reuses the evidence-receipt CSS while isolating Klaviyo rules.
function KlaviyoCsvLoader() {
  const readyAtStart = window.KlaviyoCsvShell && document.querySelector("link[data-klaviyocsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.KlaviyoCsvShell && document.querySelector("link[data-klaviyocsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.KlaviyoCsvShell;
    let style = document.querySelector("link[data-klaviyocsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-klaviyocsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.KlaviyoCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.19";
      style.dataset.klaviyocsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/klaviyocsv.js?v=10.19"; script.async = true;
      script.dataset.klaviyocsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Klaviyo profile preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.KlaviyoCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Klaviyo profile preflight</span></div>;
  return <Shell />;
}

// ============================================================ ActiveCampaign contact CSV preflight loader
// V10.20 reuses the evidence-receipt CSS while isolating ActiveCampaign rules.
function ActiveCampaignCsvLoader() {
  const readyAtStart = window.ActiveCampaignCsvShell && document.querySelector("link[data-activecampaigncsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.ActiveCampaignCsvShell && document.querySelector("link[data-activecampaigncsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.ActiveCampaignCsvShell;
    let style = document.querySelector("link[data-activecampaigncsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-activecampaigncsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.ActiveCampaignCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.20";
      style.dataset.activecampaigncsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/activecampaigncsv.js?v=10.20"; script.async = true;
      script.dataset.activecampaigncsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local ActiveCampaign contact preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.ActiveCampaignCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private ActiveCampaign contact preflight</span></div>;
  return <Shell />;
}

// ============================================================ Google Contacts CSV preflight loader
// V10.21 reuses the evidence-receipt CSS while isolating Google field rules.
function GoogleContactsCsvLoader() {
  const readyAtStart = window.GoogleContactsCsvShell && document.querySelector("link[data-googlecontactscsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.GoogleContactsCsvShell && document.querySelector("link[data-googlecontactscsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.GoogleContactsCsvShell;
    let style = document.querySelector("link[data-googlecontactscsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-googlecontactscsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.GoogleContactsCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.21";
      style.dataset.googlecontactscsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/googlecontactscsv.js?v=10.21"; script.async = true;
      script.dataset.googlecontactscsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Google Contacts CSV preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.GoogleContactsCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Google Contacts CSV preflight</span></div>;
  return <Shell />;
}

// ============================================================ Outlook Contacts CSV preflight loader
// V10.22 reuses the evidence-receipt CSS while isolating Outlook Contacts rules.
function OutlookContactsCsvLoader() {
  const readyAtStart = window.OutlookContactsCsvShell && document.querySelector("link[data-outlookcontactscsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.OutlookContactsCsvShell && document.querySelector("link[data-outlookcontactscsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.OutlookContactsCsvShell;
    let style = document.querySelector("link[data-outlookcontactscsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-outlookcontactscsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.OutlookContactsCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.22";
      style.dataset.outlookcontactscsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/outlookcontactscsv.js?v=10.22"; script.async = true;
      script.dataset.outlookcontactscsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Outlook Contacts CSV preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.OutlookContactsCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Outlook Contacts CSV preflight</span></div>;
  return <Shell />;
}

// ============================================================ Email list CSV preflight loader
// V10.23 reuses the evidence-receipt CSS while isolating Email list rules.
function EmailCsvLoader() {
  const readyAtStart = window.EmailCsvShell && document.querySelector("link[data-emailcsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.EmailCsvShell && document.querySelector("link[data-emailcsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.EmailCsvShell;
    let style = document.querySelector("link[data-emailcsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-emailcsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.EmailCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.23";
      style.dataset.emailcsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/emailcsv.js?v=10.23"; script.async = true;
      script.dataset.emailcsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Email list CSV preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.EmailCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Email list CSV preflight</span></div>;
  return <Shell />;
}

// ============================================================ Phone list CSV preflight loader
// V10.24 reuses the evidence-receipt CSS while isolating Phone list rules.
function PhoneCsvLoader() {
  const readyAtStart = window.PhoneCsvShell && document.querySelector("link[data-phonecsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.PhoneCsvShell && document.querySelector("link[data-phonecsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.PhoneCsvShell;
    let style = document.querySelector("link[data-phonecsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-phonecsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.PhoneCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.24";
      style.dataset.phonecsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/phonecsv.js?v=10.24"; script.async = true;
      script.dataset.phonecsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Phone list CSV preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.PhoneCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Phone list CSV preflight</span></div>;
  return <Shell />;
}

// ============================================================ Address list CSV preflight loader
// V10.25 reuses the evidence-receipt CSS while isolating Address list rules.
function AddressCsvLoader() {
  const readyAtStart = window.AddressCsvShell && document.querySelector("link[data-addresscsv-style]")?.sheet;
  const [state, setState] = useState(readyAtStart ? "ready" : "loading");
  useEffect(() => {
    if (window.AddressCsvShell && document.querySelector("link[data-addresscsv-style]")?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.AddressCsvShell;
    let style = document.querySelector("link[data-addresscsv-style]");
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-addresscsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.AddressCsvShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link"); style.rel = "stylesheet"; style.href = "/shopifycsv.min.css?v=10.25";
      style.dataset.addresscsvStyle = "1"; document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script"); script.src = "/addresscsv.js?v=10.25"; script.async = true;
      script.dataset.addresscsvChunk = "1"; document.head.appendChild(script);
    }
    style.addEventListener("load", styled); style.addEventListener("error", failed);
    script.addEventListener("load", loaded); script.addEventListener("error", failed);
    if (style.sheet) styleReady = true; if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled); style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded); script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The local Address list CSV preflight could not load. Refresh the page to try again.</div>;
  const Shell = window.AddressCsvShell;
  if (state !== "ready" || !Shell) return <div className="viz-loading page-workspace-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the private Address list CSV preflight</span></div>;
  return <Shell />;
}

// ============================================================ ShareRouter
function ShareRouter({ config }) {
  const tool = (config || {}).tool || "embed";
  if (tool === "story") return <StoryShell config={config} />;
  if (tool === "compare") return <CompareCsvLoader />;
  if (tool === "profile") return <ProfileCsvLoader />;
  if (tool === "map") return <MapCsvLoader />;
  if (tool === "dictionary") return <DictionaryCsvLoader />;
  if (tool === "vcard") return <VCardCsvLoader />;
  if (tool === "ics") return <ICSCsvLoader />;
  if (tool === "geomap") return <GeoMapCsvLoader />;
  if (tool === "powerbi") return <PowerBiCsvLoader />;
  if (tool === "shopify") return <ShopifyCsvLoader />;
  if (tool === "woocommerce-products") return <WooCommerceCsvLoader />;
  if (tool === "hubspot-contacts") return <HubSpotCsvLoader />;
  if (tool === "mailchimp-contacts") return <MailchimpCsvLoader />;
  if (tool === "klaviyo-profiles") return <KlaviyoCsvLoader />;
  if (tool === "activecampaign-contacts") return <ActiveCampaignCsvLoader />;
  if (tool === "google-contacts") return <GoogleContactsCsvLoader />;
  if (tool === "outlook-contacts") return <OutlookContactsCsvLoader />;
  if (tool === "email-list") return <EmailCsvLoader />;
  if (tool === "phone-list") return <PhoneCsvLoader />;
  if (tool === "address-list") return <AddressCsvLoader />;
  return <EmbedShell config={config} />;
}


/* global React, CSVTool, Convert */
// Wave C — generic CSV reshape/clean shell. Concatenated after tools3.jsx,
// before app.jsx, so it reuses useCsvInput/CsvDrop (tools3), InsightStrip/
// ConverterInput (converter), charts helpers, and Convert.reshape_* (convert-extra).
// app.jsx mounts <ReshapeShell> when window.PAGE_CONFIG.mode === "reshape"
// (window.RESHAPE_CONFIG = { toolType, cardTitle, controls:[...] }).

function reshapeColFilter(filter) {
  return c => filter === "number" ? c.type === "number"
    : filter === "date" ? c.type === "date"
    : filter === "category" ? (c.type === "category" || c.type === "boolean")
    : filter === "text" ? (c.type === "text" || c.type === "category")
    : true;
}

// Pick the best default column for a DEMO: a date/ID/high-cardinality column makes
// grouping tools error ("needs exactly two groups") or come out uselessly wide, so
// prefer the candidate with the fewest distinct values in [2..30]. Falls back to the
// first candidate when none qualify, so single-value / numeric controls are unaffected.
function bestDemoCol(cands, prof, used) {
  if (!cands || !cands.length) return null;
  used = used || new Set();
  const rows = (prof && prof.rows) ? prof.rows.slice(0, 800) : [];
  const distinct = c => { const seen = new Set(); for (let i = 0; i < rows.length && seen.size <= 40; i++) { const x = rows[i][c.name]; if (x !== "" && x != null) seen.add(x); } return seen.size; };
  let best = null, bestN = Infinity;
  for (const c of cands) {
    if (used.has(c.name)) continue; // prefer a column not already assigned to another control
    const n = distinct(c);
    if (n >= 2 && n <= 30 && n < bestN) { bestN = n; best = c; }
  }
  return best || cands.find(c => !used.has(c.name)) || cands[0];
}

function ReshapeShell({ config }) {
  const cfg = config || {};
  const toolType = cfg.toolType;
  const controls = cfg.controls || [];
  const io = useCsvInput();
  const [opts, setOpts] = useState({});
  const [copied, setCopied] = useState(false);
  const ceReady = useConvertExtra(); // convert-extra.jsx is a lazy chunk; gate dispatch on it

  function initOpts(prof) {
    const o = {};
    const used = new Set(); // columns already assigned to a control, so demos use distinct columns
    for (const ctl of controls) {
      if (ctl.type === "column") {
        const cs = prof.cols.filter(reshapeColFilter(ctl.colFilter));
        const pick = ctl.default ? null : (bestDemoCol(cs, prof, used) || cs[0] || prof.cols[0]);
        o[ctl.key] = ctl.default || ((pick || {}).name || "");
        if (pick && !ctl.default) used.add(pick.name);
      } else if (ctl.type === "columns") {
        // For a grouping selector ("group by"), pre-pick one low-cardinality column
        // so the sample demo shows an actual GROUPED result instead of one grand
        // total. (Other multi-column controls like "select columns" keep their default.)
        if (Array.isArray(ctl.default)) { o[ctl.key] = ctl.default; }
        else if (/group/i.test(ctl.key)) { const p = bestDemoCol(prof.cols.filter(reshapeColFilter(ctl.colFilter)), prof, used); o[ctl.key] = p ? (used.add(p.name), [p.name]) : []; }
        else { o[ctl.key] = []; }
      } else if (ctl.type === "select") {
        o[ctl.key] = ctl.default != null ? ctl.default : (ctl.options && ctl.options[0] ? ctl.options[0].value : "");
      } else if (ctl.type === "checkbox") {
        o[ctl.key] = !!ctl.default;
      } else if (ctl.key === "expression") {
        // calc-column: seed an expression over THIS dataset's numeric columns so the
        // sample shows a real calculated column, not a blank one (the config default
        // may reference columns this file doesn't have). Only simple identifiers, so
        // the expression stays valid without quoting.
        const nums = prof.cols.filter(c => c.type === "number" && c.role !== "id" && /^[A-Za-z_]\w*$/.test(c.name)).map(c => c.name);
        o[ctl.key] = nums.length >= 2 ? `${nums[0]} / ${nums[1]}` : nums.length === 1 ? `${nums[0]} * 2` : (ctl.default != null ? ctl.default : "");
      } else {
        o[ctl.key] = ctl.default != null ? ctl.default : "";
      }
    }
    setOpts(o);
  }

  const result = useMemo(() => {
    if (!io.profile) return null;
    const fn = Convert["reshape_" + toolType];
    if (typeof fn !== "function") return ceReady ? { error: "This transform isn't available." } : { loading: true };
    try {
      const r = fn(io.profile, opts);
      return typeof r === "string" ? { csv: r } : (r && typeof r === "object" ? { csv: r.csv || "", stats: r.stats } : { csv: "" });
    } catch (e) { return { error: e.message || "Transform failed." }; }
  }, [io.profile, opts, toolType, ceReady]);

  function up(key, val) { setOpts(o => ({ ...o, [key]: val })); }
  function toggleCol(key, name) {
    setOpts(o => { const arr = Array.isArray(o[key]) ? o[key].slice() : []; const i = arr.indexOf(name); if (i >= 0) arr.splice(i, 1); else arr.push(name); return { ...o, [key]: arr }; });
  }
  function copyOut() { if (result && result.csv) navigator.clipboard.writeText(result.csv).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }).catch(() => {}); }
  function download() {
    if (!result || !result.csv) return;
    const blob = new Blob([result.csv], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = io.filename + "-" + toolType + ".csv";
    document.body.appendChild(a); a.click(); setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 800);
  }
  function buildDashboard() {
    if (!result || !result.csv) return;
    sendCSVToDashboard(result.csv, io.filename + ".csv");
  }

  function renderControl(ctl) {
    const prof = io.profile;
    if (ctl.type === "column") {
      const cs = prof.cols.filter(reshapeColFilter(ctl.colFilter));
      const list = cs.length ? cs : prof.cols;
      return (
        <label className="pivot-control" key={ctl.key}><span>{ctl.label}</span>
          <select value={opts[ctl.key] || ""} onChange={e => up(ctl.key, e.target.value)}>
            {list.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>
        </label>
      );
    }
    if (ctl.type === "columns") {
      const cs = prof.cols.filter(reshapeColFilter(ctl.colFilter));
      const sel = Array.isArray(opts[ctl.key]) ? opts[ctl.key] : [];
      return (
        <div className="reshape-cols" key={ctl.key}>
          <span className="reshape-cols-label">{ctl.label}{sel.length ? "" : " (all)"}</span>
          <div className="reshape-cols-grid">
            {cs.map(c => (
              <label className={"reshape-chip" + (sel.indexOf(c.name) >= 0 ? " on" : "")} key={c.name}>
                <input type="checkbox" checked={sel.indexOf(c.name) >= 0} onChange={() => toggleCol(ctl.key, c.name)} />
                {c.name}
              </label>
            ))}
          </div>
        </div>
      );
    }
    if (ctl.type === "select") {
      return (
        <label className="pivot-control" key={ctl.key}><span>{ctl.label}</span>
          <select value={opts[ctl.key] != null ? opts[ctl.key] : ""} onChange={e => up(ctl.key, e.target.value)}>
            {(ctl.options || []).map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </label>
      );
    }
    if (ctl.type === "checkbox") {
      return (
        <label className="pivot-control reshape-check" key={ctl.key}>
          <input type="checkbox" checked={!!opts[ctl.key]} onChange={e => up(ctl.key, e.target.checked)} /> <span>{ctl.label}</span>
        </label>
      );
    }
    if (ctl.type === "number") {
      return (
        <label className="pivot-control" key={ctl.key}><span>{ctl.label}</span>
          <input className="conv-opts-input" type="number" min={ctl.min} max={ctl.max} value={opts[ctl.key] != null ? opts[ctl.key] : ""} onChange={e => up(ctl.key, e.target.value)} />
        </label>
      );
    }
    return (
      <label className="pivot-control" key={ctl.key}><span>{ctl.label}</span>
        <input className="conv-opts-input" type="text" placeholder={ctl.placeholder || ""} value={opts[ctl.key] != null ? opts[ctl.key] : ""} onChange={e => up(ctl.key, e.target.value)} />
      </label>
    );
  }

  return (
    <div className="viz-shell">
      {!io.profile ? <CsvDrop io={io} onLoaded={initOpts} /> : (
        <div className="viz">
          {controls.length > 0 && <div className="pivot-controls viz-controls reshape-controls">{controls.map(renderControl)}</div>}
          <div className="chart-card viz-card">
            <div className="chart-head">
              <div className="chart-title">{cfg.cardTitle || "Result"}</div>
              <div className="chart-kind">{toolType}</div>
            </div>
            <div className="viz-canvas devtool-canvas">
              {result && result.error ? <div className="conv-err">{result.error}</div> : result && result.loading ? <div className="conv-stats"><span>Loading the converter…</span></div> : (
                <>
                  {result && result.stats && <div className="conv-stats">{Object.entries(result.stats).filter(([_, v]) => v != null).map(([k, v]) => <span key={k}><span className="conv-stats-label">{k}</span> {String(v)}</span>)}</div>}
                  <ResultGrid csv={result ? result.csv : ""} toolType={toolType} opts={opts} />
                  {rgGridable(result) && <div className="rg-raw-label">Raw CSV</div>}
                  <textarea className={"conv-out-text" + (rgGridable(result) ? " rg-rawbox" : "")} readOnly value={result ? result.csv : ""} />
                </>
              )}
            </div>
          </div>
          <div className="viz-actions">
            <button className="btn-ghost" onClick={copyOut}>{copied ? "Copied!" : "Copy CSV"}</button>
            <button className="btn-ghost" onClick={download}>Download CSV</button>
            <button className="btn-ghost" onClick={buildDashboard}>Build dashboard →</button>
            <button className="btn-ghost" onClick={io.reset}>Use different data</button>
          </div>
          <InsightStrip profile={io.profile} onBuildDashboard={buildDashboard} />
        </div>
      )}
    </div>
  );
}

// ============================================================ TextToolShell (raw text -> CSV)
// app.jsx mounts this when PAGE_CONFIG.mode === "texttool"
// (window.TEXTTOOL_CONFIG = { toolType, cardTitle, controls:[...], sampleText? }).
// Calls Convert.texttool_<toolType>(text, opts) -> CSV string.
function TextToolShell({ config }) {
  const cfg = config || {};
  const toolType = cfg.toolType;
  const controls = cfg.controls || [];
  const [text, setText] = useState("");
  const [opts, setOpts] = useState(function () {
    const o = {};
    for (const c of controls) {
      if (c.type === "select") o[c.key] = c.default != null ? c.default : (c.options && c.options[0] ? c.options[0].value : "");
      else if (c.type === "checkbox") o[c.key] = !!c.default;
      else o[c.key] = c.default != null ? c.default : "";
    }
    return o;
  });
  const [copied, setCopied] = useState(false);
  const ceReady = useConvertExtra(); // convert-extra.jsx is a lazy chunk; gate dispatch on it

  const result = useMemo(() => {
    const fn = Convert["texttool_" + toolType];
    if (typeof fn !== "function") return ceReady ? { error: "This tool isn't available." } : { loading: true };
    if (!text || !text.trim()) return { csv: "" };
    try { const r = fn(text, opts); return { csv: typeof r === "string" ? r : (r && r.csv) || "" }; }
    catch (e) { return { error: e.message || "Could not process that text." }; }
  }, [text, opts, toolType, ceReady]);

  function up(k, v) { setOpts(o => ({ ...o, [k]: v })); }
  function copyOut() { if (result && result.csv) navigator.clipboard.writeText(result.csv).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }).catch(() => {}); }
  function download() {
    if (!result || !result.csv) return;
    const blob = new Blob([result.csv], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = toolType + ".csv";
    document.body.appendChild(a); a.click(); setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 800);
  }
  function buildDashboard() {
    if (!result || !result.csv) return;
    sendCSVToDashboard(result.csv, toolType + ".csv");
  }

  function renderControl(c) {
    if (c.type === "select") return <label className="pivot-control" key={c.key}><span>{c.label}</span><select value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)}>{(c.options || []).map(o => <option key={o.value} value={o.value}>{o.label}</option>)}</select></label>;
    if (c.type === "checkbox") return <label className="pivot-control reshape-check" key={c.key}><input type="checkbox" checked={!!opts[c.key]} onChange={e => up(c.key, e.target.checked)} /> <span>{c.label}</span></label>;
    if (c.type === "number") return <label className="pivot-control" key={c.key}><span>{c.label}</span><input className="conv-opts-input" type="number" min={c.min} max={c.max} value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)} /></label>;
    return <label className="pivot-control" key={c.key}><span>{c.label}</span><input className="conv-opts-input" type="text" placeholder={c.placeholder || ""} value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)} /></label>;
  }

  const rowCount = result && result.csv ? Math.max(0, result.csv.split("\n").length - 1) : 0;
  return (
    <div className="viz-shell">
      <div className="texttool">
        <div className="texttool-in-head">
          <span className="texttool-in-label">Paste your text</span>
          {cfg.sampleText && <button className="conv-drop-sample texttool-sample" onClick={() => setText(cfg.sampleText)}>try with sample text</button>}
        </div>
        <textarea className="texttool-input" placeholder="Paste anything — a log, an email thread, a list, messy delimited data…" value={text} onChange={e => setText(e.target.value)} />
        {controls.length > 0 && <div className="pivot-controls viz-controls reshape-controls">{controls.map(renderControl)}</div>}
        <div className="chart-card viz-card">
          <div className="chart-head">
            <div className="chart-title">{cfg.cardTitle || "Result"}</div>
            <div className="chart-kind">{toolType}</div>
          </div>
          <div className="viz-canvas devtool-canvas">
            {result && result.error ? <div className="conv-err">{result.error}</div> : result && result.loading ? <div className="conv-stats"><span>Loading the converter…</span></div> : (
              <>
                {rowCount > 0 && <div className="conv-stats"><span><span className="conv-stats-label">rows</span> {rowCount}</span></div>}
                <ResultGrid csv={result ? result.csv : ""} toolType={toolType} opts={opts} />
                {rgGridable(result) && <div className="rg-raw-label">Raw CSV</div>}
                <textarea className={"conv-out-text" + (rgGridable(result) ? " rg-rawbox" : "")} readOnly value={result ? result.csv : ""} placeholder="The CSV will appear here as you paste text above." />
              </>
            )}
          </div>
        </div>
        <div className="viz-actions">
          <button className="btn-ghost" onClick={copyOut}>{copied ? "Copied!" : "Copy CSV"}</button>
          <button className="btn-ghost" onClick={download}>Download CSV</button>
          <button className="btn-ghost" onClick={buildDashboard}>Build dashboard →</button>
        </div>
      </div>
    </div>
  );
}

// ============================================================ GeneratorShell (no input -> CSV)
// app.jsx mounts this when PAGE_CONFIG.mode === "generator"
// (window.GEN_CONFIG = { toolType, cardTitle, controls:[...] }).
// Calls Convert.gen_<toolType>(opts) -> CSV string. Regenerate re-rolls randomness.
function GeneratorShell({ config }) {
  const cfg = config || {};
  const toolType = cfg.toolType;
  const controls = cfg.controls || [];
  const [opts, setOpts] = useState(function () {
    const o = {};
    for (const c of controls) {
      if (c.type === "select") o[c.key] = c.default != null ? c.default : (c.options && c.options[0] ? c.options[0].value : "");
      else if (c.type === "checkbox") o[c.key] = !!c.default;
      else o[c.key] = c.default != null ? c.default : "";
    }
    return o;
  });
  const [regen, setRegen] = useState(0);
  const [copied, setCopied] = useState(false);
  const ceReady = useConvertExtra(); // convert-extra.jsx is a lazy chunk; gate dispatch on it

  const result = useMemo(() => {
    const fn = Convert["gen_" + toolType];
    if (typeof fn !== "function") return ceReady ? { error: "This generator isn't available." } : { loading: true };
    try { const r = fn(opts); return { csv: typeof r === "string" ? r : (r && r.csv) || "" }; }
    catch (e) { return { error: e.message || "Generation failed." }; }
  }, [opts, toolType, regen, ceReady]);

  function up(k, v) { setOpts(o => ({ ...o, [k]: v })); }
  function copyOut() { if (result && result.csv) navigator.clipboard.writeText(result.csv).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }).catch(() => {}); }
  function download() {
    if (!result || !result.csv) return;
    const blob = new Blob([result.csv], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = toolType + ".csv";
    document.body.appendChild(a); a.click(); setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 800);
  }
  function buildDashboard() {
    if (!result || !result.csv) return;
    sendCSVToDashboard(result.csv, toolType + ".csv");
  }
  function renderControl(c) {
    if (c.type === "select") return <label className="pivot-control" key={c.key}><span>{c.label}</span><select value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)}>{(c.options || []).map(o => <option key={o.value} value={o.value}>{o.label}</option>)}</select></label>;
    if (c.type === "checkbox") return <label className="pivot-control reshape-check" key={c.key}><input type="checkbox" checked={!!opts[c.key]} onChange={e => up(c.key, e.target.checked)} /> <span>{c.label}</span></label>;
    if (c.type === "number") return <label className="pivot-control" key={c.key}><span>{c.label}</span><input className="conv-opts-input" type="number" min={c.min} max={c.max} value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)} /></label>;
    return <label className="pivot-control" key={c.key}><span>{c.label}</span><input className="conv-opts-input" type="text" placeholder={c.placeholder || ""} value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)} /></label>;
  }

  const rowCount = result && result.csv ? Math.max(0, result.csv.split("\n").length - 1) : 0;
  return (
    <div className="viz-shell">
      <div className="texttool">
        {controls.length > 0 && <div className="pivot-controls viz-controls reshape-controls">{controls.map(renderControl)}</div>}
        <div className="chart-card viz-card">
          <div className="chart-head">
            <div className="chart-title">{cfg.cardTitle || "Generated CSV"}</div>
            <div className="chart-kind">{toolType}</div>
          </div>
          <div className="viz-canvas devtool-canvas">
            {result && result.error ? <div className="conv-err">{result.error}</div> : result && result.loading ? <div className="conv-stats"><span>Loading the converter…</span></div> : (
              <>
                {rowCount > 0 && <div className="conv-stats"><span><span className="conv-stats-label">rows</span> {rowCount}</span></div>}
                <ResultGrid csv={result ? result.csv : ""} toolType={toolType} opts={opts} />
                {rgGridable(result) && <div className="rg-raw-label">Raw CSV</div>}
                <textarea className={"conv-out-text" + (rgGridable(result) ? " rg-rawbox" : "")} readOnly value={result ? result.csv : ""} />
              </>
            )}
          </div>
        </div>
        <div className="viz-actions">
          <button className="btn-ghost" onClick={() => setRegen(n => n + 1)}>↻ Regenerate</button>
          <button className="btn-ghost" onClick={copyOut}>{copied ? "Copied!" : "Copy CSV"}</button>
          <button className="btn-ghost" onClick={download}>Download CSV</button>
          <button className="btn-ghost" onClick={buildDashboard}>Build dashboard →</button>
        </div>
      </div>
    </div>
  );
}

// ============================================================ FormatShell (text -> text)
// app.jsx mounts this when PAGE_CONFIG.mode === "format"
// (window.FORMAT_CONFIG = { toolType, cardTitle, controls:[...], sampleText?, outExt?, inLabel?, inPlaceholder? }).
// Calls Convert.fmt_<toolType>(text, opts) -> string | { out, error, note }.
// Developer/data utilities: format, validate, decode, convert text in the browser.
function FormatShell({ config }) {
  const cfg = config || {};
  const toolType = cfg.toolType;
  const controls = cfg.controls || [];
  const outExt = cfg.outExt || "txt";
  const [text, setText] = useState("");
  const [opts, setOpts] = useState(function () {
    const o = {};
    for (const c of controls) {
      if (c.type === "select") o[c.key] = c.default != null ? c.default : (c.options && c.options[0] ? c.options[0].value : "");
      else if (c.type === "checkbox") o[c.key] = !!c.default;
      else o[c.key] = c.default != null ? c.default : "";
    }
    return o;
  });
  const [copied, setCopied] = useState(false);
  const ceReady = useConvertExtra(); // convert-extra.jsx is a lazy chunk; gate dispatch on it

  const result = useMemo(() => {
    const fn = Convert["fmt_" + toolType];
    if (typeof fn !== "function") return ceReady ? { out: "", error: "This tool isn't available." } : { loading: true };
    if (!text || !text.trim()) return { out: "" };
    try {
      const r = fn(text, opts);
      if (typeof r === "string") return { out: r };
      return { out: (r && r.out) || "", error: r && r.error, note: r && r.note };
    } catch (e) { return { out: "", error: e.message || "Could not process that input." }; }
  }, [text, opts, toolType, ceReady]);

  function up(k, v) { setOpts(o => ({ ...o, [k]: v })); }
  function copyOut() { if (result && result.out) navigator.clipboard.writeText(result.out).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }).catch(() => {}); }
  function download() {
    if (!result || !result.out) return;
    const mime = outExt === "json" ? "application/json" : (outExt === "csv" ? "text/csv" : (outExt === "ts" ? "text/typescript" : "text/plain"));
    const blob = new Blob([result.out], { type: mime + ";charset=utf-8" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = toolType + "." + outExt;
    document.body.appendChild(a); a.click(); setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 800);
  }

  function renderControl(c) {
    if (c.type === "select") return <label className="pivot-control" key={c.key}><span>{c.label}</span><select value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)}>{(c.options || []).map(o => <option key={o.value} value={o.value}>{o.label}</option>)}</select></label>;
    if (c.type === "checkbox") return <label className="pivot-control reshape-check" key={c.key}><input type="checkbox" checked={!!opts[c.key]} onChange={e => up(c.key, e.target.checked)} /> <span>{c.label}</span></label>;
    if (c.type === "number") return <label className="pivot-control" key={c.key}><span>{c.label}</span><input className="conv-opts-input" type="number" min={c.min} max={c.max} value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)} /></label>;
    return <label className="pivot-control" key={c.key}><span>{c.label}</span><input className="conv-opts-input" type="text" placeholder={c.placeholder || ""} value={opts[c.key] != null ? opts[c.key] : ""} onChange={e => up(c.key, e.target.value)} /></label>;
  }

  return (
    <div className="viz-shell">
      <div className="texttool">
        <div className="texttool-in-head">
          <span className="texttool-in-label">{cfg.inLabel || "Paste your input"}</span>
          {cfg.sampleText && <button className="conv-drop-sample texttool-sample" onClick={() => setText(cfg.sampleText)}>try with a sample</button>}
        </div>
        <textarea className="texttool-input devtool-input" placeholder={cfg.inPlaceholder || "Paste here…"} value={text} onChange={e => setText(e.target.value)} spellCheck={false} />
        {controls.length > 0 && <div className="pivot-controls viz-controls reshape-controls">{controls.map(renderControl)}</div>}
        <div className="chart-card viz-card">
          <div className="chart-head">
            <div className="chart-title">{cfg.cardTitle || "Result"}</div>
            <div className="chart-kind">{toolType}</div>
          </div>
          <div className="viz-canvas devtool-canvas">
            {result && result.error ? <div className="conv-err">{result.error}</div> : result && result.loading ? <div className="conv-stats"><span>Loading the converter…</span></div> : (
              <>
                {result && result.note && <div className="conv-stats"><span>{result.note}</span></div>}
                <textarea className="conv-out-text" readOnly value={result ? result.out : ""} spellCheck={false} placeholder="The result will appear here as you paste input above." />
              </>
            )}
          </div>
        </div>
        <div className="viz-actions">
          <button className="btn-ghost" onClick={copyOut}>{copied ? "Copied!" : "Copy"}</button>
          <button className="btn-ghost" onClick={download}>Download .{outExt}</button>
        </div>
      </div>
    </div>
  );
}

// ============================================================ QRShell (text / CSV -> QR codes, lib-backed)
// app.jsx mounts this when PAGE_CONFIG.mode === "qr"
// (window.QR_CONFIG = { kind:"single"|"batch", cardTitle, sample? }).
// Uses window.qrcode (vendored qrcode-generator, MIT). 100% client-side — the
// value you encode never leaves the browser.
function qrSvgString(value, o) {
  const ecl = o.ecl || "M", cell = +o.cell || 6, margin = o.margin == null ? 4 : +o.margin;
  const dark = o.dark || "#0d2a22", light = o.light || "#ffffff";
  const qr = window.qrcode(0, ecl);
  qr.addData(value == null ? "" : String(value));
  qr.make();
  const n = qr.getModuleCount();
  const size = (n + margin * 2) * cell;
  let cells = "";
  for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) {
    if (qr.isDark(r, c)) cells += '<rect x="' + ((c + margin) * cell) + '" y="' + ((r + margin) * cell) + '" width="' + cell + '" height="' + cell + '"/>';
  }
  return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '" shape-rendering="crispEdges"><rect width="' + size + '" height="' + size + '" fill="' + light + '"/><g fill="' + dark + '">' + cells + '</g></svg>';
}
function qrDownloadBlob(data, type, name) {
  const blob = new Blob([data], { type: type });
  const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = name;
  document.body.appendChild(a); a.click(); setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 800);
}
function qrSvgToPng(svg, scale, cb) {
  const img = new Image();
  img.onload = function () {
    const canvas = document.createElement("canvas");
    canvas.width = img.width * (scale || 1); canvas.height = img.height * (scale || 1);
    const ctx = canvas.getContext("2d"); ctx.imageSmoothingEnabled = false;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    canvas.toBlob(function (b) { cb(b); }, "image/png");
  };
  img.onerror = function () { cb(null); };
  img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}
function safeName(s) { return (String(s || "qr").replace(/[^a-z0-9_-]+/gi, "-").replace(/^-+|-+$/g, "").slice(0, 40) || "qr"); }

function QROptions({ ctl }) {
  return (
    <div className="pivot-controls viz-controls reshape-controls qr-controls">
      <label className="pivot-control"><span>Error correction</span>
        <select value={ctl.ecl} onChange={e => ctl.setEcl(e.target.value)}>
          <option value="L">L · ~7%</option><option value="M">M · ~15%</option><option value="Q">Q · ~25%</option><option value="H">H · ~30%</option>
        </select></label>
      <label className="pivot-control"><span>Cell size (px)</span><input className="conv-opts-input" type="number" min="2" max="24" value={ctl.cell} onChange={e => ctl.setCell(e.target.value)} /></label>
      <label className="pivot-control"><span>Quiet margin</span><input className="conv-opts-input" type="number" min="0" max="16" value={ctl.margin} onChange={e => ctl.setMargin(e.target.value)} /></label>
      <label className="pivot-control qr-color"><span>Dark</span><input type="color" value={ctl.dark} onChange={e => ctl.setDark(e.target.value)} /></label>
      <label className="pivot-control qr-color"><span>Light</span><input type="color" value={ctl.light} onChange={e => ctl.setLight(e.target.value)} /></label>
    </div>
  );
}

function QRShell({ config }) {
  const cfg = config || {};
  const kind = cfg.kind === "batch" ? "batch" : "single";
  const [ready, setReady] = useState(typeof window !== "undefined" && !!window.qrcode);
  useEffect(function () {
    if (window.qrcode) { setReady(true); return; }
    const t = setInterval(function () { if (window.qrcode) { setReady(true); clearInterval(t); } }, 100);
    return function () { clearInterval(t); };
  }, []);
  const [ecl, setEcl] = useState("M");
  const [cell, setCell] = useState(6);
  const [margin, setMargin] = useState(4);
  const [dark, setDark] = useState("#0d2a22");
  const [light, setLight] = useState("#ffffff");
  const ctl = { ecl, setEcl, cell, setCell, margin, setMargin, dark, setDark, light, setLight };
  const opts = { ecl, cell, margin, dark, light };

  // ---- single ----
  const [text, setText] = useState(cfg.sample || "https://csvtodashboard.com");
  const single = useMemo(() => {
    if (kind !== "single" || !ready) return null;
    if (!text) return { empty: true };
    try { return { svg: qrSvgString(text, opts) }; }
    catch (e) { return { error: "That's too much data for a single QR code — shorten the text or raise the error-correction headroom." }; }
  }, [kind, ready, text, ecl, cell, margin, dark, light]);

  // ---- batch ----
  const [csv, setCsv] = useState("");
  const [valueCol, setValueCol] = useState("");
  const [labelCol, setLabelCol] = useState("");
  const parsed = useMemo(() => {
    if (kind !== "batch" || !csv.trim() || !window.CSVTool) return null;
    try { const p = window.CSVTool.parseCSV(csv); return (p && p.headers && p.headers.length) ? p : null; } catch (e) { return null; }
  }, [kind, csv]);
  useEffect(() => { if (parsed && parsed.headers.length) { if (!parsed.headers.includes(valueCol)) setValueCol(parsed.headers[0]); } }, [parsed]);
  const CAP = 200;
  const batch = useMemo(() => {
    if (kind !== "batch" || !ready || !parsed || !valueCol) return null;
    const rows = parsed.rows.slice(0, CAP);
    const items = [];
    for (let i = 0; i < rows.length; i++) {
      const v = rows[i][valueCol];
      if (v == null || String(v).trim() === "") continue;
      const label = labelCol ? String(rows[i][labelCol] == null ? "" : rows[i][labelCol]) : String(v);
      try { items.push({ value: String(v), label, svg: qrSvgString(v, opts) }); }
      catch (e) { items.push({ value: String(v), label, error: true }); }
    }
    return { items, total: parsed.rows.length, capped: parsed.rows.length > CAP };
  }, [kind, ready, parsed, valueCol, labelCol, ecl, cell, margin, dark, light]);

  function dlSingleSvg() { if (single && single.svg) qrDownloadBlob(single.svg, "image/svg+xml", safeName(text) + ".svg"); }
  function dlSinglePng() { if (single && single.svg) qrSvgToPng(single.svg, 4, function (b) { if (b) qrDownloadBlob(b, "image/png", safeName(text) + ".png"); }); }
  function dlItemSvg(it) { qrDownloadBlob(it.svg, "image/svg+xml", safeName(it.label) + ".svg"); }
  function dlSheet() {
    if (!batch || !batch.items.length) return;
    const escCap = s => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const cards = batch.items.map(it => '<figure>' + (it.error ? '<div class="err">too long</div>' : it.svg) + '<figcaption>' + escCap(it.label) + '</figcaption></figure>').join("");
    const html = '<!doctype html><meta charset="utf-8"><title>QR sheet</title><style>body{font-family:system-ui,sans-serif;margin:24px}h1{font-size:16px}.grid{display:flex;flex-wrap:wrap;gap:18px}figure{margin:0;text-align:center;width:160px}figure svg{width:140px;height:140px}figcaption{font-size:11px;word-break:break-all;margin-top:6px}.err{color:#b00;font-size:11px;padding:40px 0}@media print{.no-print{display:none}}</style><h1>QR codes · ' + batch.items.length + '</h1><p class="no-print"><button onclick="print()">Print / Save as PDF</button></p><div class="grid">' + cards + '</div>';
    qrDownloadBlob(html, "text/html", "qr-sheet.html");
  }

  return (
    <div className="viz-shell">
      <div className="texttool">
        {!ready && <div className="conv-stats"><span>Loading the QR engine…</span></div>}
        {kind === "single" ? (
          <>
            <div className="texttool-in-head"><span className="texttool-in-label">{cfg.inLabel || "Text or URL to encode"}</span></div>
            <textarea className="texttool-input" placeholder="https://example.com — or any text, vCard, Wi-Fi string…" value={text} onChange={e => setText(e.target.value)} />
            <QROptions ctl={ctl} />
            <div className="chart-card viz-card">
              <div className="chart-head"><div className="chart-title">{cfg.cardTitle || "Your QR code"}</div><div className="chart-kind">qr</div></div>
              <div className="viz-canvas qr-canvas">
                {single && single.error ? <div className="conv-err">{single.error}</div> :
                  single && single.svg ? <div className="qr-preview" dangerouslySetInnerHTML={{ __html: single.svg }} /> :
                  <div className="conv-stats"><span>Type something above to generate a QR code.</span></div>}
              </div>
            </div>
            <div className="viz-actions">
              <button className="btn-ghost" onClick={dlSingleSvg} disabled={!single || !single.svg}>Download SVG</button>
              <button className="btn-ghost" onClick={dlSinglePng} disabled={!single || !single.svg}>Download PNG</button>
            </div>
          </>
        ) : (
          <>
            <div className="texttool-in-head">
              <span className="texttool-in-label">{cfg.inLabel || "Paste CSV — one QR per row"}</span>
              {cfg.sample && <button className="conv-drop-sample texttool-sample" onClick={() => setCsv(cfg.sample)}>try with a sample</button>}
            </div>
            <textarea className="texttool-input" placeholder="id,url&#10;1,https://example.com/1&#10;2,https://example.com/2" value={csv} onChange={e => setCsv(e.target.value)} />
            {parsed && parsed.headers.length > 0 && (
              <div className="pivot-controls viz-controls reshape-controls">
                <label className="pivot-control"><span>Encode column</span><select value={valueCol} onChange={e => setValueCol(e.target.value)}>{parsed.headers.map(h => <option key={h} value={h}>{h}</option>)}</select></label>
                <label className="pivot-control"><span>Caption column</span><select value={labelCol} onChange={e => setLabelCol(e.target.value)}><option value="">(same as encoded)</option>{parsed.headers.map(h => <option key={h} value={h}>{h}</option>)}</select></label>
              </div>
            )}
            <QROptions ctl={ctl} />
            <div className="chart-card viz-card">
              <div className="chart-head"><div className="chart-title">{cfg.cardTitle || "QR codes"}</div><div className="chart-kind">{batch ? batch.items.length + " codes" : "qr batch"}</div></div>
              <div className="viz-canvas qr-canvas">
                {!parsed ? <div className="conv-stats"><span>Paste CSV with a header row to generate a QR code per row.</span></div> :
                  batch && batch.items.length ? (
                    <>
                      {batch.capped && <div className="conv-stats"><span>Showing the first {CAP} of {batch.total} rows.</span></div>}
                      <div className="qr-grid">
                        {batch.items.map((it, i) => (
                          <figure className="qr-cell" key={i} onClick={() => !it.error && dlItemSvg(it)} title={it.error ? "too long for one QR" : "click to download SVG"}>
                            {it.error ? <div className="conv-err qr-cell-err">too long</div> : <div className="qr-cell-img" dangerouslySetInnerHTML={{ __html: it.svg }} />}
                            <figcaption className="qr-cell-cap">{it.label}</figcaption>
                          </figure>
                        ))}
                      </div>
                    </>
                  ) : <div className="conv-stats"><span>No non-empty values in that column.</span></div>}
              </div>
            </div>
            <div className="viz-actions">
              <button className="btn-ghost" onClick={dlSheet} disabled={!batch || !batch.items.length}>Download printable sheet</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}


/* global React, CSVTool, Convert */
// V4 Batch A — EditorShell: the /csv-editor, /csv-viewer, /excel-viewer,
// /parquet-viewer and /open-large-csv head-term pages. One shell, configured by
// window.EDITOR_CONFIG = { editable, accept ("csv"|"xlsx"|"parquet"|"json"),
// bigDemo (row count for the generate-demo button) }.
//
// Concatenated after tools4.jsx, before app.jsx. Reuses ensureXLSX/SheetPicker/
// Convert.* (converter.jsx), sendCSVToDashboard/fmtNum (charts.jsx) and
// CSVTool.parseCSVAsync (parser.js / parser.worker.js).
//
// Editing model — built to survive a 1M-row file:
//   · The parsed rows array is NEVER mutated and never copied per edit.
//   · Cell edits live in an overlay Map keyed `rowKeycolId`.
//   · Row identity: original index (number) or "a<N>" for added rows, so
//     sorting/filtering (display permutations) never corrupt edit targets.
//   · Deleted rows are a Set of row keys; added rows an array of keys whose
//     cells live only in the overlay. Columns are specs {id,name,src,type} —
//     renames touch the spec, never the data; added columns have src:null.
//   · Export materializes original order + overlay in one pass.

function edCellKey(rowKey, colId) { return rowKey + "" + colId; }

function edEscCSV(v) {
  const s = v == null ? "" : String(v);
  return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

// Deterministic big-CSV synthesis for the /open-large-csv demo. Index-mixed
// pseudo-randomness (no Math.random) so repeat runs build the same file.
// Generated in chunks with setTimeout yields so the page stays responsive and
// the progress bar actually moves — this page's whole pitch is "no freezing".
function edGenerateBigCSV(n, onProgress) {
  const regions = ["North", "South", "East", "West", "Central"];
  const products = ["Aurora Lamp", "Pebble Speaker", "Cedar Shelf", "Meadow Chair", "Linen Throw", "Glow Bulb", "Tide Mug"];
  const channels = ["Online", "Retail", "Partner"];
  const dates = new Array(730);
  for (let d = 0; d < 730; d++) dates[d] = new Date(Date.UTC(2024, 0, 1 + d)).toISOString().slice(0, 10);
  const out = new Array(n + 1);
  out[0] = "date,region,product,channel,units,unit_price,revenue";
  const CHUNK = 100000;
  return new Promise(resolve => {
    let i = 0;
    function tick() {
      const end = Math.min(n, i + CHUNK);
      for (; i < end; i++) {
        const h = (i * 2654435761) >>> 0; // Knuth multiplicative hash of the index
        const units = 1 + ((h >>> 9) % 12);
        const price = 19 + ((h >>> 13) % 180) + (((h >>> 5) % 100) / 100);
        out[i + 1] = dates[i % 730] + "," + regions[h % regions.length] + ',"' + products[(h >>> 3) % products.length] + '",' + channels[(h >>> 7) % channels.length] + "," + units + "," + price.toFixed(2) + "," + (units * price).toFixed(2);
      }
      if (onProgress) onProgress(i / n);
      if (i < n) setTimeout(tick, 0);
      else resolve(out.join("\n"));
    }
    tick();
  });
}

// Lazy loader for the self-hosted hyparquet READER global (vendor build:
// scripts/build-parquet-reader.mjs → vendor/hyparquet.global.js).
function ensureParquetReader() {
  if (window.HyParquet) return Promise.resolve();
  if (window.__parquetReaderLoading) return window.__parquetReaderLoading;
  window.__parquetReaderLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "/vendor/hyparquet.global.js";
    s.async = true;
    s.onload = () => (window.HyParquet ? resolve() : reject(new Error("Parquet engine failed to initialize")));
    s.onerror = () => reject(new Error("Could not load the Parquet engine"));
    document.head.appendChild(s);
  });
  return window.__parquetReaderLoading;
}

// Parquet cell values can be BigInt / Date / byte arrays / nested objects —
// flatten each to a CSV-safe string.
function edParquetVal(v) {
  if (v == null) return "";
  if (typeof v === "bigint") return v.toString();
  if (v instanceof Date) return isNaN(+v) ? "" : v.toISOString().replace(/T00:00:00\.000Z$/, "");
  if (typeof v === "object") {
    if (v instanceof Uint8Array) { let s = ""; for (let i = 0; i < v.length; i++) s += String.fromCharCode(v[i]); try { return btoa(s); } catch (e) { return "[bytes]"; } }
    try { return JSON.stringify(v, (k, x) => (typeof x === "bigint" ? x.toString() : x)); } catch (e) { return String(v); }
  }
  return String(v);
}

async function edParquetToCSV(arrayBuffer) {
  await ensureParquetReader();
  const file = { byteLength: arrayBuffer.byteLength, slice: (s, e) => arrayBuffer.slice(s, e) };
  const opts = { file };
  if (window.HyParquet.compressors) opts.compressors = window.HyParquet.compressors;
  const rows = await window.HyParquet.parquetReadObjects(opts);
  if (!rows || !rows.length) throw new Error("That Parquet file has no rows.");
  const headers = Object.keys(rows[0]);
  const lines = new Array(rows.length + 1);
  lines[0] = headers.map(edEscCSV).join(",");
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i], cells = new Array(headers.length);
    for (let j = 0; j < headers.length; j++) cells[j] = edEscCSV(edParquetVal(r[headers[j]]));
    lines[i + 1] = cells.join(",");
  }
  return lines.join("\n");
}

function EditorShell({ config }) {
  const cfg = config || {};
  const editable = cfg.editable !== false;

  const [prof, setProf] = useState(null);
  const [filename, setFilename] = useState("data.csv");
  const [error, setError] = useState("");
  const [progress, setProgress] = useState(null); // 0..1 while parsing/generating
  const [progressLabel, setProgressLabel] = useState("Parsing your file");
  const [pendingSheets, setPendingSheets] = useState(null);

  // ----- editing state -----
  const [columns, setColumns] = useState([]);   // [{id, name, src, type}]
  const [edits, setEdits] = useState(() => new Map());
  const [deleted, setDeleted] = useState(() => new Set());
  const [added, setAdded] = useState([]);       // ["a0", "a1", ...]
  const addSeq = useRef(0);
  const colSeq = useRef(0);
  const colSigRef = useRef(""); // load-time column-id order, to detect reorder/column-delete (V7 audit)
  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);

  // ----- view state -----
  const [sort, setSort] = useState(null);       // {id, dir}
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  useEffect(() => { const t = setTimeout(() => setDebouncedQuery(query.trim().toLowerCase()), 250); return () => clearTimeout(t); }, [query]);

  // ----- grid/selection state -----
  const [sel, setSel] = useState(null);         // {anchor:{r,c}, head:{r,c}} over DISPLAY rows
  const [dragging, setDragging] = useState(false);
  const [editing, setEditing] = useState(null); // {rowKey, colId, r, c}
  const [editVal, setEditVal] = useState("");
  const [headEditing, setHeadEditing] = useState(null); // colId
  const [headVal, setHeadVal] = useState("");
  const [copied, setCopied] = useState("");
  const [scrollTop, setScrollTop] = useState(0);
  const [viewportH, setViewportH] = useState(480);
  const [rowH, setRowH] = useState(38);
  const [colWidths, setColWidths] = useState(null);
  // ----- V7 Batch B state -----
  const [pinned, setPinned] = useState(0);        // freeze the first N data columns
  const [statsPop, setStatsPop] = useState(null); // {colId, x, y} column-stats popover
  const [copyMenu, setCopyMenu] = useState(false);
  const dragColRef = useRef(null);                // display index of the header being dragged
  const [dragOverCol, setDragOverCol] = useState(null);
  const scrollRef = useRef(null);
  const firstRowRef = useRef(null);
  const headRef = useRef(null);
  const editInputRef = useRef(null);

  // V6 workspace wiring: handoffs from other tools land here; the palette can
  // open workspace files into the grid; "send to" exposes the edited CSV.
  useToolFile(
    (csv, name) => loadCSVText(csv, name),
    () => (prof ? { csv: materializeCSV(), name: base() + ".csv" } : null)
  );

  function resetAll() {
    setProf(null); setError(""); setProgress(null); setPendingSheets(null);
    setColumns([]); setEdits(new Map()); setDeleted(new Set()); setAdded([]);
    setUndoStack([]); setRedoStack([]); setSort(null); setQuery(""); setSel(null);
    setEditing(null); setHeadEditing(null); setColWidths(null); setScrollTop(0);
    setPinned(0); setStatsPop(null); setCopyMenu(false); setDragOverCol(null);
    addSeq.current = 0; colSeq.current = 0; dragColRef.current = null;
  }

  function loadCSVText(text, name) {
    setError("");
    setProgressLabel("Parsing your file");
    setProgress(0);
    CSVTool.parseCSVAsync(text, p => setProgress(p)).then(p => {
      setProgress(null);
      // A header-only CSV (0 data rows) is valid in the editor — you load a typed
      // schema then click + Row. Only the read-only viewer needs data rows.
      if (!p || !p.headers.length || (!editable && !p.rows.length)) { setError("Couldn't read that file — is it a valid CSV with a header row?"); return; }
      setProf(p);
      colSigRef.current = p.cols.map((c, i) => "c" + i).join();
      setColumns(p.cols.map((c, i) => ({ id: "c" + i, name: c.name, src: c.name, type: c.type })));
      setFilename(name || "data.csv");
      wsMaybeSave(name || "data.csv", text);
      setEdits(new Map()); setDeleted(new Set()); setAdded([]); setUndoStack([]); setRedoStack([]);
      setSort(null); setQuery(""); setSel(null); setColWidths(null); setScrollTop(0);
      setPinned(0); setStatsPop(null); setCopyMenu(false);
      if (scrollRef.current) scrollRef.current.scrollTop = 0;
    }).catch(e => { setProgress(null); console.error(e); setError("Something went wrong parsing that file."); });
  }

  function handleXLSXBuffer(buf, name) {
    try {
      const { sheets } = CSVTool.parseXLSXBuffer(buf);
      if (!sheets.length) { setError("That workbook didn't have any rows we could read."); return; }
      if (sheets.length === 1) { loadCSVText(sheets[0].csvText, name); return; }
      setPendingSheets({ sheets, filename: name });
    } catch (e) { console.error(e); setError("Couldn't read that Excel file. If it's password-protected, export to CSV instead."); }
  }

  function handleFile(f) {
    setError("");
    if (f === "sample") {
      if (cfg.bigDemo) {
        // Generate-then-parse demo for /open-large-csv: a real multi-MB file,
        // synthesized locally in chunks, then parsed off-thread — both phases
        // report live progress.
        setProgressLabel("Generating " + fmtNum(cfg.bigDemo) + " rows");
        setProgress(0.01);
        edGenerateBigCSV(cfg.bigDemo, p => setProgress(p))
          .then(csv => loadCSVText(csv, "demo-" + cfg.bigDemo + "-rows.csv"))
          .catch(() => { setProgress(null); setError("Demo generation failed — try a smaller file."); });
        return;
      }
      const samples = CSVTool.SAMPLES || {};
      const s = (CONFIG.sampleCsv ? { csv: CONFIG.sampleCsv, name: CONFIG.sampleName || "sample.csv" } : null) || samples[CONFIG.sampleKey] || samples.sales;
      loadCSVText(s.csv, s.name);
      return;
    }
    if (f.size > 250 * 1024 * 1024) { setError("That file is over 250 MB — beyond what a browser tab holds comfortably. Split it first (try /csv-split)."); return; }
    setFilename(f.name);
    const name = f.name || "";
    const isXLSX = /\.(xlsx|xls)$/i.test(name);
    const isParquet = /\.parquet$/i.test(name);
    const isJSON = /\.(json|ndjson)$/i.test(name);
    const reader = new FileReader();
    reader.onerror = () => setError("Could not read that file.");
    if (isXLSX) {
      reader.onload = e => ensureXLSX().then(() => handleXLSXBuffer(e.target.result, f.name)).catch(err => setError(err.message));
      reader.readAsArrayBuffer(f);
    } else if (isParquet) {
      setProgressLabel("Reading Parquet");
      setProgress(0.05);
      reader.onload = e => {
        edParquetToCSV(e.target.result)
          .then(csv => loadCSVText(csv, f.name))
          .catch(err => { setProgress(null); console.error(err); setError(err.message || "Couldn't read that Parquet file."); });
      };
      reader.readAsArrayBuffer(f);
    } else if (isJSON) {
      reader.onload = e => {
        const text = e.target.result;
        const looksND = /^\s*\{/.test(text) && /\}\s*\n\s*\{/.test(text);
        const done = () => {
          try {
            const csv = looksND && Convert.ndjsonToCSV ? Convert.ndjsonToCSV(text) : Convert.jsonToCSV(text);
            loadCSVText(csv, f.name);
          } catch (err) { setError(err.message || "Couldn't read that JSON."); }
        };
        // ndjsonToCSV lives in the lazy convert-extra chunk; load it before an
        // NDJSON/JSONL open. Plain JSON uses in-bundle jsonToCSV (no chunk).
        if (looksND) ensureConvertExtra().then(done).catch(() => setError("Could not load the converter."));
        else done();
      };
      reader.readAsText(f);
    } else {
      reader.onload = e => loadCSVText(e.target.result, f.name);
      reader.readAsText(f);
    }
  }

  // ===== derived rows =====
  const cellVal = (rowKey, col, row) => {
    const k = edCellKey(rowKey, col.id);
    if (edits.has(k)) return edits.get(k);
    return col.src && row ? (row[col.src] != null ? row[col.src] : "") : "";
  };

  const baseRows = useMemo(() => {
    if (!prof) return [];
    const out = [];
    for (let i = 0; i < prof.rows.length; i++) if (!deleted.has(i)) out.push({ key: i, r: prof.rows[i] });
    for (const k of added) if (!deleted.has(k)) out.push({ key: k, r: null });
    return out;
  }, [prof, deleted, added]);

  const filtered = useMemo(() => {
    if (!debouncedQuery) return baseRows;
    const q = debouncedQuery;
    return baseRows.filter(({ key, r }) => {
      for (const col of columns) {
        const v = cellVal(key, col, r);
        if (v !== "" && String(v).toLowerCase().indexOf(q) !== -1) return true;
      }
      return false;
    });
  }, [baseRows, debouncedQuery, columns, edits]);

  const shown = useMemo(() => {
    if (!sort) return filtered;
    const col = columns.find(c => c.id === sort.id);
    if (!col) return filtered;
    const dir = sort.dir === "asc" ? 1 : -1;
    const arr = filtered.slice();
    if (col.type === "number") {
      arr.sort((a, b) => {
        const va = CSVTool.parseNumber(cellVal(a.key, col, a.r)), vb = CSVTool.parseNumber(cellVal(b.key, col, b.r));
        if (va === null && vb === null) return 0;
        if (va === null) return 1;
        if (vb === null) return -1;
        return (va - vb) * dir;
      });
    } else {
      arr.sort((a, b) => String(cellVal(a.key, col, a.r)).localeCompare(String(cellVal(b.key, col, b.r))) * dir);
    }
    return arr;
  }, [filtered, sort, columns, edits]);

  const totalRows = shown.length;
  const totalCols = columns.length;
  const liveRowCount = baseRows.length;

  // ===== virtualization window (same technique as the dashboard DataTable) =====
  const OVERSCAN = 8;
  const visibleCount = Math.max(1, Math.ceil(viewportH / rowH)) + OVERSCAN * 2;
  const winStart = Math.max(0, Math.floor(scrollTop / rowH) - OVERSCAN);
  const winEnd = Math.min(totalRows, winStart + visibleCount);
  const windowRows = shown.slice(winStart, winEnd);
  const padTop = winStart * rowH;
  const padBottom = Math.max(0, (totalRows - winEnd) * rowH);

  React.useLayoutEffect(() => {
    const sc = scrollRef.current;
    if (sc) { const vh = sc.clientHeight; if (vh && Math.abs(vh - viewportH) > 1) setViewportH(vh); }
    const fr = firstRowRef.current;
    if (fr) { const h = fr.offsetHeight; if (h && Math.abs(h - rowH) > 0.5) setRowH(h); }
  });
  const colsSig = useMemo(() => columns.map(c => c.id + ":" + c.name).join("|"), [columns]);
  React.useLayoutEffect(() => { setColWidths(null); }, [colsSig]);
  React.useLayoutEffect(() => {
    if (colWidths !== null) return;
    const head = headRef.current;
    if (!head) return;
    const ths = head.querySelectorAll("th");
    if (!ths.length) return;
    setColWidths(Array.from(ths).map(th => Math.ceil(th.getBoundingClientRect().width)));
  });
  useEffect(() => { if (editing && editInputRef.current) editInputRef.current.focus(); }, [editing]);

  // ===== history =====
  function applyOp(op, forward) {
    if (op.t === "cells") {
      setEdits(m => {
        const n = new Map(m);
        for (const it of op.items) {
          const has = forward ? it.nextHas : it.prevHas;
          const val = forward ? it.next : it.prev;
          if (has) n.set(it.ek, val); else n.delete(it.ek);
        }
        return n;
      });
    } else if (op.t === "delRows") {
      setDeleted(d => { const n = new Set(d); for (const k of op.keys) { if (forward) n.add(k); else n.delete(k); } return n; });
      setSel(null);
    } else if (op.t === "addRow") {
      setAdded(a => forward ? a.concat([op.key]) : a.filter(k => k !== op.key));
      setSel(null);
    } else if (op.t === "addCol") {
      setColumns(cs => forward ? cs.concat([op.col]) : cs.filter(c => c.id !== op.col.id));
      setSel(null);
    } else if (op.t === "delCol") {
      setColumns(cs => {
        if (forward) return cs.filter(c => c.id !== op.col.id);
        const n = cs.slice(); n.splice(Math.min(op.at, n.length), 0, op.col); return n;
      });
      setSel(null);
    } else if (op.t === "renameCol") {
      setColumns(cs => cs.map(c => c.id === op.id ? { ...c, name: forward ? op.next : op.prev } : c));
    } else if (op.t === "moveCol") {
      setColumns(cs => {
        const from = forward ? op.from : op.to, to = forward ? op.to : op.from;
        if (from < 0 || from >= cs.length || to < 0 || to >= cs.length) return cs;
        const n = cs.slice(); const [c] = n.splice(from, 1); n.splice(to, 0, c); return n;
      });
      setSel(null);
    }
  }
  function pushOp(op) {
    applyOp(op, true);
    setUndoStack(s => s.length >= 500 ? s.slice(1).concat([op]) : s.concat([op]));
    setRedoStack([]);
  }
  function undo() { setUndoStack(s => { if (!s.length) return s; const op = s[s.length - 1]; applyOp(op, false); setRedoStack(r => r.concat([op])); return s.slice(0, -1); }); }
  function redo() { setRedoStack(s => { if (!s.length) return s; const op = s[s.length - 1]; applyOp(op, true); setUndoStack(u => u.concat([op])); return s.slice(0, -1); }); }

  // One cell-change item; normalizes "set back to original" into deleting the overlay key.
  function cellChangeItem(rowKey, col, row, next) {
    const ek = edCellKey(rowKey, col.id);
    const prevHas = edits.has(ek), prev = prevHas ? edits.get(ek) : undefined;
    const orig = col.src && row ? (row[col.src] != null ? row[col.src] : "") : "";
    const nextHas = !(String(next) === String(orig) && col.src && row);
    const cur = prevHas ? prev : orig;
    if (String(cur) === String(next)) return null; // no-op
    return { ek, prevHas, prev, nextHas, next };
  }

  // ===== selection =====
  const rect = sel ? {
    r0: Math.min(sel.anchor.r, sel.head.r), r1: Math.max(sel.anchor.r, sel.head.r),
    c0: Math.min(sel.anchor.c, sel.head.c), c1: Math.max(sel.anchor.c, sel.head.c)
  } : null;
  function inSel(r, c) { return rect && r >= rect.r0 && r <= rect.r1 && c >= rect.c0 && c <= rect.c1; }
  function pickCell(r, c, extend) {
    if (extend && sel) setSel({ anchor: sel.anchor, head: { r, c } });
    else setSel({ anchor: { r, c }, head: { r, c } });
  }
  function pickRow(r, extend) {
    if (extend && sel) setSel({ anchor: { r: sel.anchor.r, c: 0 }, head: { r, c: totalCols - 1 } });
    else setSel({ anchor: { r, c: 0 }, head: { r, c: totalCols - 1 } });
  }
  function pickColumn(c, extend) {
    if (extend && sel) setSel({ anchor: { r: 0, c: sel.anchor.c }, head: { r: totalRows - 1, c } });
    else setSel({ anchor: { r: 0, c }, head: { r: totalRows - 1, c } });
  }

  function copySelection() {
    if (!rect) return;
    const lines = [];
    for (let i = rect.r0; i <= rect.r1; i++) {
      const item = shown[i];
      if (!item) continue;
      const cells = [];
      for (let j = rect.c0; j <= rect.c1; j++) {
        const s = String(cellVal(item.key, columns[j], item.r));
        cells.push(/[\t\n"]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s);
      }
      lines.push(cells.join("\t"));
    }
    navigator.clipboard.writeText(lines.join("\n")).catch(() => {});
  }

  // ===== editing actions =====
  function startEdit(r, c, initial) {
    if (!editable) return;
    const item = shown[r];
    if (!item || !columns[c]) return;
    setEditing({ rowKey: item.key, colId: columns[c].id, r, c });
    setEditVal(initial != null ? initial : String(cellVal(item.key, columns[c], item.r)));
  }
  function commitEdit(move) {
    if (!editing) return;
    const col = columns.find(c => c.id === editing.colId);
    const item = shown[editing.r];
    const row = item && item.key === editing.rowKey ? item.r : (typeof editing.rowKey === "number" ? prof.rows[editing.rowKey] : null);
    if (col) {
      const it = cellChangeItem(editing.rowKey, col, row, editVal);
      if (it) pushOp({ t: "cells", items: [it] });
    }
    const { r, c } = editing;
    setEditing(null);
    if (move === "down" && r < totalRows - 1) pickCell(r + 1, c, false);
    else if (move === "right" && c < totalCols - 1) pickCell(r, c + 1, false);
    else if (move === "left" && c > 0) pickCell(r, c - 1, false);
    else pickCell(r, c, false);
    if (scrollRef.current) scrollRef.current.focus({ preventScroll: true });
  }
  function cancelEdit() {
    setEditing(null);
    if (scrollRef.current) scrollRef.current.focus({ preventScroll: true });
  }
  function clearSelectedCells() {
    if (!editable || !rect) return;
    const items = [];
    for (let i = rect.r0; i <= rect.r1; i++) {
      const item = shown[i];
      if (!item) continue;
      for (let j = rect.c0; j <= rect.c1; j++) {
        const it = cellChangeItem(item.key, columns[j], item.r, "");
        if (it) items.push(it);
      }
    }
    if (items.length) pushOp({ t: "cells", items });
  }
  // ===== find & replace (slice 2) =====
  // Everything flows through the edits overlay as ONE grouped op — a
  // 50,000-cell replace is a single Ctrl+Z away from undone.
  const [fr, setFr] = useState(null); // {find, replace, matchCase, wholeCell, regex, scope}
  const [frFlash, setFrFlash] = useState("");
  function frMatcher(f) {
    if (!f.find) return null;
    try {
      if (f.regex) {
        const re = new RegExp(f.wholeCell ? "^(?:" + f.find + ")$" : f.find, f.matchCase ? "g" : "gi");
        return {
          test: v => { re.lastIndex = 0; return re.test(v); },
          apply: v => v.replace((re.lastIndex = 0, re), f.replace)
        };
      }
      if (f.wholeCell) {
        const want = f.matchCase ? f.find : f.find.toLowerCase();
        return {
          test: v => (f.matchCase ? v : v.toLowerCase()) === want,
          apply: () => f.replace
        };
      }
      const esc = f.find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const re = new RegExp(esc, f.matchCase ? "g" : "gi");
      return {
        test: v => { re.lastIndex = 0; return re.test(v); },
        apply: v => v.replace((re.lastIndex = 0, re), f.replace.replace(/\$/g, "$$$$"))
      };
    } catch (e) { return { error: e.message }; }
  }
  const frTargets = () => {
    const colIdx = fr && fr.scope === "column" && sel ? [sel.head.c] : columns.map((_, i) => i);
    return colIdx.filter(i => columns[i]);
  };
  const frCount = useMemo(() => {
    if (!fr || !fr.find) return null;
    const m = frMatcher(fr);
    if (!m || m.error) return m && m.error ? { error: m.error } : null;
    let n = 0;
    const cols = frTargets();
    outer: for (const item of filtered) {
      for (const ci of cols) {
        const v = String(cellVal(item.key, columns[ci], item.r));
        if (v !== "" && m.test(v)) { n++; if (n >= 100000) break outer; }
      }
    }
    return { n };
  }, [fr, filtered, columns, edits, sel && fr && fr.scope === "column" ? sel.head.c : -1]);
  function frReplaceAll() {
    if (!fr || !fr.find) return;
    const m = frMatcher(fr);
    if (!m || m.error) return;
    const cols = frTargets();
    const items = [];
    for (const item of filtered) {
      for (const ci of cols) {
        const col = columns[ci];
        const v = String(cellVal(item.key, col, item.r));
        if (v === "" || !m.test(v)) continue;
        const next = m.apply(v);
        if (next === v) continue;
        const it = cellChangeItem(item.key, col, item.r, next);
        if (it) items.push(it);
        if (items.length > 200000) { setFrFlash("Over 200,000 replacements — narrow the scope or use the pipeline tool."); return; }
      }
    }
    if (items.length) {
      pushOp({ t: "cells", items });
      setFrFlash(items.length.toLocaleString() + " cell" + (items.length === 1 ? "" : "s") + " replaced — Ctrl+Z undoes all of it");
    } else setFrFlash("No matches.");
    setTimeout(() => setFrFlash(""), 4000);
  }

  function addRow() {
    if (!editable) return;
    if (query) setQuery(""); // a blank new row would be filtered out — clear the filter so it's visible
    const key = "a" + (addSeq.current++);
    pushOp({ t: "addRow", key });
    setSort(null);
    // Select the first cell of the new row (it lands at the end of the unsorted view)
    setTimeout(() => {
      const sc = scrollRef.current;
      if (sc) sc.scrollTop = sc.scrollHeight;
    }, 30);
  }
  function addColumn() {
    if (!editable) return;
    const id = "n" + (colSeq.current++);
    let n = columns.length + 1, name = "column_" + n;
    while (columns.some(c => c.name === name)) name = "column_" + (++n);
    pushOp({ t: "addCol", col: { id, name, src: null, type: "text" } });
  }
  function deleteSelectedRows() {
    if (!editable || !rect) return;
    const keys = [];
    for (let i = rect.r0; i <= rect.r1; i++) if (shown[i]) keys.push(shown[i].key);
    if (keys.length) pushOp({ t: "delRows", keys });
  }
  function deleteSelectedColumn() {
    if (!editable || !rect || columns.length <= 1) return;
    const col = columns[sel.head.c];
    if (!col) return;
    pushOp({ t: "delCol", col, at: sel.head.c });
  }
  // Fill the selection downward from its top row (Ctrl+D) — one grouped op.
  function fillDown() {
    if (!editable || !rect || rect.r1 <= rect.r0) return;
    const items = [];
    for (let j = rect.c0; j <= rect.c1; j++) {
      const col = columns[j];
      const top = shown[rect.r0];
      if (!col || !top) continue;
      const v = String(cellVal(top.key, col, top.r));
      for (let i = rect.r0 + 1; i <= rect.r1; i++) {
        const item = shown[i];
        if (!item) continue;
        const it = cellChangeItem(item.key, col, item.r, v);
        if (it) items.push(it);
      }
    }
    if (items.length) pushOp({ t: "cells", items });
  }

  // ===== V7 Batch B: frozen columns =====
  // Sticky offsets ride the measured header widths: colWidths[0] is the
  // row-number corner, colWidths[j+1] is data column j. The row-number column
  // is already sticky (.th-rownum), so pinned data columns start after it.
  const pinnedN = Math.min(pinned, totalCols);
  const pinLeft = useMemo(() => {
    if (!pinnedN || !colWidths) return null;
    const out = []; let acc = colWidths[0] || 0;
    for (let j = 0; j < pinnedN; j++) { out.push(acc); acc += colWidths[j + 1] || 0; }
    return out;
  }, [pinnedN, colWidths]);
  function pinStyle(j, header) {
    if (!pinLeft || j >= pinnedN) return null;
    return { position: "sticky", left: pinLeft[j], zIndex: header ? 2 : 1 };
  }
  function pinClass(j) {
    if (!pinLeft || j >= pinnedN) return "";
    return " ed-pinned" + (j === pinnedN - 1 ? " ed-pin-last" : "");
  }

  // ===== V7 Batch B: scroll a cell into view (shared by keyboard + find-nav) =====
  function scrollToCell(nr, nc) {
    const sc = scrollRef.current;
    if (!sc) return;
    const headH = headRef.current ? headRef.current.offsetHeight : 0;
    const top = nr * rowH, bottom = (nr + 1) * rowH;
    if (top < sc.scrollTop + headH) sc.scrollTop = Math.max(0, top - headH);
    else if (bottom > sc.scrollTop + sc.clientHeight) sc.scrollTop = bottom - sc.clientHeight;
    requestAnimationFrame(() => {
      const cell = sc.querySelector(`[data-edcell="${nr}-${nc}"]`);
      if (cell && cell.scrollIntoView) cell.scrollIntoView({ block: "nearest", inline: "nearest" });
    });
  }

  // ===== V7 Batch B: find navigation + replace-one =====
  // Walks the DISPLAY grid (current sort + filter) row-major from the selection,
  // wrapping once. No match list is materialized — 1M-row safe.
  function frFindNext(dir) {
    if (!fr || !fr.find || !totalRows) return;
    const m = frMatcher(fr);
    if (!m || m.error) return;
    const cols = frTargets();
    if (!cols.length) return;
    const nC = cols.length;
    const N = totalRows * nC;
    let startK = dir > 0 ? -1 : 0;
    if (sel) {
      const ciIdx = cols.indexOf(sel.head.c);
      startK = sel.head.r * nC + (ciIdx >= 0 ? ciIdx : (dir > 0 ? nC - 1 : 0));
    }
    for (let step = 1; step <= N; step++) {
      const k = ((startK + dir * step) % N + N) % N;
      const r = Math.floor(k / nC), ci = cols[k % nC];
      const item = shown[r];
      if (!item) continue;
      const v = String(cellVal(item.key, columns[ci], item.r));
      if (v !== "" && m.test(v)) { pickCell(r, ci, false); scrollToCell(r, ci); return; }
    }
    setFrFlash("No matches.");
    setTimeout(() => setFrFlash(""), 2000);
  }
  function frReplaceOne() {
    if (!editable || !fr || !fr.find) return;
    const m = frMatcher(fr);
    if (!m || m.error) return;
    const cols = frTargets();
    if (sel && cols.indexOf(sel.head.c) >= 0) {
      const item = shown[sel.head.r];
      const col = columns[sel.head.c];
      if (item && col) {
        const v = String(cellVal(item.key, col, item.r));
        if (v !== "" && m.test(v)) {
          const next = m.apply(v);
          if (next !== v) {
            const it = cellChangeItem(item.key, col, item.r, next);
            if (it) pushOp({ t: "cells", items: [it] });
          }
        }
      }
    }
    frFindNext(1);
  }

  // ===== V7 Batch B: column stats (computed on demand from the filtered view) =====
  const statsData = useMemo(() => {
    if (!statsPop) return null;
    const col = columns.find(c => c.id === statsPop.colId);
    if (!col) return null;
    const CAP = 200000;
    const rowsScanned = Math.min(filtered.length, CAP);
    let nonEmpty = 0, empty = 0, nNum = 0, sum = 0, min = Infinity, max = -Infinity;
    const distinct = new Set();
    for (let i = 0; i < rowsScanned; i++) {
      const item = filtered[i];
      const v = String(cellVal(item.key, col, item.r));
      if (v === "") { empty++; continue; }
      nonEmpty++;
      if (distinct.size <= 10000) distinct.add(v);
      if (col.type === "number") {
        const n = CSVTool.parseNumber(v);
        if (n != null && isFinite(n)) { nNum++; sum += n; if (n < min) min = n; if (n > max) max = n; }
      }
    }
    return {
      col, nonEmpty, empty,
      distinct: distinct.size, distinctCapped: distinct.size > 10000,
      isNum: nNum > 0, min, max, sum, avg: nNum ? sum / nNum : null,
      capped: filtered.length > CAP, rowsScanned
    };
  }, [statsPop, columns, filtered, edits]);

  // ===== V7 Batch B: copy selection as TSV / CSV / Markdown / JSON =====
  function selData() {
    if (!rect) return null;
    const cols = [];
    for (let j = rect.c0; j <= rect.c1; j++) if (columns[j]) cols.push(columns[j]);
    const rows = [];
    for (let i = rect.r0; i <= rect.r1; i++) if (shown[i]) rows.push(shown[i]);
    return cols.length && rows.length ? { cols, rows } : null;
  }
  function copySelectionAs(fmt) {
    setCopyMenu(false);
    const d = selData();
    if (!d) return;
    let text;
    if (fmt === "markdown") {
      const esc = s => String(s).replace(/\|/g, "\\|").replace(/\r?\n/g, " ");
      const lines = [
        "| " + d.cols.map(c => esc(c.name)).join(" | ") + " |",
        "| " + d.cols.map(c => c.type === "number" ? "---:" : "---").join(" | ") + " |"
      ];
      for (const item of d.rows) lines.push("| " + d.cols.map(c => esc(cellVal(item.key, c, item.r))).join(" | ") + " |");
      text = lines.join("\n");
    } else if (fmt === "json") {
      const arr = d.rows.map(item => {
        const o = {};
        for (const c of d.cols) {
          const v = String(cellVal(item.key, c, item.r));
          if (c.type === "number") { const n = v === "" ? null : CSVTool.parseNumber(v); o[c.name] = v === "" ? null : (n != null ? n : v); }
          else o[c.name] = v;
        }
        return o;
      });
      text = JSON.stringify(arr, null, 2);
    } else if (fmt === "csv") {
      const lines = [d.cols.map(c => edEscCSV(c.name)).join(",")];
      for (const item of d.rows) lines.push(d.cols.map(c => edEscCSV(cellVal(item.key, c, item.r))).join(","));
      text = lines.join("\n");
    } else { copySelection(); setCopied("sel"); setTimeout(() => setCopied(""), 1500); return; }
    navigator.clipboard.writeText(text).then(() => { setCopied("sel"); setTimeout(() => setCopied(""), 1500); }).catch(() => {});
  }

  // Close the copy menu / stats popover on outside click or Escape.
  useEffect(() => {
    if (!copyMenu && !statsPop) return;
    function onDoc(e) {
      if (copyMenu && !e.target.closest(".ed-copyas")) setCopyMenu(false);
      if (statsPop && !e.target.closest(".ed-stats-pop, .th-stats-mini")) setStatsPop(null);
    }
    function onKey(e) { if (e.key === "Escape") { setCopyMenu(false); setStatsPop(null); } }
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
  }, [copyMenu, statsPop]);

  function startHeadEdit(col) {
    if (!editable) return;
    setHeadEditing(col.id);
    setHeadVal(col.name);
  }
  function commitHeadEdit() {
    const col = columns.find(c => c.id === headEditing);
    setHeadEditing(null);
    if (!col) return;
    const next = headVal.trim();
    if (!next || next === col.name) return;
    pushOp({ t: "renameCol", id: col.id, prev: col.name, next });
  }

  // ===== keyboard =====
  useEffect(() => {
    function onKeyDown(e) {
      if (!scrollRef.current || editing || headEditing) return;
      const active = document.activeElement;
      const inGrid = scrollRef.current === active || scrollRef.current.contains(active);
      if (!inGrid) return;
      if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;
      const mod = e.ctrlKey || e.metaKey;

      if (mod && e.key.toLowerCase() === "z" && !e.shiftKey && editable) { e.preventDefault(); undo(); return; }
      if (((mod && e.key.toLowerCase() === "y") || (mod && e.shiftKey && e.key.toLowerCase() === "z")) && editable) { e.preventDefault(); redo(); return; }
      if (e.key === "Escape") { setSel(null); return; }
      if (mod && e.key.toLowerCase() === "a") { e.preventDefault(); setSel({ anchor: { r: 0, c: 0 }, head: { r: Math.max(0, totalRows - 1), c: Math.max(0, totalCols - 1) } }); return; }
      if (mod && e.key.toLowerCase() === "c") { if (sel) { e.preventDefault(); copySelection(); } return; }
      if (!sel) {
        if (e.key.startsWith("Arrow") || e.key === "Home" || e.key === "End") { e.preventDefault(); pickCell(0, 0, false); }
        return;
      }
      if (editable && (e.key === "Delete" || e.key === "Backspace")) { e.preventDefault(); clearSelectedCells(); return; }
      if (editable && mod && e.key.toLowerCase() === "d") { e.preventDefault(); fillDown(); return; }
      if (editable && (e.key === "Enter" || e.key === "F2")) { e.preventDefault(); startEdit(sel.head.r, sel.head.c); return; }
      // Type-to-edit: a printable character replaces the cell content
      if (editable && !mod && e.key.length === 1 && !e.altKey) { e.preventDefault(); startEdit(sel.head.r, sel.head.c, e.key); return; }

      const r = sel.head.r, c = sel.head.c;
      let nr = r, nc = c;
      if (e.key === "ArrowUp") nr = Math.max(0, mod ? 0 : r - 1);
      else if (e.key === "ArrowDown") nr = Math.min(totalRows - 1, mod ? totalRows - 1 : r + 1);
      else if (e.key === "ArrowLeft") nc = Math.max(0, mod ? 0 : c - 1);
      else if (e.key === "ArrowRight") nc = Math.min(totalCols - 1, mod ? totalCols - 1 : c + 1);
      else if (e.key === "Home") { nc = 0; if (mod) nr = 0; }
      else if (e.key === "End") { nc = totalCols - 1; if (mod) nr = totalRows - 1; }
      else if (e.key === "PageUp") nr = Math.max(0, r - 10);
      else if (e.key === "PageDown") nr = Math.min(totalRows - 1, r + 10);
      else if (e.key === "Tab") { e.preventDefault(); nc = Math.min(totalCols - 1, Math.max(0, c + (e.shiftKey ? -1 : 1))); }
      else return;
      e.preventDefault();
      pickCell(nr, nc, e.shiftKey && !mod && e.key !== "Tab");
      scrollToCell(nr, nc);
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [sel, editing, headEditing, totalRows, totalCols, columns, shown, edits, editable]);

  useEffect(() => {
    if (!dragging) return;
    function up() { setDragging(false); }
    window.addEventListener("mouseup", up);
    return () => window.removeEventListener("mouseup", up);
  }, [dragging]);

  // Paste a TSV range from the clipboard into the grid, anchored at the
  // selection's top-left — one grouped (undoable) op, clipped to the grid.
  useEffect(() => {
    function onPaste(e) {
      if (!editable || editing || headEditing || !sel) return;
      const sc = scrollRef.current;
      if (!sc) return;
      const active = document.activeElement;
      if (!(sc === active || sc.contains(active))) return;
      if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;
      const text = e.clipboardData && e.clipboardData.getData("text/plain");
      if (!text) return;
      const lines = text.replace(/\r/g, "").split("\n");
      while (lines.length && lines[lines.length - 1] === "") lines.pop();
      if (!lines.length) return;
      e.preventDefault();
      // The grid owns this paste — without this, App's global paste-to-dashboard
      // listener also fires and replaces the whole editor with a dashboard.
      e.stopImmediatePropagation();
      const grid = lines.map(l => l.split("\t"));
      const r0 = Math.min(sel.anchor.r, sel.head.r), c0 = Math.min(sel.anchor.c, sel.head.c);
      const items = [];
      for (let i = 0; i < grid.length && r0 + i < totalRows; i++) {
        const item = shown[r0 + i];
        if (!item) continue;
        for (let j = 0; j < grid[i].length && c0 + j < totalCols; j++) {
          const it = cellChangeItem(item.key, columns[c0 + j], item.r, grid[i][j]);
          if (it) items.push(it);
        }
      }
      if (items.length) pushOp({ t: "cells", items });
      setSel({ anchor: { r: r0, c: c0 }, head: { r: Math.min(totalRows - 1, r0 + grid.length - 1), c: Math.min(totalCols - 1, c0 + grid[0].length - 1) } });
    }
    window.addEventListener("paste", onPaste);
    return () => window.removeEventListener("paste", onPaste);
  }, [sel, editing, headEditing, shown, columns, edits, totalRows, totalCols, editable]);

  // ===== export =====
  function materializeCSV() {
    const lines = [columns.map(c => edEscCSV(c.name)).join(",")];
    const pushRow = (key, row) => {
      const cells = new Array(columns.length);
      for (let j = 0; j < columns.length; j++) cells[j] = edEscCSV(cellVal(key, columns[j], row));
      lines.push(cells.join(","));
    };
    for (let i = 0; i < prof.rows.length; i++) if (!deleted.has(i)) pushRow(i, prof.rows[i]);
    for (const k of added) if (!deleted.has(k)) pushRow(k, null);
    return lines.join("\n");
  }
  function base() { return String(filename).replace(/\.[^.]+$/, "") || "data"; }
  function downloadCSV() {
    const blob = new Blob([materializeCSV()], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = base() + (isModified ? "-edited" : "") + ".csv";
    document.body.appendChild(a); a.click(); setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(a.href); }, 800);
    setCopied("dl"); setTimeout(() => setCopied(""), 1500);
  }
  function downloadXLSX() {
    const csv = materializeCSV();
    ensureXLSX().then(() => {
      const p = CSVTool.profile(CSVTool.parseCSV(csv));
      Convert.download(Convert.csvToExcel(p), base() + (isModified ? "-edited" : "") + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      setCopied("xl"); setTimeout(() => setCopied(""), 1500);
    }).catch(() => setError("Could not load the Excel engine."));
  }
  function copyCSV() {
    navigator.clipboard.writeText(materializeCSV()).then(() => { setCopied("csv"); setTimeout(() => setCopied(""), 1500); }).catch(() => {});
  }

  const isModified = edits.size > 0 || deleted.size > 0 || added.length > 0 || columns.some(c => !c.src || c.name !== c.src) || columns.map(c => c.id).join() !== colSigRef.current;

  // ===== render =====
  if (!prof) {
    return (
      <div className="editor-shell">
        {pendingSheets && (
          <SheetPicker sheets={pendingSheets.sheets} filename={pendingSheets.filename}
            onPick={s => { loadCSVText(s.csvText, pendingSheets.filename + " · " + s.name); setPendingSheets(null); }}
            onCancel={() => setPendingSheets(null)} />
        )}
        <DropZone onFile={handleFile} error={error} />
        <WorkspaceStrip onOpen={r => loadCSVText(r.csv, r.name)} />
        {progress !== null && (
          <div className="parse-progress" role="status" aria-live="polite">
            <div className="parse-progress-label">{progressLabel} · {Math.round(progress * 100)}%</div>
            <div className="parse-progress-track"><div className="parse-progress-bar" style={{ width: Math.max(3, Math.round(progress * 100)) + "%" }} /></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="editor-shell">
      <div className="editor-toolbar">
        <div className="editor-toolbar-group">
          {editable && (
            <>
              <button className="ed-btn" onClick={addRow} title="Append an empty row">+ Row</button>
              <button className="ed-btn" onClick={addColumn} title="Append an empty column">+ Column</button>
              <button className="ed-btn" disabled={!rect} onClick={deleteSelectedRows} title="Delete the selected row(s)">Delete row{rect && rect.r1 > rect.r0 ? "s" : ""}</button>
              <button className="ed-btn" disabled={!rect || columns.length <= 1} onClick={deleteSelectedColumn} title="Delete the selected column">Delete column</button>
              <span className="ed-sep" aria-hidden="true" />
              <button className="ed-btn" disabled={!undoStack.length} onClick={undo} title="Undo (Ctrl+Z)">↩ Undo</button>
              <button className="ed-btn" disabled={!redoStack.length} onClick={redo} title="Redo (Ctrl+Y)">↪ Redo</button>
              <button className={"ed-btn" + (fr ? " primary" : "")} onClick={() => setFr(f => f ? null : { find: "", replace: "", matchCase: false, wholeCell: false, regex: false, scope: "all" })} title="Find & replace across the file">⌕ Replace</button>
            </>
          )}
          <div className="ed-copyas">
            <button className="ed-btn" disabled={!rect} onClick={() => setCopyMenu(m => !m)} title="Copy the selected cells as…" aria-haspopup="menu" aria-expanded={!!copyMenu}>{copied === "sel" ? "Copied ✓" : "Copy as ▾"}</button>
            {copyMenu && rect && (
              <div className="ed-copy-menu" role="menu">
                <button role="menuitem" onClick={() => copySelectionAs("tsv")}>TSV — pastes into Excel</button>
                <button role="menuitem" onClick={() => copySelectionAs("csv")}>CSV</button>
                <button role="menuitem" onClick={() => copySelectionAs("markdown")}>Markdown table</button>
                <button role="menuitem" onClick={() => copySelectionAs("json")}>JSON</button>
              </div>
            )}
          </div>
          <select className="ed-pin" value={pinned} onChange={e => setPinned(+e.target.value)} title="Keep the first columns visible while scrolling sideways" aria-label="Freeze columns">
            <option value={0}>No freeze</option>
            <option value={1}>Freeze 1 col</option>
            <option value={2}>Freeze 2 cols</option>
            <option value={3}>Freeze 3 cols</option>
          </select>
          <input className="ed-search" type="search" placeholder={"Filter " + fmtNum(liveRowCount) + " rows…"} value={query} onChange={e => setQuery(e.target.value)} aria-label="Filter rows" />
        </div>
        <div className="editor-toolbar-group">
          <button className="ed-btn primary" onClick={downloadCSV}>{copied === "dl" ? "Saved ✓" : "Download CSV"}</button>
          <button className="ed-btn" onClick={downloadXLSX}>{copied === "xl" ? "Saved ✓" : ".xlsx"}</button>
          <button className="ed-btn" onClick={copyCSV}>{copied === "csv" ? "Copied ✓" : "Copy"}</button>
          <SendToMenu getPayload={() => ({ csv: materializeCSV(), name: base() + ".csv" })} onError={msg => setError(msg)} />
          <button className="ed-btn ghost" onClick={resetAll} title="Close this file">✕ {String(filename).length > 22 ? String(filename).slice(0, 20) + "…" : filename}</button>
        </div>
      </div>

      {error && <div className="conv-err" role="alert">{error}</div>}

      {editable && fr && (
        <div className="ed-fr" role="search">
          <input className="ed-fr-input" placeholder="Find…" value={fr.find} autoFocus
            onChange={e => setFr(f => ({ ...f, find: e.target.value }))} aria-label="Find" />
          <input className="ed-fr-input" placeholder="Replace with…" value={fr.replace}
            onChange={e => setFr(f => ({ ...f, replace: e.target.value }))} aria-label="Replace with" />
          <label className="ed-fr-opt"><input type="checkbox" checked={fr.matchCase} onChange={e => setFr(f => ({ ...f, matchCase: e.target.checked }))} /> Match case</label>
          <label className="ed-fr-opt"><input type="checkbox" checked={fr.wholeCell} onChange={e => setFr(f => ({ ...f, wholeCell: e.target.checked }))} /> Whole cell</label>
          <label className="ed-fr-opt"><input type="checkbox" checked={fr.regex} onChange={e => setFr(f => ({ ...f, regex: e.target.checked }))} /> Regex</label>
          <select className="ed-fr-scope" value={fr.scope} onChange={e => setFr(f => ({ ...f, scope: e.target.value }))} aria-label="Scope">
            <option value="all">All columns</option>
            <option value="column" disabled={!sel}>Selected column{sel ? " (" + (columns[sel.head.c] || {}).name + ")" : ""}</option>
          </select>
          <span className="ed-fr-count">
            {frCount && frCount.error ? "Bad pattern" : frCount ? (frCount.n >= 100000 ? "100,000+" : frCount.n.toLocaleString()) + " match" + (frCount.n === 1 ? "" : "es") : ""}
          </span>
          <button className="ed-btn" disabled={!fr.find || !frCount || frCount.error || !frCount.n} onClick={() => frFindNext(-1)} title="Previous match">↑</button>
          <button className="ed-btn" disabled={!fr.find || !frCount || frCount.error || !frCount.n} onClick={() => frFindNext(1)} title="Next match">↓</button>
          <button className="ed-btn" disabled={!fr.find || !frCount || frCount.error || !frCount.n} onClick={frReplaceOne} title="Replace the current match, then jump to the next">Replace</button>
          <button className="ed-btn primary" disabled={!fr.find || !frCount || frCount.error || !frCount.n} onClick={frReplaceAll}>Replace all</button>
          {frFlash && <span className="ed-fr-flash">{frFlash}</span>}
        </div>
      )}

      <div ref={scrollRef} className="table-scroll editor-scroll" tabIndex={0}
        onScroll={e => { setScrollTop(e.currentTarget.scrollTop); if (statsPop) setStatsPop(null); }}
        aria-label={editable ? "Editable data grid — double-click a cell to edit" : "Data grid"}>
        <table className={"data data-selectable" + (dragging ? " dragging" : "")} style={{ tableLayout: colWidths ? "fixed" : "auto" }}>
          {colWidths && <colgroup>{colWidths.map((w, j) => <col key={j} style={{ width: w }} />)}</colgroup>}
          <thead ref={headRef}>
            <tr>
              <th className="th-corner" onClick={() => setSel({ anchor: { r: 0, c: 0 }, head: { r: Math.max(0, totalRows - 1), c: Math.max(0, totalCols - 1) } })} title="Select all">⌧</th>
              {columns.map((c, j) => {
                const colSelected = rect && rect.c0 <= j && j <= rect.c1;
                return (
                  <th key={c.id} className={"th-col" + (colSelected ? " selected" : "") + pinClass(j) + (dragOverCol === j ? " ed-drag-over" : "")}
                    style={pinStyle(j, true)}
                    aria-sort={sort && sort.id === c.id ? (sort.dir === "asc" ? "ascending" : "descending") : undefined}
                    draggable={headEditing !== c.id}
                    onDragStart={e => { dragColRef.current = j; e.dataTransfer.effectAllowed = "move"; try { e.dataTransfer.setData("text/plain", c.name); } catch (err) {} }}
                    onDragOver={e => { if (dragColRef.current != null && dragColRef.current !== j) { e.preventDefault(); e.dataTransfer.dropEffect = "move"; if (dragOverCol !== j) setDragOverCol(j); } }}
                    onDragLeave={() => setDragOverCol(d => (d === j ? null : d))}
                    onDrop={e => { e.preventDefault(); const from = dragColRef.current; dragColRef.current = null; setDragOverCol(null); if (from != null && from !== j) pushOp({ t: "moveCol", from, to: j }); }}
                    onDragEnd={() => { dragColRef.current = null; setDragOverCol(null); }}
                    onClick={(e) => { if (!e.target.closest(".th-sort-mini, .th-stats-mini, .ed-head-input")) pickColumn(j, e.shiftKey); }}
                    onDoubleClick={() => startHeadEdit(c)}>
                    {headEditing === c.id ? (
                      <input className="ed-head-input" autoFocus value={headVal} aria-label="Rename column"
                        onChange={e => setHeadVal(e.target.value)}
                        onBlur={commitHeadEdit}
                        onKeyDown={e => { if (e.key === "Enter") commitHeadEdit(); else if (e.key === "Escape") setHeadEditing(null); e.stopPropagation(); }} />
                    ) : (
                      <div className="th-grid">
                        <span className="th-name" title={(editable ? "Double-click to rename · drag to reorder" : "Drag to reorder · ") + (editable ? "" : c.name)}>{c.name}</span>
                        {editable && j > 0 && <button className="th-move-mini" onClick={(e) => { e.stopPropagation(); pushOp({ t: "moveCol", from: j, to: j - 1 }); }} title={"Move " + c.name + " left"} aria-label={"Move column " + c.name + " left"}>‹</button>}
                        {editable && j < columns.length - 1 && <button className="th-move-mini" onClick={(e) => { e.stopPropagation(); pushOp({ t: "moveCol", from: j, to: j + 1 }); }} title={"Move " + c.name + " right"} aria-label={"Move column " + c.name + " right"}>›</button>}
                        <button className="th-stats-mini" onClick={(e) => { e.stopPropagation(); const r = e.currentTarget.getBoundingClientRect(); setStatsPop(p => p && p.colId === c.id ? null : { colId: c.id, x: r.left, y: r.bottom }); }} title={"Column stats: " + c.name} aria-haspopup="dialog" aria-expanded={!!(statsPop && statsPop.colId === c.id)}>Σ</button>
                        <button className="th-sort-mini" onClick={(e) => { e.stopPropagation(); setSort(s => (!s || s.id !== c.id) ? { id: c.id, dir: "asc" } : s.dir === "asc" ? { id: c.id, dir: "desc" } : null); }} title={"Sort by " + c.name}>
                          {!sort || sort.id !== c.id ? "↕" : sort.dir === "asc" ? "↑" : "↓"}
                        </button>
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {padTop > 0 && <tr aria-hidden="true" style={{ height: padTop }}><td colSpan={totalCols + 1} style={{ padding: 0, border: 0 }} /></tr>}
            {windowRows.map((item, k) => {
              const ri = winStart + k;
              const rowSelected = rect && rect.r0 <= ri && ri <= rect.r1;
              const isAdded = typeof item.key === "string";
              return (
                <tr key={item.key} ref={k === 0 ? firstRowRef : null} className={isAdded ? "ed-added-row" : ""}>
                  <th className={"th-rownum" + (rowSelected ? " selected" : "")}
                    onClick={(e) => pickRow(ri, e.shiftKey)}
                    onMouseDown={(e) => { setDragging(true); pickRow(ri, e.shiftKey); }}
                    title={"Select row " + (ri + 1)}>
                    {ri + 1}
                  </th>
                  {columns.map((c, ci) => {
                    const isEditingCell = editing && editing.r === ri && editing.colId === c.id;
                    const ek = edCellKey(item.key, c.id);
                    const v = cellVal(item.key, c, item.r);
                    return (
                      <td key={c.id}
                        data-edcell={ri + "-" + ci}
                        style={pinStyle(ci, false)}
                        className={(c.type === "number" ? "num " : "") + (inSel(ri, ci) ? "selected " : "") + (sel && sel.head.r === ri && sel.head.c === ci ? "head " : "") + (edits.has(ek) ? "ed-edited " : "") + (isEditingCell ? "ed-editing" : "") + pinClass(ci)}
                        onMouseDown={(e) => {
                          if (isEditingCell) return;
                          e.preventDefault();
                          if (editing) commitEdit();
                          setDragging(true);
                          pickCell(ri, ci, e.shiftKey);
                          // preventScroll is load-bearing: focusing the scroll container
                          // mid-double-click otherwise scrolls the page, the table shifts
                          // under the cursor, and the second click lands on a different row.
                          scrollRef.current && scrollRef.current.focus({ preventScroll: true });
                        }}
                        onMouseEnter={() => { if (dragging) setSel(s => s ? { anchor: s.anchor, head: { r: ri, c: ci } } : s); }}
                        onDoubleClick={() => startEdit(ri, ci)}
                      >
                        {isEditingCell ? (
                          <input ref={editInputRef} className="ed-input" value={editVal} aria-label="Edit cell value"
                            onChange={e => setEditVal(e.target.value)}
                            onBlur={() => commitEdit()}
                            onKeyDown={e => {
                              if (e.key === "Enter") { e.preventDefault(); commitEdit("down"); }
                              else if (e.key === "Tab") { e.preventDefault(); commitEdit(e.shiftKey ? "left" : "right"); }
                              else if (e.key === "Escape") { e.preventDefault(); cancelEdit(); }
                              e.stopPropagation();
                            }} />
                        ) : (v === "" ? " " : String(v))}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            {padBottom > 0 && <tr aria-hidden="true" style={{ height: padBottom }}><td colSpan={totalCols + 1} style={{ padding: 0, border: 0 }} /></tr>}
          </tbody>
        </table>
      </div>

      {statsPop && statsData && (
        <div className="ed-stats-pop" role="dialog" aria-label={"Column stats: " + statsData.col.name}
          style={{ left: Math.max(8, Math.min(statsPop.x - 40, (window.innerWidth || 1200) - 248)), top: statsPop.y + 6 }}>
          <div className="ed-stats-title">
            <span>{statsData.col.name}</span>
            <button className="ed-stats-x" onClick={() => setStatsPop(null)} aria-label="Close">✕</button>
          </div>
          <div className="ed-stats-row"><span>filled</span><b>{fmtNum(statsData.nonEmpty)}</b></div>
          <div className="ed-stats-row"><span>empty</span><b>{fmtNum(statsData.empty)}</b></div>
          <div className="ed-stats-row"><span>distinct</span><b>{statsData.distinctCapped ? "10,000+" : fmtNum(statsData.distinct)}</b></div>
          {statsData.isNum && (
            <>
              <div className="ed-stats-row"><span>min</span><b>{fmtNum(statsData.min)}</b></div>
              <div className="ed-stats-row"><span>max</span><b>{fmtNum(statsData.max)}</b></div>
              <div className="ed-stats-row"><span>average</span><b>{fmtNum(statsData.avg)}</b></div>
              <div className="ed-stats-row"><span>sum</span><b>{fmtNum(statsData.sum)}</b></div>
            </>
          )}
          <div className="ed-stats-note">{statsData.capped ? "first " + fmtNum(statsData.rowsScanned) + " rows" : debouncedQuery ? "filtered rows" : "all rows"}</div>
        </div>
      )}

      <div className="editor-status">
        <span>{fmtNum(liveRowCount)} row{liveRowCount === 1 ? "" : "s"} × {totalCols} column{totalCols === 1 ? "" : "s"}{debouncedQuery ? ` · ${fmtNum(totalRows)} matching` : ""}</span>
        {editable && isModified && (
          <span className="editor-status-mod">
            {edits.size > 0 ? fmtNum(edits.size) + " edited cell" + (edits.size === 1 ? "" : "s") : ""}
            {edits.size > 0 && (deleted.size > 0 || added.length > 0) ? " · " : ""}
            {deleted.size > 0 ? fmtNum(deleted.size) + " deleted row" + (deleted.size === 1 ? "" : "s") : ""}
            {deleted.size > 0 && added.length > 0 ? " · " : ""}
            {added.length > 0 ? fmtNum(added.length) + " new row" + (added.length === 1 ? "" : "s") : ""}
          </span>
        )}
        {editable && !isModified && <span className="editor-status-hint">Double-click a cell to edit · Ctrl+D fills down · paste a range from your spreadsheet · Ctrl+Z undoes</span>}
        {!editable && <span className="editor-status-hint">Click a column header to sort · type in the filter box to search</span>}
      </div>
    </div>
  );
}


/* global React, CSVTool, Convert */
// V5 Batch A — the relational workbench: /csv-join, /csv-lookup, /csv-append.
// One shell (mode "join", window.JOIN_CONFIG = { tool: "join"|"lookup"|"append",
// sampleA:{name,csv}, sampleB:{name,csv}, samples:[{name,csv}…] }).
// Concatenated after tools5.jsx, before app.jsx — reuses ConverterInput /
// ensureXLSX / SheetPicker (converter.jsx), rowsToCSV (tools2.jsx),
// sendCSVToDashboard (charts.jsx), and the recent-files store (app.jsx,
// hoisted) as the opt-in workspace.
//
// Engines are pure JS (hash join) — instant, no 10 MB DuckDB download for the
// 99% case; the equivalent DuckDB SQL is displayed for anyone who wants to
// take the same operation to /csv-sql-query.

// ---------- engines ----------

// Multi-key hash join. opts: keys [{a,b}], joinType inner|left|right|full,
// bCols (B columns to carry over; default = all non-key), suffix for collisions.
Convert.joinCSV = function (profA, profB, opts) {
  opts = opts || {};
  const keys = (opts.keys && opts.keys.length ? opts.keys : [{ a: profA.cols[0].name, b: profB.cols[0].name }])
    .filter(k => k && k.a && k.b);
  if (!keys.length) throw new Error("Pick at least one key column on each side.");
  const joinType = opts.joinType || "inner";
  const SEP = "";
  const keyOf = (row, names) => names.map(n => String(row[n] == null ? "" : row[n])).join(SEP);
  const aNames = keys.map(k => k.a), bNames = keys.map(k => k.b);

  const aHeaders = profA.cols.map(c => c.name);
  const aSet = new Set(aHeaders);
  const bKeySet = new Set(bNames);
  const allBCols = profB.cols.map(c => c.name).filter(h => !bKeySet.has(h));
  const wanted = opts.bCols && opts.bCols.length ? allBCols.filter(h => opts.bCols.includes(h)) : allBCols;
  const suffix = opts.suffix || "_b";
  const bOut = wanted.map(h => ({ src: h, out: aSet.has(h) ? h + suffix : h }));
  const headers = aHeaders.concat(bOut.map(x => x.out));

  const bMap = new Map();
  for (const rb of profB.rows) {
    const k = keyOf(rb, bNames);
    if (!bMap.has(k)) bMap.set(k, []);
    bMap.get(k).push(rb);
  }

  const out = [];
  const matchedBKeys = new Set();
  let matchedA = 0;
  const CAP = 2000000;
  for (const ra of profA.rows) {
    const k = keyOf(ra, aNames);
    const bs = bMap.get(k);
    if (bs && bs.length) {
      matchedA++;
      matchedBKeys.add(k);
      for (const rb of bs) { // matched rows appear in every join type
        const o = { ...ra };
        for (const x of bOut) o[x.out] = rb[x.src];
        out.push(o);
      }
    } else if (joinType === "left" || joinType === "full") {
      const o = { ...ra };
      for (const x of bOut) o[x.out] = "";
      out.push(o);
    }
    if (out.length > CAP) throw new Error("Result exceeds 2,000,000 rows — your keys produce a many-to-many explosion. Add a second key column to make matches more specific.");
  }
  let unmatchedB = 0;
  if (joinType === "right" || joinType === "full") {
    for (const rb of profB.rows) {
      const k = keyOf(rb, bNames);
      if (!matchedBKeys.has(k)) {
        unmatchedB++;
        const o = {};
        for (const h of aHeaders) o[h] = "";
        keys.forEach((kp, i) => { o[kp.a] = rb[bNames[i]]; }); // carry the key through
        for (const x of bOut) o[x.out] = rb[x.src];
        out.push(o);
        if (out.length > CAP) throw new Error("Result exceeds 2,000,000 rows.");
      }
    }
  } else {
    for (const [k] of bMap) if (!matchedBKeys.has(k)) unmatchedB++;
  }

  const pct = profA.rows.length ? Math.round((matchedA / profA.rows.length) * 100) : 0;
  return {
    csv: rowsToCSV(headers, out), headers, rows: out,
    stats: {
      "A rows": profA.rows.length, "B rows": profB.rows.length,
      "matched A": matchedA + " (" + pct + "%)",
      "unmatched A": profA.rows.length - matchedA,
      "unmatched B keys": unmatchedB,
      "rows out": out.length
    }
  };
};

// Stack/UNION N files. opts: mode "union"|"common", addSource bool.
// Returns a per-file reconciliation report alongside the data.
Convert.appendCSV = function (items, opts) {
  opts = opts || {};
  if (!items || items.length < 2) throw new Error("Load at least two files to append.");
  const mode = opts.mode || "union";
  let headers;
  if (mode === "common") {
    headers = items[0].prof.cols.map(c => c.name).filter(h => items.every(it => it.prof.cols.some(c => c.name === h)));
    if (!headers.length) throw new Error("The files share no columns — nothing to stack in common-columns mode.");
  } else {
    headers = [];
    const seen = new Set();
    for (const it of items) for (const c of it.prof.cols) if (!seen.has(c.name)) { seen.add(c.name); headers.push(c.name); }
  }
  const SRC = "_source";
  const outHeaders = opts.addSource ? headers.concat([SRC]) : headers;
  const out = [];
  const report = [];
  for (const it of items) {
    const own = new Set(it.prof.cols.map(c => c.name));
    const missing = headers.filter(h => !own.has(h));
    const extra = mode === "common" ? it.prof.cols.map(c => c.name).filter(h => !headers.includes(h)) : [];
    for (const r of it.prof.rows) {
      const o = {};
      for (const h of headers) o[h] = own.has(h) ? (r[h] == null ? "" : r[h]) : "";
      if (opts.addSource) o[SRC] = it.name;
      out.push(o);
    }
    report.push({ name: it.name, rows: it.prof.rows.length, missing, dropped: extra });
  }
  return {
    csv: rowsToCSV(outHeaders, out), headers: outHeaders, rows: out, report,
    stats: { files: items.length, "rows out": out.length, columns: outHeaders.length, mode }
  };
};

// V5 Batch D, local slice — template-based natural language → SQL for the
// /csv-sql-query "ask in plain English" box. ENTIRELY local: a handful of
// question shapes + fuzzy column matching; the question never leaves the
// browser. (A schema-only BYO-key model variant remains unbuilt by design.)
Convert.nlToSQL = function (profile, q) {
  const cols = profile.cols.map(c => c.name);
  const norm = s => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "");
  const colMap = new Map(cols.map(c => [norm(c), c]));
  function findCol(phrase) {
    if (!phrase) return null;
    const n = norm(phrase);
    if (!n) return null;
    if (colMap.has(n)) return colMap.get(n);
    if (n.endsWith("s") && colMap.has(n.slice(0, -1))) return colMap.get(n.slice(0, -1));
    if (colMap.has(n + "s")) return colMap.get(n + "s");
    // Substring fallback — but a short column name must not claim a much longer
    // phrase ("region" must NOT match "amount by region" when amount is unknown).
    for (const [k, v] of colMap) {
      if (k.length >= 3 && k.includes(n)) return v;
      if (k.length >= 3 && n.includes(k) && k.length >= n.length * 0.6) return v;
    }
    return null;
  }
  const quote = c => (/^[A-Za-z_][A-Za-z0-9_]*$/.test(c) ? c : '"' + c + '"');
  const text = String(q || "").trim().toLowerCase().replace(/[?.!]+$/, "").replace(/\s+/g, " ");
  if (!text) return { error: "Type a question first." };
  let m;

  if (/^how many (rows|records|entries|items)( are there| do i have)?$/.test(text) || text === "how many rows") {
    return { sql: "SELECT COUNT(*) AS rows FROM csv" };
  }
  if ((m = text.match(/^(?:count|how many)(?: .*?)? (?:by|per|for each) (.+)$/))) {
    const g = findCol(m[1]);
    if (g) return { sql: `SELECT ${quote(g)}, COUNT(*) AS count FROM csv GROUP BY ${quote(g)} ORDER BY count DESC` };
  }
  if ((m = text.match(/^(?:top|biggest|largest|highest) (\d+) (.+?) by (.+)$/))) {
    const n = Math.max(1, parseInt(m[1], 10)), g = findCol(m[2]), v = findCol(m[3]);
    if (g && v && g !== v) return { sql: `SELECT ${quote(g)}, SUM(${quote(v)}) AS total FROM csv GROUP BY ${quote(g)} ORDER BY total DESC LIMIT ${n}` };
    if (v) return { sql: `SELECT * FROM csv ORDER BY ${quote(v)} DESC LIMIT ${n}` };
  }
  if ((m = text.match(/^(total|sum|average|avg|mean|max|maximum|min|minimum) (?:of )?(.+?) (?:by|per|for each) (.+)$/))) {
    const v = findCol(m[2]), g = findCol(m[3]);
    const fn = /avg|average|mean/.test(m[1]) ? "AVG" : /max/.test(m[1]) ? "MAX" : /min/.test(m[1]) ? "MIN" : "SUM";
    const alias = fn.toLowerCase() + "_" + (norm(m[2]) || "value");
    if (v && g) return { sql: `SELECT ${quote(g)}, ${fn}(${quote(v)}) AS ${alias} FROM csv GROUP BY ${quote(g)} ORDER BY ${alias} DESC` };
  }
  if ((m = text.match(/^(total|sum|average|avg|mean|max|maximum|min|minimum) (?:of )?(.+)$/))) {
    const v = findCol(m[2]);
    const fn = /avg|average|mean/.test(m[1]) ? "AVG" : /max/.test(m[1]) ? "MAX" : /min/.test(m[1]) ? "MIN" : "SUM";
    if (v) return { sql: `SELECT ${fn}(${quote(v)}) AS ${fn.toLowerCase()} FROM csv` };
  }
  if ((m = text.match(/^(?:show |list |find |get )?(?:rows? |records? |everything )?(?:where )?(.+?) (over|above|greater than|more than|under|below|less than|at least|at most|equals?|is|=) (.+)$/))) {
    const c = findCol(m[1]);
    if (c) {
      const op = /over|above|greater|more/.test(m[2]) ? ">" : /under|below|less/.test(m[2]) ? "<" : /at least/.test(m[2]) ? ">=" : /at most/.test(m[2]) ? "<=" : "=";
      let val = m[3].trim();
      if (val === "" || isNaN(parseFloat(val))) val = "'" + val.replace(/'/g, "") + "'";
      return { sql: `SELECT * FROM csv WHERE ${quote(c)} ${op} ${val}` };
    }
  }
  return { error: "Couldn't map that to SQL. Shapes that work: “total revenue by region” · “top 5 products by revenue” · “average units” · “count by channel” · “rows where revenue over 1000” · “how many rows”." };
};

// Equivalent DuckDB SQL for the join — shown for education + portability.
function joinEquivalentSQL(nameA, nameB, keys, joinType, bOut) {
  const jt = { inner: "JOIN", left: "LEFT JOIN", right: "RIGHT JOIN", full: "FULL OUTER JOIN" }[joinType] || "JOIN";
  const on = keys.map(k => `a."${k.a}" = b."${k.b}"`).join("\n   AND ");
  const bSel = bOut.map(x => x.out === x.src ? `b."${x.src}"` : `b."${x.src}" AS "${x.out}"`).join(", ");
  return `SELECT a.*${bSel ? ", " + bSel : ""}\nFROM '${nameA}.csv' a\n${jt} '${nameB}.csv' b\n  ON ${on};`;
}

// ---------- shell ----------

function JoinShell({ config }) {
  const cfg = config || {};
  const tool = cfg.tool || "join";
  const isAppend = tool === "append";
  const isLookup = tool === "lookup";

  // join/lookup: two slots; append: a list
  const [a, setA] = useState(null), [b, setB] = useState(null);
  const [items, setItems] = useState([]); // append: [{name, prof}]
  const [errA, setErrA] = useState(""), [errB, setErrB] = useState("");
  const [opts, setOpts] = useState({});
  const [copied, setCopied] = useState(false);
  const [showSQL, setShowSQL] = useState(false);
  const [recent, setRecent] = useState([]);

  // Workspace substrate: when "Remember recent files" is on (the dashboard's
  // opt-in IndexedDB store), every slot can pick from those files directly.
  useEffect(() => {
    let live = true;
    try {
      if (localStorage.getItem("csvtd-remember") === "1") {
        recentGetAll().then(r => { if (live && r && r.length) setRecent(r); }).catch(() => {});
      }
    } catch (e) { /* private mode */ }
    return () => { live = false; };
  }, []);

  function parse(text) {
    const p = CSVTool.parseCSV(text);
    if (!p.headers.length || !p.rows.length) throw new Error("That file needs a header row and at least one data row.");
    return CSVTool.profile(p);
  }
  function loadInto(which, text, name) {
    try {
      const prof = parse(text);
      const obj = { prof, name: String(name || "data").replace(/\.[^.]+$/, "") };
      if (which === "a") { setA(obj); setErrA(""); } else { setB(obj); setErrB(""); }
      wsMaybeSave(String(name || "data"), text);
    } catch (e) { (which === "a" ? setErrA : setErrB)(e.message); }
  }
  function fileInto(which, file) {
    if (!file) return;
    const reader = new FileReader();
    reader.onerror = () => (which === "a" ? setErrA : setErrB)("Could not read that file.");
    if (/\.(xlsx|xls)$/i.test(file.name || "")) {
      reader.onload = e => ensureXLSX().then(() => {
        try { const { sheets } = CSVTool.parseXLSXBuffer(e.target.result); if (sheets && sheets[0]) loadInto(which, sheets[0].csvText, file.name); }
        catch (err) { (which === "a" ? setErrA : setErrB)(err.message); }
      }).catch(() => (which === "a" ? setErrA : setErrB)("Could not load the Excel engine."));
      reader.readAsArrayBuffer(file);
    } else { reader.onload = e => loadInto(which, e.target.result, file.name); reader.readAsText(file); }
  }

  // ----- append: multi-file intake -----
  function addAppendFiles(fileList) {
    const files = Array.from(fileList || []);
    files.forEach(f => {
      const reader = new FileReader();
      reader.onload = e => {
        try {
          const prof = parse(e.target.result);
          setItems(list => list.concat([{ name: String(f.name || "data").replace(/\.[^.]+$/, ""), prof }]));
          setErrA("");
        } catch (err) { setErrA(f.name + ": " + err.message); }
      };
      reader.readAsText(f);
    });
  }
  function addAppendText(csv, name) {
    try {
      const prof = parse(csv);
      setItems(list => list.concat([{ name: String(name || "data").replace(/\.[^.]+$/, ""), prof }]));
      setErrA("");
      wsMaybeSave(String(name || "data"), csv);
    } catch (e) { setErrA(e.message); }
  }

  // default keys once both sides load: prefer shared column names
  useEffect(() => {
    if (isAppend || !a || !b) return;
    const aH = a.prof.cols.map(c => c.name), bH = b.prof.cols.map(c => c.name);
    const common = aH.filter(h => bH.includes(h));
    setOpts(o => {
      if (o.keys && o.keys.length) return o;
      const first = common[0] || aH[0];
      return { ...o, keys: [{ a: first, b: bH.includes(first) ? first : bH[0] }], joinType: o.joinType || (isLookup ? "left" : "inner") };
    });
  }, [a, b]);

  const result = useMemo(() => {
    try {
      if (isAppend) return items.length >= 2 ? Convert.appendCSV(items, { mode: opts.mode || "union", addSource: opts.addSource !== false }) : null;
      if (!a || !b) return null;
      return Convert.joinCSV(a.prof, b.prof, { keys: opts.keys, joinType: isLookup ? "left" : (opts.joinType || "inner"), bCols: opts.bCols });
    } catch (e) { return { error: e.message }; }
  }, [a, b, items, opts, tool]);

  // V6 workspace wiring: a handed-off CSV becomes side A (or an append item);
  // the joined/appended result is "the current file" for send-to/palette.
  useToolFile(
    (csv, name) => { if (isAppend) addAppendText(csv, name); else loadInto("a", csv, name); },
    () => (result && result.csv ? { csv: result.csv, name: (isAppend ? "appended" : (a ? a.name + "-" + tool : tool)) + ".csv" } : null)
  );

  const aH = a ? a.prof.cols.map(c => c.name) : [];
  const bH = b ? b.prof.cols.map(c => c.name) : [];
  const keys = opts.keys || [];
  const bKeyNames = new Set(keys.map(k => k.b));
  const bCarry = bH.filter(h => !bKeyNames.has(h));
  const chosenB = opts.bCols && opts.bCols.length ? opts.bCols : bCarry;

  function setKey(i, side, val) {
    setOpts(o => { const ks = (o.keys || []).slice(); ks[i] = { ...ks[i], [side]: val }; return { ...o, keys: ks }; });
  }
  function addKey() { setOpts(o => ({ ...o, keys: (o.keys || []).concat([{ a: aH[0] || "", b: bH[0] || "" }]) })); }
  function removeKey(i) { setOpts(o => ({ ...o, keys: o.keys.filter((_, j) => j !== i) })); }
  function toggleBCol(h) {
    setOpts(o => {
      const cur = o.bCols && o.bCols.length ? o.bCols.slice() : bCarry.slice();
      const i = cur.indexOf(h);
      if (i >= 0) cur.splice(i, 1); else cur.push(h);
      return { ...o, bCols: cur };
    });
  }

  function copyOut() { if (result && result.csv) navigator.clipboard.writeText(result.csv).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }).catch(() => {}); }
  function downloadOut() {
    if (!result || !result.csv) return;
    const blob = new Blob([result.csv], { type: "text/csv;charset=utf-8" });
    const el = document.createElement("a"); el.href = URL.createObjectURL(blob);
    el.download = (isAppend ? "appended" : (a ? a.name : "data") + "-" + tool) + ".csv";
    document.body.appendChild(el); el.click(); setTimeout(() => { document.body.removeChild(el); URL.revokeObjectURL(el.href); }, 800);
  }
  function downloadXLSX() {
    if (!result || !result.csv) return;
    ensureXLSX().then(() => {
      const p = CSVTool.profile(CSVTool.parseCSV(result.csv));
      Convert.download(Convert.csvToExcel(p), (isAppend ? "appended" : tool) + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }).catch(() => {});
  }
  function resetAll() { setA(null); setB(null); setItems([]); setOpts({}); setShowSQL(false); }

  const sql = (!isAppend && a && b && keys.length)
    ? joinEquivalentSQL(a.name, b.name, keys, isLookup ? "left" : (opts.joinType || "inner"),
        bCarry.filter(h => chosenB.includes(h)).map(h => ({ src: h, out: aH.includes(h) ? h + "_b" : h })))
    : "";

  function recentPicker(which) {
    if (!recent.length) return null;
    return (
      <select className="join-recent" value="" aria-label="Load a remembered file"
        onChange={e => {
          const r = recent.find(x => String(x.id) === e.target.value);
          if (!r) return;
          if (which === "items") addAppendText(r.csv, r.name); else loadInto(which, r.csv, r.name);
        }}>
        <option value="">…or pick a remembered file</option>
        {recent.map(r => <option key={r.id} value={r.id}>{r.name} ({r.rows.toLocaleString()} rows)</option>)}
      </select>
    );
  }

  function previewTable() {
    if (!result || !result.csv) return null;
    // Shared rich grid (resultgrid.jsx): caps rows itself, sortable headers,
    // aria-sort, and its own oversize fallback past RG_MAX_CHARS. join/lookup/
    // append aren't special-cased there, so they get the plain sortable grid.
    return (
      <div className="table-wrap join-preview">
        <ResultGrid csv={result.csv} toolType={tool} />
      </div>
    );
  }

  // ----- render -----
  if (isAppend) {
    const samples = cfg.samples || [];
    return (
      <div className="viz-shell">
        <div className="join-add">
          <label className="drop join-drop">
            <input type="file" accept=".csv,.tsv,.txt" multiple style={{ display: "none" }}
              onChange={e => { addAppendFiles(e.target.files); e.target.value = ""; }} />
            <div className="drop-title">{items.length ? "Add more files" : "Drop or choose the CSV files to stack"}</div>
            <div className="drop-sub">select multiple at once — same or similar columns</div>
            <span className="drop-btn" role="button">Choose files</span>
            {!items.length && samples.length >= 2 && (
              <div className="drop-or">no files handy?{" "}
                <button type="button" onClick={e => { e.preventDefault(); e.stopPropagation(); samples.forEach(s => addAppendText(s.csv, s.name)); }}>
                  try with two sample months
                </button>
              </div>
            )}
          </label>
          {recentPicker("items")}
          {errA && <div className="conv-err">{errA}</div>}
          {items.length > 0 && (
            <ul className="join-files">
              {items.map((it, i) => (
                <li key={i}>
                  <span className="join-file-name">{it.name}</span>
                  <span className="join-file-meta">{it.prof.rows.length.toLocaleString()} rows · {it.prof.cols.length} cols</span>
                  <button className="recent-item-x" onClick={() => setItems(list => list.filter((_, j) => j !== i))} aria-label={"Remove " + it.name}>×</button>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length >= 2 && (
          <div className="viz" style={{ marginTop: 18 }}>
            <div className="pivot-controls viz-controls">
              <label className="pivot-control"><span>Columns</span>
                <select value={opts.mode || "union"} onChange={e => setOpts(o => ({ ...o, mode: e.target.value }))}>
                  <option value="union">Union — keep every column, blank-fill gaps</option>
                  <option value="common">Common only — drop columns not in every file</option>
                </select>
              </label>
              <label className="pivot-control reshape-check"><span>Add a _source column</span>
                <input type="checkbox" checked={opts.addSource !== false} onChange={e => setOpts(o => ({ ...o, addSource: e.target.checked }))} />
              </label>
            </div>
            <div className="chart-card viz-card">
              <div className="chart-head">
                <div className="chart-title">Stacked result</div>
                <div className="chart-kind">append</div>
              </div>
              <div className="viz-canvas devtool-canvas">
                {result && result.error ? <div className="conv-err">{result.error}</div> : (
                  <>
                    {result && result.stats && <div className="conv-stats">{Object.entries(result.stats).map(([k, v]) => <span key={k}><span className="conv-stats-label">{k}</span> {String(v)}</span>)}</div>}
                    {result && result.report && (
                      <ul className="join-report">
                        {result.report.map((r, i) => (
                          <li key={i}>
                            <strong>{r.name}</strong> — {r.rows.toLocaleString()} rows
                            {r.missing.length > 0 && <span className="join-report-warn"> · blank-filled: {r.missing.join(", ")}</span>}
                            {r.dropped.length > 0 && <span className="join-report-warn"> · dropped: {r.dropped.join(", ")}</span>}
                            {!r.missing.length && !r.dropped.length && <span className="join-report-ok"> · columns aligned ✓</span>}
                          </li>
                        ))}
                      </ul>
                    )}
                    {previewTable()}
                  </>
                )}
              </div>
            </div>
            <div className="viz-actions">
              <button className="btn-ghost" onClick={downloadOut}>Download CSV</button>
              <button className="btn-ghost" onClick={downloadXLSX}>Download .xlsx</button>
              <button className="btn-ghost" onClick={copyOut}>{copied ? "Copied!" : "Copy CSV"}</button>
              <SendToMenu getPayload={() => (result && result.csv ? { csv: result.csv, name: (isAppend ? "appended" : tool) + ".csv" } : null)} onError={msg => setErrA(msg)} />
              <button className="btn-ghost" onClick={resetAll}>Reset</button>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="viz-shell">
      <div className="dual-inputs">
        <div className="dual-pane">
          <div className="dual-label">{isLookup ? "Your main file" : "Dataset A"} {a && <span className="dual-meta">{a.prof.rows.length.toLocaleString()} rows · {a.prof.cols.length} cols</span>}</div>
          <ConverterInput label={isLookup ? "Drop the file that needs extra columns" : "Drop CSV / XLSX (A)"} inputFormat="csv" accept=".csv,.tsv,.txt,.xlsx,.xls,text/csv"
            onFile={f => fileInto("a", f)} onPasteText={t => loadInto("a", t, "A")}
            onLoadSample={() => cfg.sampleA && loadInto("a", cfg.sampleA.csv, cfg.sampleA.name)} loaded={!!a} onClear={() => setA(null)} />
          {recentPicker("a")}
          {errA && <div className="conv-err">{errA}</div>}
        </div>
        <div className="dual-pane">
          <div className="dual-label">{isLookup ? "Lookup table" : "Dataset B"} {b && <span className="dual-meta">{b.prof.rows.length.toLocaleString()} rows · {b.prof.cols.length} cols</span>}</div>
          <ConverterInput label={isLookup ? "Drop the file holding the values to bring over" : "Drop CSV / XLSX (B)"} inputFormat="csv" accept=".csv,.tsv,.txt,.xlsx,.xls,text/csv"
            onFile={f => fileInto("b", f)} onPasteText={t => loadInto("b", t, "B")}
            onLoadSample={() => cfg.sampleB && loadInto("b", cfg.sampleB.csv, cfg.sampleB.name)} loaded={!!b} onClear={() => setB(null)} />
          {recentPicker("b")}
          {errB && <div className="conv-err">{errB}</div>}
        </div>
      </div>

      {a && b && (
        <div className="viz" style={{ marginTop: 18 }}>
          <div className="join-keys">
            <div className="reshape-cols-label">{isLookup ? "Match rows on" : "Join keys"}</div>
            {keys.map((k, i) => (
              <div className="join-key-row" key={i}>
                <select aria-label="Dataset A key column" value={k.a} onChange={e => setKey(i, "a", e.target.value)}>{aH.map(c => <option key={c} value={c}>{c}</option>)}</select>
                <span className="join-key-eq">=</span>
                <select aria-label="Dataset B key column" value={k.b} onChange={e => setKey(i, "b", e.target.value)}>{bH.map(c => <option key={c} value={c}>{c}</option>)}</select>
                {keys.length > 1 && <button className="recent-item-x" onClick={() => removeKey(i)} aria-label="Remove key">×</button>}
              </div>
            ))}
            {keys.length < 3 && <button className="ed-btn" onClick={addKey}>+ compound key</button>}
            {!isLookup && (
              <label className="pivot-control join-type"><span>Join type</span>
                <select value={opts.joinType || "inner"} onChange={e => setOpts(o => ({ ...o, joinType: e.target.value }))}>
                  <option value="inner">Inner — only matching rows</option>
                  <option value="left">Left — keep every A row</option>
                  <option value="right">Right — keep every B row</option>
                  <option value="full">Full outer — keep everything</option>
                </select>
              </label>
            )}
          </div>

          <div className="join-bcols">
            <div className="reshape-cols-label">{isLookup ? "Columns to bring over" : "B columns to include"}</div>
            <div className="reshape-cols-grid">
              {bCarry.map(h => (
                <label className={"reshape-chip" + (chosenB.includes(h) ? " on" : "")} key={h}>
                  <input type="checkbox" checked={chosenB.includes(h)} onChange={() => toggleBCol(h)} />
                  {h}
                </label>
              ))}
            </div>
          </div>

          <div className="chart-card viz-card">
            <div className="chart-head">
              <div className="chart-title">{isLookup ? "Enriched file" : "Joined result"}</div>
              <div className="chart-kind">{tool}</div>
            </div>
            <div className="viz-canvas devtool-canvas">
              {result && result.error ? <div className="conv-err">{result.error}</div> : (
                <>
                  {result && result.stats && <div className="conv-stats">{Object.entries(result.stats).map(([k, v]) => <span key={k}><span className="conv-stats-label">{k}</span> {String(v)}</span>)}</div>}
                  {previewTable()}
                </>
              )}
            </div>
          </div>

          {sql && (
            <div className="join-sql">
              <button className="ed-btn" onClick={() => setShowSQL(s => !s)}>{showSQL ? "Hide the SQL" : "Show the equivalent SQL"}</button>
              {showSQL && (
                <>
                  <pre className="join-sql-pre">{sql}</pre>
                  <div className="join-sql-note">The same operation as a DuckDB query — take it to the <a href="/csv-sql-query">SQL tool</a> for anything fancier.</div>
                </>
              )}
            </div>
          )}

          <div className="viz-actions">
            <button className="btn-ghost" onClick={downloadOut}>Download CSV</button>
            <button className="btn-ghost" onClick={downloadXLSX}>Download .xlsx</button>
            <button className="btn-ghost" onClick={copyOut}>{copied ? "Copied!" : "Copy CSV"}</button>
            <SendToMenu getPayload={() => (result && result.csv ? { csv: result.csv, name: (isAppend ? "appended" : tool) + ".csv" } : null)} onError={msg => setErrA(msg)} />
            <button className="btn-ghost" onClick={resetAll}>Reset</button>
          </div>
        </div>
      )}
    </div>
  );
}


/* global React, CSVTool, Convert */
// V5 Batch B — the SQL-on-CSV course: /sql-on-csv lessons.
// One shell (mode "lesson", window.LESSON_CONFIG = { csv, teach, starter,
// exercises, nav, lessonNo, total }). Concatenated after tools6.jsx.
//
// Exercises self-check ENTIRELY client-side: the learner's query and a hidden
// reference query both run through the same in-bundle SQL engine
// (Convert.sqlQuery) on the same data, and the VALUE matrices are compared —
// header names are ignored so any AS alias is accepted; row order is ignored
// unless the exercise teaches ORDER BY (ex.ordered).

function lessonNormalize(csv, ordered) {
  if (!csv) return "";
  const parsed = CSVTool.parseCSV(csv);
  const rows = parsed.rows.map(r => parsed.headers.map(h => String(r[h] == null ? "" : r[h])).join(""));
  if (!ordered) rows.sort();
  return parsed.headers.length + "" + rows.join("");
}

function LessonShell({ config }) {
  const cfg = config || {};
  const exercises = cfg.exercises || [];
  const storeKey = "csvtd-sql-" + (cfg.slug || "lesson");

  const profile = useMemo(() => {
    try { return CSVTool.profile(CSVTool.parseCSV(cfg.csv || "")); } catch (e) { return null; }
  }, []);

  const [sql, setSql] = useState(cfg.starter || "SELECT * FROM csv LIMIT 5");
  const [result, setResult] = useState(null); // {headers, rows, count, error}
  const [done, setDone] = useState(() => {
    try { return JSON.parse(localStorage.getItem(storeKey) || "[]"); } catch (e) { return []; }
  });
  const [verdict, setVerdict] = useState({}); // id -> "correct" | "incorrect"
  const [hintOpen, setHintOpen] = useState({});
  const taRef = useRef(null);

  function execute(q) {
    const r = Convert.sqlQuery(profile, { sql: q });
    const parsed = r.csv ? CSVTool.parseCSV(r.csv) : { headers: [], rows: [] };
    return { csv: r.csv, headers: parsed.headers, rows: parsed.rows, count: parsed.rows.length };
  }
  function run() {
    if (!profile) return;
    try { setResult(execute(sql)); }
    catch (e) { setResult({ error: e.message }); }
  }
  function check(ex) {
    if (!profile) return;
    let user;
    try { user = execute(sql); }
    catch (e) { setResult({ error: e.message }); setVerdict(v => ({ ...v, [ex.id]: "incorrect" })); return; }
    setResult(user);
    let ref;
    try { ref = execute(ex.reference); } catch (e) { return; }
    const okNow = lessonNormalize(user.csv, ex.ordered) === lessonNormalize(ref.csv, ex.ordered);
    setVerdict(v => ({ ...v, [ex.id]: okNow ? "correct" : "incorrect" }));
    if (okNow && !done.includes(ex.id)) {
      const next = done.concat([ex.id]);
      setDone(next);
      try { localStorage.setItem(storeKey, JSON.stringify(next)); } catch (e) {}
    }
  }
  function loadStarter(q) {
    setSql(q);
    setResult(null);
    if (taRef.current) taRef.current.focus();
  }

  const allDone = exercises.length > 0 && exercises.every(ex => done.includes(ex.id));

  return (
    <div className="lesson-shell">
      {cfg.lessonNo != null && (
        <div className="lesson-meta">
          Lesson {cfg.lessonNo} of {cfg.total} · <a href={cfg.nav && cfg.nav.index}>course index</a>
          {exercises.length > 0 && <span className="lesson-progress"> · {done.length}/{exercises.length} exercises done</span>}
        </div>
      )}

      {(cfg.teach || []).map((t, i) => (
        <section className="lesson-teach" key={i}>
          {t.h && <h3>{t.h}</h3>}
          {t.body.map((p, j) => <p key={j} dangerouslySetInnerHTML={{ __html: p }} />)}
          {t.try && <button className="ed-btn lesson-try" onClick={() => loadStarter(t.try)}>▸ try it: <code>{t.try}</code></button>}
        </section>
      ))}

      {profile && (
        <details className="lesson-data">
          <summary>The data — <code>csv</code> table · {profile.rows.length} rows × {profile.cols.length} columns</summary>
          <div className="table-wrap" style={{ marginTop: 8 }}>
            <div style={{ overflowX: "auto" }}>
              <table className="data">
                <thead><tr>{profile.cols.map(c => <th key={c.name}>{c.name}</th>)}</tr></thead>
                <tbody>
                  {profile.rows.slice(0, 8).map((r, i) => (
                    <tr key={i}>{profile.cols.map(c => <td key={c.name}>{String(r[c.name] == null ? "" : r[c.name])}</td>)}</tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </details>
      )}

      <div className="lesson-runner">
        <textarea ref={taRef} className="lesson-sql" value={sql} spellCheck={false}
          onChange={e => setSql(e.target.value)}
          onKeyDown={e => { if ((e.ctrlKey || e.metaKey) && e.key === "Enter") { e.preventDefault(); run(); } }}
          aria-label="SQL editor" rows={4} />
        <div className="lesson-run-row">
          <button className="ed-btn primary" onClick={run}>Run (Ctrl+Enter)</button>
          {result && !result.error && <span className="lesson-count">{result.count.toLocaleString()} row{result.count === 1 ? "" : "s"}</span>}
        </div>
        {result && result.error && <div className="conv-err" role="alert">{result.error}</div>}
        {result && !result.error && result.headers.length > 0 && (
          <div className="table-wrap lesson-result">
            <div style={{ overflow: "auto", maxHeight: 320 }}>
              <table className="data">
                <thead><tr>{result.headers.map(h => <th key={h}>{h}</th>)}</tr></thead>
                <tbody>
                  {result.rows.slice(0, 50).map((r, i) => (
                    <tr key={i}>{result.headers.map(h => <td key={h}>{String(r[h] == null ? "" : r[h])}</td>)}</tr>
                  ))}
                </tbody>
              </table>
            </div>
            {result.count > 50 && <div className="join-preview-note">Showing 50 of {result.count.toLocaleString()} result rows.</div>}
          </div>
        )}
      </div>

      {exercises.length > 0 && (
        <div className="lesson-exercises">
          <div className="section-eyebrow" style={{ marginTop: 8 }}>Exercises — write the query above, then check</div>
          {exercises.map((ex, i) => {
            const isDone = done.includes(ex.id);
            const v = verdict[ex.id];
            return (
              <div className={"lesson-ex" + (isDone ? " done" : "")} key={ex.id}>
                <div className="lesson-ex-head">
                  <span className="lesson-ex-num">{isDone ? "✓" : i + 1}</span>
                  <span className="lesson-ex-title">{ex.title}</span>
                </div>
                <p className="lesson-ex-prompt" dangerouslySetInnerHTML={{ __html: ex.prompt }} />
                <div className="lesson-ex-actions" role="status" aria-live="polite">
                  <button className="ed-btn primary" onClick={() => check(ex)}>Check my query</button>
                  {ex.hint && <button className="ed-btn" onClick={() => setHintOpen(h => ({ ...h, [ex.id]: !h[ex.id] }))}>{hintOpen[ex.id] ? "Hide hint" : "Hint"}</button>}
                  {v === "correct" && <span className="lesson-ok">Correct ✓</span>}
                  {v === "incorrect" && <span className="lesson-no">Not quite — compare your result with what's asked.</span>}
                </div>
                {hintOpen[ex.id] && ex.hint && <p className="lesson-hint" dangerouslySetInnerHTML={{ __html: ex.hint }} />}
              </div>
            );
          })}
          {allDone && (
            <div className="lesson-complete">
              Lesson complete ✓ {cfg.nav && cfg.nav.next ? <a href={cfg.nav.next}>→ next lesson</a> : <a href={cfg.nav && cfg.nav.index}>→ back to the course</a>}
            </div>
          )}
        </div>
      )}

      <div className="lesson-nav">
        {cfg.nav && cfg.nav.prev ? <a href={cfg.nav.prev}>← previous lesson</a> : <span />}
        {cfg.nav && cfg.nav.next ? <a href={cfg.nav.next}>next lesson →</a> : <span />}
      </div>
    </div>
  );
}


/* global React, ReactDOM, CSVTool, Charts */
// All bindings (useState, useEffect, BarChart, LineChart, Histogram, Donut, fmtNum, fmtDateShort)
// are already declared in charts.jsx and shared via the babel global scope.

// Apply persisted theme before first paint to avoid a flash.
(function initTheme() {
  try {
    const stored = localStorage.getItem("csvtd-theme");
    const prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    const theme = stored || (prefersDark ? "dark" : "light");
    document.documentElement.setAttribute("data-theme", theme);
  } catch (e) { /* localStorage may be blocked */ }
})();

// Page-level config — each landing page sets window.PAGE_CONFIG before this script loads.
// Falls back to the primary "CSV to Dashboard" copy.
const DEFAULT_CONFIG = {
  mode: "tool", // "tool" or "examples"
  eyebrow: "Free · No signup · Private by default",
  headlinePrefix: "Turn any CSV into a ",
  headlineEm: "dashboard.",
  headlineSuffix: "",
  subhead: "Drop a spreadsheet, get charts, stats and a clean data table in seconds. Everything runs in your browser — your file never leaves this tab.",
  dropTitle: "Drop your CSV here",
  dropSub: "or click anywhere in this box to choose a file",
  dropAccept: ".csv,text/csv,.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
  sampleKey: "sales",
  sampleLinkText: "try with sample sales data",
  sampleCsv: null,   // optional inline sample CSV (vertical dashboards carry their own source-shaped export)
  sampleName: null,
  brand: { prefix: "csvto", em: "dashboard" },
  trust: [
    { num: "0", numEm: true, unit: "s", label: "setup time" },
    { num: "100%", label: "in your browser" },
    { num: "50", unit: "MB", label: "max file size" },
    { num: "∅", numEm: true, label: "accounts, ever" }
  ],
  sections: {
    how: {
      eyebrow: "01 · How it works",
      title: "Three steps, then you're ",
      titleEm: "done.",
      lede: "Drop, detect, done. There's no setup, no signup, and no configuration to think through before you see your data.",
      steps: [
        { n: "i. drop", h: "Drop your CSV", p: "Pull a file out of Finder, the Downloads folder, or your data export. We accept CSV and Excel up to 50 MB." },
        { n: "ii. detect", h: "We read the shape", p: "Columns get classified as number, date, category or text. Aggregations and time grains are chosen so the charts make sense for your shape of data." },
        { n: "iii. dashboard", h: "Use it, share it", p: "Headline stats, trend over time, breakdowns by category and a sortable table. Screenshot, print, or download a summary." }
      ]
    },
    examples: {
      eyebrow: "02 · Examples",
      title: "Made for ",
      titleEm: "real",
      titleSuffix: " spreadsheets.",
      lede: "Sales exports, survey responses, expense logs, web analytics, inventory snapshots — anything you'd normally open in Excel and stare at.",
      items: [
        { n: "01", h: "Sales & revenue", p: "Region breakdowns, product mix, channel performance, daily revenue trend." },
        { n: "02", h: "Survey responses", p: "Top answers per question, distributions across Likert scales, segment splits." },
        { n: "03", h: "Expense & invoice logs", p: "Totals by category, vendor concentration, monthly run-rate at a glance." },
        { n: "04", h: "Operational metrics", p: "Daily counts, throughput trend, distribution of durations or sizes." }
      ],
      pull: "I dropped a 30,000-row export and had three usable charts before my coffee finished steeping.",
      pullAttr: "— every user, hopefully"
    },
    faq: {
      eyebrow: "03 · FAQ",
      title: "Things people ",
      titleEm: "ask."
    }
  },
  faqItems: [
    { q: "Is this really free?", a: "Yes. No signup, no trial, no card. It's a tool — you drop a CSV, you get a dashboard. We make a small amount from the ads on the page, and that's enough." },
    { q: "Where does my data go?", a: "Nowhere. Everything runs in your browser — parsing, charting, all of it. Your file never touches a server. Close the tab and it's gone — unless you tick \"Remember recent files,\" which keeps them only on this device (in your browser's IndexedDB) so you can reopen them. That's off by default, never leaves your machine, and turning it off erases them." },
    { q: "What CSV format do I need?", a: "Standard comma-separated values with a header row in the first line. Quoted strings and escaped quotes work. UTF-8 with or without BOM is fine." },
    { q: "How big a file can it handle?", a: "Up to a few hundred MB and hundreds of thousands of rows in modern browsers. Large files are parsed on a background thread with a live progress bar, so the page never freezes, and the data table only renders the rows on screen (true virtualization) so it scrolls smoothly however big it gets. Past that, performance depends on your machine's memory. Charts sample for speed." },
    { q: "Does it work with Excel files?", a: "Yes — .xlsx and .xls work alongside CSV. Multi-sheet workbooks let you pick which sheet to load." },
    { q: "Can I save the dashboard?", a: "Use Download JSON to grab a summary of the metrics. For visuals, your browser's screenshot or print-to-PDF works well — the layout is print-friendly." }
  ],
  // For mode === "examples"
  gallery: [
    { key: "sales", title: "Q1 sales by region", tag: "Sales · 40 rows", description: "Daily product sales across four regions and two channels." },
    { key: "survey", title: "Employee satisfaction survey", tag: "Survey · 20 rows", description: "Likert satisfaction + NPS recommend score by department." },
    { key: "analytics", title: "Web analytics — 5 days", tag: "Analytics · 20 rows", description: "Sessions, bounce rate and duration by page and source." },
    { key: "expenses", title: "Operating expenses, Q1", tag: "Finance · 20 rows", description: "Monthly vendor spend by category, with paid/pending status." },
    { key: "headcount", title: "Headcount by department", tag: "HR · 18 rows", description: "Monthly headcount, average salary and open roles." },
    { key: "inventory", title: "Inventory snapshot", tag: "Ops · 15 rows", description: "SKU-level stock, unit cost and total inventory value." }
  ]
};

function mergeConfig(base, override) {
  if (!override) return base;
  const out = { ...base };
  for (const k of Object.keys(override)) {
    if (override[k] && typeof override[k] === "object" && !Array.isArray(override[k])) {
      out[k] = mergeConfig(base[k] || {}, override[k]);
    } else {
      out[k] = override[k];
    }
  }
  return out;
}
const CONFIG = mergeConfig(DEFAULT_CONFIG, window.PAGE_CONFIG || {});

// =================== Analytics helpers ===================
function pearson(xs, ys) {
  const n = Math.min(xs.length, ys.length);
  if (n < 3) return 0;
  let sumX = 0, sumY = 0, sumXY = 0, sumXX = 0, sumYY = 0;
  for (let i = 0; i < n; i++) {
    sumX += xs[i]; sumY += ys[i];
    sumXY += xs[i] * ys[i];
    sumXX += xs[i] * xs[i]; sumYY += ys[i] * ys[i];
  }
  const num = n * sumXY - sumX * sumY;
  const den = Math.sqrt((n * sumXX - sumX * sumX) * (n * sumYY - sumY * sumY));
  return den === 0 ? 0 : num / den;
}

function findAnomalies(rows, numCol) {
  if (!numCol || numCol.nums.length < 6) return [];
  const nums = numCol.nums;
  const mean = numCol.avg;
  const variance = nums.reduce((s, n) => s + (n - mean) ** 2, 0) / nums.length;
  const sigma = Math.sqrt(variance);
  if (sigma === 0) return [];
  const out = [];
  rows.forEach((r, i) => {
    const v = CSVTool.parseNumber(r[numCol.name]);
    if (v === null) return;
    const z = (v - mean) / sigma;
    if (Math.abs(z) >= 2) {
      out.push({ rowIdx: i, row: r, value: v, z, direction: z > 0 ? "high" : "low" });
    }
  });
  return out.sort((a, b) => Math.abs(b.z) - Math.abs(a.z));
}

function findTopMovers(rows, dateCol, numCol, catCol) {
  if (!dateCol || !numCol || !catCol) return null;
  // Split date range in half, compute per-category sum in each half
  const dated = rows.map(r => ({
    d: CSVTool.parseDate(r[dateCol.name]),
    v: CSVTool.parseNumber(r[numCol.name]),
    c: String(r[catCol.name] || "—")
  })).filter(x => x.d && x.v !== null);
  if (dated.length < 6) return null;
  dated.sort((a, b) => a.d - b.d);
  const mid = dated[Math.floor(dated.length / 2)].d;
  const first = new Map(), second = new Map();
  dated.forEach(x => {
    const target = x.d < mid ? first : second;
    target.set(x.c, (target.get(x.c) || 0) + x.v);
  });
  const allKeys = new Set([...first.keys(), ...second.keys()]);
  const movers = [];
  allKeys.forEach(k => {
    const a = first.get(k) || 0;
    const b = second.get(k) || 0;
    if (a === 0 && b === 0) return;
    const delta = b - a;
    const pct = a === 0 ? 1 : (b - a) / Math.abs(a);
    movers.push({ key: k, a, b, delta, pct });
  });
  movers.sort((x, y) => y.delta - x.delta);
  const gainer = movers[0];
  const loser = movers[movers.length - 1];
  return { gainer, loser, all: movers, splitDate: mid };
}

// Rule-based insight detectors. Each returns { text, score } if it fires; we rank by score and take the top 3.
function generateInsights(profile) {
  const { rows, cols } = profile;
  const chartable = cols.filter(c => c.role !== "id");
  const nums = chartable.filter(c => c.type === "number").sort((a, b) => b.importance - a.importance);
  const cats = chartable.filter(c => c.type === "category" || c.type === "boolean").sort((a, b) => b.importance - a.importance);
  const dates = chartable.filter(c => c.type === "date");
  const num = nums[0];
  const num2 = nums[1];
  const cat = cats[0];
  const date = dates[0];
  const out = [];

  // Concentration: top category share of primary numeric
  if (num && cat) {
    const sums = new Map();
    rows.forEach(r => {
      const k = String(r[cat.name] || "—");
      const v = CSVTool.parseNumber(r[num.name]);
      if (v !== null) sums.set(k, (sums.get(k) || 0) + v);
    });
    const entries = [...sums.entries()].sort((a, b) => b[1] - a[1]);
    const total = entries.reduce((s, e) => s + e[1], 0);
    if (entries[0] && total > 0) {
      const pct = entries[0][1] / total * 100;
      if (pct > 25) {
        out.push({
          text: `${entries[0][0]} leads ${cat.name} with ${pct.toFixed(0)}% of ${num.name} — ${fmtByCol(num, entries[0][1])} of ${fmtByCol(num, total)}.`,
          score: pct + (pct > 50 ? 20 : 0)
        });
      }
    }
  }

  // Trend: first half vs second half of dated period
  if (num && date) {
    const dated = rows.map(r => ({
      d: CSVTool.parseDate(r[date.name]),
      v: CSVTool.parseNumber(r[num.name])
    })).filter(x => x.d && x.v !== null).sort((a, b) => a.d - b.d);
    if (dated.length >= 6) {
      const mid = Math.floor(dated.length / 2);
      const firstSum = dated.slice(0, mid).reduce((s, x) => s + x.v, 0);
      const secondSum = dated.slice(mid).reduce((s, x) => s + x.v, 0);
      if (firstSum !== 0) {
        const pct = (secondSum - firstSum) / Math.abs(firstSum) * 100;
        if (Math.abs(pct) >= 10) {
          const verb = pct > 0 ? "grew" : "declined";
          out.push({
            text: `${num.name} ${verb} ${Math.abs(pct).toFixed(0)}% from the first half to the second half — ${fmtByCol(num, firstSum)} → ${fmtByCol(num, secondSum)}.`,
            score: Math.min(80, Math.abs(pct))
          });
        }
      }
    }
  }

  // Outliers
  if (num && num.nums.length >= 6) {
    const mean = num.avg;
    const variance = num.nums.reduce((s, n) => s + (n - mean) ** 2, 0) / num.nums.length;
    const sigma = Math.sqrt(variance);
    if (sigma > 0) {
      const outliers = num.nums.filter(n => Math.abs((n - mean) / sigma) >= 2);
      if (outliers.length > 0) {
        const extreme = outliers.reduce((m, n) => Math.abs(n - mean) > Math.abs(m - mean) ? n : m, outliers[0]);
        const z = (extreme - mean) / sigma;
        out.push({
          text: `${outliers.length} ${outliers.length === 1 ? "row is an" : "rows are"} ${outliers.length === 1 ? "" : ""}outlier${outliers.length === 1 ? "" : "s"} in ${num.name} (>2σ from mean) — the biggest is ${fmtByCol(num, extreme)} at ${z > 0 ? "+" : ""}${z.toFixed(1)}σ.`,
          score: 35 + outliers.length * 3
        });
      }
    }
  }

  // Skew: mean vs median divergence
  if (num && num.nums.length >= 5) {
    const sorted = [...num.nums].sort((a, b) => a - b);
    const median = sorted[Math.floor(sorted.length / 2)];
    if (median !== 0) {
      const skew = (num.avg - median) / Math.abs(median);
      if (Math.abs(skew) > 0.4) {
        const direction = skew > 0
          ? "long-tail — a few large values pull the average above the median"
          : "skewed low — a few small values pull the average below the median";
        out.push({
          text: `${num.name} is ${direction} (median ${fmtByCol(num, median)} vs average ${fmtByCol(num, num.avg)}).`,
          score: 20 + Math.abs(skew) * 20
        });
      }
    }
  }

  // Correlation between two numerics
  if (num && num2) {
    const xs = [], ys = [];
    rows.forEach(r => {
      const x = CSVTool.parseNumber(r[num.name]);
      const y = CSVTool.parseNumber(r[num2.name]);
      if (x !== null && y !== null) { xs.push(x); ys.push(y); }
    });
    if (xs.length >= 4) {
      const r = pearson(xs, ys);
      const absR = Math.abs(r);
      if (absR > 0.7) {
        out.push({
          text: `${num.name} and ${num2.name} move together — strongly ${r > 0 ? "positively" : "negatively"} correlated (r = ${r.toFixed(2)}).`,
          score: 45 + absR * 25
        });
      } else if (absR > 0.4) {
        out.push({
          text: `${num.name} and ${num2.name} show a moderate ${r > 0 ? "positive" : "negative"} correlation (r = ${r.toFixed(2)}).`,
          score: 25 + absR * 20
        });
      }
    }
  }

  // Row dominance in low-card category (when concentration didn't already cover it)
  if (cat && cat.unique > 1 && cat.unique <= 6 && cat.counts && cat.counts[0]) {
    const topShare = cat.counts[0].value / rows.length * 100;
    if (topShare > 50) {
      out.push({
        text: `${cat.counts[0].key} dominates ${cat.name} at ${topShare.toFixed(0)}% of all rows (${cat.counts[0].value} of ${rows.length}).`,
        score: topShare * 0.5
      });
    }
  }

  // Date span
  if (date && date.minDate && date.maxDate) {
    const days = Math.round((date.maxDate - date.minDate) / 86400000);
    if (days > 0 && rows.length >= 10) {
      const perDay = (rows.length / Math.max(1, days)).toFixed(1);
      // Only surface if not noisy
      if (days >= 7) {
        out.push({
          text: `Activity averages ${perDay} rows per day across ${days >= 365 ? (days / 365).toFixed(1) + " years" : days >= 60 ? Math.round(days / 30) + " months" : days + " days"} of data.`,
          score: 10
        });
      }
    }
  }

  // Coverage / unique-ness when no dominant signal
  if (cat && cat.unique > 6 && out.length < 3) {
    out.push({
      text: `${cat.name} has ${cat.unique} unique values across ${rows.length} rows — high diversity.`,
      score: 8
    });
  }

  // Sort by score, dedupe by first 30 chars, take top 3
  const seen = new Set();
  return out
    .sort((a, b) => b.score - a.score)
    .filter(i => {
      const key = i.text.slice(0, 40);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, 3)
    .map(i => i.text);
}

function Insights({ profile }) {
  const [dismissed, setDismissed] = useState(false);
  const insights = useMemo(() => generateInsights(profile), [profile]);

  if (dismissed) return null;
  if (insights.length === 0) return null;

  return (
    <div className="insights">
      <div className="insights-head">
        <div className="insights-eyebrow">
          <span className="dot"></span>What we noticed
        </div>
        <button className="insights-close" onClick={() => setDismissed(true)} aria-label="dismiss">×</button>
      </div>
      <ul className="insights-list">
        {insights.map((s, i) => (
          <li key={i}><span className="insight-mark">{String(i + 1).padStart(2, "0")}</span><span>{s}</span></li>
        ))}
      </ul>
    </div>
  );
}

// =================== Auto-named dashboard ===================
function generateDashboardName(profile) {
  const { cols } = profile;
  const chartable = cols.filter(c => c.role !== "id");
  const nums = chartable.filter(c => c.type === "number").sort((a, b) => b.importance - a.importance);
  const cats = chartable.filter(c => c.type === "category" || c.type === "boolean").sort((a, b) => b.importance - a.importance);
  const dates = chartable.filter(c => c.type === "date");
  const num = nums[0], cat = cats[0], date = dates[0];

  if (!num && !cat) return "Your dashboard";

  let period = "";
  if (date && date.minDate && date.maxDate) {
    const yA = date.minDate.getFullYear();
    const yB = date.maxDate.getFullYear();
    if (yA === yB) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const mA = date.minDate.getMonth();
      const mB = date.maxDate.getMonth();
      if (mA === mB) period = `${months[mA]} ${yA}`;
      else if (mB - mA <= 2) period = `Q${Math.floor(mA / 3) + 1} ${yA}`;
      else period = `${yA}`;
    } else {
      period = `${yA}–${yB}`;
    }
  }

  if (num && cat) return `${num.name} by ${cat.name}${period ? " · " + period : ""}`;
  if (num) return `${num.name}${period ? " · " + period : ""}`;
  if (cat) return `${cat.name} distribution${period ? " · " + period : ""}`;
  return "Your dashboard";
}

// =================== Standalone HTML export ===================
// Fetch the self-hosted font CSS and inline every woff2 as a base64 data: URI,
// so the exported file is truly self-contained and offline (no Google Fonts CDN,
// no /vendor/fonts/ paths that 404 under file://).
async function inlineFontsCSS() {
  try {
    const css = await fetch("/vendor/fonts.css").then(r => r.text());
    const urls = [...new Set([...css.matchAll(/url\((\/vendor\/fonts\/[^)]+\.woff2)\)/g)].map(m => m[1]))];
    let out = css;
    await Promise.all(urls.map(async u => {
      const buf = await fetch(u).then(r => r.arrayBuffer());
      const bytes = new Uint8Array(buf);
      let bin = ""; for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
      out = out.split(u).join("data:font/woff2;base64," + btoa(bin));
    }));
    return out;
  } catch (e) { return ""; }
}

async function exportStandaloneHTML(csvText, filename) {
  const [react, reactDom, parser, bundle, styles, fontsCss] = await Promise.all([
    fetch("/vendor/react.production.min.js").then(r => r.text()),
    fetch("/vendor/react-dom.production.min.js").then(r => r.text()),
    fetch("/parser.js").then(r => r.text()),
    fetch("/bundle.js").then(r => r.text()),
    fetch("/styles.css").then(r => r.text()),
    inlineFontsCSS()
  ]);
  // Escape </script> so a CSV/filename containing that sequence can't terminate
  // the inlined config script early (the \/ parses back to / inside a JS string).
  const enc = s => JSON.stringify(s).replace(/<\/(script)/gi, "<\\/$1");
  const csvJSON = enc(csvText);
  const nameJSON = enc(filename || "data.csv");

  const html = `<!doctype html>
<html lang="en"><head><meta charset="utf-8" /><meta name="viewport" content="width=device-width, initial-scale=1" />
<title>${(filename || "Dashboard").replace(/[<>]/g, "")} — csvtodashboard</title>
<style>${fontsCss}</style>
<style>${styles}</style>
<script>${react}</script>
<script>${reactDom}</script>
<script>${parser}</script>
<script>
window.PAGE_CONFIG = {
  eyebrow: "Standalone dashboard · offline copy",
  headlinePrefix: "",
  headlineEm: "",
  subhead: "",
  mode: "tool"
};
window.__STANDALONE_AUTOLOAD__ = { csv: ${csvJSON}, name: ${nameJSON} };
</script>
</head><body><div id="root"></div>
<!-- bundle runs AFTER #root exists (it is inlined, so it can't be deferred like
     the live site's <script defer>). In <head> it would hit React #299. -->
<script>${bundle}</script>
</body></html>`;

  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = (filename || "dashboard").replace(/\.csv$/i, "") + ".dashboard.html";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// =================== PNG dashboard screenshot ===================
// Truncate a string to fit maxW px under the current ctx.font, adding an ellipsis.
function fitText(ctx, text, maxW) {
  text = text || "";
  if (ctx.measureText(text).width <= maxW) return text;
  let t = text;
  while (t.length > 1 && ctx.measureText(t + "…").width > maxW) t = t.slice(0, -1);
  return t + "…";
}

function chartFileStem(value) {
  const stem = String(value || "chart")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
  return stem || "chart";
}

function wrapChartExportTitle(value, max = 62) {
  const words = String(value || "Chart").trim().split(/\s+/);
  const lines = [""];
  words.forEach(word => {
    let remaining = word;
    while (remaining.length > max) {
      if (lines[lines.length - 1]) lines.push("");
      lines[lines.length - 1] = remaining.slice(0, max);
      remaining = remaining.slice(max);
      lines.push("");
    }
    const current = lines[lines.length - 1];
    if (!current || current.length + 1 + remaining.length <= max) {
      lines[lines.length - 1] = current ? current + " " + remaining : remaining;
    } else {
      lines.push(remaining);
    }
  });
  return lines.filter(Boolean).slice(0, 2);
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Clone a live chart SVG and resolve every CSS paint/font property before it
// leaves the document. Exported SVG files therefore keep the visible theme and
// optional panel hue without depending on this site's stylesheets.
function resolvedChartClone(svg) {
  const clone = svg.cloneNode(true);
  const sourceNodes = [svg, ...svg.querySelectorAll("*")];
  const cloneNodes = [clone, ...clone.querySelectorAll("*")];
  const props = [
    "fill", "stroke", "stroke-width", "stroke-opacity", "fill-opacity",
    "opacity", "stop-color", "stop-opacity", "font-family", "font-size",
    "font-weight", "font-style", "letter-spacing", "text-anchor"
  ];
  sourceNodes.forEach((node, i) => {
    const computed = getComputedStyle(node);
    let style = "";
    props.forEach(prop => {
      const value = computed.getPropertyValue(prop);
      if (value) style += prop + ":" + value + ";";
    });
    cloneNodes[i].setAttribute("style", style + (cloneNodes[i].getAttribute("style") || ""));
  });
  clone.setAttribute("preserveAspectRatio", "xMidYMid meet");
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  return clone;
}

function chartExportDocument(card, fallbackTitle) {
  const source = card && card.querySelector(".chart-body svg");
  if (!source) throw new Error("This chart has not finished rendering yet.");

  const text = selector => {
    const node = card.querySelector(selector);
    return node ? node.textContent.replace(/\s+/g, " ").trim() : "";
  };
  const title = text(".chart-title") || fallbackTitle || "Chart";
  const subtitle = text(".chart-sub");
  const rootStyle = getComputedStyle(document.documentElement);
  const color = (name, fallback) => rootStyle.getPropertyValue(name).trim() || fallback;
  const colors = {
    bg: color("--bg", "#f8f6f0"),
    card: color("--bg-card", "#ffffff"),
    ink: color("--ink", "#16231d"),
    soft: color("--ink-faint", "#6c776f"),
    line: color("--line", "#d9ddd8"),
    accent: color("--accent-ink", "#27794b")
  };

  const NS = "http://www.w3.org/2000/svg";
  const W = 1200, H = 720;
  const root = document.createElementNS(NS, "svg");
  root.setAttribute("xmlns", NS);
  root.setAttribute("viewBox", `0 0 ${W} ${H}`);
  root.setAttribute("width", String(W));
  root.setAttribute("height", String(H));
  root.setAttribute("role", "img");
  root.setAttribute("aria-label", title);

  const add = (name, attrs, value) => {
    const node = document.createElementNS(NS, name);
    Object.entries(attrs || {}).forEach(([key, val]) => node.setAttribute(key, String(val)));
    if (value != null) node.textContent = value;
    root.appendChild(node);
    return node;
  };
  add("title", {}, title);
  if (subtitle) add("desc", {}, subtitle);
  add("rect", { x: 0, y: 0, width: W, height: H, fill: colors.bg });
  add("rect", { x: 30, y: 30, width: W - 60, height: H - 60, rx: 18, fill: colors.card, stroke: colors.line });
  const titleLines = wrapChartExportTitle(title);
  titleLines.forEach((line, i) => add("text", { x: 64, y: 88 + i * 38, fill: colors.ink, "font-family": "Georgia, serif", "font-size": 38 }, line));
  const subtitleY = titleLines.length > 1 ? 150 : 122;
  if (subtitle) add("text", { x: 64, y: subtitleY, fill: colors.soft, "font-family": "Arial, sans-serif", "font-size": 15 }, subtitle.length > 120 ? subtitle.slice(0, 119) + "…" : subtitle);
  const ruleY = titleLines.length > 1 ? 170 : 142;
  add("line", { x1: 64, x2: W - 64, y1: ruleY, y2: ruleY, stroke: colors.line });

  const body = card.querySelector(".chart-body");
  const legend = body && Array.from(body.children).find(node => node.tagName === "DIV");
  const legendRows = legend ? Array.from(legend.children).slice(0, 8) : [];
  const plot = resolvedChartClone(source);
  plot.setAttribute("x", "64");
  plot.setAttribute("y", String(ruleY + 22));
  plot.setAttribute("width", legendRows.length ? "710" : "1072");
  plot.setAttribute("height", String(604 - (ruleY + 22)));
  root.appendChild(plot);

  if (legendRows.length) {
    add("text", { x: 830, y: ruleY + 46, fill: colors.soft, "font-family": "Arial, sans-serif", "font-size": 12, "font-weight": 700, "letter-spacing": 1.2 }, "LEGEND");
    legendRows.forEach((row, i) => {
      const label = row.textContent.replace(/\s+/g, " ").trim();
      const swatch = row.querySelector("span");
      const fill = swatch ? getComputedStyle(swatch).backgroundColor : colors.accent;
      const y = ruleY + 78 + i * 38;
      add("rect", { x: 830, y: y - 13, width: 14, height: 14, rx: 3, fill });
      add("text", { x: 856, y, fill: colors.ink, "font-family": "Arial, sans-serif", "font-size": 15 }, label.length > 34 ? label.slice(0, 33) + "…" : label);
    });
  }

  add("line", { x1: 64, x2: W - 64, y1: 624, y2: 624, stroke: colors.line });
  add("text", { x: 64, y: 650, fill: colors.soft, "font-family": "Arial, sans-serif", "font-size": 13 }, "Generated locally in your browser");
  add("text", { x: W - 64, y: 650, fill: colors.accent, "font-family": "Arial, sans-serif", "font-size": 14, "font-weight": 700, "text-anchor": "end" }, "csvtodashboard.com");

  return {
    title,
    stem: chartFileStem(title),
    markup: '<?xml version="1.0" encoding="UTF-8"?>\n' + new XMLSerializer().serializeToString(root)
  };
}

async function exportChartPanel(card, title, format) {
  const output = chartExportDocument(card, title);
  const svgBlob = new Blob([output.markup], { type: "image/svg+xml;charset=utf-8" });
  if (format === "svg") {
    downloadBlob(svgBlob, output.stem + ".svg");
    return;
  }
  const url = URL.createObjectURL(svgBlob);
  try {
    const image = await new Promise((resolve, reject) => {
      const next = new Image();
      next.onload = () => resolve(next);
      next.onerror = () => reject(new Error("Could not render this chart for PNG export."));
      next.src = url;
    });
    const canvas = document.createElement("canvas");
    canvas.width = 2400;
    canvas.height = 1440;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    const png = await new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error("Could not encode this chart as PNG.")), "image/png"));
    downloadBlob(png, output.stem + ".png");
  } finally {
    URL.revokeObjectURL(url);
  }
}

// Compose a designed "dashboard summary card" PNG — the headline title, the key
// KPIs, and the top charts on a clean branded canvas — instead of a raw screenshot
// of the whole scrolling page. Drawn directly with the Canvas 2D API (no
// foreignObject), so it's reliable and the layout is deliberate.
// Builds the branded dashboard-summary canvas (title + KPIs + top charts).
// PNG export downloads it directly; PDF export (V7 D) embeds it as the cover.
async function renderDashboardCanvas(filename) {
  if (!document.getElementById("dashboard-anchor")) return null;
  if (document.fonts && document.fonts.ready) { try { await document.fonts.ready; } catch (e) {} }

  // ---- gather the important info from the live dashboard ----
  const txt = el => (el ? el.textContent : "").replace(/\s+/g, " ").trim();
  const title = txt(document.querySelector(".dash-title")) || (filename || "Dashboard").replace(/\.csv$/i, "");
  const kpis = Array.from(document.querySelectorAll(".kpi")).slice(0, 4).map(k => ({
    label: txt(k.querySelector(".kpi-label")),
    value: txt(k.querySelector(".kpi-value")),
    sub: txt(k.querySelector(".kpi-sub")),
  })).filter(k => k.value);
  const chartEls = Array.from(document.querySelectorAll(".chart-card")).map(c => ({
    title: txt(c.querySelector(".chart-title")), svg: c.querySelector("svg"),
  })).filter(c => c.svg).slice(0, 3);

  // ---- theme colours (resolved, so oklch()/var() become concrete sRGB) ----
  const cs = getComputedStyle(document.documentElement);
  const v = (n, fb) => { const x = cs.getPropertyValue(n).trim(); return x || fb; };
  const COL = {
    bg: v("--bg", "#f7f5ef"), card: v("--bg-card", "#ffffff"),
    ink: v("--ink", "#16231d"), inkFaint: v("--ink-faint", "#8a978e"),
    accent: v("--accent-ink", v("--accent", "#2f8f4e")), line: v("--line-soft", v("--line", "rgba(0,0,0,0.08)")),
  };

  // ---- rasterize the top charts (inline computed paint so var()/class colours
  // resolve; pure SVG-as-image rasterizes reliably, unlike a foreignObject) ----
  function chartSVG(svg) {
    const clone = svg.cloneNode(true);
    const src = svg.querySelectorAll("*"), cl = clone.querySelectorAll("*");
    const PROPS = ["fill", "stroke", "stroke-width", "stroke-opacity", "fill-opacity", "opacity", "stop-color", "stop-opacity", "font-family", "font-size", "font-weight", "text-anchor"];
    for (let i = 0; i < src.length; i++) {
      const ecs = getComputedStyle(src[i]); let st = "";
      for (const p of PROPS) { const val = ecs.getPropertyValue(p); if (val) st += p + ":" + val + ";"; }
      cl[i].setAttribute("style", st + (cl[i].getAttribute("style") || ""));
    }
    const r = svg.getBoundingClientRect();
    clone.setAttribute("width", String(Math.max(1, Math.round(r.width))));
    clone.setAttribute("height", String(Math.max(1, Math.round(r.height))));
    clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    return { str: new XMLSerializer().serializeToString(clone), aspect: (r.height || 1) / (r.width || 1) };
  }
  const charts = [];
  for (const c of chartEls) {
    const s = chartSVG(c.svg);
    const im = await new Promise(res => { const i = new Image(); i.onload = () => res(i); i.onerror = () => res(null); i.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(s.str); });
    if (im) charts.push({ title: c.title, img: im, aspect: s.aspect });
  }

  // ---- layout ----
  const W = 1200, PAD = 44, GAP = 16, S = 2;
  const contentW = W - 2 * PAD;
  const nK = Math.min(kpis.length, 4);
  const kpiH = nK ? 108 : 0;
  const featured = charts[0], rest = charts.slice(1, 3);
  const featH = featured ? 300 : 0, restH = rest.length ? 224 : 0, footerH = 46, headerH = 72;
  const H = Math.round(PAD + headerH + (nK ? 18 + kpiH : 0) + (featured ? 26 + featH : 0) + (rest.length ? 18 + restH : 0) + 22 + footerH + PAD);

  const canvas = document.createElement("canvas");
  canvas.width = W * S; canvas.height = H * S;
  const ctx = canvas.getContext("2d");
  ctx.scale(S, S);
  const rr = (x, y, w, h, r) => { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); };
  const card = (x, y, w, h) => { ctx.fillStyle = COL.card; rr(x, y, w, h, 12); ctx.fill(); ctx.strokeStyle = COL.line; ctx.lineWidth = 1; rr(x, y, w, h, 12); ctx.stroke(); };

  ctx.fillStyle = COL.bg; ctx.fillRect(0, 0, W, H);
  let y = PAD;

  // header — title + "Dashboard summary", brand wordmark top-right
  ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
  ctx.fillStyle = COL.ink; ctx.font = "36px 'Instrument Serif', Georgia, serif";
  ctx.fillText(fitText(ctx, title, contentW - 240), PAD, y + 32);
  ctx.fillStyle = COL.inkFaint; ctx.font = "500 13px 'DM Sans', system-ui, sans-serif";
  ctx.fillText("Dashboard summary", PAD, y + 56);
  ctx.textAlign = "right"; ctx.font = "600 17px 'DM Sans', system-ui, sans-serif";
  ctx.fillStyle = COL.accent; ctx.fillText("dashboard", W - PAD, y + 24);
  const dwid = ctx.measureText("dashboard").width;
  ctx.fillStyle = COL.ink; ctx.fillText("csvto", W - PAD - dwid, y + 24);
  ctx.textAlign = "left";
  y += headerH;
  ctx.strokeStyle = COL.line; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(PAD, y - 6); ctx.lineTo(W - PAD, y - 6); ctx.stroke();

  // KPI cards
  if (nK) {
    y += 18;
    const cw = (contentW - (nK - 1) * GAP) / nK;
    for (let i = 0; i < nK; i++) {
      const x = PAD + i * (cw + GAP), k = kpis[i];
      card(x, y, cw, kpiH);
      ctx.fillStyle = COL.inkFaint; ctx.font = "600 11px 'DM Sans', system-ui, sans-serif";
      ctx.fillText(fitText(ctx, k.label.toUpperCase(), cw - 30), x + 16, y + 30);
      ctx.fillStyle = COL.ink; ctx.font = "600 28px 'DM Sans', system-ui, sans-serif";
      ctx.fillText(fitText(ctx, k.value, cw - 30), x + 16, y + 66);
      if (k.sub) { ctx.fillStyle = COL.inkFaint; ctx.font = "500 12px 'DM Sans', system-ui, sans-serif"; ctx.fillText(fitText(ctx, k.sub, cw - 30), x + 16, y + 90); }
    }
    y += kpiH;
  }

  // chart cards (rasterized SVG fit inside, aspect preserved)
  const drawChart = (x, yy, w, h, c) => {
    card(x, yy, w, h);
    ctx.fillStyle = COL.ink; ctx.font = "600 15px 'DM Sans', system-ui, sans-serif";
    ctx.fillText(fitText(ctx, c.title || "Chart", w - 28), x + 16, yy + 28);
    const ix = x + 14, iy = yy + 40, iw = w - 28, ih = h - 52;
    let dw = iw, dh = iw * c.aspect;
    if (dh > ih) { dh = ih; dw = ih / c.aspect; }
    ctx.drawImage(c.img, ix + (iw - dw) / 2, iy + (ih - dh) / 2, dw, dh);
  };
  if (featured) { y += 26; drawChart(PAD, y, contentW, featH, featured); y += featH; }
  if (rest.length) {
    y += 18;
    const cw = rest.length === 1 ? contentW : (contentW - GAP) / 2;
    rest.forEach((c, i) => drawChart(PAD + i * (cw + GAP), y, cw, restH, c));
    y += restH;
  }

  // footer brand line
  ctx.textAlign = "center"; ctx.fillStyle = COL.inkFaint; ctx.font = "500 12px 'DM Sans', system-ui, sans-serif";
  ctx.fillText("Made with csvtodashboard.com — free CSV dashboards, in your browser", W / 2, H - PAD - 6);
  ctx.textAlign = "left";

  return canvas;
}

async function exportDashboardPNG(filename) {
  const canvas = await renderDashboardCanvas(filename);
  if (!canvas) return;
  await new Promise(r => canvas.toBlob(b => {
    const u = URL.createObjectURL(b);
    const a = document.createElement("a");
    a.href = u;
    a.download = (filename || "dashboard").replace(/\.csv$/i, "") + ".png";
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(u);
    r();
  }, "image/png"));
}

// V7 D — dashboard → PDF: page 1 is the rendered summary canvas, then the
// data itself as typed table pages. Rides the same self-hosted jsPDF +
// autoTable pair the csv-to-pdf converter lazy-loads (ensurePDF).
async function exportDashboardPDF(profile, filename) {
  await ensurePDF();
  const canvas = await renderDashboardCanvas(filename);
  if (!canvas) return;
  const J = window.jspdf && window.jspdf.jsPDF;
  if (!J) throw new Error("PDF engine missing");
  const doc = new J({ orientation: "landscape", unit: "pt", format: "a4" });
  const pw = doc.internal.pageSize.getWidth(), ph = doc.internal.pageSize.getHeight();
  const m = 24;
  const scale = Math.min((pw - m * 2) / canvas.width, (ph - m * 2) / canvas.height);
  const iw = canvas.width * scale, ih = canvas.height * scale;
  doc.addImage(canvas.toDataURL("image/png"), "PNG", (pw - iw) / 2, (ph - ih) / 2, iw, ih);
  if (profile && profile.rows && profile.rows.length) {
    const MAXR = 300;
    const heads = profile.cols.map(c => c.name);
    const body = profile.rows.slice(0, MAXR).map(r => heads.map(h => {
      const v = r[h];
      return v == null ? "" : String(v);
    }));
    doc.addPage("a4", "landscape");
    doc.setFontSize(10);
    doc.text((filename || "data") + " — first " + Math.min(MAXR, profile.rows.length).toLocaleString() + " of " + profile.rows.length.toLocaleString() + " rows", m, m);
    doc.autoTable({ head: [heads], body, startY: m + 10, styles: { fontSize: 7, cellPadding: 3 }, headStyles: { fillColor: [22, 95, 76] }, margin: { left: m, right: m } });
  }
  doc.save((filename || "dashboard").replace(/\.csv$/i, "") + ".pdf");
}

// =================== Calculated columns ===================
// Tiny safe expression evaluator: supports + - * / ( ) and column references by name.
// No JS Function constructor — pure tokenized recursive-descent.
function evalExpr(expr, env) {
  // Tokenize
  let i = 0;
  function peek() { while (i < expr.length && /\s/.test(expr[i])) i++; return expr[i]; }
  function eat(ch) { peek(); if (expr[i] === ch) { i++; return true; } return false; }
  function num() {
    peek();
    let s = "";
    while (i < expr.length && /[0-9.]/.test(expr[i])) s += expr[i++];
    return parseFloat(s);
  }
  function ident() {
    peek();
    // Identifier may be quoted with [brackets] for names with spaces
    if (expr[i] === "[") {
      i++;
      let s = "";
      while (i < expr.length && expr[i] !== "]") s += expr[i++];
      if (expr[i] === "]") i++;
      return s.trim();
    }
    let s = "";
    while (i < expr.length && /[A-Za-z0-9_]/.test(expr[i])) s += expr[i++];
    return s;
  }
  function factor() {
    peek();
    if (eat("(")) {
      const v = expression();
      eat(")");
      return v;
    }
    if (eat("-")) return -factor();
    if (eat("+")) return factor();
    if (/[0-9.]/.test(expr[i])) return num();
    const name = ident();
    if (!name) return NaN;
    const raw = env[name];
    const n = (raw === undefined || raw === null) ? NaN : CSVTool.parseNumber(raw);
    return n === null ? NaN : n;
  }
  function term() {
    let v = factor();
    while (true) {
      peek();
      if (eat("*")) v *= factor();
      else if (eat("/")) {
        const d = factor();
        v = d === 0 ? NaN : v / d;
      } else break;
    }
    return v;
  }
  function expression() {
    let v = term();
    while (true) {
      peek();
      if (eat("+")) v += term();
      else if (eat("-")) v -= term();
      else break;
    }
    return v;
  }
  try { return expression(); } catch (e) { return NaN; }
}

function CalcColumnInput({ cols, onAdd }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [formula, setFormula] = useState("");
  const numericNames = cols.filter(c => c.type === "number" && c.role !== "id").map(c => c.name);

  function submit(e) {
    e && e.preventDefault();
    if (!name.trim() || !formula.trim()) return;
    onAdd(name.trim(), formula.trim());
    setName(""); setFormula(""); setOpen(false);
  }

  if (!open) {
    return (
      <div className="calc-col-trigger">
        <button className="btn-ghost" onClick={() => setOpen(true)}>+ Calculated column</button>
      </div>
    );
  }

  return (
    <form className="calc-col" onSubmit={submit}>
      <div className="calc-col-label">Add column</div>
      <input
        className="calc-col-input"
        aria-label="New column name"
        placeholder="name (e.g. AvgPrice)"
        value={name}
        onChange={e => setName(e.target.value)}
        autoFocus
      />
      <span className="calc-col-eq">=</span>
      <input
        className="calc-col-input"
        aria-label="Column formula"
        style={{ flex: 2 }}
        placeholder={numericNames.length >= 2 ? `${numericNames[0]} / ${numericNames[1]}` : "expression (e.g. Revenue / Units)"}
        value={formula}
        onChange={e => setFormula(e.target.value)}
      />
      <button type="submit" className="calc-col-btn" disabled={!name.trim() || !formula.trim()}>Add</button>
      <button type="button" className="calc-col-cancel" onClick={() => setOpen(false)}>Cancel</button>
      <div className="calc-col-hint">
        Use <code>+ - * /</code> and column names. Wrap names with spaces in [brackets].
        Available numeric columns: {numericNames.join(", ") || "none"}.
      </div>
    </form>
  );
}

// =================== Pivot table ===================
function PivotTable({ profile, filters, onToggleFilter }) {
  const { cols, rows } = profile;
  const chartable = cols.filter(c => c.role !== "id");
  const cats = chartable.filter(c => c.type === "category" || c.type === "boolean" || c.type === "date");
  const nums = chartable.filter(c => c.type === "number").sort((a, b) => b.importance - a.importance);

  const [rowDim, setRowDim] = useState(cats[0]?.name || "");
  const [colDim, setColDim] = useState(cats[1]?.name || "");
  const [valDim, setValDim] = useState(nums[0]?.name || "");
  const [agg, setAgg] = useState("sum"); // sum | avg | count
  const [shade, setShade] = useState(false); // heatmap shading of cells by value

  const data = useMemo(() => {
    if (!rowDim) return null;
    const rowCol = cols.find(c => c.name === rowDim);
    const valCol = cols.find(c => c.name === valDim);
    const rowKeys = new Set();
    const colKeys = new Set();
    const cell = new Map(); // r|c → { sum, count }
    const colKeyOf = (r) => colDim ? String(r[colDim] || "—") : "Total";
    const rowKeyOf = (r) => {
      const raw = r[rowDim];
      if (rowCol && rowCol.type === "date") {
        const d = CSVTool.parseDate(raw);
        if (!d) return "—";
        return d.toISOString().slice(0, 10);
      }
      return String(raw || "—");
    };
    rows.forEach(r => {
      const rk = rowKeyOf(r);
      const ck = colKeyOf(r);
      rowKeys.add(rk); colKeys.add(ck);
      const key = rk + "‖" + ck;
      const v = agg === "count" ? 1 : (valCol ? CSVTool.parseNumber(r[valDim]) : null);
      if (v === null) return;
      const prev = cell.get(key) || { sum: 0, count: 0 };
      prev.sum += v; prev.count += 1;
      cell.set(key, prev);
    });
    const rks = [...rowKeys].sort(), cks = [...colKeys].sort();
    // Range of the displayed aggregate, for heatmap shading.
    let vmin = Infinity, vmax = -Infinity;
    rks.forEach(rk => cks.forEach(ck => {
      const c = cell.get(rk + "‖" + ck); if (!c) return;
      const v = agg === "count" ? c.count : agg === "avg" ? (c.count ? c.sum / c.count : null) : c.sum;
      if (v === null || isNaN(v)) return;
      if (v < vmin) vmin = v; if (v > vmax) vmax = v;
    }));
    return { rowKeys: rks, colKeys: cks, cell, valCol, vmin, vmax };
  }, [profile, rowDim, colDim, valDim, agg, cols, rows]);

  function aggValue(rk, ck) {
    if (!data) return null;
    const k = rk + "‖" + ck;
    const c = data.cell.get(k);
    if (!c) return null;
    if (agg === "count") return c.count;
    if (agg === "avg") return c.count ? c.sum / c.count : null;
    return c.sum;
  }

  const valCol = data?.valCol;
  function fmt(v) {
    if (v === null || v === undefined || isNaN(v)) return "";
    if (agg === "count") return fmtNum(v);
    return valCol ? fmtByCol(valCol, v) : fmtNum(v);
  }

  // Drill-down: click a cell to filter the dashboard to that row × column. Only
  // category/boolean dims are toggled (date keys are bucketed, so they wouldn't
  // match the raw cell value); the filter persists to the URL hash via the parent.
  const dimFilterable = (dim) => { const c = cols.find(x => x.name === dim); return !!c && (c.type === "category" || c.type === "boolean"); };
  const canDrill = !!onToggleFilter && (dimFilterable(rowDim) || (!!colDim && dimFilterable(colDim)));
  function drill(rk, ck) {
    if (!onToggleFilter) return;
    if (dimFilterable(rowDim)) onToggleFilter(rowDim, rk);
    if (colDim && dimFilterable(colDim)) onToggleFilter(colDim, ck);
  }
  function heatStyle(v) {
    if (!shade || !data || v === null || v === undefined || isNaN(v)) return undefined;
    const { vmin, vmax } = data;
    if (!isFinite(vmin) || vmax === vmin) return undefined;
    const t = (v - vmin) / (vmax - vmin);
    return { background: "rgba(52, 168, 83, " + (0.06 + t * 0.5).toFixed(3) + ")" };
  }

  return (
    <div className="pivot">
      <div className="pivot-controls">
        <label className="pivot-control">
          <span>Rows</span>
          <select value={rowDim} onChange={e => setRowDim(e.target.value)}>
            {cats.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>
        </label>
        <label className="pivot-control">
          <span>Columns</span>
          <select value={colDim} onChange={e => setColDim(e.target.value)}>
            <option value="">(none)</option>
            {cats.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>
        </label>
        <label className="pivot-control">
          <span>Values</span>
          <select value={valDim} onChange={e => setValDim(e.target.value)}>
            {nums.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>
        </label>
        <label className="pivot-control">
          <span>Aggregate</span>
          <select value={agg} onChange={e => setAgg(e.target.value)}>
            <option value="sum">Sum</option>
            <option value="avg">Average</option>
            <option value="count">Count</option>
          </select>
        </label>
        <label className="pivot-control pivot-control-check">
          <input type="checkbox" checked={shade} onChange={e => setShade(e.target.checked)} /> <span>Shade</span>
        </label>
        {canDrill && <span className="pivot-hint">Click a cell to filter →</span>}
      </div>
      {data ? (
        <div className="pivot-scroll">
          <table className="pivot-table">
            <thead>
              <tr>
                <th className="pivot-corner">{rowDim} ↓ {colDim ? "× " + colDim : ""}</th>
                {data.colKeys.map(ck => <th key={ck}>{ck}</th>)}
                <th className="pivot-total">Total</th>
              </tr>
            </thead>
            <tbody>
              {data.rowKeys.map(rk => {
                let rowTotal = 0, rowCount = 0;
                data.colKeys.forEach(ck => {
                  const v = aggValue(rk, ck);
                  if (v !== null) { rowTotal += v; rowCount++; }
                });
                const totalDisplay = agg === "avg" ? (rowCount ? rowTotal / rowCount : null) : rowTotal;
                return (
                  <tr key={rk}>
                    <th>{rk}</th>
                    {data.colKeys.map(ck => {
                      const v = aggValue(rk, ck);
                      return <td key={ck} className={canDrill ? "pivot-cell" : ""} style={heatStyle(v)} onClick={canDrill ? () => drill(rk, ck) : undefined} title={canDrill ? "Filter to " + rk + (colDim ? " · " + ck : "") : undefined}>{fmt(v)}</td>;
                    })}
                    <td className="pivot-total">{fmt(totalDisplay)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : <div style={{ padding: 24, color: "var(--ink-faint)" }}>Pick a row dimension to get started.</div>}
    </div>
  );
}

// =================== Export dropdown (CSV → JSON / SQL / MD / HTML / XML / Excel) ===================
function ExportMenu({ profile, csvText, filename, standalone }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    function onDoc(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  function base() { return (filename || "data").replace(/\.[^.]+$/, ""); }

  function exportAs(format) {
    setOpen(false);
    if (!profile) return;
    try {
      if (format === "json")     Convert.download(Convert.csvToJSON(profile, { minified: false }), base() + ".json", "application/json");
      else if (format === "sql") Convert.download(Convert.csvToSQL(profile, { tableName: base() }), base() + ".sql", "application/sql");
      else if (format === "md")  Convert.download(Convert.csvToMarkdown(profile), base() + ".md", "text/markdown");
      else if (format === "html") Convert.download(Convert.csvToHTML(profile, { standalone: true }), base() + ".html", "text/html");
      else if (format === "xml") Convert.download(Convert.csvToXML(profile), base() + ".xml", "application/xml");
      else if (format === "xlsx") {
        ensureXLSX()
          .then(() => Convert.download(Convert.csvToExcel(profile), base() + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))
          .catch(() => alert("Could not load the Excel engine. Check your connection and try again."));
      }
      else if (format === "csv") Convert.download(csvText || "", base() + ".csv", "text/csv");
      else if (format === "pdf") {
        exportDashboardPDF(profile, filename).catch(() => alert("Could not load the PDF engine. Check your connection and try again."));
      }
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div className="export-menu-wrap" ref={ref}>
      <button className="btn-ghost" onClick={() => setOpen(v => !v)}>
        Export {open ? "▴" : "▾"}
      </button>
      {open && (
        <div className="export-menu">
          <button className="export-menu-item" onClick={() => exportAs("csv")}>CSV<span className="export-menu-hint">.csv · original</span></button>
          <button className="export-menu-item" onClick={() => exportAs("json")}>JSON<span className="export-menu-hint">.json · typed</span></button>
          <button className="export-menu-item" onClick={() => exportAs("sql")}>SQL<span className="export-menu-hint">.sql · CREATE + INSERT</span></button>
          <button className="export-menu-item" onClick={() => exportAs("md")}>Markdown<span className="export-menu-hint">.md · pipe table</span></button>
          <button className="export-menu-item" onClick={() => exportAs("html")}>HTML<span className="export-menu-hint">.html · standalone</span></button>
          <button className="export-menu-item" onClick={() => exportAs("xml")}>XML<span className="export-menu-hint">.xml · well-formed</span></button>
          {/* Excel needs the SheetJS vendor lib loaded from /vendor — unavailable
              in a downloaded standalone copy (file://), so hide it there. */}
          {!standalone && <button className="export-menu-item" onClick={() => exportAs("xlsx")}>Excel<span className="export-menu-hint">.xlsx · typed</span></button>}
          {/* PDF needs the jsPDF vendor pair — same file:// constraint as Excel */}
          {!standalone && <button className="export-menu-item" onClick={() => exportAs("pdf")}>PDF<span className="export-menu-hint">.pdf · summary + data</span></button>}
        </div>
      )}
    </div>
  );
}

// =================== Share button (copies current URL with state hash) ===================
function ShareButton({ csvText }) {
  const [state, setState] = useState("idle");
  async function share() {
    let url = window.location.href, viewOnly = false;
    // A sample-backed link is already self-sufficient (it references a built-in
    // sample by name). For uploaded data the URL alone carries no data, so embed
    // the CSV via the existing #data= load path when it's small enough.
    let isSample = false;
    try {
      const h = (window.location.hash || "").replace(/^#/, "");
      if (h && !h.startsWith("data=")) { const s = JSON.parse(decodeURIComponent(atob(h.replace(/-/g, "+").replace(/_/g, "/")))); isSample = !!(s && s.sample); }
    } catch (e) { /* not a state hash */ }
    if (!isSample && csvText) {
      try {
        const b64 = btoa(unescape(encodeURIComponent(csvText))).replace(/\+/g, "-").replace(/\//g, "_");
        const cand = window.location.origin + window.location.pathname + "#data=" + b64;
        if (cand.length <= 32000) url = cand; else viewOnly = true; // too big to embed in a URL
      } catch (e) { viewOnly = true; }
    }
    try {
      await navigator.clipboard.writeText(url);
      setState(viewOnly ? "viewonly" : "copied");
      setTimeout(() => setState("idle"), 2600);
    } catch (e) {
      setState("error");
      setTimeout(() => setState("idle"), 2200);
    }
  }
  const label = state === "copied" ? "Link copied" : state === "viewonly" ? "Copied · needs the file" : state === "error" ? "Copy failed" : "Share link";
  return <button className="btn-ghost" onClick={share} title="Copies a link that reproduces this dashboard — small files embed the data; large files share the view and the recipient needs the same CSV">{label}</button>;
}

// =================== Screenshot button ===================
function ScreenshotButton({ filename }) {
  const [state, setState] = useState("idle");
  async function shoot() {
    setState("rendering");
    try {
      await exportDashboardPNG(filename);
      setState("done");
      setTimeout(() => setState("idle"), 1800);
    } catch (e) {
      console.error(e);
      setState("error");
      setTimeout(() => setState("idle"), 2200);
    }
  }
  const label = state === "rendering" ? "Rendering…" : state === "done" ? "Saved!" : state === "error" ? "Failed" : "Save PNG";
  return <button className="btn-ghost" onClick={shoot} disabled={state === "rendering"}>{label}</button>;
}

// =================== Highlights row (top movers + anomalies) ===================
function HighlightsRow({ movers, anomalies, primaryNum, primaryDate, primaryCat }) {
  if (!movers && (!anomalies || anomalies.length === 0)) return null;

  function pctStr(pct) {
    const sign = pct >= 0 ? "+" : "";
    return sign + (pct * 100).toFixed(0) + "%";
  }

  return (
    <div className="highlights">
      {movers && movers.gainer && movers.loser && (
        <>
          <div className="highlight-card highlight-up">
            <div className="highlight-label">
              <span className="highlight-arrow">↑</span>
              Top gainer
            </div>
            <div className="highlight-value">{movers.gainer.key}</div>
            <div className="highlight-sub">
              {fmtByCol(primaryNum, movers.gainer.a)} → {fmtByCol(primaryNum, movers.gainer.b)}{" "}
              <span className="highlight-delta">{pctStr(movers.gainer.pct)}</span>
            </div>
            <div className="highlight-context">in {primaryNum.name}, second half of {primaryDate.name}</div>
          </div>
          <div className="highlight-card highlight-down">
            <div className="highlight-label">
              <span className="highlight-arrow">↓</span>
              Biggest decline
            </div>
            <div className="highlight-value">{movers.loser.key}</div>
            <div className="highlight-sub">
              {fmtByCol(primaryNum, movers.loser.a)} → {fmtByCol(primaryNum, movers.loser.b)}{" "}
              <span className="highlight-delta down">{pctStr(movers.loser.pct)}</span>
            </div>
            <div className="highlight-context">in {primaryNum.name}, second half of {primaryDate.name}</div>
          </div>
        </>
      )}
      {anomalies && anomalies.length > 0 && (
        <div className="highlight-card highlight-anom">
          <div className="highlight-label">
            <span className="highlight-arrow">!</span>
            {anomalies.length === 1 ? "1 outlier" : `${anomalies.length} outliers`}
          </div>
          <div className="highlight-value">
            {anomalies.slice(0, 3).map((a, i) => (
              <div key={i} className="anom-line">
                <span className="anom-z">{a.z > 0 ? "+" : ""}{a.z.toFixed(1)}σ</span>
                <span className="anom-val">{fmtByCol(primaryNum, a.value)}</span>
              </div>
            ))}
          </div>
          <div className="highlight-context">{anomalies.length > 3 ? `+${anomalies.length - 3} more · ` : ""}{">"}2σ from mean in {primaryNum.name}</div>
        </div>
      )}
    </div>
  );
}

// =================== Copy-as-text summary (deterministic) ===================
function buildSummaryText(profile) {
  const { rows, cols } = profile;
  const chartable = cols.filter(c => c.role !== "id");
  const nums = chartable.filter(c => c.type === "number").sort((a, b) => b.importance - a.importance);
  const cats = chartable.filter(c => c.type === "category" || c.type === "boolean").sort((a, b) => b.importance - a.importance);
  const dates = chartable.filter(c => c.type === "date");
  const num = nums[0], cat = cats[0], date = dates[0];
  const parts = [];

  // Opener: scope
  let opener = `${rows.length.toLocaleString()} rows across ${cols.length} columns`;
  if (date && date.minDate && date.maxDate) {
    const days = Math.round((date.maxDate - date.minDate) / 86400000);
    const range = days >= 365 ? `${(days / 365).toFixed(1)} years` :
                  days >= 60 ? `${Math.round(days / 30)} months` :
                  days >= 7 ? `${Math.round(days / 7)} weeks` :
                  `${days} days`;
    opener += ` spanning ${range}`;
  }
  parts.push(opener + ".");

  // Primary metric total + average
  if (num) {
    const useAvg = num.role === "rating" || num.role === "percent" || num.role === "age";
    if (useAvg) {
      parts.push(`Average ${num.name} is ${fmtByCol(num, num.avg)} (range ${fmtByCol(num, num.min)}–${fmtByCol(num, num.max)}).`);
    } else {
      parts.push(`Total ${num.name} is ${fmtByCol(num, num.sum)}, averaging ${fmtByCol(num, num.avg)} per row.`);
    }
  }

  // Top category by primary metric
  if (num && cat) {
    const sums = new Map();
    rows.forEach(r => {
      const k = String(r[cat.name] || "—");
      const v = CSVTool.parseNumber(r[num.name]);
      if (v !== null) sums.set(k, (sums.get(k) || 0) + v);
    });
    const sorted = [...sums.entries()].sort((a, b) => b[1] - a[1]);
    const total = sorted.reduce((s, e) => s + e[1], 0);
    if (sorted[0] && total > 0) {
      const pct = sorted[0][1] / total * 100;
      parts.push(`${sorted[0][0]} leads ${cat.name} at ${pct.toFixed(0)}% of ${num.name} (${fmtByCol(num, sorted[0][1])}).`);
    }
  }

  // Trend (first half vs second half)
  if (num && date) {
    const dated = rows.map(r => ({
      d: CSVTool.parseDate(r[date.name]),
      v: CSVTool.parseNumber(r[num.name])
    })).filter(x => x.d && x.v !== null).sort((a, b) => a.d - b.d);
    if (dated.length >= 6) {
      const mid = Math.floor(dated.length / 2);
      const a = dated.slice(0, mid).reduce((s, x) => s + x.v, 0);
      const b = dated.slice(mid).reduce((s, x) => s + x.v, 0);
      if (a !== 0) {
        const pct = (b - a) / Math.abs(a) * 100;
        if (Math.abs(pct) >= 5) {
          parts.push(`${num.name} ${pct > 0 ? "grew" : "declined"} ${Math.abs(pct).toFixed(0)}% from the first half to the second.`);
        }
      }
    }
  }

  // Outliers
  if (num && num.nums.length >= 6) {
    const mean = num.avg;
    const variance = num.nums.reduce((s, n) => s + (n - mean) ** 2, 0) / num.nums.length;
    const sigma = Math.sqrt(variance);
    if (sigma > 0) {
      const count = num.nums.filter(n => Math.abs((n - mean) / sigma) >= 2).length;
      if (count > 0) {
        parts.push(`${count} ${count === 1 ? "row was" : "rows were"} flagged as outliers (>2σ from mean in ${num.name}).`);
      }
    }
  }

  return parts.join(" ");
}

function CopySummaryButton({ profile, filters }) {
  const [state, setState] = useState("idle"); // idle | copied | error

  async function copy() {
    try {
      const text = buildSummaryText(profile);
      await navigator.clipboard.writeText(text);
      setState("copied");
      setTimeout(() => setState("idle"), 2500);
    } catch (e) {
      console.error(e);
      setState("error");
      setTimeout(() => setState("idle"), 2500);
    }
  }

  const label = state === "copied" ? "Copied!"
    : state === "error" ? "Try again"
    : "Copy summary";

  return (
    <button className="btn-ghost" onClick={copy}>
      {label}
    </button>
  );
}

// =================== Dashboard component ===================
// V5 Batch C — profile-driven data-hygiene hints. Detection runs on a 500-row
// sample; each hint deep-links the tool (or guide) that fixes it. Dismissable.
function CleaningSuggestions({ profile }) {
  const [hidden, setHidden] = useState(false);
  const suggestions = useMemo(() => {
    const out = [];
    const rows = profile.rows.slice(0, 500);
    if (!rows.length) return out;
    for (const c of profile.cols) {
      const vals = [];
      for (let i = 0; i < rows.length; i++) { const v = rows[i][c.name]; if (v != null && v !== "") vals.push(String(v)); }
      if (vals.length < 5) continue;
      const frac = f => vals.filter(f).length / vals.length;
      if ((c.type === "text" || c.type === "category") && frac(v => v.length >= 6 && CSVTool.parseDate(v) != null) > 0.8) {
        out.push({ key: "dates-" + c.name, text: `“${c.name}” looks like dates stored as text`, href: "/csv-normalize-dates", cta: "normalize to ISO" });
      }
      if (frac(v => /^\d{15,}$/.test(v.trim())) > 0.5) {
        out.push({ key: "ids-" + c.name, text: `“${c.name}” holds 15+ digit IDs Excel would corrupt`, href: "/csv-scientific-notation", cta: "protect them" });
      }
      if (frac(v => v !== v.trim()) > 0.1) {
        out.push({ key: "ws-" + c.name, text: `“${c.name}” has stray leading/trailing spaces`, href: "/csv-trim-whitespace", cta: "trim whitespace" });
      }
    }
    const seen = new Set();
    let dup = 0;
    for (const r of rows) {
      const k = profile.cols.map(c => String(r[c.name] == null ? "" : r[c.name])).join("");
      if (seen.has(k)) dup++; else seen.add(k);
    }
    if (dup > 0) out.push({ key: "dupes", text: `${dup === 1 ? "a duplicate row" : fmtNum(dup) + " duplicate rows"} in the first ${fmtNum(rows.length)}`, href: "/csv-dedupe", cta: "dedupe" });
    return out.slice(0, 3);
  }, [profile]);
  if (hidden || !suggestions.length) return null;
  return (
    <div className="clean-suggest" role="note">
      <span className="clean-suggest-label">✦ data hygiene</span>
      {suggestions.map(s => (
        <span className="clean-suggest-item" key={s.key}>
          {s.text} — <a href={s.href}>{s.cta} →</a>
        </span>
      ))}
      <button className="clean-suggest-x" onClick={() => setHidden(true)} aria-label="Dismiss suggestions">×</button>
    </div>
  );
}

function Dashboard({ profile: rawProfile, filename, onReset, csvText }) {
  // Role overrides: { [colName]: newRole }
  const [roleOverrides, setRoleOverrides] = useState({});
  // Calculated columns: [{ name, formula }]
  const [calcCols, setCalcCols] = useState([]);

  // Apply calculated columns first (extends the profile with derived numeric columns)
  const profileWithCalc = useMemo(() => {
    if (calcCols.length === 0) return rawProfile;
    const newRows = rawProfile.rows.map(r => {
      const out = { ...r };
      for (const c of calcCols) {
        const v = evalExpr(c.formula, r);
        out[c.name] = isNaN(v) ? "" : String(+v.toFixed(4));
      }
      return out;
    });
    const newHeaders = [...rawProfile.cols.map(c => c.name), ...calcCols.map(c => c.name)];
    return CSVTool.profile({ headers: newHeaders, rows: newRows });
  }, [rawProfile, calcCols]);

  // Apply role overrides to the calc-augmented profile
  const profile = useMemo(() => {
    if (Object.keys(roleOverrides).length === 0) return profileWithCalc;
    const ROLE_TO_FORMAT = {
      currency: "currency", count: "int", percent: "percent", rating: "decimal",
      duration: "decimal", numeric: "decimal", id: "id",
      email: "email", url: "url", phone: "phone",
      status: "text", product: "text", channel: "text", region: "text", country: "text",
      state: "text", city: "text", team: "text", name: "text", category: "text", text: "text",
      date: "date", boolean: "text"
    };
    const ROLE_TO_IMPORTANCE = {
      currency: 100, count: 70, percent: 60, rating: 50, duration: 40, numeric: 30, id: -10,
      email: 5, url: 5, phone: 5, country: 25, region: 25, state: 20, city: 20,
      status: 20, product: 28, channel: 24, team: 22, category: 22, name: 8, text: 10,
      date: 50, boolean: 15
    };
    return {
      ...profileWithCalc,
      cols: profileWithCalc.cols.map(c => {
        const r = roleOverrides[c.name];
        if (!r) return c;
        return { ...c, role: r, format: ROLE_TO_FORMAT[r] || c.format, importance: ROLE_TO_IMPORTANCE[r] ?? c.importance };
      })
    };
  }, [profileWithCalc, roleOverrides]);

  const { rows: allRows, cols } = profile;
  // Read initial state from URL hash (filters, brush, groupBy, roleOverrides) — applied once
  // after first render so we can re-share a populated dashboard via a single link.
  const initial = useMemo(() => {
    try {
      const m = (window.location.hash || "").match(/^#?(.+)$/);
      if (!m) return null;
      const json = decodeURIComponent(escape(atob(m[1].replace(/-/g, "+").replace(/_/g, "/"))));
      return JSON.parse(json);
    } catch (e) { return null; }
  }, []);

  const [filters, setFilters] = useState(() => {
    if (initial && initial.filters) {
      const out = {};
      for (const k of Object.keys(initial.filters)) out[k] = new Set(initial.filters[k]);
      return out;
    }
    return {};
  });
  const [dateBrush, setDateBrush] = useState(() => {
    if (initial && initial.brush && initial.brush.start && initial.brush.end) {
      return { start: new Date(initial.brush.start), end: new Date(initial.brush.end) };
    }
    return null;
  });
  const [groupBy, setGroupBy] = useState(() => initial?.groupBy || null);
  const [pivotMode, setPivotMode] = useState(false);
  // Editable-canvas state lives here (next to the hash logic) so it persists +
  // shares via the URL like filters/brush. Hydrated from the hash; absent keys
  // (old share links) default to no customization.
  const [layout, setLayout] = useState(() => (initial && initial.layout) || null);
  const [customPanels, setCustomPanels] = useState(() => (initial && Array.isArray(initial.customPanels)) ? initial.customPanels : []);

  // Apply role overrides from hash on first render
  useEffect(() => {
    if (initial && initial.roleOverrides) {
      setRoleOverrides(prev => ({ ...prev, ...initial.roleOverrides }));
    }
    // eslint-disable-next-line
  }, []);

  // Persist current state to URL hash so the link is shareable
  useEffect(() => {
    const state = {};
    // Sample key from current filename if applicable
    if (CSVTool.SAMPLES) {
      const match = Object.entries(CSVTool.SAMPLES).find(([, s]) => s.name === filename);
      if (match) state.sample = match[0];
    }
    if (Object.keys(filters).length > 0) {
      state.filters = {};
      for (const k of Object.keys(filters)) state.filters[k] = [...filters[k]];
    }
    if (dateBrush && dateBrush.start && dateBrush.end) {
      state.brush = { start: +dateBrush.start, end: +dateBrush.end };
    }
    if (groupBy) state.groupBy = groupBy;
    if (Object.keys(roleOverrides).length > 0) state.roleOverrides = roleOverrides;
    if (layout && ((layout.order || []).length || (layout.removed || []).length || Object.keys(layout.hues || {}).length)) state.layout = layout;
    if (customPanels.length > 0) state.customPanels = customPanels;

    if (Object.keys(state).length === 0) {
      if (window.location.hash) history.replaceState(null, "", window.location.pathname + window.location.search);
      return;
    }
    const json = JSON.stringify(state);
    const b64 = btoa(unescape(encodeURIComponent(json))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    if ("#" + b64 !== window.location.hash) {
      history.replaceState(null, "", window.location.pathname + window.location.search + "#" + b64);
    }
  }, [filters, dateBrush, groupBy, roleOverrides, filename, layout, customPanels]);

  function toggleFilter(colName, value) {
    setFilters(f => {
      const cur = new Set(f[colName] || []);
      if (cur.has(value)) cur.delete(value); else cur.add(value);
      const next = { ...f };
      if (cur.size === 0) delete next[colName];
      else next[colName] = cur;
      return next;
    });
  }
  function clearFilter(colName) {
    setFilters(f => { const n = { ...f }; delete n[colName]; return n; });
  }
  function clearAllFilters() { setFilters({}); setDateBrush(null); }

  // Find primary date column once (using original profile so it survives empty-filter cases)
  const primaryDateCol = useMemo(() => cols.find(c => c.type === "date" && c.role !== "id"), [cols]);

  // Filtered rows: apply category filters + date brush
  const rows = useMemo(() => {
    const keys = Object.keys(filters);
    let out = allRows;
    if (keys.length > 0) {
      out = out.filter(r => keys.every(k => filters[k].has(String(r[k] || "—"))));
    }
    if (dateBrush && primaryDateCol) {
      const start = +dateBrush.start;
      const end = +dateBrush.end;
      const lo = Math.min(start, end);
      const hi = Math.max(start, end);
      out = out.filter(r => {
        const d = CSVTool.parseDate(r[primaryDateCol.name]);
        if (!d) return false;
        const t = +d;
        return t >= lo && t <= hi;
      });
    }
    return out;
  }, [allRows, filters, dateBrush, primaryDateCol]);

  // Re-profile the filtered rows for KPIs/aggregations but keep original col META (roles, types)
  const filteredProfile = useMemo(() => {
    if (Object.keys(filters).length === 0 && !dateBrush) return profile;
    const reProfiled = CSVTool.profile({ headers: cols.map(c => c.name), rows });
    reProfiled.cols = reProfiled.cols.map((c, i) => ({
      ...c,
      role: cols[i].role,
      format: cols[i].format,
      importance: cols[i].importance,
      currencySymbol: cols[i].currencySymbol
    }));
    return reProfiled;
  }, [rows, profile, filters, dateBrush]);

  return <DashboardInner
    profile={filteredProfile}
    originalProfile={profile}
    filteredRowCount={rows.length}
    totalRowCount={allRows.length}
    filters={filters}
    dateBrush={dateBrush}
    onBrushChange={setDateBrush}
    groupBy={groupBy}
    onGroupByChange={setGroupBy}
    onToggleFilter={toggleFilter}
    onClearFilter={clearFilter}
    onClearAll={clearAllFilters}
    onRoleOverride={(name, role) => setRoleOverrides(o => ({ ...o, [name]: role }))}
    onAddCalcCol={(name, formula) => setCalcCols(cs => [...cs, { name, formula }])}
    pivotMode={pivotMode}
    onPivotModeChange={setPivotMode}
    layout={layout}
    onLayoutChange={setLayout}
    customPanels={customPanels}
    onCustomPanelsChange={setCustomPanels}
    filename={filename}
    csvText={csvText}
    onReset={onReset}
  />;
}

function DashboardInner({ profile, originalProfile, filteredRowCount, totalRowCount, filters, dateBrush, onBrushChange, groupBy, onGroupByChange, onToggleFilter, onClearFilter, onClearAll, onRoleOverride, onAddCalcCol, pivotMode, onPivotModeChange, layout, onLayoutChange, customPanels, onCustomPanelsChange, filename, csvText, onReset }) {
  const { rows, cols } = profile;
  const isStandalone = typeof window !== "undefined" && !!window.__STANDALONE_AUTOLOAD__;
  const isFiltered = Object.keys(filters).length > 0 || !!dateBrush;
  // Editable canvas: the heuristic below still SEEDS the panels every render (so
  // live filters/brush stay wired), but the user can remove + reorder them and add
  // custom ones. `layout` ({order,removed}, null=default) and `customPanels`
  // (specs) are OWNED by the parent Dashboard so they persist + share via the URL
  // hash; here they're just props. Setter aliases keep the call sites below short.
  const setLayout = onLayoutChange;
  const setCustomPanels = onCustomPanelsChange;
  const [adding, setAdding] = useState(false);
  const [huePick, setHuePick] = useState(null); // panel id with the color swatches open (V7 D)
  const [exportPick, setExportPick] = useState(null);
  const [exportStatus, setExportStatus] = useState("");
  // Close panel popovers on Escape / outside click, like the editor's popovers.
  useEffect(() => {
    if (!huePick && !exportPick) return;
    const onKey = e => {
      if (e.key !== "Escape") return;
      setHuePick(null);
      setExportPick(null);
    };
    const onDoc = e => {
      if (e.target.closest(".hue-pop, .chart-export-pop, .chart-tool")) return;
      setHuePick(null);
      setExportPick(null);
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onDoc);
    return () => { document.removeEventListener("keydown", onKey); document.removeEventListener("mousedown", onDoc); };
  }, [huePick, exportPick]);
  const [draft, setDraft] = useState({ kind: "bar", cat: "", date: "", num: "", num2: "", agg: "sum", topN: 8, title: "" });
  // Filter out id columns from charting — but if that leaves nothing (e.g. a
  // table where every numeric column looks like an id), fall back to charting
  // all columns so the dashboard still has content instead of rendering blank.
  let chartableCols = cols.filter(c => c.role !== "id");
  if (chartableCols.length === 0) chartableCols = cols.slice();
  const numericCols = chartableCols.filter(c => c.type === "number");
  const categoryCols = chartableCols.filter(c => c.type === "category" || c.type === "boolean");
  const dateCols = chartableCols.filter(c => c.type === "date");

  // Pick PRIMARY metric by importance (revenue beats count beats "value")
  const sortedNum = [...numericCols].sort((a, b) => b.importance - a.importance);
  const primaryNum = sortedNum[0];
  const secondaryNum = sortedNum[1];

  // Pick primary category by importance (region/product beats name)
  const sortedCat = [...categoryCols].sort((a, b) => b.importance - a.importance);
  const autoCat = sortedCat[0];
  // Group-by override
  const primaryCat = (groupBy && categoryCols.find(c => c.name === groupBy)) || autoCat;
  const secondaryCat = sortedCat.find(c => c.name !== (primaryCat && primaryCat.name)) || sortedCat[1];

  const primaryDate = dateCols[0];

  // ===== Time-series for primary numeric over primary date =====
  const timeSeries = useMemo(() => {
    if (!primaryDate || !primaryNum) return null;
    const buckets = new Map();
    rows.forEach(r => {
      const d = CSVTool.parseDate(r[primaryDate.name]);
      const n = CSVTool.parseNumber(r[primaryNum.name]);
      if (!d || n === null) return;
      const key = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
      buckets.set(key, (buckets.get(key) || 0) + n);
    });
    const points = [...buckets.entries()]
      .map(([k, v]) => ({ x: new Date(k), y: v }))
      .sort((a, b) => a.x - b.x);
    return points.length >= 2 ? points : null;
  }, [profile]);

  // ===== KPIs (using semantic formatting) =====
  // KPIs with a `rawValue` + `format` get animated count-up; ones with `value` are static text.
  const kpis = useMemo(() => {
    const out = [
      { label: "Rows", rawValue: rows.length, format: (n) => fmtNum(n), sub: `${cols.length} columns` }
    ];

    if (primaryNum) {
      const useAvg = primaryNum.role === "rating" || primaryNum.role === "percent" || primaryNum.role === "age";
      const headlineValue = useAvg ? primaryNum.avg : primaryNum.sum;
      const headlineLabel = useAvg ? `Avg · ${primaryNum.name}` : `Total · ${primaryNum.name}`;

      let sparkValues = null;
      if (timeSeries) {
        sparkValues = timeSeries.map(p => p.y);
      } else if (primaryNum.nums.length >= 4) {
        sparkValues = primaryNum.nums.slice(0, 30);
      }

      out.push({
        label: headlineLabel,
        rawValue: headlineValue,
        format: (n) => fmtByCol(primaryNum, n),
        sub: `${fmtNum(primaryNum.count)} values · avg ${fmtByCol(primaryNum, primaryNum.avg)}`,
        spark: sparkValues,
        temporal: !!timeSeries // only a real time series earns a "vs first half" trend badge
      });

      if (secondaryNum) {
        const useAvg2 = secondaryNum.role === "rating" || secondaryNum.role === "percent" || secondaryNum.role === "age";
        out.push({
          label: (useAvg2 ? "Avg · " : "Total · ") + secondaryNum.name,
          rawValue: useAvg2 ? secondaryNum.avg : secondaryNum.sum,
          format: (n) => fmtByCol(secondaryNum, n),
          sub: `min ${fmtByCol(secondaryNum, secondaryNum.min)} · max ${fmtByCol(secondaryNum, secondaryNum.max)}`
        });
      }
    }

    if (primaryCat) {
      out.push({
        label: `Top · ${primaryCat.name}`,
        value: primaryCat.counts[0]?.key || "—",
        sub: `${fmtNum(primaryCat.counts[0]?.value || 0)} of ${fmtNum(rows.length)} · ${primaryCat.unique} unique`
      });
    }

    if (primaryDate && primaryDate.minDate && primaryDate.maxDate) {
      const days = Math.round((primaryDate.maxDate - primaryDate.minDate) / 86400000);
      const rangeStr = days >= 365
        ? `${(days / 365).toFixed(1)}y`
        : days >= 60 ? `${Math.round(days / 30)}mo` : `${days}d`;
      out.push({
        label: `Range · ${primaryDate.name}`,
        value: rangeStr,
        sub: `${fmtDateShort(primaryDate.minDate)} → ${fmtDateShort(primaryDate.maxDate)}`
      });
    }

    return out.slice(0, 5);
  }, [profile, timeSeries]);

  // ===== Cat × num aggregation =====
  function aggCatNum(cat, num) {
    const sums = new Map();
    rows.forEach(r => {
      const k = String(r[cat.name] || "—");
      const v = CSVTool.parseNumber(r[num.name]);
      if (v === null) return;
      sums.set(k, (sums.get(k) || 0) + v);
    });
    return [...sums.entries()].map(([key, value]) => ({ key, value })).sort((a, b) => b.value - a.value);
  }

  // ===== Top movers (first half vs second half over time) =====
  // deps must include the groupBy-derived columns — primaryCat changes on regroup
  // WITHOUT profile changing, which otherwise leaves the mover cards stale vs the
  // breakdown bar (V7 audit).
  const movers = useMemo(() => findTopMovers(rows, primaryDate, primaryNum, primaryCat), [profile, primaryCat && primaryCat.name, primaryNum && primaryNum.name, primaryDate && primaryDate.name]);
  // ===== Anomalies =====
  const anomalies = useMemo(() => findAnomalies(rows, primaryNum), [profile]);

  // ===== Build chart panels =====
  const panels = [];
  if (timeSeries) {
    const days = (timeSeries[timeSeries.length - 1].x - timeSeries[0].x) / 86400000;
    const grain = days > 365 ? "month" : days > 60 ? "week" : "day";
    panels.push({
      kind: "trend",
      title: `${primaryNum.name} over time`,
      sub: `${grain === "day" ? "daily" : grain + "ly"} totals · ${timeSeries.length} ${grain}s · drag to zoom · dashed = forecast`,
      wide: true,
      render: () => <LineChart
        points={timeSeries}
        valueLabel={primaryNum.name}
        col={primaryNum}
        brush={dateBrush}
        onBrushChange={onBrushChange}
        forecast={timeSeries.length >= 5}
      />
    });
  }
  if (primaryCat && primaryNum) {
    panels.push({
      kind: "breakdown",
      title: `${primaryNum.name} by ${primaryCat.name}`,
      sub: `Sum, top ${Math.min(8, primaryCat.unique)} · click to filter`,
      render: () => <BarChart
        data={aggCatNum(primaryCat, primaryNum)}
        maxBars={8}
        col={primaryNum}
        onBarClick={(k) => onToggleFilter(primaryCat.name, k)}
        activeKeys={filters[primaryCat.name]}
      />
    });
  }
  if (primaryNum && primaryNum.nums.length >= 5) {
    panels.push({
      kind: "distribution",
      title: `Distribution of ${primaryNum.name}`,
      sub: `${primaryNum.nums.length} values`,
      render: () => <Histogram values={primaryNum.nums} col={primaryNum} />
    });
  }
  if (secondaryCat && primaryNum) {
    const agg = aggCatNum(secondaryCat, primaryNum);
    if (agg.length <= 6) {
      panels.push({
        kind: "share",
        title: `${primaryNum.name} by ${secondaryCat.name}`,
        sub: `${secondaryCat.unique} segments · click to filter`,
        render: () => <Donut
          data={agg}
          col={primaryNum}
          onSliceClick={(k) => onToggleFilter(secondaryCat.name, k)}
          activeKeys={filters[secondaryCat.name]}
        />
      });
    } else {
      panels.push({
        kind: "breakdown",
        title: `${primaryNum.name} by ${secondaryCat.name}`,
        sub: `Sum, top 8 · click to filter`,
        render: () => <BarChart
          data={agg}
          maxBars={8}
          col={primaryNum}
          onBarClick={(k) => onToggleFilter(secondaryCat.name, k)}
          activeKeys={filters[secondaryCat.name]}
        />
      });
    }
  }
  if (secondaryNum && secondaryNum.nums.length >= 5) {
    panels.push({
      kind: "distribution",
      title: `Distribution of ${secondaryNum.name}`,
      sub: `${secondaryNum.nums.length} values`,
      render: () => <Histogram values={secondaryNum.nums} col={secondaryNum} />
    });
  }

  // ===== Scatter plot for 2 numerics (with correlation) =====
  const scatter = useMemo(() => {
    if (!primaryNum || !secondaryNum) return null;
    const pts = [];
    rows.forEach(r => {
      const x = CSVTool.parseNumber(r[primaryNum.name]);
      const y = CSVTool.parseNumber(r[secondaryNum.name]);
      if (x !== null && y !== null) pts.push({ x, y });
    });
    if (pts.length < 4) return null;
    const r = pearson(pts.map(p => p.x), pts.map(p => p.y));
    return { points: pts, correlation: r };
  }, [profile]);

  if (scatter) {
    const r = scatter.correlation;
    const strength = Math.abs(r) > 0.7 ? "strong" : Math.abs(r) > 0.4 ? "moderate" : Math.abs(r) > 0.2 ? "weak" : "no";
    const dir = r > 0 ? "positive" : "negative";
    panels.push({
      kind: "correlation",
      title: `${primaryNum.name} vs ${secondaryNum.name}`,
      sub: `r = ${r.toFixed(2)} · ${strength}${strength === "no" ? "" : " " + dir} correlation`,
      render: () => <ScatterPlot points={scatter.points} xCol={primaryNum} yCol={secondaryNum} correlation={r} />
    });
  }

  // V7 D — auto-seed a heatmap when two low-cardinality categories cross a
  // numeric: the matrix view answers "which combination drives it" at a glance.
  if (primaryCat && secondaryCat && primaryNum && primaryCat.unique >= 2 && primaryCat.unique <= 20 && secondaryCat.unique >= 2 && secondaryCat.unique <= 12) {
    panels.push({
      kind: "matrix",
      title: `${primaryNum.name}: ${primaryCat.name} × ${secondaryCat.name}`,
      sub: `sum per combination · click a cell`,
      wide: true,
      render: () => <HeatmapViz profile={profile} sel={{ rowDim: primaryCat.name, colDim: secondaryCat.name, measure: primaryNum.name, agg: "sum" }} />
    });
  }

  // Geographic bubble map when a country/state/region column exists
  const geoCol = chartableCols.find(c => ["country", "state", "region", "city"].includes(c.role));
  if (geoCol && primaryNum) {
    const sums = new Map();
    rows.forEach(r => {
      const k = String(r[geoCol.name] || "").trim();
      if (!k) return;
      const v = CSVTool.parseNumber(r[primaryNum.name]);
      if (v === null) return;
      sums.set(k, (sums.get(k) || 0) + v);
    });
    const geoData = [...sums.entries()].map(([key, value]) => ({ key, value }));
    panels.push({
      kind: "geo",
      title: `${primaryNum.name} by ${geoCol.name}`,
      sub: `world map · bubble size = ${primaryNum.name}`,
      wide: true,
      render: () => <GeoMap data={geoData} col={primaryNum} />
    });
  }
  if (panels.length === 0 && chartableCols[0]) {
    const c = chartableCols[0];
    const counts = new Map();
    rows.forEach(r => {
      const k = String(r[c.name] || "—");
      counts.set(k, (counts.get(k) || 0) + 1);
    });
    const data = [...counts.entries()].map(([key, value]) => ({ key, value })).sort((a, b) => b.value - a.value);
    panels.push({
      kind: "counts",
      title: `Counts by ${c.name}`,
      sub: `${counts.size} unique`,
      wide: true,
      render: () => <BarChart data={data} maxBars={10} />
    });
  }

  function panelClass(i, p) {
    if (p.wide) return "chart-card wide";
    return "chart-card";
  }

  // Aggregate a numeric measure by a category with sum / avg / count.
  function aggBy(catName, numName, agg) {
    const acc = new Map();
    rows.forEach(r => {
      const k = String(r[catName] || "—");
      const e = acc.get(k) || { sum: 0, n: 0, count: 0 };
      e.count += 1;
      if (agg !== "count") { const v = CSVTool.parseNumber(r[numName]); if (v !== null) { e.sum += v; e.n += 1; } }
      acc.set(k, e);
    });
    return [...acc.entries()]
      .map(([key, e]) => ({ key, value: agg === "count" ? e.count : agg === "avg" ? (e.n ? e.sum / e.n : 0) : e.sum }))
      .sort((a, b) => b.value - a.value);
  }

  function aggByDate(dateName, numName, agg) {
    const acc = new Map();
    rows.forEach(row => {
      const date = CSVTool.parseDate(row[dateName]);
      if (!date) return;
      const key = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
      const entry = acc.get(key) || { sum: 0, n: 0, count: 0 };
      entry.count += 1;
      if (agg !== "count") {
        const value = CSVTool.parseNumber(row[numName]);
        if (value !== null) { entry.sum += value; entry.n += 1; }
      }
      acc.set(key, entry);
    });
    return [...acc.entries()]
      .map(([key, entry]) => ({
        x: new Date(key),
        y: agg === "count" ? entry.count : agg === "avg" ? (entry.n ? entry.sum / entry.n : 0) : entry.sum
      }))
      .sort((a, b) => a.x - b.x);
  }

  // Render the user-composed ("Add chart") panels and append them to the seeded
  // set so they flow through the same layout / reorder / remove machinery.
  customPanels.forEach(spec => {
    const kind = ["bar", "donut", "line", "scatter", "histogram"].includes(spec.kind) ? spec.kind : "bar";
    const aggLabel = spec.agg === "count" ? "Count" : spec.agg === "avg" ? "Average" : "Sum";
    const customTitle = String(spec.title || "").trim();

    if (kind === "bar" || kind === "donut") {
      const cat = cols.find(c => c.name === spec.cat);
      if (!cat) return;
      const num = spec.agg === "count" ? null : cols.find(c => c.name === spec.num);
      if (spec.agg !== "count" && !num) return;
      const data = aggBy(spec.cat, spec.num, spec.agg);
      const what = spec.agg === "count" ? "rows" : spec.num;
      panels.push({
        id: spec.id,
        custom: true,
        kind,
        title: customTitle || `${aggLabel} of ${what} by ${spec.cat}`,
        sub: `custom ${kind} · ${aggLabel.toLowerCase()} by ${spec.cat}${kind === "bar" ? " · top " + (spec.topN || 8) : ""}`,
        render: () => kind === "donut"
          ? <Donut data={data.slice(0, 8)} col={num || undefined} />
          : <BarChart data={data} maxBars={spec.topN || 8} col={num || undefined} />
      });
      return;
    }

    if (kind === "line") {
      const date = cols.find(c => c.name === spec.date && c.type === "date");
      const num = spec.agg === "count" ? null : cols.find(c => c.name === spec.num && c.type === "number");
      if (!date || (spec.agg !== "count" && !num)) return;
      const points = aggByDate(spec.date, spec.num, spec.agg);
      if (points.length < 2) return;
      const what = spec.agg === "count" ? "rows" : spec.num;
      panels.push({
        id: spec.id,
        custom: true,
        kind: "line",
        wide: true,
        title: customTitle || `${aggLabel} of ${what} over ${spec.date}`,
        sub: `custom line · daily ${aggLabel.toLowerCase()} · ${points.length} dates`,
        render: () => <LineChart points={points} valueLabel={what} col={num || undefined} />
      });
      return;
    }

    if (kind === "scatter") {
      const xCol = cols.find(c => c.name === spec.num && c.type === "number");
      const yCol = cols.find(c => c.name === spec.num2 && c.type === "number");
      if (!xCol || !yCol || xCol.name === yCol.name) return;
      const points = rows.map(row => ({ x: CSVTool.parseNumber(row[xCol.name]), y: CSVTool.parseNumber(row[yCol.name]) }))
        .filter(point => point.x !== null && point.y !== null);
      if (points.length < 2) return;
      const correlation = pearson(points.map(point => point.x), points.map(point => point.y));
      panels.push({
        id: spec.id,
        custom: true,
        kind: "scatter",
        title: customTitle || `${yCol.name} vs ${xCol.name}`,
        sub: `custom scatter · ${points.length} pairs · r = ${correlation.toFixed(2)}`,
        render: () => <ScatterPlot points={points} xCol={xCol} yCol={yCol} correlation={correlation} />
      });
      return;
    }

    const num = cols.find(c => c.name === spec.num && c.type === "number");
    if (!num || num.nums.length < 2) return;
    panels.push({
      id: spec.id,
      custom: true,
      kind: "histogram",
      title: customTitle || `Distribution of ${num.name}`,
      sub: `custom histogram · ${num.nums.length} values · 12 bins`,
      render: () => <Histogram values={num.nums} col={num} />
    });
  });

  function draftIsValid() {
    if (draft.kind === "bar" || draft.kind === "donut") return !!draft.cat && (draft.agg === "count" || !!draft.num);
    if (draft.kind === "line") return !!draft.date && (draft.agg === "count" || !!draft.num);
    if (draft.kind === "scatter") return !!draft.num && !!draft.num2 && draft.num !== draft.num2;
    return !!draft.num;
  }

  function addChart() {
    if (!draftIsValid()) return;
    // Derive the next id from the max existing one (no ref) so ids restored from
    // the hash and newly-added ones never collide.
    const maxId = customPanels.reduce((m, s) => { const n = parseInt((s.id || "").split(":")[1], 10); return isNaN(n) ? m : Math.max(m, n); }, 0);
    const id = "custom:" + (maxId + 1);
    setCustomPanels(p => [...p, {
      id,
      kind: draft.kind,
      cat: draft.cat,
      date: draft.date,
      num: draft.num,
      num2: draft.num2,
      agg: draft.agg,
      topN: 8,
      title: String(draft.title || "").trim().slice(0, 120)
    }]);
    setAdding(false);
  }
  function openAddChart() {
    setDraft(d => ({
      ...d,
      cat: d.cat || (categoryCols[0] && categoryCols[0].name) || "",
      date: d.date || (dateCols[0] && dateCols[0].name) || "",
      num: d.num || (numericCols[0] && numericCols[0].name) || "",
      num2: d.num2 || (numericCols[1] && numericCols[1].name) || ""
    }));
    setAdding(true);
  }

  async function runPanelExport(event, panel, format) {
    const card = event.currentTarget.closest(".chart-card");
    setExportPick(null);
    setExportStatus(`Preparing ${format.toUpperCase()}…`);
    try {
      await exportChartPanel(card, panel.title, format);
      setExportStatus(`Saved ${format.toUpperCase()} · ${panel.title}`);
    } catch (error) {
      setExportStatus(error && error.message ? error.message : "Chart export failed.");
    }
  }

  const dashboardName = useMemo(() => generateDashboardName(profile), [profile]);

  // ===== Editable canvas: apply the user's layout over the seeded panels =====
  panels.forEach(p => { if (!p.id) p.id = p.kind + "·" + p.title; });
  let orderedPanels;
  if (!layout) {
    orderedPanels = panels;
  } else {
    const removedSet = new Set(layout.removed || []);
    const byId = new Map(panels.map(p => [p.id, p]));
    const ordered = (layout.order || []).map(id => byId.get(id)).filter(Boolean);
    const known = new Set(ordered.map(p => p.id));
    const appended = panels.filter(p => !known.has(p.id)); // panels new since the layout was set
    orderedPanels = [...ordered, ...appended].filter(p => !removedSet.has(p.id));
  }
  const isCustomized = !!layout && (((layout.removed || []).length) || ((layout.order || []).length) || Object.keys(layout.hues || {}).length > 0);
  const curOrder = () => orderedPanels.map(p => p.id);
  // V7 D — per-chart hue override, persisted in the layout hash like order/removed
  const panelHues = (layout && layout.hues) || {};
  function setPanelHue(id, hue) {
    setHuePick(null);
    setLayout(prev => {
      const hues = { ...((prev && prev.hues) || {}) };
      if (hue == null) delete hues[id]; else hues[id] = hue;
      return { order: (prev && prev.order) || [], removed: (prev && prev.removed) || [], hues };
    });
  }
  function removePanel(id) {
    if (id.indexOf("custom:") === 0) { setCustomPanels(p => p.filter(s => s.id !== id)); return; }
    setLayout(prev => {
      const order = (prev && prev.order && prev.order.length) ? prev.order : curOrder();
      return { order: order.filter(x => x !== id), removed: [...((prev && prev.removed) || []), id], hues: (prev && prev.hues) || {} };
    });
  }
  function movePanel(id, dir) {
    setLayout(prev => {
      const order = ((prev && prev.order && prev.order.length) ? prev.order : curOrder()).slice();
      const i = order.indexOf(id), j = i + dir;
      if (i < 0 || j < 0 || j >= order.length) return prev || { order, removed: [], hues: {} };
      const t = order[i]; order[i] = order[j]; order[j] = t;
      return { order, removed: (prev && prev.removed) || [], hues: (prev && prev.hues) || {} };
    });
  }

  return (
    <div className="dash fade-in">
      <div className="dash-head">
        <div>
          <h2 className="dash-title">{dashboardName}</h2>
          <div className="dash-meta">
            <span>{filename || "data.csv"}</span>
            <span>
              {isFiltered ? `${fmtNum(filteredRowCount)} of ${fmtNum(totalRowCount)} rows` : `${fmtNum(totalRowCount)} rows`}
            </span>
            <span>{cols.length} columns</span>
            {primaryNum && <span>focus: {primaryNum.name}</span>}
          </div>
        </div>
        <div className="dash-actions">
          {/* In a downloaded standalone copy there's no server and no shareable URL,
              so hide the controls that depend on them (Share, re-Export, and the
              vendor-lib-backed Excel export — all break under file://). */}
          {!isStandalone && <ShareButton csvText={csvText} />}
          <CopySummaryButton profile={profile} filters={filters} />
          <ScreenshotButton filename={filename} />
          <button className="btn-ghost"
            onClick={() => onPivotModeChange && onPivotModeChange(!pivotMode)}
            style={pivotMode ? { background: "var(--ink)", color: "var(--bg)", borderColor: "var(--ink)" } : {}}>
            {pivotMode ? "✓ Pivot" : "Pivot"}
          </button>
          {!isStandalone && <button className="btn-ghost" onClick={() => csvText && exportStandaloneHTML(csvText, filename)} title="Self-contained HTML — open offline, no internet needed">Export dashboard</button>}
          <ExportMenu profile={profile} csvText={csvText} filename={filename} standalone={isStandalone} />
          <a className="kofi-pill" href="https://ko-fi.com/csvtodashboard" target="_blank" rel="noopener" title="Support the project on Ko-fi">
            <span className="kofi-cup">☕</span>
            <span>Ko-fi</span>
          </a>
          <button className="btn-ghost danger" onClick={onReset}>Clear & upload new</button>
        </div>
      </div>

      <CleaningSuggestions profile={profile} />

      {isFiltered && (
        <div className="filter-bar">
          <span className="filter-bar-label">Filtered by</span>
          <div className="filter-chips">
            {Object.entries(filters).map(([col, set]) =>
              [...set].map(val => (
                <button key={col + ":" + val} className="filter-chip" onClick={() => onToggleFilter(col, val)}>
                  <span className="filter-chip-col">{col}</span>
                  <span className="filter-chip-val">{val}</span>
                  <span className="filter-chip-x">×</span>
                </button>
              ))
            )}
            {dateBrush && primaryDate && (
              <button className="filter-chip" onClick={() => onBrushChange(null)}>
                <span className="filter-chip-col">{primaryDate.name}</span>
                <span className="filter-chip-val">{fmtDateShort(dateBrush.start)} → {fmtDateShort(dateBrush.end)}</span>
                <span className="filter-chip-x">×</span>
              </button>
            )}
          </div>
          <button className="filter-clear" onClick={onClearAll}>Clear all</button>
        </div>
      )}

      {categoryCols.length >= 2 && (
        <div className="groupby">
          <span className="groupby-label">Group by</span>
          <div className="groupby-chips">
            {categoryCols.slice(0, 6).map(c => (
              <button
                key={c.name}
                className={"groupby-chip " + ((primaryCat && primaryCat.name === c.name) ? "active" : "")}
                onClick={() => onGroupByChange(c.name === autoCat.name ? null : c.name)}>
                {c.name}
              </button>
            ))}
          </div>
        </div>
      )}

      <Insights profile={profile} key={"insights-" + JSON.stringify(filters) + ":" + (dateBrush ? +dateBrush.start + "-" + +dateBrush.end : "") + ":" + (groupBy || "")} />

      <div className="kpi-row stagger">
        {kpis.map((k, i) => {
          // V7 D — conditional formatting: negative headline reads red; a spark
          // with ≥4 points gets a first-half vs second-half trend badge.
          const neg = typeof k.rawValue === "number" && k.rawValue < 0;
          let trend = null;
          // Only a genuine time series (date column) gets a temporal trend badge —
          // otherwise the spark is just row-order values and "vs first half" is a
          // fabricated trend on the common no-date dataset (V7 audit).
          if (k.temporal && k.spark && k.spark.length >= 4) {
            const half = Math.floor(k.spark.length / 2);
            const avg = a => a.reduce((x, y) => x + y, 0) / a.length;
            const a = avg(k.spark.slice(0, half)), b = avg(k.spark.slice(half));
            if (a !== 0) { const t = (b - a) / Math.abs(a) * 100; if (Math.abs(t) >= 1 && isFinite(t)) trend = t; }
          }
          return (
          <div className="kpi" key={i}>
            <div className="kpi-label">{k.label}</div>
            <div className={"kpi-value" + (neg ? " kpi-neg" : "")}>
              {k.rawValue !== undefined ? <AnimatedNumber value={k.rawValue} format={k.format} /> : k.value}
              {trend != null && (
                <span className={"kpi-trend " + (trend >= 0 ? "kpi-trend-up" : "kpi-trend-down")} title="Second half of the period vs the first half">
                  {(trend >= 0 ? "▲" : "▼") + " " + Math.abs(trend).toFixed(0) + "%"}
                </span>
              )}
            </div>
            <div className="kpi-sub">
              {k.sub}
              {k.spark && (
                <div style={{ marginTop: 8 }}>
                  <Sparkline values={k.spark} width={88} height={22} />
                </div>
              )}
            </div>
          </div>
          );
        })}
      </div>

      <HighlightsRow movers={movers} anomalies={anomalies} primaryNum={primaryNum} primaryDate={primaryDate} primaryCat={primaryCat} />

      {pivotMode ? (
        <PivotTable profile={profile} filters={filters} onToggleFilter={onToggleFilter} />
      ) : (
        <>
          <div className="charts-toolbar">
            {(categoryCols.length > 0 || dateCols.length > 0 || numericCols.length > 0) && (
              <button className="btn-ghost" onClick={() => (adding ? setAdding(false) : openAddChart())}>{adding ? "Close" : "+ Add chart"}</button>
            )}
            <span className="charts-toolbar-spacer" />
            <span className="charts-export-status" role="status" aria-live="polite">{exportStatus}</span>
            {isCustomized && <span className="charts-toolbar-note">Custom layout</span>}
            {isCustomized && <button className="btn-ghost" onClick={() => { setLayout(null); setCustomPanels([]); }}>Reset</button>}
          </div>
          {adding && (categoryCols.length > 0 || dateCols.length > 0 || numericCols.length > 0) && (
            <div className="add-chart-form" role="group" aria-label="Add a custom chart">
              <label>Chart
                <select value={draft.kind} onChange={e => setDraft(d => ({ ...d, kind: e.target.value }))}>
                  <option value="bar">Bar</option>
                  <option value="donut">Donut</option>
                  <option value="line">Line / area</option>
                  <option value="scatter">Scatter</option>
                  <option value="histogram">Histogram</option>
                </select>
              </label>
              {(draft.kind === "bar" || draft.kind === "donut" || draft.kind === "line") && (
                <label>Show
                  <select value={draft.agg} onChange={e => setDraft(d => ({ ...d, agg: e.target.value }))}>
                    <option value="sum">Sum</option>
                    <option value="avg">Average</option>
                    <option value="count">Count rows</option>
                  </select>
                </label>
              )}
              {draft.kind !== "line" && draft.kind !== "scatter" && draft.kind !== "histogram" && draft.agg !== "count" && (
                <label>of
                  <select value={draft.num} onChange={e => setDraft(d => ({ ...d, num: e.target.value }))}>
                    <option value="">Choose number</option>
                    {numericCols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                  </select>
                </label>
              )}
              {(draft.kind === "bar" || draft.kind === "donut") && (
                <label>by
                  <select value={draft.cat} onChange={e => setDraft(d => ({ ...d, cat: e.target.value }))}>
                    <option value="">Choose category</option>
                    {categoryCols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                  </select>
                </label>
              )}
              {draft.kind === "line" && draft.agg !== "count" && (
                <label>of
                  <select value={draft.num} onChange={e => setDraft(d => ({ ...d, num: e.target.value }))}>
                    <option value="">Choose number</option>
                    {numericCols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                  </select>
                </label>
              )}
              {draft.kind === "line" && (
                <label>over
                  <select value={draft.date} onChange={e => setDraft(d => ({ ...d, date: e.target.value }))}>
                    <option value="">Choose date</option>
                    {dateCols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                  </select>
                </label>
              )}
              {draft.kind === "scatter" && (
                <>
                  <label>X axis
                    <select value={draft.num} onChange={e => setDraft(d => ({ ...d, num: e.target.value }))}>
                      <option value="">Choose number</option>
                      {numericCols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                    </select>
                  </label>
                  <label>Y axis
                    <select value={draft.num2} onChange={e => setDraft(d => ({ ...d, num2: e.target.value }))}>
                      <option value="">Choose another</option>
                      {numericCols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                    </select>
                  </label>
                </>
              )}
              {draft.kind === "histogram" && (
                <label>Column
                  <select value={draft.num} onChange={e => setDraft(d => ({ ...d, num: e.target.value }))}>
                    <option value="">Choose number</option>
                    {numericCols.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                  </select>
                </label>
              )}
              <label className="add-chart-title">Title <span>(optional)</span>
                <input value={draft.title} maxLength="120" placeholder="Use a descriptive default" onChange={e => setDraft(d => ({ ...d, title: e.target.value }))} />
              </label>
              <button className="add-chart-go" onClick={addChart} disabled={!draftIsValid()}>Add chart</button>
              {draft.kind === "scatter" && draft.num && draft.num === draft.num2 && <span className="add-chart-hint" role="alert">Choose two different numeric columns.</span>}
            </div>
          )}
          {orderedPanels.length === 0 ? (
            <div className="charts-empty">
              All panels hidden. <button className="link-btn" onClick={() => setLayout(null)}>Reset layout</button> to bring them back.
            </div>
          ) : (
            <div className="charts stagger">
              {orderedPanels.map((p, i) => {
                const hue = panelHues[p.id];
                return (
                <div key={p.id} className={panelClass(i, p) + (hue != null ? " hued" : "")} style={hue != null ? { "--ch": hue } : undefined}>
                  <div className="chart-head">
                    <div className="chart-title">{p.title}</div>
                    <div className="chart-tools">
                      <span className="chart-kind">{p.kind}</span>
                      <button className="chart-tool" title="Chart color" onClick={() => { setExportPick(null); setHuePick(h => h === p.id ? null : p.id); }} aria-label={`Change color for ${p.title}`} aria-expanded={huePick === p.id}>◐</button>
                      <button className="chart-tool chart-tool-export" title="Export chart" onClick={() => { setHuePick(null); setExportPick(open => open === p.id ? null : p.id); }} aria-label={`Export ${p.title}`} aria-expanded={exportPick === p.id} aria-controls={`chart-export-${i}`}>↓</button>
                      <button className="chart-tool" title="Move left" disabled={i === 0} onClick={() => movePanel(p.id, -1)} aria-label="Move panel earlier">←</button>
                      <button className="chart-tool" title="Move right" disabled={i === orderedPanels.length - 1} onClick={() => movePanel(p.id, 1)} aria-label="Move panel later">→</button>
                      <button className="chart-tool chart-tool-remove" title="Remove panel" onClick={() => removePanel(p.id)} aria-label="Remove panel">×</button>
                      {huePick === p.id && (
                        <div className="hue-pop" role="menu" aria-label="Chart color">
                          {[162, 200, 280, 340, 30, 60, 120].map(h => (
                            <button key={h} role="menuitem" className={"hue-swatch" + (hue === h ? " on" : "")} style={{ "--ch": h }} onClick={() => setPanelHue(p.id, h)} aria-label={"Hue " + h} />
                          ))}
                          <button role="menuitem" className={"hue-swatch hue-auto" + (hue == null ? " on" : "")} onClick={() => setPanelHue(p.id, null)} title="Default colors">auto</button>
                        </div>
                      )}
                      {exportPick === p.id && (
                        <div className="chart-export-pop" id={`chart-export-${i}`} role="menu" aria-label={`Export ${p.title}`}>
                          <button role="menuitem" onClick={event => runPanelExport(event, p, "svg")}>
                            <span>SVG</span><small>editable vector</small>
                          </button>
                          <button role="menuitem" onClick={event => runPanelExport(event, p, "png")}>
                            <span>PNG</span><small>2× image</small>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="chart-sub">{p.sub}</div>
                  {p.render()}
                </div>
                );
              })}
            </div>
          )}
        </>
      )}

      <CalcColumnInput cols={originalProfile.cols} onAdd={onAddCalcCol} />

      <DataTable profile={profile} anomalies={anomalies} onRoleOverride={onRoleOverride} />
    </div>
  );
}

function downloadDashboard(profile, filename) {
  const summary = {
    filename,
    rows: profile.rows.length,
    columns: profile.cols.map(c => ({
      name: c.name,
      type: c.type,
      role: c.role,
      ...(c.type === "number" ? { sum: c.sum, avg: c.avg, min: c.min, max: c.max } : {}),
      ...(c.type === "category" ? { unique: c.unique, top: c.counts.slice(0, 5) } : {}),
    }))
  };
  const blob = new Blob([JSON.stringify(summary, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = (filename || "dashboard").replace(/\.csv$/i, "") + ".summary.json";
  a.click();
  URL.revokeObjectURL(url);
}

function renderCell(col, value) {
  if (value === "" || value === null || value === undefined) {
    return <span style={{ color: "var(--ink-faint)" }}>—</span>;
  }
  if (col.role === "email") {
    return <a href={`mailto:${value}`} style={{ color: "var(--accent-ink)" }}>{value}</a>;
  }
  if (col.role === "url") {
    const href = /^https?:\/\//.test(value) ? value : `https://${value}`;
    return <a href={href} target="_blank" rel="noopener" style={{ color: "var(--accent-ink)" }}>{value}</a>;
  }
  if (col.type === "number") {
    const n = CSVTool.parseNumber(value);
    if (n !== null) return fmtByCol(col, n);
  }
  if (col.role === "status") {
    return <span className="cell-chip">{value}</span>;
  }
  return value;
}

// =================== Data table — Excel-like selection + keyboard nav ===================
function DataTable({ profile, anomalies, onRoleOverride }) {
  const { cols, rows } = profile;
  const [anomalyOnly, setAnomalyOnly] = useState(false);
  const [sort, setSort] = useState(null);
  const [roleMenu, setRoleMenu] = useState(null);

  // Real row virtualization: `shown` holds ALL filtered rows (so selection
  // coordinates are absolute, never window-relative); only a window of <tr>s is
  // rendered, with spacer rows preserving the full scroll height.
  const [scrollTop, setScrollTop] = useState(0);
  const [viewportH, setViewportH] = useState(480);
  const [rowH, setRowH] = useState(38);
  const [colWidths, setColWidths] = useState(null); // measured once per dataset, then locked to stop column jitter

  // Selection — { anchor: {r,c}, head: {r,c} } over the (absolute) filtered rows.
  const [sel, setSel] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const tableScrollRef = useRef(null);
  const firstRowRef = useRef(null);
  const headRef = useRef(null);

  const anomalySet = useMemo(() => new Set((anomalies || []).map(a => a.rowIdx)), [anomalies]);
  const indexed = useMemo(() => rows.map((r, i) => ({ r, i })), [rows]);

  const sorted = useMemo(() => {
    if (!sort) return indexed;
    const col = cols.find(c => c.name === sort.col);
    if (!col) return indexed;
    const dir = sort.dir === "asc" ? 1 : -1;
    const arr = indexed.slice();
    arr.sort((a, b) => {
      let va = a.r[sort.col], vb = b.r[sort.col];
      if (col.type === "number") {
        va = CSVTool.parseNumber(va); vb = CSVTool.parseNumber(vb);
        if (va === null && vb === null) return 0;
        if (va === null) return 1;
        if (vb === null) return -1;
        return (va - vb) * dir;
      }
      if (col.type === "date") {
        const da = CSVTool.parseDate(va); const db = CSVTool.parseDate(vb);
        if (!da && !db) return 0; if (!da) return 1; if (!db) return -1;
        return (+da - +db) * dir;
      }
      return String(va || "").localeCompare(String(vb || "")) * dir;
    });
    return arr;
  }, [indexed, sort, cols]);

  const filteredRows = anomalyOnly ? sorted.filter(({ i }) => anomalySet.has(i)) : sorted;
  const shown = filteredRows;          // selection / copy / stats index into the FULL set
  const totalRows = shown.length;
  const totalCols = cols.length;

  // Rendered window derived from scroll position. Only these rows become <tr>s;
  // spacer rows above/below preserve total scroll height so the scrollbar is real.
  const OVERSCAN = 8;
  const visibleCount = Math.max(1, Math.ceil(viewportH / rowH)) + OVERSCAN * 2;
  const winStart = Math.max(0, Math.floor(scrollTop / rowH) - OVERSCAN);
  const winEnd = Math.min(totalRows, winStart + visibleCount);
  const windowRows = shown.slice(winStart, winEnd);
  const padTop = winStart * rowH;
  const padBottom = Math.max(0, (totalRows - winEnd) * rowH);

  // Measure real row height + viewport (keeps windowing accurate across theme/zoom);
  // converges in 1–2 renders thanks to the change guards. Lock column widths per
  // dataset so windowed re-renders don't make columns jitter.
  React.useLayoutEffect(() => {
    const sc = tableScrollRef.current;
    if (sc) { const vh = sc.clientHeight; if (vh && Math.abs(vh - viewportH) > 1) setViewportH(vh); }
    const fr = firstRowRef.current;
    if (fr) { const h = fr.offsetHeight; if (h && Math.abs(h - rowH) > 0.5) setRowH(h); }
  });
  const colsSig = useMemo(() => cols.map(c => c.name).join("|"), [cols]);
  React.useLayoutEffect(() => { setColWidths(null); }, [colsSig]); // re-measure on a new dataset
  React.useLayoutEffect(() => {
    if (colWidths !== null) return;
    const head = headRef.current;
    if (!head) return;
    const ths = head.querySelectorAll("th");
    if (!ths.length) return;
    setColWidths(Array.from(ths).map(th => Math.ceil(th.getBoundingClientRect().width)));
  });

  function toggleSort(name) {
    setSort(s => {
      if (!s || s.col !== name) return { col: name, dir: "asc" };
      if (s.dir === "asc") return { col: name, dir: "desc" };
      return null;
    });
  }
  function sortGlyph(name) {
    if (!sort || sort.col !== name) return "↕";
    return sort.dir === "asc" ? "↑" : "↓";
  }

  const ROLE_OPTIONS = {
    number: ["currency", "count", "percent", "rating", "duration", "numeric", "id"],
    category: ["category", "status", "product", "channel", "region", "country", "state", "city", "team", "name", "text"],
    text: ["text", "email", "url", "phone", "name", "id"],
    date: ["date"],
    boolean: ["boolean"]
  };

  // ===== Selection helpers =====
  const rect = sel ? {
    r0: Math.min(sel.anchor.r, sel.head.r), r1: Math.max(sel.anchor.r, sel.head.r),
    c0: Math.min(sel.anchor.c, sel.head.c), c1: Math.max(sel.anchor.c, sel.head.c)
  } : null;

  function inSel(r, c) { return rect && r >= rect.r0 && r <= rect.r1 && c >= rect.c0 && c <= rect.c1; }
  function isHead(r, c) { return sel && sel.head.r === r && sel.head.c === c; }
  function pickCell(r, c, extend) {
    if (extend && sel) setSel({ anchor: sel.anchor, head: { r, c } });
    else setSel({ anchor: { r, c }, head: { r, c } });
  }
  function pickRow(r, extend) {
    if (extend && sel) setSel({ anchor: { r: sel.anchor.r, c: 0 }, head: { r, c: totalCols - 1 } });
    else setSel({ anchor: { r, c: 0 }, head: { r, c: totalCols - 1 } });
  }
  function pickColumn(c, extend) {
    if (extend && sel) setSel({ anchor: { r: 0, c: sel.anchor.c }, head: { r: totalRows - 1, c } });
    else setSel({ anchor: { r: 0, c }, head: { r: totalRows - 1, c } });
  }
  function pickAll() {
    setSel({ anchor: { r: 0, c: 0 }, head: { r: Math.max(0, totalRows - 1), c: Math.max(0, totalCols - 1) } });
  }

  function copySelection() {
    if (!rect) return Promise.resolve();
    const lines = [];
    for (let i = rect.r0; i <= rect.r1; i++) {
      const row = shown[i]?.r;
      if (!row) continue;
      const cells = [];
      for (let j = rect.c0; j <= rect.c1; j++) {
        const v = row[cols[j].name];
        // Wrap fields with tabs/newlines/quotes (TSV safe)
        const s = v == null ? "" : String(v);
        cells.push(/[\t\n"]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s);
      }
      lines.push(cells.join("\t"));
    }
    return navigator.clipboard.writeText(lines.join("\n")).catch(() => {});
  }

  // ===== Keyboard nav =====
  useEffect(() => {
    function onKeyDown(e) {
      if (!tableScrollRef.current) return;
      // Only intercept when our table area has focus (or contains the active element)
      const active = document.activeElement;
      const inOurTable = tableScrollRef.current === active || tableScrollRef.current.contains(active);
      if (!inOurTable) return;
      // Skip when typing in form fields outside cells
      if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;

      const mod = e.ctrlKey || e.metaKey;
      if (e.key === "Escape") { setSel(null); return; }
      if (mod && e.key.toLowerCase() === "a") {
        e.preventDefault(); pickAll(); return;
      }
      if (mod && e.key.toLowerCase() === "c") {
        if (sel) { e.preventDefault(); copySelection(); }
        return;
      }
      if (!sel) {
        if (e.key.startsWith("Arrow") || e.key === "Home" || e.key === "End") {
          e.preventDefault(); pickCell(0, 0, false);
        }
        return;
      }
      const r = sel.head.r, c = sel.head.c;
      let nr = r, nc = c;
      const step = mod ? Infinity : 1;
      if (e.key === "ArrowUp") nr = Math.max(0, mod ? 0 : r - 1);
      else if (e.key === "ArrowDown") nr = Math.min(totalRows - 1, mod ? totalRows - 1 : r + 1);
      else if (e.key === "ArrowLeft") nc = Math.max(0, mod ? 0 : c - 1);
      else if (e.key === "ArrowRight") nc = Math.min(totalCols - 1, mod ? totalCols - 1 : c + 1);
      else if (e.key === "Home") { nc = 0; if (mod) nr = 0; }
      else if (e.key === "End") { nc = totalCols - 1; if (mod) nr = totalRows - 1; }
      else if (e.key === "PageUp") nr = Math.max(0, r - 10);
      else if (e.key === "PageDown") nr = Math.min(totalRows - 1, r + 10);
      else if (e.key === "Tab") { e.preventDefault(); nc = Math.min(totalCols - 1, c + (e.shiftKey ? -1 : 1)); if (nc < 0) nc = 0; }
      else return;
      e.preventDefault();
      pickCell(nr, nc, e.shiftKey && !mod);
      // Bring the active row into view by scrolling the CONTAINER — the target row
      // may not be in the rendered window, so querying its cell would fail.
      const sc = tableScrollRef.current;
      if (sc) {
        const headH = headRef.current ? headRef.current.offsetHeight : 0;
        const top = nr * rowH, bottom = (nr + 1) * rowH;
        if (top < sc.scrollTop + headH) sc.scrollTop = Math.max(0, top - headH);
        else if (bottom > sc.scrollTop + sc.clientHeight) sc.scrollTop = bottom - sc.clientHeight;
        // Horizontal: the cell exists once the row renders next frame.
        requestAnimationFrame(() => {
          const cell = sc.querySelector(`[data-cell="${nr}-${nc}"]`);
          if (cell && cell.scrollIntoView) cell.scrollIntoView({ block: "nearest", inline: "nearest" });
        });
      }
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [sel, totalRows, totalCols, cols, shown]);

  // Stop dragging when mouse released anywhere
  useEffect(() => {
    if (!dragging) return;
    function up() { setDragging(false); }
    window.addEventListener("mouseup", up);
    return () => window.removeEventListener("mouseup", up);
  }, [dragging]);

  // Stats for the current selection
  const selStats = useMemo(() => {
    if (!rect) return null;
    let count = 0, numCount = 0, sum = 0, min = Infinity, max = -Infinity;
    const uniq = new Set();
    for (let i = rect.r0; i <= rect.r1; i++) {
      const row = shown[i]?.r;
      if (!row) continue;
      for (let j = rect.c0; j <= rect.c1; j++) {
        const v = row[cols[j].name];
        if (v == null || v === "") continue;
        count++;
        uniq.add(String(v));
        const n = CSVTool.parseNumber(v);
        if (n !== null && !isNaN(n)) {
          numCount++; sum += n;
          if (n < min) min = n;
          if (n > max) max = n;
        }
      }
    }
    return { count, numCount, sum, min: isFinite(min) ? min : null, max: isFinite(max) ? max : null, uniq: uniq.size };
  }, [rect, shown, cols]);

  return (
    <div className="table-wrap">
      <div className="table-head-row">
        <h3>Data</h3>
        <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          {selStats && selStats.count > 0 && (
            <div className="sel-stats">
              <span className="sel-stats-count">{fmtNum(selStats.count)} cell{selStats.count === 1 ? "" : "s"}</span>
              {selStats.numCount >= 2 && (
                <>
                  <span className="sel-stats-sep">·</span>
                  <span><span className="sel-stats-label">sum</span> {fmtNum(selStats.sum)}</span>
                  <span className="sel-stats-sep">·</span>
                  <span><span className="sel-stats-label">avg</span> {fmtNum(selStats.sum / selStats.numCount)}</span>
                  <span className="sel-stats-sep">·</span>
                  <span><span className="sel-stats-label">range</span> {fmtNum(selStats.min)}–{fmtNum(selStats.max)}</span>
                </>
              )}
              {selStats.numCount < 2 && selStats.count >= 2 && (
                <>
                  <span className="sel-stats-sep">·</span>
                  <span>{selStats.uniq} unique</span>
                </>
              )}
            </div>
          )}
          {anomalies && anomalies.length > 0 && (
            <button
              className={"table-toggle " + (anomalyOnly ? "active" : "")}
              onClick={() => setAnomalyOnly(v => !v)}
            >
              {anomalyOnly ? "Show all" : `Show outliers (${anomalies.length})`}
            </button>
          )}
          <div style={{ fontFamily: "var(--mono)", fontSize: 11, color: "var(--ink-faint)", letterSpacing: "0.06em", textTransform: "uppercase" }}>
            {fmtNum(totalRows)} row{totalRows === 1 ? "" : "s"}{anomalyOnly ? " (outliers)" : ""}
          </div>
        </div>
      </div>
      <div ref={tableScrollRef} className="table-scroll" tabIndex={0}
        onScroll={e => setScrollTop(e.currentTarget.scrollTop)}
        aria-label="Data table — click a cell or press an arrow key to select">
        <table className={"data data-selectable" + (dragging ? " dragging" : "")} style={{ tableLayout: colWidths ? "fixed" : "auto" }}>
          {colWidths && (
            <colgroup>
              {colWidths.map((w, j) => <col key={j} style={{ width: w }} />)}
            </colgroup>
          )}
          <thead ref={headRef}>
            <tr>
              <th className="th-corner" onClick={pickAll} title="Select all cells">⌧</th>
              {cols.map((c, j) => {
                const opts = ROLE_OPTIONS[c.type] || [c.role];
                const colSelected = rect && rect.c0 <= j && j <= rect.c1;
                return (
                  <th key={c.name}
                    className={"th-col" + (colSelected ? " selected" : "")}
                    onClick={(e) => { if (!e.target.closest(".th-sort-mini, .col-type, .role-menu")) pickColumn(j, e.shiftKey); }}>
                    <div className="th-grid">
                      <span className="th-name">{c.name}</span>
                      <button className="th-sort-mini" onClick={(e) => { e.stopPropagation(); toggleSort(c.name); }} title={"Sort by " + c.name}>
                        {sortGlyph(c.name)}
                      </button>
                    </div>
                    <span className="col-type-wrap">
                      <button
                        className="col-type"
                        onClick={(e) => { e.stopPropagation(); setRoleMenu(roleMenu === c.name ? null : c.name); }}
                        title="Change column role"
                      >{c.role || c.type}</button>
                      {roleMenu === c.name && onRoleOverride && (
                        <div className="role-menu" onClick={(e) => e.stopPropagation()}>
                          {opts.map(opt => (
                            <button key={opt}
                              className={"role-menu-item " + (c.role === opt ? "active" : "")}
                              onClick={() => { onRoleOverride(c.name, opt); setRoleMenu(null); }}>
                              {opt}
                            </button>
                          ))}
                        </div>
                      )}
                    </span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {padTop > 0 && <tr aria-hidden="true" style={{ height: padTop }}><td colSpan={totalCols + 1} style={{ padding: 0, border: 0 }} /></tr>}
            {windowRows.map(({ r, i }, k) => {
              const ri = winStart + k;
              const rowSelected = rect && rect.r0 <= ri && ri <= rect.r1;
              return (
                <tr key={i} ref={k === 0 ? firstRowRef : null} className={anomalySet.has(i) ? "anomaly-row" : ""}>
                  <th className={"th-rownum" + (rowSelected ? " selected" : "")}
                    onClick={(e) => pickRow(ri, e.shiftKey)}
                    onMouseDown={(e) => { setDragging(true); pickRow(ri, e.shiftKey); }}
                    title={"Select row " + (ri + 1)}>
                    {ri + 1}
                  </th>
                  {cols.map((c, ci) => {
                    const selected = inSel(ri, ci);
                    const head = isHead(ri, ci);
                    return (
                      <td key={c.name}
                        data-cell={ri + "-" + ci}
                        className={(c.type === "number" ? "num " : "") + (selected ? "selected " : "") + (head ? "head" : "")}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          setDragging(true);
                          pickCell(ri, ci, e.shiftKey);
                          tableScrollRef.current && tableScrollRef.current.focus();
                        }}
                        onMouseEnter={() => { if (dragging) setSel(s => s ? { anchor: s.anchor, head: { r: ri, c: ci } } : s); }}
                      >
                        {renderCell(c, r[c.name])}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            {padBottom > 0 && <tr aria-hidden="true" style={{ height: padBottom }}><td colSpan={totalCols + 1} style={{ padding: 0, border: 0 }} /></tr>}
          </tbody>
        </table>
      </div>
      <div className="table-foot">
        <button className="table-foot-help" onClick={() => setShowHelp(s => !s)} title="Keyboard shortcuts">
          {showHelp ? "Hide shortcuts" : "Keyboard shortcuts"}
        </button>
        {showHelp && (
          <div className="shortcut-grid">
            <div><kbd>Click</kbd> select cell · <kbd>Drag</kbd> select range · <kbd>Shift+Click</kbd> extend</div>
            <div><kbd>Arrows</kbd> move · <kbd>Shift+Arrows</kbd> extend · <kbd>Tab</kbd> next column</div>
            <div><kbd>Ctrl/Cmd+A</kbd> select all · <kbd>Ctrl/Cmd+C</kbd> copy as TSV</div>
            <div><kbd>Home/End</kbd> row start/end · <kbd>Ctrl+Home/End</kbd> table corners</div>
            <div><kbd>Click row#</kbd> select row · <kbd>Click header</kbd> select column · <kbd>⌧</kbd> select all</div>
            <div><kbd>Esc</kbd> clear selection</div>
          </div>
        )}
      </div>
    </div>
  );
}

// =================== Drop Zone ===================
function DropZone({ onFile, error }) {
  const [drag, setDrag] = useState(false);
  const inputRef = useRef(null);

  function handleFiles(files) {
    if (!files || !files[0]) return;
    onFile(files[0]);
  }

  return (
    <div
      className={"drop " + (drag ? "dragging" : "")}
      onDragOver={e => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={e => {
        e.preventDefault();
        setDrag(false);
        handleFiles(e.dataTransfer.files);
      }}
      onClick={() => inputRef.current?.click()}
    >
      <input ref={inputRef} type="file" accept={CONFIG.dropAccept}
        style={{ display: "none" }}
        onChange={e => handleFiles(e.target.files)} />
      <div className="drop-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 4v12m0 0l-4-4m4 4l4-4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2" strokeLinecap="round" />
        </svg>
      </div>
      <div className="drop-title">{CONFIG.dropTitle}</div>
      <div className="drop-sub">{CONFIG.dropSub}</div>
      <button className="drop-btn" onClick={e => { e.stopPropagation(); inputRef.current?.click(); }}>
        Choose file
      </button>
      <div className="drop-or">
        no file handy?{" "}
        <button onClick={e => { e.stopPropagation(); onFile("sample"); }}>
          {CONFIG.sampleLinkText}
        </button>
      </div>
      {error && <div className="drop-err">{error}</div>}
    </div>
  );
}

// =================== Google Sheets URL importer ===================
function SheetsImport({ onLoad, onError }) {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  function toCsvExportUrl(input) {
    // Accept full Sheets URLs:
    //   https://docs.google.com/spreadsheets/d/{ID}/edit#gid={GID}
    //   https://docs.google.com/spreadsheets/d/{ID}/edit?usp=sharing
    //   https://docs.google.com/spreadsheets/d/{ID}/export?format=csv
    const m = input.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
    if (!m) return null;
    const id = m[1];
    const gidMatch = input.match(/[#&?]gid=(\d+)/);
    const gid = gidMatch ? gidMatch[1] : "0";
    return `https://docs.google.com/spreadsheets/d/${id}/export?format=csv&gid=${gid}`;
  }

  async function submit(e) {
    e.preventDefault();
    if (!url.trim() || busy) return;
    const csvUrl = toCsvExportUrl(url.trim());
    if (!csvUrl) {
      onError && onError("That doesn't look like a Google Sheets URL.");
      return;
    }
    setBusy(true);
    try {
      const r = await fetch(csvUrl, { mode: "cors" });
      if (!r.ok) throw new Error("HTTP " + r.status);
      const text = await r.text();
      if (!text || text.trim().length < 10) throw new Error("empty response");
      const m = url.match(/\/d\/([a-zA-Z0-9-_]+)/);
      onLoad(text, "google-sheet-" + (m ? m[1].slice(0, 8) : "import") + ".csv");
      setUrl("");
    } catch (err) {
      onError && onError("Couldn't fetch that sheet. Make sure it's shared publicly (Anyone with the link → Viewer).");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="sheets-import" onSubmit={submit}>
      <span className="sheets-import-label">Or import from</span>
      <input
        type="url"
        aria-label="Google Sheets URL"
        className="sheets-import-input"
        placeholder="paste a public Google Sheets URL…"
        value={url}
        onChange={e => setUrl(e.target.value)}
        disabled={busy}
      />
      <button className="sheets-import-btn" disabled={busy || !url.trim()} type="submit">
        {busy ? "Fetching…" : "Import"}
      </button>
    </form>
  );
}

// =================== Sheet Picker (XLSX with multiple sheets) ===================
function SheetPicker({ sheets, filename, onPick, onCancel }) {
  const modalRef = useRef(null);
  useModalA11y(modalRef, onCancel);
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" ref={modalRef} role="dialog" aria-modal="true" aria-label="Pick a sheet" onClick={e => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-eyebrow">Multi-sheet workbook</div>
            <h3 className="modal-title">Pick a sheet</h3>
            <div className="modal-sub">{filename} · {sheets.length} sheets</div>
          </div>
          <button className="modal-close" onClick={onCancel} aria-label="cancel">×</button>
        </div>
        <ul className="sheet-list">
          {sheets.map((s, i) => (
            <li key={i}>
              <button className="sheet-row" onClick={() => onPick(s)}>
                <div className="sheet-name">{s.name}</div>
                <div className="sheet-rows">{fmtNum(s.rowCount)} {s.rowCount === 1 ? "row" : "rows"}</div>
                <div className="sheet-arrow">→</div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

// Stable primitives for page-only feature chunks. Functions keep their lexical
// closures; the chunk receives only the components and helpers it actually uses.
window.CSVTDShared = {
  BarChart, LineChart, ConverterInput, SheetPicker,
  fmtInt, fmtNum, fmtByCol,
  ensureXLSX, shareDecode, shareEncode,
  wsMaybeSave, useToolFile, sendCSVToDashboard
};

function AskCSVLoader() {
  const [state, setState] = useState(window.AskCSVShell && document.querySelector('link[data-askcsv-style]')?.sheet ? "ready" : "loading");
  useEffect(() => {
    if (window.AskCSVShell && document.querySelector('link[data-askcsv-style]')?.sheet) { setState("ready"); return; }
    let scriptReady = !!window.AskCSVShell;
    let style = document.querySelector('link[data-askcsv-style]');
    let styleReady = !!(style && style.sheet);
    let script = document.querySelector("script[data-askcsv-chunk]");
    const finish = () => { if (scriptReady && styleReady) setState("ready"); };
    const loaded = () => { scriptReady = !!window.AskCSVShell; if (!scriptReady) setState("error"); else finish(); };
    const styled = () => { styleReady = true; finish(); };
    const failed = () => setState("error");
    if (!style) {
      style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = "/askcsv.min.css";
      style.dataset.askcsvStyle = "1";
      document.head.appendChild(style);
    }
    if (!script) {
      script = document.createElement("script");
      script.src = "/askcsv.js";
      script.async = true;
      script.dataset.askcsvChunk = "1";
      document.head.appendChild(script);
    }
    style.addEventListener("load", styled);
    style.addEventListener("error", failed);
    script.addEventListener("load", loaded);
    script.addEventListener("error", failed);
    if (style.sheet) styleReady = true;
    if (styleReady) finish();
    return () => {
      style.removeEventListener("load", styled);
      style.removeEventListener("error", failed);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
  }, []);
  if (state === "error") return <div className="conv-err" role="alert">The Ask CSV workspace could not load. Refresh the page to try again.</div>;
  const Shell = window.AskCSVShell;
  if (!Shell) return <div className="ask-loading" role="status"><span className="spinner" aria-hidden="true"></span><span>Loading the local analysis workspace</span></div>;
  return <Shell />;
}

// =================== Gallery (mode === "examples") ===================
function Gallery({ items, onPick }) {
  return (
    <div className="gallery">
      {items.map((it, i) => {
        const sample = CSVTool.SAMPLES[it.key];
        if (!sample) return null;
        return (
          <button key={i} className="gallery-card" onClick={() => onPick(it.key)}>
            <div className="gallery-tag">{it.tag}</div>
            <div className="gallery-title">{it.title}</div>
            <div className="gallery-spark">
              <GallerySpark seed={i} />
            </div>
            <div className="gallery-desc">{it.description}</div>
            <div className="gallery-cta">View dashboard →</div>
          </button>
        );
      })}
    </div>
  );
}

// Tiny deterministic decorative sparkline for gallery cards
function GallerySpark({ seed }) {
  const w = 220, h = 56;
  const pts = [];
  const n = 14;
  let x = 0;
  let rng = (seed + 1) * 9301;
  function rand() { rng = (rng * 1664525 + 1013904223) % 4294967296; return rng / 4294967296; }
  let y = h * 0.6;
  for (let i = 0; i < n; i++) {
    y += (rand() - 0.45) * 14;
    y = Math.max(8, Math.min(h - 8, y));
    pts.push([x, y]);
    x += w / (n - 1);
  }
  const path = pts.map((p, i) => `${i === 0 ? "M" : "L"} ${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(" ");
  const area = path + ` L ${w} ${h} L 0 ${h} Z`;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" style={{ width: "100%", height: "100%", display: "block" }}>
      <path d={area} fill="var(--accent)" opacity="0.1" />
      <path d={path} fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}

// =================== FAQ ===================
function FAQ({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="faq-list">
      {items.map((it, i) => (
        <div key={i} className={"faq-item " + (open === i ? "open" : "")}>
          <button className="faq-q" aria-expanded={open === i} aria-controls={"faq-a-" + i} onClick={() => setOpen(open === i ? -1 : i)}>
            <span>{it.q}</span>
            <span className="plus" aria-hidden="true">+</span>
          </button>
          <div className="faq-a" id={"faq-a-" + i}>{it.a}</div>
        </div>
      ))}
    </div>
  );
}

// =================== Animated number (count-up) ===================
function AnimatedNumber({ value, format, duration = 700 }) {
  const [current, setCurrent] = useState(value);
  const fromRef = useRef(0);
  const startRef = useRef(null);
  const rafRef = useRef(null);
  const targetRef = useRef(value);

  useEffect(() => {
    fromRef.current = current;
    targetRef.current = value;
    startRef.current = null;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    function step(t) {
      if (!startRef.current) startRef.current = t;
      const elapsed = t - startRef.current;
      const progress = Math.min(1, elapsed / duration);
      const eased = 1 - Math.pow(1 - progress, 3); // cubic ease-out
      const next = fromRef.current + (targetRef.current - fromRef.current) * eased;
      setCurrent(next);
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    }
    rafRef.current = requestAnimationFrame(step);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const display = Number.isInteger(value) ? Math.round(current) : current;
  return format(display);
}

// =================== AdSense slot ===================
// Renders a Google AdSense <ins> placement. Until you create an ad unit in your AdSense
// dashboard and pass its `slot` id, this renders nothing visible — but the AdSense
// script (loaded in <head>) will still place Auto Ads on the page if that's enabled.
const ADSENSE_CLIENT = "ca-pub-6352806306420887";
function AdSlot({ slot, format = "auto", layout, style }) {
  useEffect(() => {
    if (!slot) return; // Skip the push if no slot yet — avoids empty-ad warnings
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { /* AdBlock or not ready */ }
  }, [slot]);
  if (!slot) return null; // Render nothing until a real slot id is provided
  // Labelled + separated so the ad is clearly distinguished from the tool UI and
  // content (AdSense policy: ads must not be mistaken for navigation/controls).
  return (
    <aside className="ad-wrap" aria-label="Advertisement">
      <span className="ad-label">Advertisement</span>
      <ins
        className="adsbygoogle"
        style={style || { display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        {...(layout ? { "data-ad-layout": layout } : {})}
        data-full-width-responsive="true"
      />
    </aside>
  );
}

// =================== Home: tool category cards ===================
// Rendered on the homepage (when CONFIG.showHomeSections === true) to surface
// every tool surface area in one scroll. Same card style as /tools.
const HOME_CATEGORIES = [
  {
    eyebrow: "Convert",
    title: "Format conversion with type detection.",
    lede: "Numbers stay numbers, dates stay dates, booleans stay booleans — no quoted-string everywhere.",
    cards: [
      { tag: "JSON", title: "CSV to JSON", href: "/csv-to-json", popular: true, desc: "Typed JSON output — numbers, booleans, nulls preserved correctly." },
      { tag: "SQL", title: "CSV to SQL", href: "/csv-to-sql", popular: true, desc: "Smart CREATE TABLE + INSERT — INT, DECIMAL, DATE detected automatically." },
      { tag: "XLSX", title: "CSV ↔ Excel", href: "/csv-to-excel", desc: "Typed .xlsx output. Or drop an .xlsx, get a clean CSV." },
      { tag: ".md", title: "CSV to Markdown", href: "/csv-to-markdown", desc: "Pipe-formatted, numeric columns right-aligned. GitHub-ready." }
    ],
    seeMore: { href: "/tools", text: "All converters →" }
  },
  {
    eyebrow: "Clean",
    title: "Tidy a messy CSV.",
    lede: "Catch problems before they bite, drop duplicates, slice down to the rows that matter.",
    cards: [
      { tag: "VALIDATE", title: "CSV Validator", href: "/csv-validate", popular: true, desc: "Missing values, type errors, duplicates, bad delimiters, broken rows — ranked by severity." },
      { tag: "DEDUPE", title: "Remove duplicates", href: "/csv-dedupe", desc: "By entire row or by selected columns. Case-sensitive toggle." },
      { tag: "SORT · FILTER", title: "Sort & filter", href: "/csv-sort-filter", desc: "Sort by any column + up to 3 filter conditions joined by AND." },
      { tag: "SPLIT", title: "Split CSV", href: "/csv-split", desc: "By row count, into N files, or one file per column value. Download as a .zip." }
    ],
    seeMore: { href: "/tools", text: "All cleaners →" }
  },
  {
    eyebrow: "Query",
    title: "Ask plainly, or write SQL.",
    lede: "Use a plain-English question with a visible calculation, or query your CSV like a database. No setup, no upload.",
    cards: [
      { tag: "PLAIN ENGLISH", title: "Ask CSV", href: "/ask-csv", desc: "Get exact answers with visible formulas, build a brief, then rerun its saved questions on the next file." },
      { tag: "SQL", title: "Query CSV with SQL", href: "/csv-sql-query", popular: true, desc: "Custom SQL engine. Supports =, !=, <, >, LIKE, AND/OR, ORDER BY, LIMIT." },
      { tag: "PIPELINE", title: "Chain operations", href: "/csv-pipeline", popular: true, desc: "Run SQL as one step in a larger workflow — query then split, query then dashboard." }
    ],
    seeMore: { href: "/tools", text: "All query tools →" }
  },
  {
    eyebrow: "Visualize",
    title: "Build a real dashboard.",
    lede: "Once your data is shaped, the dashboard auto-generates KPIs, charts, anomalies and a sortable table.",
    cards: [
      { tag: "DASHBOARD", title: "Dashboard Builder", href: "/", popular: true, desc: "The main tool — drop a CSV, get the full dashboard with filters, brush, group-by, pivot." },
      { tag: "EXAMPLES", title: "Sample dashboards", href: "/examples", desc: "Six datasets covering sales, surveys, expenses, web analytics, headcount, inventory." },
      { tag: "GUIDE", title: "How-to guide", href: "/how-to-make-a-dashboard-from-csv", desc: "Step-by-step walkthrough. Start to finish in under a minute." },
      { tag: "SALES", title: "Sales dashboard", href: "/sales-dashboard", desc: "Stripe / Shopify / HubSpot exports → revenue trends, top products." }
    ],
    seeMore: { href: "/tools", text: "All visualizations →" }
  }
];

function HomeCategorySections() {
  return (
    <>
      {HOME_CATEGORIES.map((cat, i) => (
        <section className="section home-cat" key={i}>
          <div className="shell">
            <div className="section-eyebrow">{cat.eyebrow}</div>
            <h2>{cat.title}</h2>
            <p className="section-lede">{cat.lede}</p>
            <div className="tools-grid">
              {cat.cards.map((c, j) => (
                <a className={"tools-card" + (c.popular ? " tools-card-popular" : "")} href={c.href} key={j}>
                  {c.popular && <div className="tools-card-badge">Most popular</div>}
                  <div className="tools-card-tag">{c.tag}</div>
                  <div className="tools-card-title">{c.title}</div>
                  <div className="tools-card-desc">{c.desc}</div>
                  <div className="tools-card-cta">Open →</div>
                </a>
              ))}
            </div>
            {cat.seeMore && (
              <p style={{ marginTop: 18 }}>
                <a href={cat.seeMore.href} style={{ color: "var(--accent-ink)", fontFamily: "var(--mono)", fontSize: 13, letterSpacing: "0.04em" }}>
                  {cat.seeMore.text}
                </a>
              </p>
            )}
          </div>
        </section>
      ))}
    </>
  );
}

function HomePipelineCallout() {
  return (
    <section className="section pipe-callout">
      <div className="shell">
        <div className="section-eyebrow">Workflow</div>
        <h2>One tab. Many steps. <em>One pipeline.</em></h2>
        <p className="section-lede">
          The CSV Workflow Builder chains operations together. Validate, dedupe, filter, sort, query, split — all in one tab, re-running instantly as you tweak each step. Then export to any format or build a dashboard from the final result.
        </p>
        <div className="pipe-callout-actions">
          <a className="pipe-callout-btn" href="/csv-pipeline">Try the workflow builder →</a>
          <span className="pipe-callout-hint">Free · runs in your browser</span>
        </div>
      </div>
    </section>
  );
}

// V9 #6 — visceral, live proof of the local-first promise. Reflects real
// navigator.onLine state (so airplane mode flips it to "Offline" live) and
// states the two facts that are architecturally true: zero bytes of the file
// are uploaded, zero accounts are required. Demonstrates the stance the
// privacy section describes rather than just asserting it.
function TrustProof() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return (
    <div className="trust-proof">
      <div className={"trust-pill" + (online ? "" : " is-offline")} role="status" aria-live="polite">
        <span className="trust-dot" aria-hidden="true" />
        <span>{online ? "Connected — your file still never leaves this tab" : "Offline — and every tool here still works"}</span>
      </div>
      <div className="trust-stats">
        <div className="trust-stat"><span className="trust-stat-num">0</span><span className="trust-stat-lbl">bytes of your file uploaded</span></div>
        <div className="trust-stat"><span className="trust-stat-num">0</span><span className="trust-stat-lbl">accounts or sign-ins required</span></div>
      </div>
      <p className="trust-hint">Don't take our word for it: switch on airplane mode and keep working — parsing, charts and exports all keep running, and this badge flips to <em>Offline</em> the instant your connection drops.</p>
    </div>
  );
}

function HomePrivacySection() {
  return (
    <section className="section privacy-callout">
      <div className="shell">
        <div className="section-eyebrow">Privacy</div>
        <h2>Local-first by <em>default</em>.</h2>
        <p className="section-lede" style={{ maxWidth: "64ch" }}>
          The browser tools on csvtodashboard.com process your file locally whenever possible — your CSV is parsed in your tab, not on a server. We'd rather be honest than oversell, so here's the actual stance.
        </p>
        <TrustProof />
        <ul className="why-list" style={{ maxWidth: "none" }}>
          <li><div className="why-num">·</div><div>
            <h4>No required account</h4>
            <p>There is no signup, no login, no email field. Drop a file, use the tool, close the tab.</p>
          </div></li>
          <li><div className="why-num">·</div><div>
            <h4>No required upload for the browser tools</h4>
            <p>Converters, cleaners, pipeline, dashboard — all parse and run in your browser. You can confirm in DevTools → Network: no requests fire when you drop a file.</p>
          </div></li>
          <li><div className="why-num">·</div><div>
            <h4>What we DO load from third parties</h4>
            <p>Google Fonts for typography, AdSense for ads (so the site stays free). These see standard request headers but not your CSV content. Full list on the <a href="/privacy" style={{ color: "var(--accent-ink)" }}>privacy page</a>.</p>
          </div></li>
          <li><div className="why-num">·</div><div>
            <h4>If anything ever changes</h4>
            <p>If a future feature needs to send data to a server (e.g. an opt-in API), the UI will say so clearly before any data leaves the browser. No silent backend writes.</p>
          </div></li>
        </ul>
      </div>
    </section>
  );
}

function HomeUseCases() {
  const cases = [
    { eyebrow: "Sales", title: "Revenue trend + region breakdown from a Stripe export", body: "Drop the Payments CSV. Sort by date, dedupe refunded transactions, query the rows you want, see the dashboard." },
    { eyebrow: "Operations", title: "Validate then split a 50,000-row inventory file", body: "Catch broken rows and bad delimiters first, then split the file by warehouse for distribution." },
    { eyebrow: "Marketing", title: "Web analytics CSV → clean, query, visualize", body: "Filter to the campaign you care about, query the top pages by sessions, send the slice to a dashboard for your weekly review." },
    { eyebrow: "Finance", title: "Audit a vendor list before importing to QuickBooks", body: "Run the validator to catch type mismatches and duplicate rows, then export clean JSON or SQL for the import." },
    { eyebrow: "Development", title: "Convert CSV to SQL with correct column types", body: "INT and DECIMAL inferred from data — no manual CREATE TABLE editing. Paste into your migration." },
    { eyebrow: "Research", title: "Survey responses — pivot by department, run NPS", body: "Drop the export, switch to pivot mode, group by department, take a screenshot for the readout." }
  ];
  return (
    <section className="section home-cases">
      <div className="shell">
        <div className="section-eyebrow">Use cases</div>
        <h2>What people actually <em>use it for</em>.</h2>
        <div className="cases-grid">
          {cases.map((c, i) => (
            <div className="cases-card" key={i}>
              <div className="cases-eyebrow">{c.eyebrow}</div>
              <div className="cases-title">{c.title}</div>
              <div className="cases-body">{c.body}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// =================== Related tools block (any tool page) ===================
// Renders a small card row before the footer when CONFIG.relatedTools is set.
// Shape: [{ href, title, desc }]
function RelatedTools({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <section className="section related-tools">
      <div className="shell">
        <div className="section-eyebrow">Related tools</div>
        <div className="related-grid">
          {items.map((t, i) => (
            <a key={i} className="related-card" href={t.href}>
              <div className="related-title">{t.title}</div>
              {t.desc && <div className="related-desc">{t.desc}</div>}
              <div className="related-cta">Open →</div>
            </a>
          ))}
        </div>
        <p className="related-foot">
          Next step: <a href="/" style={{ color: "var(--accent-ink)" }}>send your CSV to the dashboard builder</a> or <a href="/csv-pipeline" style={{ color: "var(--accent-ink)" }}>chain multiple operations in CSV Pipeline</a>.
        </p>
      </div>
    </section>
  );
}

// =================== Theme toggle ===================
function ThemeToggle() {
  const [theme, setTheme] = useState(() => document.documentElement.getAttribute("data-theme") || "light");
  function toggle() {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    try { localStorage.setItem("csvtd-theme", next); } catch (e) { /* ignore */ }
  }
  return (
    <button className="theme-toggle" onClick={toggle} aria-label={"Switch to " + (theme === "dark" ? "light" : "dark") + " mode"} title={"Switch to " + (theme === "dark" ? "light" : "dark") + " mode"}>
      {theme === "dark" ? (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
}

// =================== Mobile nav menu ===================
// <details>-based so it also works without JS on the prerendered/static pages
// (seo-prerender.mjs ships the same markup). Shown ≤640px where .nav-links is
// hidden; native <summary> gives keyboard toggling for free. Links close the
// menu on tap (matters for same-page #how anchors).
function NavMenu() {
  const ref = useRef(null);
  function closeMenu() { if (ref.current) ref.current.open = false; }
  return (
    <details className="nav-menu" ref={ref}>
      <summary aria-label="Open the menu">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
      </summary>
      <div className="nav-menu-panel" onClick={closeMenu}>
        <a href="/tools">Tools</a>
        <a href="/examples">Examples</a>
        <a href="#how">How it works</a>
        <a href="/about">About</a>
        <div className="nav-menu-row" onClick={e => e.stopPropagation()}>
          <span>Theme</span>
          <ThemeToggle />
        </div>
      </div>
    </details>
  );
}

// =================== Opt-in "Recent files" persistence ===================
// The IndexedDB store + helpers (recentDbOpen/recentGetAll/recentSave/…,
// fmtBytes, RECENT_* consts) moved to workspace.jsx in V6 — same names, same
// bundle scope, every tool shell shares them now. App below is unchanged as a
// consumer.

// =================== App ===================
function App() {
  const [profile, setProfile] = useState(null);
  const [csvText, setCsvText] = useState("");
  const [filename, setFilename] = useState("");
  const [error, setError] = useState("");
  const [pendingSheets, setPendingSheets] = useState(null); // { sheets, filename }
  const [parseProgress, setParseProgress] = useState(null); // null = idle; 0..1 while a large file parses off-thread
  // Opt-in "Recent files" — OFF by default. The preference is a single boolean in
  // localStorage; the actual file bytes live only in IndexedDB on this device.
  const [remember, setRemember] = useState(() => { try { return localStorage.getItem("csvtd-remember") === "1"; } catch (e) { return false; } });
  const [recent, setRecent] = useState([]);
  useEffect(() => { let live = true; if (remember) recentGetAll().then(r => { if (live) setRecent(r); }); else setRecent([]); return () => { live = false; }; }, [remember]);
  function toggleRemember(on) {
    setRemember(on);
    try { localStorage.setItem("csvtd-remember", on ? "1" : "0"); } catch (e) {}
    if (!on) recentClear().then(() => setRecent([])); // off = wipe the device store, no leftovers
  }
  function loadRecent(rec) { loadCSVText(rec.csv, rec.name); }
  function clearRecent() { recentClear().then(() => setRecent([])); }
  function removeRecent(id) { recentDelete(id).then(() => recentGetAll().then(setRecent)); }

  function loadCSVText(text, name, opts) {
    opts = opts || {};
    // Parse + profile off the main thread for large files (small inputs resolve
    // inline on a microtask), so the UI stays responsive and shows real progress
    // instead of freezing. parseCSVAsync resolves with the profile object.
    setError("");
    setParseProgress(0);
    CSVTool.parseCSVAsync(text, p => setParseProgress(p)).then(prof => {
      setParseProgress(null);
      if (!prof || prof.headers.length === 0 || prof.rows.length === 0) {
        setError("Couldn't read that file — is it a valid CSV with a header row?");
        return;
      }
      // Drop any leftover share-link view-state hash before showing THIS data —
      // otherwise filters/brush encoded for someone else's dataset get applied to
      // the freshly-loaded one and silently produce a 0-row dashboard. (The
      // sample-restore path passes preserveHash so its own state still applies.)
      if (!opts.preserveHash && window.location.hash) {
        history.replaceState(null, "", window.location.pathname + window.location.search);
      }
      setProfile(prof);
      setCsvText(text);
      setFilename(name);
      setError("");
      setPendingSheets(null);
      // Persist to the device store only when the user opted in AND this is a real
      // file they brought (not a built-in sample). recentSave is keyed by name, so
      // re-opening a remembered file just bumps it back to the top.
      if (remember && !opts.sample) recentSave(name, text).then(() => recentGetAll().then(setRecent));
      setTimeout(() => {
        const el = document.getElementById("dashboard-anchor");
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 16;
          window.scrollTo({ top, behavior: scrollBehavior() });
        }
      }, 100);
    }).catch(e => {
      setParseProgress(null);
      console.error(e);
      setError("Something went wrong parsing that file.");
    });
  }

  function handleXLSXBuffer(buf, name) {
    try {
      const { sheets } = CSVTool.parseXLSXBuffer(buf);
      if (!sheets.length) {
        setError("That workbook didn't have any rows we could read.");
        return;
      }
      if (sheets.length === 1) {
        loadCSVText(sheets[0].csvText, name);
        return;
      }
      setPendingSheets({ sheets, filename: name });
      setError("");
    } catch (e) {
      console.error(e);
      setError("Couldn't read that Excel file. If it's password-protected, try exporting to CSV instead.");
    }
  }

  function handleFile(f) {
    if (f === "sample") {
      if (CONFIG.sampleCsv) { loadCSVText(CONFIG.sampleCsv, CONFIG.sampleName || "sample.csv", { sample: true }); return; }
      const samples = CSVTool.SAMPLES || {};
      const s = samples[CONFIG.sampleKey] || samples.sales;
      loadCSVText(s.csv, s.name, { sample: true });
      return;
    }
    if (typeof f === "string" && CSVTool.SAMPLES && CSVTool.SAMPLES[f]) {
      const s = CSVTool.SAMPLES[f];
      loadCSVText(s.csv, s.name, { sample: true });
      return;
    }
    if (f.size > 250 * 1024 * 1024) {
      setError("That file is over 250 MB — that's beyond what a browser tab can hold comfortably. Pre-filter or split the export first.");
      return;
    }
    setFilename(f.name);
    const isXLSX = /\.(xlsx|xls)$/i.test(f.name) ||
      f.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      f.type === "application/vnd.ms-excel";
    const reader = new FileReader();
    reader.onerror = () => setError("Could not read file.");
    if (isXLSX) {
      reader.onload = e => ensureXLSX().then(() => handleXLSXBuffer(e.target.result, f.name));
      reader.readAsArrayBuffer(f);
    } else {
      reader.onload = e => loadCSVText(e.target.result, f.name);
      reader.readAsText(f);
    }
  }

  // Clipboard paste — paste CSV/TSV anywhere on the home page (when no dashboard is open).
  useEffect(() => {
    if (profile) return; // Only listen when on the upload screen
    // The editor/join shells own paste on their pages (range-paste into the
    // grid, paste-into-slot) — hijacking it into a dashboard would destroy
    // the tool mid-use.
    if (CONFIG.mode === "editor" || CONFIG.mode === "join") return;
    function onPaste(e) {
      // Ignore paste inside form fields
      const tag = (e.target && e.target.tagName) || "";
      if (/^(INPUT|TEXTAREA)$/.test(tag) || (e.target && e.target.isContentEditable)) return;
      const text = e.clipboardData && e.clipboardData.getData("text/plain");
      if (!text) return;
      // Looks like tabular data?
      const lines = text.split(/\r?\n/).filter(l => l.trim().length > 0);
      if (lines.length < 2) return;
      const firstSep = (lines[0].match(/,/g) || []).length;
      const firstTab = (lines[0].match(/\t/g) || []).length;
      if (firstSep < 1 && firstTab < 1) return;
      // Tab-separated? Convert to CSV (quote fields containing commas).
      let csv = text;
      if (firstTab >= firstSep && firstTab > 0) {
        csv = text.split(/\r?\n/).map(line =>
          line.split("\t").map(cell => {
            if (/[",\n]/.test(cell)) return '"' + cell.replace(/"/g, '""') + '"';
            return cell;
          }).join(",")
        ).join("\n");
      }
      e.preventDefault();
      loadCSVText(csv, "pasted-data.csv");
    }
    window.addEventListener("paste", onPaste);
    return () => window.removeEventListener("paste", onPaste);
  }, [profile]);

  // ============ Shareable URL state ============
  // Encode { sample, filters, dateBrush, groupBy, roleOverrides } in URL hash so a link
  // restores the same view. CSV uploads aren't encoded (privacy + size); only sample data
  // auto-loads via &sample=<key>. Other state restores after data is loaded.
  function buildShareState(extra) {
    const state = { ...(extra || {}) };
    // Caller fills in filter/brush/groupBy at the Dashboard level
    return state;
  }

  function applyHashOnLoad() {
    const m = (window.location.hash || "").match(/^#?(.+)$/);
    if (!m) return null;
    try {
      const json = decodeURIComponent(escape(atob(m[1].replace(/-/g, "+").replace(/_/g, "/"))));
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  }

  // On mount: handle the standalone-HTML export autoload, converter→dashboard
  // storage-key handoff (?importKey=…), small inline #data=… handoff, and
  // sample-name hash references.
  useEffect(() => {
    // Standalone export auto-load
    if (window.__STANDALONE_AUTOLOAD__) {
      const { csv, name } = window.__STANDALONE_AUTOLOAD__;
      setTimeout(() => loadCSVText(csv, name || "data.csv"), 0);
      return;
    }
    // PWA file handler: when the installed app is chosen for "Open with…" on a
    // .csv/.tsv/.xlsx, the OS hands the file in via launchQueue.
    try {
      if ("launchQueue" in window && window.launchQueue.setConsumer) {
        window.launchQueue.setConsumer(params => {
          if (!params.files || !params.files.length) return;
          params.files[0].getFile().then(f => handleFile(f)).catch(() => {});
        });
      }
    } catch (e) { /* unsupported browser */ }
    // The branches below ingest data INTO THE DASHBOARD — they must only run
    // on dashboard-capable pages: the builder (DEFAULT_CONFIG.mode "tool" —
    // homepage, vertical dashboards, templates) and the examples gallery. On
    // shell pages (editor/join/converter/…) the shell itself consumes
    // ?importKey= via consumeToolHandoff() (workspace.jsx); running this too
    // would silently swallow the handoff into invisible state.
    if (CONFIG.mode !== "tool" && CONFIG.mode !== "examples") return;
    // Storage-key handoff from a converter page (large files)
    try {
      const params = new URLSearchParams(window.location.search);
      // ?demo=/datasets/<name>.csv — the sample-dataset pages' "Open in
      // dashboard" CTA. Same-origin path-validated fetch only: must be a CSV
      // under /datasets/, so the param can't be abused to load arbitrary URLs.
      const demo = params.get("demo");
      if (demo && /^\/datasets\/[a-z0-9-]+\.csv$/.test(demo)) {
        fetch(demo)
          .then(r => (r.ok ? r.text() : Promise.reject(new Error("HTTP " + r.status))))
          .then(text => {
            history.replaceState(null, "", window.location.pathname + window.location.hash);
            loadCSVText(text, demo.split("/").pop(), { sample: true });
          })
          .catch(() => setError("Couldn't load that sample dataset — drop a file instead."));
        return;
      }
      const importKey = params.get("importKey");
      if (importKey && /^csvtd-import-/.test(importKey)) {
        const raw = sessionStorage.getItem(importKey);
        sessionStorage.removeItem(importKey);
        // Always clean the URL — whether the handoff succeeded or the key was
        // already consumed/expired (e.g. on refresh) — so ?importKey= doesn't
        // linger or re-import. Show a hint if the data is gone.
        history.replaceState(null, "", window.location.pathname + window.location.hash);
        if (raw) {
          const payload = JSON.parse(raw);
          setTimeout(() => loadCSVText(payload.csv, payload.name || "imported.csv"), 0);
        } else {
          setError("That dashboard link has expired — drop the file again to rebuild it.");
        }
        return;
      }
    } catch (e) { /* fall through */ }
    // Small inline handoff via hash (#data=<base64>) — for small files
    if (/^#data=/.test(window.location.hash)) {
      try {
        const b64 = window.location.hash.slice(6).replace(/-/g, "+").replace(/_/g, "/");
        const text = decodeURIComponent(escape(atob(b64)));
        history.replaceState(null, "", window.location.pathname + window.location.search);
        setTimeout(() => loadCSVText(text, "imported.csv"), 0);
        return;
      } catch (e) { /* fall through */ }
    }
    const state = applyHashOnLoad();
    if (state && state.sample && CSVTool.SAMPLES && CSVTool.SAMPLES[state.sample]) {
      const s = CSVTool.SAMPLES[state.sample];
      setTimeout(() => loadCSVText(s.csv, s.name, { preserveHash: true, sample: true }), 0);
    }
  }, []);

  // V6 workspace wiring: on dashboard-capable pages (mode "tool"/"examples")
  // the palette/workspace can load a file straight into the builder, and the
  // loaded CSV becomes "the current file" for send-to-tool. On shell pages
  // BOTH stay null — the shell owns its registrations. Handoff consumption
  // stays in the mount effect above.
  const isDashPage = CONFIG.mode === "tool" || CONFIG.mode === "examples";
  useToolFile(
    isDashPage ? ((csv, name) => loadCSVText(csv, name)) : null,
    isDashPage ? (() => (profile && csvText ? { csv: csvText, name: filename || "data.csv" } : null)) : null,
    { consume: false }
  );

  // Lazy-load SheetJS on demand (when an .xlsx is selected). Cached after first load.
  function ensureXLSX() {
    if (typeof window.XLSX !== "undefined") return Promise.resolve();
    if (window.__xlsxLoading) return window.__xlsxLoading;
    window.__xlsxLoading = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "/vendor/xlsx.full.min.js";
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("Could not load XLSX library"));
      document.head.appendChild(s);
    });
    return window.__xlsxLoading;
  }

  const isGallery = CONFIG.mode === "examples";
  const isConverter = CONFIG.mode === "converter" && window.CONVERT_CONFIG;
  const isPipeline = CONFIG.mode === "pipeline";
  const isViz = CONFIG.mode === "viz" && window.VIZ_CONFIG;
  const isDevTool = CONFIG.mode === "devtool" && window.DEVTOOL_CONFIG;
  const isDual = CONFIG.mode === "dual" && window.DUAL_CONFIG;
  const isReshape = CONFIG.mode === "reshape" && window.RESHAPE_CONFIG;
  const isTextTool = CONFIG.mode === "texttool" && window.TEXTTOOL_CONFIG;
  const isGenerator = CONFIG.mode === "generator" && window.GEN_CONFIG;
  const isFormat = CONFIG.mode === "format" && window.FORMAT_CONFIG;
  const isQR = CONFIG.mode === "qr" && window.QR_CONFIG;
  const isShare = CONFIG.mode === "share" && window.SHARE_CONFIG;
  const isEditor = CONFIG.mode === "editor" && window.EDITOR_CONFIG;
  const isJoin = CONFIG.mode === "join" && window.JOIN_CONFIG;
  const isLesson = CONFIG.mode === "lesson" && window.LESSON_CONFIG;
  const isAsk = CONFIG.mode === "ask";
  const isEmbed = CONFIG.mode === "embed";

  // Any standalone tool page (i.e. something under /tools) — gets a visible
  // breadcrumb matching its BreadcrumbList JSON-LD. Excludes the bare dashboard
  // homepage, the chrome-free embed, and the examples gallery.
  const isToolPage = isConverter || isViz || isDevTool || isDual || isReshape || isTextTool || isGenerator || isFormat || isQR || isShare || isPipeline || isEditor || isJoin || isLesson || isAsk;
  // Last crumb = the page title's lead segment, matching seo-prerender's
  // cleanName() so the visible trail and the JSON-LD agree exactly.
  const crumbName = isToolPage ? ((typeof document !== "undefined" ? document.title : "") || "").split(/\s+[—|]\s+|\s+-\s+/)[0].trim() : "";

  // Chrome-free embed render — just the chart, read from the URL hash.
  if (isEmbed) return <EmbedView />;

  return (
    <>
      <a className="skip-link" href="#content">Skip to content</a>
      <CommandPalette />
      {pendingSheets && (
        <SheetPicker
          sheets={pendingSheets.sheets}
          filename={pendingSheets.filename}
          onPick={s => loadCSVText(s.csvText, `${pendingSheets.filename} · ${s.name}`)}
          onCancel={() => { setPendingSheets(null); setFilename(""); }}
        />
      )}
      <div className="shell">
        <nav className="nav">
          <a href="/" className="brand" style={{ textDecoration: "none" }}>
            <div className="brand-mark"></div>
            <span>{CONFIG.brand.prefix}<em style={{ fontStyle: "italic", color: "var(--accent-ink)" }}>{CONFIG.brand.em}</em></span>
          </a>
          <div className="nav-links">
            <a href="/tools">Tools</a>
            <a href="/examples">Examples</a>
            <a href="#how">How it works</a>
            <a href="/about">About</a>
            <button className="nav-kbd" onClick={() => { if (window.__csvtdOpenPalette) window.__csvtdOpenPalette(); }} title="Command palette — search every tool" aria-label="Open the command palette">Ctrl K</button>
            <ThemeToggle />
          </div>
          <NavMenu />
        </nav>
        <div id="content" tabIndex={-1}></div>

        <main>
        {isToolPage && crumbName && (
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="breadcrumb-sep" aria-hidden="true">/</span>
            <a href="/tools">Tools</a>
            <span className="breadcrumb-sep" aria-hidden="true">/</span>
            <span className="breadcrumb-current" aria-current="page">{crumbName}</span>
          </nav>
        )}

        {!profile ? (
          <section className="hero">
            <div className="eyebrow"><span className="dot"></span>{CONFIG.eyebrow}</div>
            <h1 className="headline">
              {CONFIG.headlinePrefix}<em>{CONFIG.headlineEm}</em>{CONFIG.headlineSuffix}
            </h1>
            <p className="subhead">{CONFIG.subhead}</p>
            {CONFIG.directAnswer && <p className="answer-block">{CONFIG.directAnswer}</p>}
            {isAsk ? (
              <AskCSVLoader />
            ) : isPipeline ? (
              <PipelineShell config={window.PIPELINE_CONFIG || {}} />
            ) : isViz ? (
              <VizShell config={window.VIZ_CONFIG} />
            ) : isDevTool ? (
              <DevToolShell config={window.DEVTOOL_CONFIG} />
            ) : isDual ? (
              <DualToolShell config={window.DUAL_CONFIG} />
            ) : isReshape ? (
              <ReshapeShell config={window.RESHAPE_CONFIG} />
            ) : isTextTool ? (
              <TextToolShell config={window.TEXTTOOL_CONFIG} />
            ) : isGenerator ? (
              <GeneratorShell config={window.GEN_CONFIG} />
            ) : isFormat ? (
              <FormatShell config={window.FORMAT_CONFIG} />
            ) : isQR ? (
              <QRShell config={window.QR_CONFIG} />
            ) : isShare ? (
              <ShareRouter config={window.SHARE_CONFIG} />
            ) : isEditor ? (
              <EditorShell config={window.EDITOR_CONFIG} />
            ) : isJoin ? (
              <JoinShell config={window.JOIN_CONFIG} />
            ) : isLesson ? (
              <LessonShell config={window.LESSON_CONFIG} />
            ) : isConverter ? (
              <ConverterShell config={window.CONVERT_CONFIG} />
            ) : isGallery ? (
              <Gallery items={CONFIG.gallery} onPick={k => handleFile(k)} />
            ) : (
              <>
                <DropZone onFile={handleFile} error={error} />
                {parseProgress !== null && parseProgress > 0 && (
                  <div className="parse-progress" role="status" aria-live="polite">
                    <div className="parse-progress-label">
                      {parseProgress < 0.85 ? "Parsing your file" : "Analyzing columns"} · {Math.round(parseProgress * 100)}%
                    </div>
                    <div className="parse-progress-track">
                      <div className="parse-progress-bar" style={{ width: Math.max(3, Math.round(parseProgress * 100)) + "%" }} />
                    </div>
                  </div>
                )}
                <SheetsImport
                  onLoad={(text, name) => loadCSVText(text, name)}
                  onError={(msg) => setError(msg)}
                />
                <div className="recent-files">
                  <label className="recent-toggle">
                    <input type="checkbox" checked={remember} onChange={e => toggleRemember(e.target.checked)} />
                    <span className="recent-toggle-text">
                      Keep a workspace of recent files on this device
                      <span className="recent-note">Stored only in your browser via IndexedDB — never uploaded. Every tool (editor, join, converters) can then open them; turning this off erases them.</span>
                    </span>
                  </label>
                  {remember && recent.length > 0 && (
                    <div className="recent-list">
                      <div className="recent-list-head">
                        <span>Recent files</span>
                        <button type="button" className="recent-clear" onClick={clearRecent}>Clear all</button>
                      </div>
                      {recent.map(r => (
                        <div className="recent-item" key={r.id}>
                          <button type="button" className="recent-item-load" onClick={() => loadRecent(r)} title={`Reopen ${r.name}`}>
                            <span className="recent-item-name">{r.name}</span>
                            <span className="recent-item-meta">{r.rows.toLocaleString()} rows · {fmtBytes(r.bytes)}</span>
                          </button>
                          <button type="button" className="recent-item-x" onClick={() => removeRecent(r.id)} aria-label={`Remove ${r.name}`}>×</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
            {!isGallery && !isConverter && !isPipeline && !isViz && !isDevTool && !isDual && !isShare && !isReshape && !isTextTool && !isGenerator && !isFormat && !isQR && (
              <div className="trust">
                {CONFIG.trust.map((t, i) => (
                  <div className="trust-item" key={i}>
                    <div className="trust-num">
                      {t.numEm ? <em>{t.num}</em> : t.num}
                      {t.unit && <span style={{ fontSize: 18 }}>{t.unit}</span>}
                    </div>
                    <div className="trust-label">{t.label}</div>
                  </div>
                ))}
              </div>
            )}
            {!isGallery && !isConverter && !isPipeline && !isViz && !isDevTool && !isDual && !isShare && !isReshape && !isTextTool && !isGenerator && !isFormat && !isQR && (
              <div className="empty-preview">
                <div className="empty-preview-eyebrow">No file? See what you'd get →</div>
                <div className="empty-preview-cards">
                  {[
                    { key: "sales", title: "Sales by region", tag: "Sales · 40 rows" },
                    { key: "analytics", title: "Web analytics", tag: "Traffic · 20 rows" },
                    { key: "expenses", title: "Operating expenses", tag: "Finance · 20 rows" }
                  ].map((p, i) => (
                    <button key={p.key} className="empty-preview-card" onClick={() => handleFile(p.key)}>
                      <div className="empty-preview-tag">{p.tag}</div>
                      <div className="empty-preview-title">{p.title}</div>
                      <div className="empty-preview-spark">
                        <GallerySpark seed={i + 3} />
                      </div>
                      <div className="empty-preview-cta">Load this →</div>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </section>
        ) : (
          <div id="dashboard-anchor">
            <Dashboard profile={profile} filename={filename} csvText={csvText} onReset={() => { setProfile(null); setCsvText(""); setFilename(""); setError(""); window.scrollTo({ top: 0, behavior: scrollBehavior() }); }} />
          </div>
        )}
        </main>
      </div>

      {/* AdSense — leaderboard before the content section.
          Create an ad unit in AdSense, then fill in its slot id below. */}
      <div className="shell" style={{ padding: "0 32px 24px" }}>
        <AdSlot slot="" /* TODO: paste the leaderboard ad unit slot id from AdSense */ />
      </div>

      <section className="section" id="how">
        <div className="shell">
          <div className="section-eyebrow">{CONFIG.sections.how.eyebrow}</div>
          <h2>{CONFIG.sections.how.title}<em>{CONFIG.sections.how.titleEm}</em></h2>
          <p className="section-lede">{CONFIG.sections.how.lede}</p>
          <div className="steps">
            {CONFIG.sections.how.steps.map((s, i) => (
              <div className="step" key={i}>
                <div className="step-n">{s.n}</div>
                <h3>{s.h}</h3>
                <p>{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" id="examples">
        <div className="shell">
          <div className="section-eyebrow">{CONFIG.sections.examples.eyebrow}</div>
          <h2>{CONFIG.sections.examples.title}<em>{CONFIG.sections.examples.titleEm}</em>{CONFIG.sections.examples.titleSuffix || ""}</h2>
          <p className="section-lede">{CONFIG.sections.examples.lede}</p>
          <div className="why">
            <ul className="why-list">
              {CONFIG.sections.examples.items.map((it, i) => (
                <li key={i}>
                  <div className="why-num">{it.n}</div>
                  <div>
                    <h4>{it.h}</h4>
                    <p>{it.p}</p>
                  </div>
                </li>
              ))}
            </ul>
            <div>
              <div style={{ fontFamily: "var(--serif)", fontSize: 24, lineHeight: 1.2, letterSpacing: "-0.01em", marginBottom: 16, fontStyle: "italic", color: "var(--ink-soft)" }}>
                "{CONFIG.sections.examples.pull}"
              </div>
              <div style={{ fontFamily: "var(--mono)", fontSize: 11, color: "var(--ink-faint)", letterSpacing: "0.06em", textTransform: "uppercase" }}>
                {CONFIG.sections.examples.pullAttr}
              </div>
            </div>
          </div>
        </div>
      </section>

      {CONFIG.notes && CONFIG.notes.items && CONFIG.notes.items.length > 0 && (
        <section className="section" id="notes">
          <div className="shell">
            {CONFIG.notes.eyebrow && <div className="section-eyebrow">{CONFIG.notes.eyebrow}</div>}
            <h2>{CONFIG.notes.title}<em>{CONFIG.notes.titleEm || ""}</em></h2>
            {CONFIG.notes.lede && <p className="section-lede">{CONFIG.notes.lede}</p>}
            <ul className="notes-list">
              {CONFIG.notes.items.map((it, i) => (
                <li key={i}>
                  <h4>{it.h}</h4>
                  <p>{it.p}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}

      {/* AdSense — in-article rectangle between examples and FAQ.
          Create an ad unit in AdSense, then fill in its slot id below. */}
      <div className="shell">
        <AdSlot slot="" /* TODO: paste the in-article ad unit slot id from AdSense */ />
      </div>

      {CONFIG.showHomeSections && (
        <>
          <HomeCategorySections />
          <HomePipelineCallout />
          <HomePrivacySection />
          <HomeUseCases />
        </>
      )}

      <section className="section" id="faq">
        <div className="shell">
          <div className="section-eyebrow">{CONFIG.sections.faq.eyebrow}</div>
          <h2>{CONFIG.sections.faq.title}<em>{CONFIG.sections.faq.titleEm}</em></h2>
          <FAQ items={CONFIG.faqItems} />
        </div>
      </section>

      {CONFIG.relatedTools && CONFIG.relatedTools.length > 0 && (
        <RelatedTools items={CONFIG.relatedTools} />
      )}

      <footer className="footer" id="about">
        <div className="shell">
          <div className="footer-support">
            <div className="footer-support-text">If this saved you time, <em>buy me a coffee.</em></div>
            <a className="kofi-button" href="https://ko-fi.com/csvtodashboard" target="_blank" rel="noopener noreferrer nofollow sponsored">
              <span className="kofi-cup">☕</span>
              <span>Support on Ko-fi</span>
              <span className="kofi-arrow">→</span>
            </a>
          </div>
          <div className="footer-grid footer-grid-6">
            <div className="footer-brand-col">
              <div className="footer-brand">{CONFIG.brand.prefix}<em>{CONFIG.brand.em}.</em></div>
              <p className="footer-tag">Convert, clean, query and visualize CSV — local-first, no signup.</p>
            </div>
            <div>
              <h5>Convert</h5>
              <ul>
                <li><a href="/csv-to-json">CSV to JSON</a></li>
                <li><a href="/csv-to-sql">CSV to SQL</a></li>
                <li><a href="/csv-to-excel">CSV to Excel</a></li>
                <li><a href="/csv-to-yaml">CSV to YAML</a></li>
                <li><a href="/csv-to-geojson">CSV to GeoJSON</a></li>
                <li><a href="/sql-to-csv">SQL to CSV</a></li>
                <li><a href="/html-table-to-csv">HTML to CSV</a></li>
                <li><a href="/csv-schema-generator">Schema Generator</a></li>
                <li><a href="/csv-to-notion">CSV to Notion</a></li>
                <li><a href="/csv-tools">CSV tools overview</a></li>
                <li><a href="/free-csv-tools">Free CSV tools</a></li>
                <li><a href="/tools">All converters →</a></li>
              </ul>
            </div>
            <div>
              <h5>Clean &amp; inspect</h5>
              <ul>
                <li><a href="/csv-validate">CSV Validator</a></li>
                <li><a href="/csv-profiler">CSV Profiler</a></li>
                <li><a href="/csv-data-dictionary">Data Dictionary</a></li>
                <li><a href="/csv-anonymizer">CSV Anonymizer</a></li>
                <li><a href="/csv-dedupe">Remove duplicates</a></li>
                <li><a href="/csv-diff">CSV Diff</a></li>
                <li><a href="/csv-merge">CSV Merge</a></li>
                <li><a href="/csv-sort-filter">Sort &amp; filter</a></li>
                <li><a href="/csv-split">Split CSV</a></li>
                <li><a href="/csv-cleaner">CSV Cleaner hub</a></li>
              </ul>
            </div>
            <div>
              <h5>Query</h5>
              <ul>
                <li><a href="/ask-csv">Ask CSV</a></li>
                <li><a href="/csv-sql-query">Query with SQL</a></li>
                <li><a href="/csv-regex-tester">Regex tester</a></li>
                <li><a href="/sql-on-csv">Learn SQL on CSV</a></li>
              </ul>
            </div>
            <div>
              <h5>Workflow</h5>
              <ul>
                <li><a href="/csv-pipeline">Pipeline Builder</a></li>
                <li><a href="/recipes">Pipeline recipes</a></li>
              </ul>
            </div>
            <div>
              <h5>Visualize</h5>
              <ul>
                <li><a href="/">Dashboard Builder</a></li>
                <li><a href="/csv-to-pivot">Pivot table</a></li>
                <li><a href="/csv-to-heatmap">Heatmap</a></li>
                <li><a href="/csv-to-timeline">Timeline</a></li>
                <li><a href="/csv-to-treemap">Treemap</a></li>
                <li><a href="/csv-to-sankey">Sankey diagram</a></li>
                <li><a href="/csv-to-embed">Embed a chart</a></li>
                <li><a href="/csv-story">CSV Story</a></li>
                <li><a href="/csv-compare">CSV Compare</a></li>
                <li><a href="/examples">Example dashboards</a></li>
              </ul>
            </div>
            <div>
              <h5>Company</h5>
              <ul>
                <li><a href="/about">About</a></li>
                <li><a href="/privacy">Privacy</a></li>
                <li><a href="/support">Support</a></li>
                <li><a href="/sponsor">Sponsor</a></li>
                <li><a href="/hosted-workflow">Hosted workflow inquiry</a></li>
                <li><a href="/tools">All tools</a></li>
                <li><a href="/engineering">Engineering</a></li>
                <li><a href="/changelog">Changelog</a></li>
                <li><a href="https://github.com/OSP-Engineer/csvtd-parser" target="_blank" rel="noopener">Open source</a></li>
                <li><a href="/convertcsv-alternative">vs ConvertCSV</a></li>
                <li><a href="/learn">All guides</a></li>
                <li><a href="mailto:hello@csvtodashboard.com">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <div>© 2026 {CONFIG.brand.prefix}{CONFIG.brand.em} · runs entirely in your browser</div>
            <div>made with care · ad-supported · no accounts</div>
          </div>
        </div>
      </footer>
    </>
  );
}

(function () {
  const rootEl = document.getElementById("root");
  // Remove the build-time SEO prerender (crawlers read it; the live app replaces
  // it). Done before createRoot so there's no duplicate content and no hydration.
  const pre = document.getElementById("seo-prerender");
  if (pre) pre.remove();
  ReactDOM.createRoot(rootEl).render(<App />);
})();
